
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9DfkH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AtlassianNavigation", () => $daeb815c48fa02e2$export$f66ccb39f60980e5);
$parcel$export(module.exports, "default", () => $daeb815c48fa02e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $43icZ = parcelRequire("43icZ");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $13iNl = parcelRequire("13iNl");

var $4keKa = parcelRequire("4keKa");

var $9WcgH = parcelRequire("9WcgH");

var $bcn6L = parcelRequire("bcn6L");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jp5kW = parcelRequire("jp5kW");

var $c0dQj = parcelRequire("c0dQj");

var $bBulW = parcelRequire("bBulW");

var $hwY9o = parcelRequire("hwY9o");

var $jzLyJ = parcelRequire("jzLyJ");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $apeap = parcelRequire("apeap");

var $daoB1 = parcelRequire("daoB1");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $cNd4s = parcelRequire("cNd4s");

var $cSD7y = parcelRequire("cSD7y");

var $7XYc4 = parcelRequire("7XYc4");

var $l0cYe = parcelRequire("l0cYe");

var $eoNiZ = parcelRequire("eoNiZ");

var $cibbb = parcelRequire("cibbb");

var $6RKvu = parcelRequire("6RKvu");

var $jUhOq = parcelRequire("jUhOq");

var $96WTB = parcelRequire("96WTB");

var $crC7i = parcelRequire("crC7i");

var $MBTxm = parcelRequire("MBTxm");

var $jyW1v = parcelRequire("jyW1v");

var $inFGE = parcelRequire("inFGE");

var $klog1 = parcelRequire("klog1");

var $7bwNu = parcelRequire("7bwNu");

var $0396H = parcelRequire("0396H");

var $fwJYI = parcelRequire("fwJYI");

var $ag3PC = parcelRequire("ag3PC");

var $2YzXO = parcelRequire("2YzXO");

var $2E6jA = parcelRequire("2E6jA");
const $daeb815c48fa02e2$var$isSPA = ()=>{
    if (false) return false;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $daeb815c48fa02e2$export$f66ccb39f60980e5 = (0, $cSD7y.componentWithFG)('blu-7045-separate-nav4-nav4-topnav-rendering', $daeb815c48fa02e2$var$AtlassianNavigationNew, $daeb815c48fa02e2$var$AtlassianNavigationOld);
var $daeb815c48fa02e2$export$2e2bcd8739ae039 = $daeb815c48fa02e2$export$f66ccb39f60980e5;
const $daeb815c48fa02e2$var$TopNavComponent = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $daeb815c48fa02e2$var$Nav4TopNav, $daeb815c48fa02e2$var$Nav3TopNav);
function $daeb815c48fa02e2$var$AtlassianNavigationNew() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($daeb815c48fa02e2$var$TopNavComponent, null), (0, $4R6GH.fg)('jira_nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzLyJ.default), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_2_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelNewTenantsExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelExistingUserExposure), null));
}
function $daeb815c48fa02e2$var$Nav4TopNav() {
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isMobileExperience = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const nav4NavigationProps = (0, $5uXOq.useMemo)(()=>isMobileExperience ? {
            hideSideNavToggleButton: true,
            renderSearch: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $fwJYI.Search) : undefined,
            renderNotifications: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $inFGE.Notifications) : undefined
        } : {
            renderAppSwitcher: $daeb815c48fa02e2$var$Nav4AppSwitcherMaybe,
            renderSearch: (0, $fwJYI.Search),
            renderEditionAwareness: (0, $bBulW.EditionAwareness),
            renderHelp: (0, $crC7i.Help),
            renderNotifications: (0, $inFGE.Notifications),
            renderConversationAssistant: (0, $jUhOq.ConversationAssistant),
            renderSettings: (0, $ag3PC.Settings),
            renderProfile: (0, $7bwNu.Profile),
            renderSignIn: (0, $2YzXO.SignIn)
        }, [
        isMobileExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $43icZ.TopNav4), {
        renderProductHome: (0, $klog1.ProductHome),
        renderCreate: (0, $96WTB.Create),
        renderNav4Notifications: (0, $2E6jA.Nav4NotificationsData),
        ...nav4NavigationProps,
        theme: theme,
        label: formatMessage((0, $jyW1v.default).topNav)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null));
}
function $daeb815c48fa02e2$var$Nav3TopNav() {
    const topNavSegment = (0, $azzrO.useNavPerformanceMetrics)();
    topNavSegment.mark((0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart);
    const cloudId = (0, $koeKL.useCloudId)();
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const renderNavigation = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cibbb.TopNav3), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && !(0, $jp5kW.default)('navigation.disable.prefetched.data.for.dropdowns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MBTxm.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4keKa.RecommendationLoader), {
            recommendations: (0, $13iNl.recommendations)
        })))), [
        isAnonymous
    ]);
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const projectContext = (0, $dAfqg.useProjectContext)();
    const customData = (0, $5uXOq.useMemo)(()=>{
        return {
            route: routeName,
            projectType: projectContext?.data?.projectType ?? 'UNKNOWN',
            isSPA: $daeb815c48fa02e2$var$isSPA()
        };
    }, [
        routeName,
        projectContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0cYe.NavigationSuccessTrackerForNav3), null, isAnonymous ? renderNavigation() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apeap.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcn6L.FavoritesContainer), {
        isGlobal: true,
        applicationPermissions: applicationPermissions
    }, renderNavigation()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceReport), {
        customData: customData
    }), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null));
}
function $daeb815c48fa02e2$var$AtlassianNavigationOld() {
    const topNavSegment = (0, $azzrO.useNavPerformanceMetrics)();
    topNavSegment.mark((0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart);
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isMobileExperience = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const nav4NavigationProps = (0, $5uXOq.useMemo)(()=>isMobileExperience ? {
            hideSideNavToggleButton: true,
            renderSearch: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $fwJYI.Search) : undefined,
            renderNotifications: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $inFGE.Notifications) : undefined
        } : {
            renderAppSwitcher: (0, $6RKvu.AppSwitcher),
            renderSearch: (0, $fwJYI.Search),
            renderEditionAwareness: (0, $bBulW.EditionAwareness),
            renderHelp: (0, $crC7i.Help),
            renderNotifications: (0, $inFGE.Notifications),
            renderConversationAssistant: (0, $jUhOq.ConversationAssistant),
            renderSettings: (0, $ag3PC.Settings),
            renderProfile: (0, $7bwNu.Profile),
            renderSignIn: (0, $2YzXO.SignIn)
        }, [
        isMobileExperience
    ]);
    const route = (0, $6jY6G.useCurrentRoute)();
    const renderNavigation = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $43icZ.TopNav4), {
            label: formatMessage((0, $jyW1v.default).topNav),
            renderProductHome: (0, $klog1.ProductHome),
            renderCreate: (0, $96WTB.Create),
            renderNav4Notifications: (0, $2E6jA.Nav4NotificationsData),
            ...nav4NavigationProps,
            theme: theme
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cibbb.TopNav3), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && !(0, $jp5kW.default)('navigation.disable.prefetched.data.for.dropdowns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MBTxm.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4keKa.RecommendationLoader), {
            recommendations: (0, $13iNl.recommendations)
        })))), [
        formatMessage,
        isAnonymous,
        nav4NavigationProps,
        theme
    ]);
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const projectContext = (0, $dAfqg.useProjectContext)();
    const customData = (0, $5uXOq.useMemo)(()=>{
        return {
            route: routeName,
            projectType: projectContext?.data?.projectType ?? 'UNKNOWN',
            isSPA: $daeb815c48fa02e2$var$isSPA()
        };
    }, [
        routeName,
        projectContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0cYe.NavigationSuccessTrackerForNav3), null, isAnonymous ? renderNavigation() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apeap.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcn6L.FavoritesContainer), {
        isGlobal: true,
        applicationPermissions: applicationPermissions
    }, renderNavigation()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceReport), {
        customData: customData
    }), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null), (0, $4R6GH.fg)('jira_nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzLyJ.default), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_2_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelNewTenantsExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelExistingUserExposure), null));
}
const $daeb815c48fa02e2$var$Nav4AppSwitcherMaybe = (0, $cSD7y.componentWithFG)('blu-6347-app-switcher-ep', (0, $hwY9o.AppSwitcher), (0, $6RKvu.AppSwitcher));

});
parcelRegister("43icZ", function(module, exports) {

$parcel$export(module.exports, "TopNav4", () => $08200948c12fa2de$export$76799253f2c58923);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $AameC = parcelRequire("AameC");

var $1hrBl = parcelRequire("1hrBl");
const $08200948c12fa2de$export$76799253f2c58923 = (0, $7XYc4.componentWithCondition)(()=>// eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
    (0, $6s1PB.expVal)('jira_nav4_hot_113350_changes', 'keys', []).includes('blu-5991-sync-load-nav4-sidebar'), (0, $1hrBl.AtlaskitAtlassianNavigationNav4), (0, $AameC.default));

});
parcelRegister("AameC", function(module, exports) {

$parcel$export(module.exports, "default", () => $60452d4d89241ae5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $58ST7 = parcelRequire("58ST7");

var $lfTZh = parcelRequire("lfTZh");


const $60452d4d89241ae5$var$LazyAtlaskitAtlassianNavigationNav4 = (0, $58ST7.lazyForPaint)(()=>Promise.resolve((parcelRequire("1hrBl"))).then(({ AtlaskitAtlassianNavigationNav4: AtlaskitAtlassianNavigationNav4 })=>AtlaskitAtlassianNavigationNav4), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation-nav4/src/ui/atlaskit-atlassian-navigation-nav4/AtlaskitAtlassianNavigationNav4.tsx"
});
const $60452d4d89241ae5$var$AsyncAtlaskitAtlassianNavigationNav4 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncAtlaskitAtlassianNavigationNav4",
        packageName: (0, $acc1306b50923620$export$b8b9d90f9e5bd72b),
        teamName: (0, $acc1306b50923620$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "lazyAtlaskitAtlassianNavigationNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60452d4d89241ae5$var$LazyAtlaskitAtlassianNavigationNav4, props))));
$60452d4d89241ae5$var$AsyncAtlaskitAtlassianNavigationNav4.displayName = 'AsyncAtlaskitAtlassianNavigationNav4';
var $60452d4d89241ae5$export$2e2bcd8739ae039 = $60452d4d89241ae5$var$AsyncAtlaskitAtlassianNavigationNav4;

});
const $acc1306b50923620$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $acc1306b50923620$export$d57b6b390e78d90f = 'jira-cosmos';
const $acc1306b50923620$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';

parcelRegister("1hrBl", function(module, exports) {

$parcel$export(module.exports, "AtlaskitAtlassianNavigationNav4", () => $95ae6691967260e6$export$c1591611a45b21ea);

var $iae3b = parcelRequire("iae3b");

var $9ZLcT = parcelRequire("9ZLcT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5NM6P = parcelRequire("5NM6P");

var $6Lyip = parcelRequire("6Lyip");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $fwzEJ = parcelRequire("fwzEJ");




var $ivGSs = parcelRequire("ivGSs");

var $3F9p6 = parcelRequire("3F9p6");

var $4DrQd = parcelRequire("4DrQd");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $ao2h1 = parcelRequire("ao2h1");

var $cZpsT = parcelRequire("cZpsT");

var $kxW4h = parcelRequire("kxW4h");
var $fhbrQ = parcelRequire("fhbrQ");
var $7EUR3 = parcelRequire("7EUR3");
var $3gWWB = parcelRequire("3gWWB");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $6s1PB = parcelRequire("6s1PB");


var $6Ejkr = parcelRequire("6Ejkr");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $5ORdX = parcelRequire("5ORdX");

var $k9kxe = parcelRequire("k9kxe");

var $ihoTN = parcelRequire("ihoTN");
const $95ae6691967260e6$var$Nav4TopNavigation = (0, $cSD7y.componentWithFG)('blu-5614-topnav-sidebar-toggle-button-for-ssr', $95ae6691967260e6$var$TopNavNew, $95ae6691967260e6$var$TopNavNoUserPrefs);
function $95ae6691967260e6$export$c1591611a45b21ea(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "atlaskit-atlassian-navigation-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AtlaskitAtlassianNavigationNav4",
        packageName: (0, $acc1306b50923620$export$b8b9d90f9e5bd72b),
        teamName: (0, $acc1306b50923620$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$Nav4TopNavigation, props)));
}
function $95ae6691967260e6$var$TopNavNew(props) {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)(); // This is defensive code to prevent making a request for data that will never be returned.
    // Only Customer Accounts have customer service access. These are non-Atlassian accounts considered
    // second-party party customers and should only have access to the JSM Help Center. They should
    // never have access to the regular Jira UI so should never see this top navigation. If we detect
    // that this is a customer account request we will not render the top navigation at all.
    // See https://jplat.atlassian.net/browse/BLU-7341 for context.
    if ((0, $4R6GH.fg)('blu-7341-fix_top_nav_query_for_unauthorized_users')) {
        if ((0, $j8DrX.default)('ajs-account-type') === 'customer') return null;
    }
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNoUserPrefs, props);
     // This intermediate step is to avoid fetching a user-preference-resource for an anonymous user.
    // Because hooks cannot be conditionally called, we create a new component.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNewUserPrefs, props);
}
function $95ae6691967260e6$var$TopNavNewUserPrefs(props) {
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $fwzEJ.topNav4UIStateResource)); // This intermediate step is to avoid using a null queryReference.
    // Maybe this should be a skeleton? Or is that taken care of by the page-container-v2?
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNewCommonWrapper, {
        queryReference: queryReference,
        ...props
    }) : null;
}
function $95ae6691967260e6$var$TopNavNewCommonWrapper(props) {
    const { queryReference: queryReference } = props;
    const data = (0, $8Uumt.usePreloadedQuery)((0, $9ZLcT.default), queryReference);
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $4DrQd.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT); // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavCommon, {
        ...props,
        defaultCollapsed: defaultCollapsed,
        queryReference: data
    });
}
function $95ae6691967260e6$var$TopNavNoUserPrefs(props) {
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $iae3b.default), {
        includeExtraMenuItems: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false)
    }); // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavCommon, {
        ...props,
        queryReference: data
    });
}
function $95ae6691967260e6$var$TopNavCommon(props) {
    const { defaultCollapsed: defaultCollapsed = false, hideSideNavToggleButton: hideSideNavToggleButton, queryReference: queryReference, renderCreate: Create, renderHelp: Help, renderAppSwitcher: AppSwitcher, renderNotifications: Notifications, renderNav4Notifications: Nav4NotificationsData, renderConversationAssistant: ConversationAssistant, renderProductHome: ProductHome, renderProfile: Profile, renderSettings: Settings, renderSearch: Search, renderEditionAwareness: EditionAwareness, renderSignIn: SignIn } = props;
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const siteTitleData = (0, $ihoTN.useSiteTitle)();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const attributes = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        }), []);
    const onClickSideNavToggleButton = (0, $5uXOq.useCallback)((_, analyticsEvent, _attributes)=>{
        const payload = (0, $ivGSs.getSideNavToggleButtonAnalyticEventPayload)(_attributes?.isSideNavVisible, (0, $3F9p6.getNav4Rollout)().stage);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, payload);
    }, []);
    const renderNotificationsForNavVersion = (0, $5uXOq.useCallback)(()=>{
        if (Notifications !== undefined) {
            if ((0, $6s1PB.expVal)('blu-6229-nav4-top-nav-notifications-perf', 'cohort', false)) // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Nav4NotificationsData, {
                queryReference: queryReference
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Notifications, null);
        }
        return null;
    }, [
        Nav4NotificationsData,
        Notifications,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhbrQ.HomeActions), null, hideSideNavToggleButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).JIRA_SIDEBAR_TOGGLE_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EUR3.SideNavToggleButton), {
        defaultCollapsed: defaultCollapsed,
        onClick: onClickSideNavToggleButton,
        collapseLabel: formatMessage((0, $5ORdX.messages).sideNavToggleButtonCollapseLabel),
        expandLabel: formatMessage((0, $5ORdX.messages).sideNavToggleButtonExpandLabel)
    })), AppSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProductHome, null), siteTitle && (0, $4R6GH.fg)('blu-7494-jira-site-title') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Ejkr.CustomTitle), null, siteTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxW4h.CommonActions), null, Search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Search, null), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3gWWB.UserActions), null, EditionAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditionAwareness, null), !isAnonymous && ConversationAssistant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConversationAssistant, null), !isAnonymous && renderNotificationsForNavVersion(), Help && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Help, null), Settings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Settings, null), Profile && !(0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Profile, null) : // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9kxe.Nav4Profile), {
        queryReference: queryReference
    }), SignIn && !(0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SignIn, null)));
}

});
parcelRegister("iae3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $303bb8e80a52e9e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<21be8fe1affb04a113b0a2d81348ec67>>
 * @relayHash 6359c7466250a87a7078454059df31e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa1294317b44e1df3f0811cc45e1d348c18cc974682f38c63caa8e7e7e82a61b
const $303bb8e80a52e9e7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeExtraMenuItems"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AtlaskitAtlassianNavigationNav4Query",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Profile"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AtlaskitAtlassianNavigationNav4Query",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "condition": "includeExtraMenuItems",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "email"
                                                }
                                            ],
                                            "type": "AtlassianAccountUser"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa1294317b44e1df3f0811cc45e1d348c18cc974682f38c63caa8e7e7e82a61b",
            "metadata": {},
            "name": "AtlaskitAtlassianNavigationNav4Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$303bb8e80a52e9e7$var$node.hash = "336aadcb522264aa7ac06a9dd94f4c95";
var $303bb8e80a52e9e7$export$2e2bcd8739ae039 = $303bb8e80a52e9e7$var$node;

});

parcelRegister("5NM6P", function(module, exports) {

$parcel$export(module.exports, "Nav4OnboardingComponentNames", () => $b94a87b237943b7f$export$f813aeb3fcf8b623);
$parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", () => $b94a87b237943b7f$export$c1a4e03cc30032f5);
const $b94a87b237943b7f$export$f813aeb3fcf8b623 = {
    GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
    JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
    // CONFLUENCE_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4ConfluenceSidebarToggleOnboardingSpotlight', // TODO: Spotlight has not been implemented in Confluence yet so this may change
    SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
    TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
    ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
    ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
};
const $b94a87b237943b7f$export$c1a4e03cc30032f5 = {
    nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
    nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    // nav4ConfluenceSidebarToggleOnboardingSpotlight: '', // TODO: Add when Confluence spotlight is implemented
    nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
};

});

parcelRegister("6Lyip", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlightMaybe", () => $ea144642b34a7c1d$export$77e61d078c8501ca);

var $5uXOq = parcelRequire("5uXOq");

var $aQl8U = parcelRequire("aQl8U");

var $4R6GH = parcelRequire("4R6GH");
function $ea144642b34a7c1d$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
    if (!(0, $4R6GH.fg)('blu-2735_nav4_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
        name: spotlight
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}

});

const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';

parcelRegister("ivGSs", function(module, exports) {

$parcel$export(module.exports, "getSideNavToggleButtonAnalyticEventPayload", () => $968dc7093f3ba590$export$7165a1ebf1926b86);
$parcel$export(module.exports, "MENU_ID_ANALYTIC_EVENT_IDS", () => $968dc7093f3ba590$export$d70e7a5f39328991);

var $jhS4y = parcelRequire("jhS4y");





var $jecJ3 = parcelRequire("jecJ3");
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE = 'sidebarToggle';
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE = 'collapse';
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND = 'expand';
const $968dc7093f3ba590$var$CLICKED = 'clicked';
const $968dc7093f3ba590$export$7165a1ebf1926b86 = (isSideNavVisible, stage)=>{
    const toggleAction = isSideNavVisible ? $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE : $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND;
    const payload = {
        action: $968dc7093f3ba590$var$CLICKED,
        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
        actionSubjectId: $968dc7093f3ba590$var$SIDEBAR_TOGGLE,
        attributes: {
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
            stage: stage,
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            toggleAction: toggleAction
        }
    };
    return payload;
};
const $968dc7093f3ba590$export$d70e7a5f39328991 = {
    [(0, $jhS4y.MENU_ID_APPS)]: 'appsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_ASSETS)]: 'assetsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_DASHBOARDS)]: 'dashboardsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_FILTERS)]: 'filtersNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_GOALS)]: 'goalsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_OPERATIONS)]: 'operationsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_OVERVIEWS)]: 'overviewsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_PLANS)]: 'plansNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_PROJECTS)]: 'projectsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_RECENT)]: 'recentNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_STARRED)]: 'starredNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_TEAMS)]: 'teamsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_ROADMAPS)]: 'roadmapsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_SERVICE)]: 'customerServiceMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_HUBS)]: 'customerHubsMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_SERVICE_ANALYTICS)]: 'customerServiceAnalyticsMenuItem',
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_ASSETS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_ASSETS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_GOALS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_GOALS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_CONFLUENCE)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_CONFLUENCE),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_LOOM)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_LOOM),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_TEAMS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_TEAMS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_PROJECTS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_PROJECTS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_OPSGENIE)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_OPSGENIE)
};

});
const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';

parcelRegister("jecJ3", function(module, exports) {

$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $06147718dc8a8493$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $06147718dc8a8493$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $06147718dc8a8493$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $06147718dc8a8493$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $06147718dc8a8493$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $06147718dc8a8493$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $06147718dc8a8493$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $06147718dc8a8493$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $06147718dc8a8493$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $06147718dc8a8493$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $06147718dc8a8493$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $06147718dc8a8493$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $06147718dc8a8493$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $06147718dc8a8493$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $06147718dc8a8493$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $06147718dc8a8493$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $06147718dc8a8493$export$340dfb7166bc7df6);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_CONFLUENCE", () => $06147718dc8a8493$export$68f5347447985678);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_LOOM", () => $06147718dc8a8493$export$1d6ac45ce8d48696);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_TEAMS", () => $06147718dc8a8493$export$73432842fefef2ac);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_PROJECTS", () => $06147718dc8a8493$export$3023d22f41447712);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_OPSGENIE", () => $06147718dc8a8493$export$3cc2573a8cf93a99);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $06147718dc8a8493$export$1a73d7f5e6997c6d);

var $jhS4y = parcelRequire("jhS4y");
const $06147718dc8a8493$export$ed5276b2863990a4 = 'recent';
const $06147718dc8a8493$export$73b9e2753c0313a = 'starred';
const $06147718dc8a8493$export$a01a58e0d3083eac = 'yourApps';
const $06147718dc8a8493$export$a7cdcfc40ede2092 = 'yourWork';
const $06147718dc8a8493$export$31b95a89c6fecef5 = 'apps';
const $06147718dc8a8493$export$b8d778ecbc8de386 = 'plans';
const $06147718dc8a8493$export$31111a67d393221 = 'projects';
const $06147718dc8a8493$export$15cffe8e769011f4 = 'filters';
const $06147718dc8a8493$export$573d88e8f19dee53 = 'dashboards';
const $06147718dc8a8493$export$4d8d544db40ea55b = 'operations';
const $06147718dc8a8493$export$ee4743a74ca6b2b4 = 'teams';
const $06147718dc8a8493$export$935694b184853c59 = 'assets';
const $06147718dc8a8493$export$b0aa6b1b7598bca0 = 'more';
const $06147718dc8a8493$export$60a8edfaff189e32 = 'customiseSidebar';
const $06147718dc8a8493$export$c15c267765b7c087 = 'overviews';
const $06147718dc8a8493$export$61feca79c347b0c7 = 'goals';
const $06147718dc8a8493$export$1e1623e43a47b758 = 'roadmaps';
const $06147718dc8a8493$export$99cd56faa69bbbb6 = 'customerService';
const $06147718dc8a8493$export$f3045e909a12df36 = 'customerHubs';
const $06147718dc8a8493$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $06147718dc8a8493$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $06147718dc8a8493$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $06147718dc8a8493$export$68f5347447985678 = 'confluenceGlobalAppShortcut';
const $06147718dc8a8493$export$1d6ac45ce8d48696 = 'loomGlobalAppShortcut';
const $06147718dc8a8493$export$73432842fefef2ac = 'teamsGlobalAppShortcut';
const $06147718dc8a8493$export$3023d22f41447712 = 'projectsGlobalAppShortcut';
const $06147718dc8a8493$export$3cc2573a8cf93a99 = 'opsgenieGlobalAppShortcut';
const $06147718dc8a8493$export$1a73d7f5e6997c6d = {
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).APPS]: $06147718dc8a8493$export$31b95a89c6fecef5,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS]: $06147718dc8a8493$export$935694b184853c59,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS]: $06147718dc8a8493$export$573d88e8f19dee53,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS]: $06147718dc8a8493$export$15cffe8e769011f4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS]: $06147718dc8a8493$export$4d8d544db40ea55b,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS]: $06147718dc8a8493$export$b8d778ecbc8de386,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS]: $06147718dc8a8493$export$31111a67d393221,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).RECENT]: $06147718dc8a8493$export$ed5276b2863990a4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).STARRED]: $06147718dc8a8493$export$73b9e2753c0313a,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).TEAMS]: $06147718dc8a8493$export$ee4743a74ca6b2b4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GOALS]: $06147718dc8a8493$export$61feca79c347b0c7,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OVERVIEWS]: $06147718dc8a8493$export$c15c267765b7c087,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ROADMAPS]: $06147718dc8a8493$export$1e1623e43a47b758,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $06147718dc8a8493$export$99cd56faa69bbbb6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS]: $06147718dc8a8493$export$f3045e909a12df36,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $06147718dc8a8493$export$f780439bdf7412c6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $06147718dc8a8493$export$340dfb7166bc7df6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $06147718dc8a8493$export$be1ee97c6c39a7a0,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE]: $06147718dc8a8493$export$68f5347447985678,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM]: $06147718dc8a8493$export$1d6ac45ce8d48696,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS]: $06147718dc8a8493$export$73432842fefef2ac,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS]: $06147718dc8a8493$export$3023d22f41447712,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE]: $06147718dc8a8493$export$3cc2573a8cf93a99
};

});


parcelRegister("3F9p6", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $826ce4e4d6cfd68d$export$84a05d3b37ec5d2);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7qZOo = parcelRequire("7qZOo");

var $hUCm2 = parcelRequire("hUCm2");

var $8O1QZ = parcelRequire("8O1QZ");

var $32Frn = parcelRequire("32Frn");

var $laQnH = parcelRequire("laQnH");
const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>!(0, $4R6GH.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding'),
        (0, $8O1QZ.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_eap'),
        (0, $32Frn.getNav4RolloutForEap)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_existing-customers'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('existing-customers')
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_sandboxes'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, $laQnH.getNav4RolloutForGaAndBeyond)
    ]
]);

});
parcelRegister("7qZOo", function(module, exports) {

$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $92928f70e02753a5$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $92928f70e02753a5$export$e748a16828d2f61f);
const $92928f70e02753a5$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $92928f70e02753a5$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("hUCm2", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9);

var $1i1R1 = parcelRequire("1i1R1");
const $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
            stage: 'beta',
            cohort: cohort
        } : {
            stage: 'beta',
            cohort: cohort,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        };

});

parcelRegister("8O1QZ", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $48ac6742e168ff29$export$f1e751a9a9d68fb5);

var $9glig = parcelRequire("9glig");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'),
        $48ac6742e168ff29$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1'),
        $48ac6742e168ff29$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        $48ac6742e168ff29$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("32Frn", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $d3197687d5551826$export$42dd8c002a342b8);

var $1i1R1 = parcelRequire("1i1R1");
const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
    });

});

parcelRegister("laQnH", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $8c7cc40a2449f7a7$export$99bed161b1040362);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $1i1R1 = parcelRequire("1i1R1");

var $7qZOo = parcelRequire("7qZOo");
const $8c7cc40a2449f7a7$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1-5'),
        ()=>({
                stage: 'ga',
                phase: 1.5,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptOut: (0, $1i1R1.getIsNav4TenantOptOut)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptIn: (0, $1i1R1.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("4DrQd", function(module, exports) {

$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $e2413e530566d4f6$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$6a976dc7193b8a18);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$5034ad0032cd499d);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $e2413e530566d4f6$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING", () => $e2413e530566d4f6$export$da92a6698d96e3f2);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $e2413e530566d4f6$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $e2413e530566d4f6$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $e2413e530566d4f6$export$89de709e88232646);

var $9A3ju = parcelRequire("9A3ju");

var $1KhNh = parcelRequire("1KhNh");

var $4xe5H = parcelRequire("4xe5H");

var $636od = parcelRequire("636od");

var $fqw90 = parcelRequire("fqw90");

var $9SjHf = parcelRequire("9SjHf");

var $eoPME = parcelRequire("eoPME");

var $ln03X = parcelRequire("ln03X");

var $eePjm = parcelRequire("eePjm");

var $bDqc9 = parcelRequire("bDqc9");

var $bSnHz = parcelRequire("bSnHz");

var $9jIIR = parcelRequire("9jIIR");

var $kcBHy = parcelRequire("kcBHy");

var $8ovgZ = parcelRequire("8ovgZ");

var $6MDbS = parcelRequire("6MDbS");

var $f88X3 = parcelRequire("f88X3");

var $ir6ay = parcelRequire("ir6ay");

var $9J0fZ = parcelRequire("9J0fZ");

var $96iWb = parcelRequire("96iWb");

var $felPF = parcelRequire("felPF");

var $8jvyN = parcelRequire("8jvyN");

var $9MrML = parcelRequire("9MrML");

var $6UD5j = parcelRequire("6UD5j");

var $jhS4y = parcelRequire("jhS4y");

var $6x874 = parcelRequire("6x874");

var $ih7ba = parcelRequire("ih7ba");

var $46Cti = parcelRequire("46Cti");
const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, $jhS4y.CONFIGURABLE_MENU_ID));
const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
const $e2413e530566d4f6$export$c52c93cc28495ab0 = Object.values((0, $jhS4y.GLOBAL_APP_MENU_ID));
const $e2413e530566d4f6$export$de634ec0f98ab74b = $e2413e530566d4f6$export$c52c93cc28495ab0;
const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1KhNh)))
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ln03X)))
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9A3ju)))
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ir6ay)))
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($f88X3)))
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9SjHf)))
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fqw90)))
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eoPME)))
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations,
        Icon: (0, $6x874.default)
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xe5H)))
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96iWb)))
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($636od)))
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9J0fZ)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eePjm)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDqc9)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6UD5j)))
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, $8jvyN.AssetsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, $9MrML.GoalsIcon)
    },
    // App Shortcuts for Platform Component
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $ih7ba.default).confluence,
        Icon: (0, $bSnHz.ConfluenceIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $ih7ba.default).loom,
        Icon: (0, $9jIIR.LoomIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, $8ovgZ.ProjectsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, $kcBHy.TeamsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $ih7ba.default).opsgenie,
        Icon: (0, $6MDbS.OpsgenieIcon)
    }
};
const $e2413e530566d4f6$export$5034ad0032cd499d = {
    message: (0, $ih7ba.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($felPF)))
};
const $e2413e530566d4f6$export$b66ae8c18ec95bc6 = {
    message: (0, $ih7ba.default).forYou.defaultMessage
};
const $e2413e530566d4f6$export$da92a6698d96e3f2 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $ih7ba.default).confluence.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $ih7ba.default).loom.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $ih7ba.default).opsgenie.defaultMessage
    }
};
const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240; // in pixels
const $e2413e530566d4f6$export$6621cd553335536a = 320; // in pixels
const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $e2413e530566d4f6$export$89de709e88232646 = 25;

});
parcelRegister("6x874", function(module, exports) {

$parcel$export(module.exports, "default", () => $079d8146cc6d581f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dwpuP = parcelRequire("dwpuP");

var $cs5FJ = parcelRequire("cs5FJ");

var $4R6GH = parcelRequire("4R6GH");
const $079d8146cc6d581f$var$OperationsIcon = ({ ...props })=>{
    if ((0, $4R6GH.fg)('nav4_operations_icon_update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwpuP))), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cs5FJ))), props);
};
var $079d8146cc6d581f$export$2e2bcd8739ae039 = $079d8146cc6d581f$var$OperationsIcon;

});

parcelRegister("ih7ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c16ecaa1449e546$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
        "defaultMessage": "Customer service"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer hubs"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Insights"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    },
    confluence: {
        "id": "navigation-apps-sidebar-nav4-common.common.confluence",
        "defaultMessage": "Confluence"
    },
    loom: {
        "id": "navigation-apps-sidebar-nav4-common.common.loom",
        "defaultMessage": "Loom"
    },
    opsgenie: {
        "id": "navigation-apps-sidebar-nav4-common.common.opsgenie",
        "defaultMessage": "Opsgenie"
    }
});

});

parcelRegister("46Cti", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $2d5b83df0b5ff159$export$918aea3cf024d90b);

var $jhS4y = parcelRequire("jhS4y");
const $2d5b83df0b5ff159$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    ...$2d5b83df0b5ff159$var$OPERATIONS_MENU_ID
};

});


parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bI8Pv = parcelRequire("bI8Pv");

var $g7Hs1 = parcelRequire("g7Hs1");

var $lSd8p = parcelRequire("lSd8p");

var $bBhMx = parcelRequire("bBhMx");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");

var $aJOZ3 = parcelRequire("aJOZ3");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $bI8Pv.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $g7Hs1.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $g7Hs1.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJOZ3.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBhMx.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lSd8p.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});
parcelRegister("aJOZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d596e34a54eb72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $37d596e34a54eb72$var$SsrRenderProfiler = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $37d596e34a54eb72$export$2e2bcd8739ae039 = $37d596e34a54eb72$var$SsrRenderProfiler;

});


parcelRegister("5ORdX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7e3b94d939630c6f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7e3b94d939630c6f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-collapse-label",
        "defaultMessage": "Collapse sidebar ["
    },
    sideNavToggleButtonExpandLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-expand-label",
        "defaultMessage": "Expand sidebar ["
    }
});

});

parcelRegister("k9kxe", function(module, exports) {

$parcel$export(module.exports, "Nav4Profile", () => $a99665d29fdf5a2b$export$c928b6dc7cf1e4c6);

var $3QjWU = parcelRequire("3QjWU");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9SDU1 = parcelRequire("9SDU1");

var $gFVv0 = parcelRequire("gFVv0");

var $aoMwu = parcelRequire("aoMwu");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");

var $aQl8U = parcelRequire("aQl8U");

var $aTJat = parcelRequire("aTJat");
var $cnqh1 = parcelRequire("cnqh1");

var $c0dQj = parcelRequire("c0dQj");

var $2EqxS = parcelRequire("2EqxS");

var $cYlk7 = parcelRequire("cYlk7");

var $2Ql51 = parcelRequire("2Ql51");

var $cZpsT = parcelRequire("cZpsT");

var $9OXo1 = parcelRequire("9OXo1");

var $6s1PB = parcelRequire("6s1PB");

var $6cNb0 = parcelRequire("6cNb0");

var $57H0d = parcelRequire("57H0d");

var $j671u = parcelRequire("j671u");

var $904lL = parcelRequire("904lL");

var $hCGb2 = parcelRequire("hCGb2");
var $cWFw8 = parcelRequire("cWFw8");
var $6v68O = parcelRequire("6v68O");
var $5KNBo = parcelRequire("5KNBo");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $cLIpE = parcelRequire("cLIpE");
const $a99665d29fdf5a2b$export$c928b6dc7cf1e4c6 = ({ queryReference: queryReference })=>{
    const data = (0, $8Uumt.useFragment)((0, $3QjWU.default), queryReference);
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const { theme: theme, setTheme: setTheme } = (0, $2Ql51.useThemePreference)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { environment: environment } = (0, $9OXo1.useTenantContext)();
    const isMobileExperience = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const identityEnv = (0, $57H0d.getIdentityEnv)(environment);
    const currentWindow = (0, $57H0d.getWindow)();
    const siteUrl = (0, $57H0d.getSiteUrl)(currentWindow);
    const [userBoardId, userBoardOwnerAccountId] = (0, $904lL.useUserBoardId)(false);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    const isUserType = (maybeUser)=>'emailAddress' in maybeUser;
    const emailAddress = isUserType(user) && user.emailAddress ? user.emailAddress : '';
    const links = (0, $cnqh1.useAccountLinks)({
        email: emailAddress,
        identityEnvironment: identityEnv,
        application: 'jira',
        continueUrl: siteUrl,
        isLoggedOut: isAnonymous
    });
    if ((0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a99665d29fdf5a2b$export$793e3aab7101233f, {
        testId: (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile'),
        picture: data?.me?.user?.picture,
        email: emailAddress || '',
        logInLink: links.logInLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTJat.AccountNav3), {
        name: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) ? data?.me?.user?.name : user?.userFullname,
        picture: data?.me?.user?.picture,
        trustPicture: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false),
        email: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) ? data?.me?.user?.email || '' : emailAddress,
        viewProfileLink: isMobileExperience ? undefined : profileLink,
        onThemeChange: setTheme,
        currentTheme: theme,
        identityEnvironment: identityEnv,
        application: "jira",
        continueUrl: siteUrl,
        isLoggedOut: isAnonymous,
        extraMenuItems: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j671u.MenuNav4), {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        })
    });
};
const $a99665d29fdf5a2b$export$793e3aab7101233f = ({ testId: testId, picture: picture, email: email, logInLink: logInLink })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            includeExtraMenuItems: true
        }), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cLIpE.Nav4ProfileMenuEntryPoint), entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClosePopup: ()=>{
                setIsOpen(false);
            },
            testId: testId
        }), [
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9SDU1.NavigationAnalyticsContext), {
        data: (0, $5KNBo.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCGb2.AccountMenuIntlProvider), null, logInLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWFw8.AccountMenuLoggedOutStateNav3), {
        testId: testId && `${testId}--logged-out-state`,
        logInLink: logInLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFVv0.default), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
                name: "profile-spotlight"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6v68O.AccountMenuTriggerNav3), {
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: testId && `${testId}--trigger`,
                picture: picture,
                trustPicture: true,
                email: email,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                "aria-controls": testId && `${testId}--content`,
                "data-ds--level": triggerProps['data-ds--level']
            }));
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "atlassian-navigation-profile-menu",
                packageName: "atlassian-navigation-profile-menu",
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
                    xcss: $a99665d29fdf5a2b$var$Nav4AccountMenuContentSkeletonStyles,
                    padding: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aoMwu.default), null)),
                runtimeProps: runtimeProps
            })
    })));
};
// These styles are defined to ensure that the initial popup for the AccountMenu content is the same width when
// displaying the skeleton loader as when displaying the actual content.
const $a99665d29fdf5a2b$var$Nav4AccountMenuContentSkeletonStyles = (0, $aCJg8.xcss)({
    width: '304px',
    height: '307px'
});

});
parcelRegister("3QjWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5287ccf2951923b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a0dac0c0853631e9e179741e03cf11a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f5287ccf2951923b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "includeExtraMenuItems"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Profile",
    "selections": [
        {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeExtraMenuItems",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$f5287ccf2951923b$var$node.hash = "c382d788a3ba66968e52b96eae589c15";
var $f5287ccf2951923b$export$2e2bcd8739ae039 = $f5287ccf2951923b$var$node;

});

parcelRegister("2EqxS", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $58d844745b0a5554$export$8ac70acdad00754b);
$parcel$export(module.exports, "useSwitchAccountLink", () => $58d844745b0a5554$export$dce6af3168fb6ced);
$parcel$export(module.exports, "useProfileLink", () => $58d844745b0a5554$export$b8f25e615dd30d7b);
$parcel$export(module.exports, "getBeforeEntity", () => $58d844745b0a5554$export$5b8580d0254a9349);
$parcel$export(module.exports, "getBoardLink", () => $58d844745b0a5554$export$ff5c49b7852aca68);
$parcel$export(module.exports, "getLinkFromProject", () => $58d844745b0a5554$export$dd9458ee44edd0c6);
$parcel$export(module.exports, "getQueueLink", () => $58d844745b0a5554$export$b44363840d1b683e);
$parcel$export(module.exports, "getIsClassicSoftwareProject", () => $58d844745b0a5554$export$286ea82aef1c76e9);
$parcel$export(module.exports, "getUsersApps", () => $58d844745b0a5554$export$ad0fd737fbd4a083);

var $ebyGx = parcelRequire("ebyGx");

var $9HJOg = parcelRequire("9HJOg");

var $j0xEB = parcelRequire("j0xEB");

var $iN5FK = parcelRequire("iN5FK");

var $hqguB = parcelRequire("hqguB");

var $kk6FJ = parcelRequire("kk6FJ");

var $ludxj = parcelRequire("ludxj");

var $urQ6o = parcelRequire("urQ6o");

var $7M8Tn = parcelRequire("7M8Tn");

var $7wTzh = parcelRequire("7wTzh");

var $lB6pS = parcelRequire("lB6pS");

var $lyCs2 = parcelRequire("lyCs2");

var $ee0rS = parcelRequire("ee0rS");

var $90yGq = parcelRequire("90yGq");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");
const $58d844745b0a5554$export$ab902790e443b0ec = ()=>`${(0, $9HJOg.getATLContextUrl)('id')}/login`;
const $58d844745b0a5554$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $9HJOg.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $58d844745b0a5554$export$dce6af3168fb6ced = ()=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const { href: href } = (0, $j0xEB.default)() || {};
    return `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: href,
        prompt: 'select_account'
    })}`;
};
const $58d844745b0a5554$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $58d844745b0a5554$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $58d844745b0a5554$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $kk6FJ.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $lyCs2.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $58d844745b0a5554$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $ludxj.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $iN5FK.browseProjectRedirectRoute)
    };
};
const $58d844745b0a5554$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $ee0rS.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $urQ6o.customPracticeQueueRoute) : (0, $7M8Tn.customQueueRoute)
    };
};
const $58d844745b0a5554$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $58d844745b0a5554$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $lmyls.ADDON_ID).DISCOVER);

});
parcelRegister("j0xEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1198aeec732ce1$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("iN5FK", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $84aa7aa5982a6e60$export$f9cac37753487f39);
const $84aa7aa5982a6e60$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});

parcelRegister("hqguB", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $abd9824736763ae8$export$73b60789ceb8e1eb);
const $abd9824736763ae8$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});

parcelRegister("kk6FJ", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $f1ec4cbb5ae8c6af$export$a192088aab559fa1);
const $f1ec4cbb5ae8c6af$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("ludxj", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $be54e9dad71bd630$export$1cfc858068dd8718);
const $be54e9dad71bd630$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});

parcelRegister("urQ6o", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRoute", () => $41bd265d7c0f4884$export$59d0bd42aa07faad);
const $41bd265d7c0f4884$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("7M8Tn", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $c0c93413dba087be$export$e1fac82ca0b0d637);
const $c0c93413dba087be$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("7wTzh", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $4f781bb234c1132b$export$9ae2c0a566d4e0f6);
const $4f781bb234c1132b$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("lB6pS", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9dbec22457c8ec85$export$131d51ca54849e97);
const $9dbec22457c8ec85$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("lyCs2", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $a9c2c98045690ca6$export$57a2a0fe739f16);
const $a9c2c98045690ca6$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});

parcelRegister("ee0rS", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3a8490f36704bba6$export$db58a56259f511a2);

var $oCMSG = parcelRequire("oCMSG");
const $3a8490f36704bba6$var$longToShortConversionMap = {
    [(0, $oCMSG.CHANGES)]: (0, $oCMSG.SHORT_FORM_CHANGES),
    [(0, $oCMSG.INCIDENTS)]: (0, $oCMSG.SHORT_FORM_INCIDENTS),
    [(0, $oCMSG.PROBLEMS)]: (0, $oCMSG.SHORT_FORM_PROBLEMS),
    [(0, $oCMSG.SERVICE_REQUEST)]: (0, $oCMSG.SHORT_FORM_SERVICE_REQUEST),
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: (0, $oCMSG.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $oCMSG.DEVELOPER_ESCALATION)]: (0, $oCMSG.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3a8490f36704bba6$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3a8490f36704bba6$var$longToShortConversionMap;
}
const $3a8490f36704bba6$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3a8490f36704bba6$var$isLongForm(workCategoryKey)) return $3a8490f36704bba6$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});

parcelRegister("90yGq", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $903db0de2618ef6c$export$e72033e0f5baa3e);

var $9OXo1 = parcelRequire("9OXo1");
const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("6cNb0", function(module, exports) {

$parcel$export(module.exports, "testIdConcat", () => $c1f136d19203abbc$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $c1f136d19203abbc$export$3b86b974ae586844);
const $c1f136d19203abbc$var$PREFIX = 'atlassian-navigation-';
const $c1f136d19203abbc$var$SEPARATOR = '--';
const $c1f136d19203abbc$var$isValid = (value)=>value != null && value !== '';
const $c1f136d19203abbc$export$794609946480f79c = (id, ...items)=>[
        id,
        ...items
    ].filter(Boolean).join($c1f136d19203abbc$var$SEPARATOR).toLowerCase();
const $c1f136d19203abbc$export$3b86b974ae586844 = (first, ...rest)=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    $c1f136d19203abbc$export$794609946480f79c($c1f136d19203abbc$var$PREFIX + ($c1f136d19203abbc$var$isValid(first) ? `-${first}` : ''), ...rest);

});


parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});




parcelRegister("57H0d", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => $323b60151b6ebcfa$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getSiteUrl", () => $323b60151b6ebcfa$export$63fdf20f02fdbaf2);
$parcel$export(module.exports, "getIdentityEnv", () => $323b60151b6ebcfa$export$b3f2b8c6cd294d68);
const $323b60151b6ebcfa$export$38b2d434cce3ea22 = ()=>window;
const $323b60151b6ebcfa$export$63fdf20f02fdbaf2 = (currentWindow)=>{
    if (!currentWindow.false) return `${currentWindow.location.protocol}//${currentWindow.location.host}`;
    return '';
};
const $323b60151b6ebcfa$export$b3f2b8c6cd294d68 = (env)=>{
    switch(env){
        case 'local':
            return 'staging';
        case 'dev':
            return 'staging';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        default:
            return 'prod';
    }
};

});

parcelRegister("j671u", function(module, exports) {

$parcel$export(module.exports, "MenuNav4", () => $e1c78c1b6d55a8ee$export$60113ca6a29c7a92);
/* main-nav4.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8xXpg = parcelRequire("8xXpg");
var $5gSBR = parcelRequire("5gSBR");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dAfqg = parcelRequire("dAfqg");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");


var $5VgFy = parcelRequire("5VgFy");

var $6e9wd = parcelRequire("6e9wd");

var $lwZRC = parcelRequire("lwZRC");

var $ckmlX = parcelRequire("ckmlX");

var $j6Dnq = parcelRequire("j6Dnq");
const $e1c78c1b6d55a8ee$export$60113ca6a29c7a92 = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $acc1306b50923620$export$69cbedccc0df48)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const showQuickstartOpenMenuItem = showInJwmProjects || showInSoftwareProjects || showInJsmProjects;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e9wd.MenuList), null, showQuickstartOpenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $5VgFy.MenuItem)
    }), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true,
        testId: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $ckmlX.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e9wd.MenuListItem), {
        ariaLabel: formatMessage((0, $ckmlX.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5VgFy.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $ckmlX.default).yourBoards))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwZRC.StandardToPremiumPubTouchpoint), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6Dnq.ExtraItemsNav4), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $ckmlX.default).jira)
    }));
};

});
parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

const $e7830161eb8674f1$export$6f454e69bce3a691 = 'business';
const $e7830161eb8674f1$export$e6952b12ade67489 = 'default';

parcelRegister("jrUuh", function(module, exports) {

$parcel$export(module.exports, "useJsmOnboardingType", () => $664311160f9d0bff$export$5daaa68c3a578af9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gcnn5 = parcelRequire("gcnn5");
const $664311160f9d0bff$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $664311160f9d0bff$var$Store = (0, $iXqE5.createStore)({
    initialState: $664311160f9d0bff$export$d4c72bab9d6cc13a,
    actions: $gcnn5.actions,
    name: 'JSMOnboardingType'
});
const $664311160f9d0bff$export$5daaa68c3a578af9 = (0, $3sQ5x.createHook)($664311160f9d0bff$var$Store);

});
parcelRegister("gcnn5", function(module, exports) {

$parcel$export(module.exports, "actions", () => $efcda9e0ca78f7c5$export$e324594224ef24da);

var $5R3PH = parcelRequire("5R3PH");
const $efcda9e0ca78f7c5$export$e324594224ef24da = {
    fetchOnboardingType: $5R3PH.fetchOnboardingType
};

});
parcelRegister("5R3PH", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingType", () => $a0d1630df8d288ca$export$ea62467635172b55);

var $2vSU6 = parcelRequire("2vSU6");

var $7f4tk = parcelRequire("7f4tk");
const $a0d1630df8d288ca$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $a0d1630df8d288ca$export$ea62467635172b55 = (projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $7f4tk.default)($a0d1630df8d288ca$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("4QigF", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklist", () => $a3ce66216f7840ff$export$aea93106aaeec3fc);
$parcel$export(module.exports, "JswOnboardingButton", () => $a3ce66216f7840ff$export$c0cbc1198da400db);
$parcel$export(module.exports, "LazyOpenMenuItem", () => $a3ce66216f7840ff$export$e6a8d3e2a6acc946);
$parcel$export(module.exports, "OpenMenuItem", () => $a3ce66216f7840ff$export$67c4b22563f33286);

var $5uXOq = parcelRequire("5uXOq");

var $6zTpr = parcelRequire("6zTpr");

var $7CMCs = parcelRequire("7CMCs");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $iuzc0 = parcelRequire("iuzc0");

var $l8ruj = parcelRequire("l8ruj");

var $58ST7 = parcelRequire("58ST7");

var $5Nzrp = parcelRequire("5Nzrp");

var $eIh4F = parcelRequire("eIh4F");
const $a3ce66216f7840ff$var$FallbackChecklist = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$aea93106aaeec3fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "quickstart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6zTpr.default), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Nzrp.JswOnboardingChecklistNext), null))));
const $a3ce66216f7840ff$var$FallbackButton = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsButtonAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$c0cbc1198da400db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6zTpr.default), {
        name: "software-onboarding-checklist-button-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackButton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuzc0.QuickstartPillVisibilityContainer), {
        scope: "ListPageQuickstartPill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIh4F.JswOnboardingButtonNext), null))));

const $a3ce66216f7840ff$export$e6a8d3e2a6acc946 = (0, $58ST7.lazy)(()=>(parcelRequire("jTjyt")).then(({ OpenMenuItem: OpenMenuItem })=>{
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return OpenMenuItem;
    }), {
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/open-menu-item/index.tsx"
});
const $a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.openMenuItemLoadTime).start();
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$67c4b22563f33286 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncOpenMenuItemComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6zTpr.default), {
        name: "software-onboarding-checklist-open-menu-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$export$e6a8d3e2a6acc946, props)));

});
parcelRegister("94Uc1", function(module, exports) {

$parcel$export(module.exports, "PANEL_ID", () => $5bee65240229f284$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PANEL_WIDTH", () => $5bee65240229f284$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PERFORMANCE_METRIC_PREFIX", () => $5bee65240229f284$export$495d0560d6ea05d0);
$parcel$export(module.exports, "PERFORMANCE_MARK", () => $5bee65240229f284$export$5da8d06749e84d86);
const $5bee65240229f284$export$e1d562d81d0e502d = 'jsw-nux-onboarding-checklist';
const $5bee65240229f284$export$e05cfff20e9274e6 = 360;
const $5bee65240229f284$export$495d0560d6ea05d0 = 'onboarding-quickstart';
const $5bee65240229f284$export$5da8d06749e84d86 = {
    BUNDLE_LOAD_START: 'bundleLoaded',
    BUNDLE_LOAD_END: 'bundleLoadedEnd'
};

});

parcelRegister("353uQ", function(module, exports) {

$parcel$export(module.exports, "isMetricRunning", () => $56fd78ac33bc6df4$export$5c2d3e87043198cf);
$parcel$export(module.exports, "openMenuItemLoadTime", () => $56fd78ac33bc6df4$export$9aef270bc11ae96b);
$parcel$export(module.exports, "qsButtonAutoLoadTime", () => $56fd78ac33bc6df4$export$844f48c93ed69757);
$parcel$export(module.exports, "qsChecklistAutoLoadTime", () => $56fd78ac33bc6df4$export$c501d2dfab0e9e45);
$parcel$export(module.exports, "qsChecklistMinimiseInteraction", () => $56fd78ac33bc6df4$export$ac78fba7425e64da);
$parcel$export(module.exports, "qsChecklistDismissInteraction", () => $56fd78ac33bc6df4$export$494d4094aaa2bc4d);
$parcel$export(module.exports, "qsButtonOpenInteraction", () => $56fd78ac33bc6df4$export$da7d38041ee220c8);
$parcel$export(module.exports, "qsButtonDismissInteraction", () => $56fd78ac33bc6df4$export$ce2841e9d619cdfd);
// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.

var $ktw2A = parcelRequire("ktw2A");

var $94Uc1 = parcelRequire("94Uc1");
const $56fd78ac33bc6df4$export$5c2d3e87043198cf = (metric)=>metric?.state === 'started';
const $56fd78ac33bc6df4$export$9aef270bc11ae96b = (0, $ktw2A.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.open.menu-item.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$844f48c93ed69757 = (0, $ktw2A.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$c501d2dfab0e9e45 = (0, $ktw2A.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$ac78fba7425e64da = (0, $ktw2A.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.minimize`
});
const $56fd78ac33bc6df4$export$494d4094aaa2bc4d = (0, $ktw2A.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.dismiss`
});
const $56fd78ac33bc6df4$export$da7d38041ee220c8 = (0, $ktw2A.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.open`
});
const $56fd78ac33bc6df4$export$ce2841e9d619cdfd = (0, $ktw2A.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.dismiss`
});

});

parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $ltbcl = parcelRequire("ltbcl");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $ltbcl.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});

parcelRegister("iuzc0", function(module, exports) {

$parcel$export(module.exports, "QuickstartPillVisibilityContainer", () => $eb306ed6e1ecf691$export$1a5202e8ea7b76ab);
$parcel$export(module.exports, "useQuickstartPillVisibilityStore", () => $eb306ed6e1ecf691$export$70dc54081d2075ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $eb306ed6e1ecf691$var$actions = {
    toggleShowQuickstart: ({ showQuickstartPill: showQuickstartPill })=>({ setState: setState })=>{
            setState({
                showQuickstartPill: showQuickstartPill
            });
        }
};
const $eb306ed6e1ecf691$var$initialState = {
    showQuickstartPill: null
};
const $eb306ed6e1ecf691$var$Store = (0, $iXqE5.createStore)({
    initialState: $eb306ed6e1ecf691$var$initialState,
    actions: $eb306ed6e1ecf691$var$actions,
    name: 'JiraQuickstartPillVisibility'
});
const $eb306ed6e1ecf691$export$1a5202e8ea7b76ab = (0, $gg7kZ.createContainer)($eb306ed6e1ecf691$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$eb306ed6e1ecf691$var$initialState
            });
        }
});
const $eb306ed6e1ecf691$export$70dc54081d2075ff = (0, $3sQ5x.createHook)($eb306ed6e1ecf691$var$Store);

});

parcelRegister("5Nzrp", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistNext", () => $c4258442d9598a49$export$bbc4e97e9a15a84b);

var $5uXOq = parcelRequire("5uXOq");

var $d8lsH = parcelRequire("d8lsH");

var $7SsRN = parcelRequire("7SsRN");

var $6zTpr = parcelRequire("6zTpr");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $9TQ3l = parcelRequire("9TQ3l");
const $c4258442d9598a49$export$bbc4e97e9a15a84b = ()=>{
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>()=>{
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistAutoLoadTime))) // QS Checklist loading cancelled for page load action
        (0, $353uQ.qsChecklistAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistDismissInteraction))) // User interaction completed for QS Checklist dismiss action
        (0, $353uQ.qsChecklistDismissInteraction).stop();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID)) {
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
            return;
        }
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) {
            openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH));
            (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                openRightSidebarAsMinimised: false,
                openRightSidebarToTop: false,
                trigger: 'JswOnboardingChecklistNext'
            });
        }
    }, [
        currentRightSidebarPanelId,
        openRightSidebar,
        closeRightSidebar,
        quickstartStatus,
        createAnalyticsEvent,
        isRightSidePanelMinimised
    ]);
    if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7SsRN.default), {
        name: "quickstart-fetching-data"
    });
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6zTpr.default), {
        name: "software-onboarding-checklist-next",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TQ3l.AsyncJswOnboardingChecklistInternal), null)));
};

});
parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $5f07ce956337ba8b$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $5f07ce956337ba8b$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $5f07ce956337ba8b$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $5f07ce956337ba8b$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $5f07ce956337ba8b$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $5f07ce956337ba8b$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$8ab0859f5b30b013,
    $5f07ce956337ba8b$export$d1f6d18c6698104c,
    $5f07ce956337ba8b$export$e6ee159eee7adc1c,
    $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
    $5f07ce956337ba8b$export$f14c8bffc35200d3,
    $5f07ce956337ba8b$export$36cc22c9997d92a,
    $5f07ce956337ba8b$export$d651cc94a46ff383,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$a333714599f14a6,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];

});

parcelRegister("cE2Qr", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $796be817ff5bbbfa$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $796be817ff5bbbfa$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $796be817ff5bbbfa$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $796be817ff5bbbfa$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $796be817ff5bbbfa$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $796be817ff5bbbfa$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $796be817ff5bbbfa$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $796be817ff5bbbfa$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $796be817ff5bbbfa$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $796be817ff5bbbfa$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $796be817ff5bbbfa$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $796be817ff5bbbfa$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $796be817ff5bbbfa$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $796be817ff5bbbfa$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $796be817ff5bbbfa$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $796be817ff5bbbfa$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $796be817ff5bbbfa$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $796be817ff5bbbfa$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $796be817ff5bbbfa$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $796be817ff5bbbfa$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $796be817ff5bbbfa$export$f4a2be940259bf95);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);

var $58GFP = parcelRequire("58GFP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $6RAg1 = parcelRequire("6RAg1");

var $ieqoN = parcelRequire("ieqoN");

var $cGE52 = parcelRequire("cGE52");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");

const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $cGE52.initialState,
    actions: $6RAg1.actions
});
const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $51nlc.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $gg7kZ.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
});
const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$a943afa434e9487a
});
const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: null
});
const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$9d731f44f82af09f
});
const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN || userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)];
        return visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && ((0, $4R6GH.fg)('jira_cleanup_devops_bundle_experiences') || !state.isDevOpsProject) && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN)
});
const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && ((0, $4R6GH.fg)('jira_cleanup_devops_bundle_experiences') || !state.isDevOpsProject) && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $8Bc5A.KANBAN_ONBOARDING_TASK)))
});
const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $c364c398187f9175$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
$parcel$export(module.exports, "isJwmTmpTemplateKey", () => $c364c398187f9175$export$aff130309b9a2baf);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$278632cc7ed9a312 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $c364c398187f9175$export$594d0d4f5ecbf4c7 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $c364c398187f9175$export$dda85c7a8278e495 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $c364c398187f9175$export$b92c431651f9ee91 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $c364c398187f9175$export$d72d75d9d0e071fc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $c364c398187f9175$export$753322ed1c32ff89 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};
const $c364c398187f9175$export$aff130309b9a2baf = (templateKey)=>{
    return [
        $c364c398187f9175$export$477ca3550da12e43,
        $c364c398187f9175$export$b5ab111fb8825075,
        $c364c398187f9175$export$ebf7af45376deb8b,
        $c364c398187f9175$export$310a9ac5c28d65f6,
        $c364c398187f9175$export$136d17feb2f4285d,
        $c364c398187f9175$export$e288f4758e94a8cc,
        $c364c398187f9175$export$4e9ac1417ba54bba,
        $c364c398187f9175$export$560c9f6765bf9af4,
        $c364c398187f9175$export$14d4c6dbbb62a127,
        $c364c398187f9175$export$1367ee12532c525f,
        $c364c398187f9175$export$278632cc7ed9a312,
        $c364c398187f9175$export$594d0d4f5ecbf4c7,
        $c364c398187f9175$export$dda85c7a8278e495,
        $c364c398187f9175$export$b92c431651f9ee91,
        $c364c398187f9175$export$d72d75d9d0e071fc,
        $c364c398187f9175$export$753322ed1c32ff89
    ].includes(templateKey);
};

});

parcelRegister("6RAg1", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4752306278e43a2d$export$e324594224ef24da);

var $6fSBR = parcelRequire("6fSBR");

var $j6wxT = parcelRequire("j6wxT");

var $7mZ3t = parcelRequire("7mZ3t");

var $8UXiA = parcelRequire("8UXiA");

var $3iEb4 = parcelRequire("3iEb4");

var $7yDu9 = parcelRequire("7yDu9");

var $5UBG2 = parcelRequire("5UBG2");

var $lHcRB = parcelRequire("lHcRB");

var $eiyXc = parcelRequire("eiyXc");

var $jZvbN = parcelRequire("jZvbN");

var $azcAL = parcelRequire("azcAL");

var $gbXQ5 = parcelRequire("gbXQ5");

var $iZuFy = parcelRequire("iZuFy");

var $70Fss = parcelRequire("70Fss");

var $erLQY = parcelRequire("erLQY");

var $dQPsy = parcelRequire("dQPsy");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $cUGWT = parcelRequire("cUGWT");

var $boV1S = parcelRequire("boV1S");

var $4Viq4 = parcelRequire("4Viq4");

var $jIoq4 = parcelRequire("jIoq4");

var $75A1x = parcelRequire("75A1x");

var $1Xkin = parcelRequire("1Xkin");
const $4752306278e43a2d$export$e324594224ef24da = {
    changeTaskGroupParent: $6fSBR.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $6fSBR.nextGoBackToPreviousTaskGroup,
    setIsOpen: $j6wxT.setIsOpen,
    refreshAppState: $7mZ3t.refreshAppState,
    setNudgeStep: $8UXiA.setNudgeStep,
    addMountedNudge: $3iEb4.addMountedNudge,
    removeMountedNudge: $3iEb4.removeMountedNudge,
    setShouldRenderComponent: $7yDu9.setShouldRenderComponent,
    setProjectState: $5UBG2.setProjectState,
    setHasNudgeActive: $lHcRB.setHasNudgeActive,
    forceHideNudge: $eiyXc.forceHideNudge,
    setHasEverSeenRoute: $jZvbN.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $azcAL.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $azcAL.setRoadmapIsListEmpty,
    openNextTask: $gbXQ5.openNextTask,
    resetIsQuickstartLoaded: $iZuFy.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $70Fss.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $erLQY.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $dQPsy.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $abQXL.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $4VXxO.nextSetChecklistIsOpen,
    nextOpenTask: $cUGWT.nextOpenTask,
    nextAutoExpand: $boV1S.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $4Viq4.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $jIoq4.nextGetTasks,
    syncVisibilityWithLocal: $75A1x.syncVisibilityWithLocal,
    universalDispatch: $1Xkin.universalDispatch
};

});
parcelRegister("6fSBR", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $0f1566e1d3fc2987$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $0f1566e1d3fc2987$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
    };
const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("1ftPQ", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $d3dd40bf54ad27bf$export$583b2d2422a6757f);

var $89SaW = parcelRequire("89SaW");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $89SaW.setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
    });
const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
    const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
};

});


parcelRegister("j6wxT", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $eefde484654068e9$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");
const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };
var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;

});
parcelRegister("3B5jO", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $47424244d57f6abc$export$eae834ce0286017a);

var $2vSU6 = parcelRequire("2vSU6");

var $8Bc5A = parcelRequire("8Bc5A");
const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
    if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("7mZ3t", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);

var $4R6GH = parcelRequire("4R6GH");


var $8fqy8 = parcelRequire("8fqy8");

var $8zOmE = parcelRequire("8zOmE");

var $bfWlw = parcelRequire("bfWlw");

var $ldyPw = parcelRequire("ldyPw");

var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $1ftPQ = parcelRequire("1ftPQ");

var $52Vcw = parcelRequire("52Vcw");

var $ljzlb = parcelRequire("ljzlb");

var $3ORcf = parcelRequire("3ORcf");

var $6ypzr = parcelRequire("6ypzr");

var $4ji4w = parcelRequire("4ji4w");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $erLQY = parcelRequire("erLQY");

var $6fSBR = parcelRequire("6fSBR");
const $ecf6e94ad9c4f8d6$var$allTasks = [
    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
    ...(0, $8Bc5A.JSM_BUSINESS_TASKS)
];
const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $8Bc5A.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_TASK_GROUP),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                ...$ecf6e94ad9c4f8d6$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, $3ORcf.getIsDevOpsProject)(projectState.projectKey);
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $4ji4w.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $ldyPw.PREMIUM_EDITION)) {
            dispatch((0, $6fSBR.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $8fqy8.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $ljzlb.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials && (0, $4R6GH.fg)('jsw_reverse_trials_feature_gate')) {
            const isOnboardingPremiumTrial = await (0, $bfWlw.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $4VXxO.nextSetChecklistIsOpen)(true));
            dispatch((0, $abQXL.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $erLQY.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $6fSBR.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $1ftPQ.pushToBackend)({
                key: (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("8fqy8", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $77364531dfabe700$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $77364531dfabe700$export$6da79f996c267010);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $eusud.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("bfWlw", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $a55f3307b43c0521$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $a55f3307b43c0521$export$ef676f7f369f74fe);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $6c7t9 = parcelRequire("6c7t9");
const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $6c7t9.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $6c7t9.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $eusud.performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $6c7t9.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $6c7t9.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("6c7t9", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$f389f8ca168b4a3a);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $fab9df2877e9db77$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6yhDy", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $760653e5a4f27459$export$8420ef0cee98de);

var $1sYcL = parcelRequire("1sYcL");

var $g5X3G = parcelRequire("g5X3G");

var $8Bc5A = parcelRequire("8Bc5A");
const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $1sYcL.get)((0, $g5X3G.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("1sYcL", function(module, exports) {

$parcel$export(module.exports, "get", () => $7fc92c544211ac93$export$3988ae62b71be9a3);

var $lbWm4 = parcelRequire("lbWm4");

var $3T6Xo = parcelRequire("3T6Xo");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $fjcgS = parcelRequire("fjcgS");

var $jpBWy = parcelRequire("jpBWy");
var $Syify = parcelRequire("Syify");
let $7fc92c544211ac93$var$ufoExperiencesMap = {};
const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
    if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, $Syify.UFOExperience)(key, {
        type: (0, $jpBWy.ExperienceTypes).Operation,
        performanceType: (0, $jpBWy.ExperiencePerformanceTypes).Custom
    });
    return $7fc92c544211ac93$var$ufoExperiencesMap[key];
};
const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
    $7fc92c544211ac93$var$ufoExperiencesMap = {};
};
const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $eusud.performGetRequest)(url);
        if (response === null) (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $7fc92c544211ac93$var$patchProperties(response, 'user');
        $7fc92c544211ac93$var$patchProperties(response, 'instance');
        $7fc92c544211ac93$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("52Vcw", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $5dab66e6da9554ae$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $5dab66e6da9554ae$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $5dab66e6da9554ae$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $5dab66e6da9554ae$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $5dab66e6da9554ae$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $5dab66e6da9554ae$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $5dab66e6da9554ae$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $5dab66e6da9554ae$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $5dab66e6da9554ae$export$6c39ca65ca354e59);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");
const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $8Bc5A.ACTION_SUBJECT_ID), attributes);
};
const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $izv86.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("izv86", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $4725f5ccfabd2231$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $4725f5ccfabd2231$export$3b914201960fa7a6);

var $e4eHl = parcelRequire("e4eHl");

var $2vSU6 = parcelRequire("2vSU6");
const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
    [(0, $2vSU6.CORE_PROJECT)]: 'workManagement',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(projectType);
    return null;
};
const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
};

});


parcelRegister("ljzlb", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $9217b5bb53dd29c2$export$7f2186c37a3d095d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $k9OK8 = parcelRequire("k9OK8");
const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $eusud.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $8Bc5A.PACKAGE_NAME),
                teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $k9OK8.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("k9OK8", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ee27e8acf854e0ab$export$99f3e48748c2a8c3);

var $eNf8a = parcelRequire("eNf8a");

const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("3ORcf", function(module, exports) {

$parcel$export(module.exports, "getIsDevOpsProject", () => $d5d39abfab8df073$export$88ee873472aa9bb7);

var $8Bc5A = parcelRequire("8Bc5A");
const $d5d39abfab8df073$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, $8Bc5A.KEY_IS_DEVOPS_PROJECT}`;
const $d5d39abfab8df073$export$88ee873472aa9bb7 = async (projectKey)=>{
    const url = $d5d39abfab8df073$var$projectPropertyUrl(projectKey);
    const response = await fetch(url);
    if (response.ok) {
        const result = await response.json();
        return result.value;
    }
    return false;
};

});

parcelRegister("6ypzr", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $98fe78eb4dc2e758$export$980c26b6f100081d);

var $eusud = parcelRequire("eusud");
const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, $eusud.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("4ji4w", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $af696889329ec63a$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $af696889329ec63a$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $af696889329ec63a$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $af696889329ec63a$export$93d719890ad66653);

var $bSSG7 = parcelRequire("bSSG7");

var $aFsRe = parcelRequire("aFsRe");
const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $af696889329ec63a$var$store = (0, $bSSG7.createLocalStorageProvider)('quickstart');
const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
    $af696889329ec63a$var$store.set(key, value);
};
const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);

});
parcelRegister("aFsRe", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $856e0575daef172f$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $856e0575daef172f$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $856e0575daef172f$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $856e0575daef172f$export$293f6b2affa6ea5a);

var $izv86 = parcelRequire("izv86");







const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("abQXL", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $dc09dffee9419aae$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED : (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: false
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("4VXxO", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $7815e3bf96163d46$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("erLQY", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $f082da41253fd664$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1ftPQ = parcelRequire("1ftPQ");
const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $1ftPQ.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("8UXiA", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $2d15900fae273e3c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;

});

parcelRegister("3iEb4", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d23aba2b0749d2be$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d23aba2b0749d2be$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("7yDu9", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $e7988e1b8f7782bd$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;

});

parcelRegister("5UBG2", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $72dc29ca0b198f0e$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;

});

parcelRegister("lHcRB", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $4ecbca1b06d3bc5e$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;

});

parcelRegister("eiyXc", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("jZvbN", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $bde38543b00c29f3$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;

});

parcelRegister("azcAL", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f19987e3027503ab$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f19987e3027503ab$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gbXQ5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $460159056a360dfc$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $4ji4w.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $cUGWT.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cUGWT", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $f8b3135a172025f8$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $f8b3135a172025f8$export$cc5f3544a6cb2922);


var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $8UXiA = parcelRequire("8UXiA");

var $lHcRB = parcelRequire("lHcRB");
const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        else dispatch((0, $lHcRB.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.SCRUM_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.KANBAN_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.ADD_COLUMNS_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else dispatch((0, $8UXiA.setNudgeStep)(''));
    };
const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        dispatch((0, $8UXiA.setNudgeStep)(''));
    };

});


parcelRegister("iZuFy", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $b50ce46f86d3e3d7$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $3B5jO = parcelRequire("3B5jO");
const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("70Fss", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $f0fdda8951af3bde$export$87fe8079a4ed9766);


var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $52Vcw = parcelRequire("52Vcw");

var $6ypzr = parcelRequire("6ypzr");

var $abQXL = parcelRequire("abQXL");
const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dQPsy", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $82a74350685dcd25$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $8Bc5A.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("boV1S", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $35a410a5fb89f79b$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $984bX.localStorageProvider)().get({
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $4ji4w.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $cUGWT.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("984bX", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $a6d0a6873aa6f7aa$export$f2666fae743fa5f);

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $8Bc5A = parcelRequire("8Bc5A");
const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
const $a6d0a6873aa6f7aa$var$DAY = 86400000;
const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
};
let $a6d0a6873aa6f7aa$var$localStorage;
const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
    if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
    const provider = (0, $eNf8a.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    $a6d0a6873aa6f7aa$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $a6d0a6873aa6f7aa$var$localStorage;
};
const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
    $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
        accountId: (0, $8Bc5A.ACCOUNT_ID),
        key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("4Viq4", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $lHcRB = parcelRequire("lHcRB");
const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $984bX.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $lHcRB.setHasNudgeActive)(true));
            (0, $984bX.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("jIoq4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $034f263b888956c9$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ikZFc = parcelRequire("ikZFc");
const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $ikZFc.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("ikZFc", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $cb6c1b1dc7b1b225$export$d1f442602a91e7cc);

var $6s1PB = parcelRequire("6s1PB");

var $4jROM = parcelRequire("4jROM");

var $4R6GH = parcelRequire("4R6GH");


var $ldyPw = parcelRequire("ldyPw");

var $jtI3q = parcelRequire("jtI3q");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $ieqoN = parcelRequire("ieqoN");

var $h3PyW = parcelRequire("h3PyW");

var $3Iaiu = parcelRequire("3Iaiu");

var $aHo1U = parcelRequire("aHo1U");

var $5yUqp = parcelRequire("5yUqp");

var $5zzQl = parcelRequire("5zzQl");

var $jJca1 = parcelRequire("jJca1");

var $d7Knl = parcelRequire("d7Knl");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $aHo1U.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $8Bc5A.ROOT_TASK) ? (0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $8Bc5A.ROOT_TASK];
    return {
        title: title,
        items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
    };
};
const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
    if ((0, $4jROM.isFedRamp)()) variants.add((0, $aHo1U.JSW).experience.fedRamp);
    if (premiumTrialOnSignup && (0, $4R6GH.fg)('jsw_reverse_trials_feature_gate')) {
        variants.add((0, $aHo1U.JSW).experiment.jswReverseTrial);
        (0, $6s1PB.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $aHo1U.JSW).experiment.rtQuickstartM1);
    }
    if (isCustomerTemplateProject) variants.add((0, $aHo1U.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $aHo1U.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $aHo1U.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $aHo1U.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $aHo1U.JSW).experience.kanbanOnboarding);
    if (isWizardSimplifyQS) variants.add((0, $aHo1U.JSW).experiment.wizard);
    if (canCreateProject === false) variants.add((0, $aHo1U.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $aHo1U.JSW).projectStyle.teamManaged);
    else variants.add((0, $aHo1U.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $aHo1U.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.jiraAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.siteAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $ldyPw.FREE_EDITION)) variants.add((0, $aHo1U.JSW).edition.free);
    else if (projectState?.edition === (0, $ldyPw.STANDARD_EDITION)) variants.add((0, $aHo1U.JSW).edition.standard);
    else if (projectState?.edition === (0, $ldyPw.PREMIUM_EDITION)) variants.add((0, $aHo1U.JSW).edition.premium);
    if ((0, $1ffS1.isRoadmapRoute)(routeName)) variants.add((0, $aHo1U.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $aHo1U.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $aHo1U.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $aHo1U.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $aHo1U.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $aHo1U.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $4R6GH.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $aHo1U.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $aHo1U.JSW).experiment.customizeSiteName);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $aHo1U.JSW).taskVariants,
        taskList: (0, $aHo1U.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList = (0, $5yUqp.JWM).taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $5yUqp.JWM).experiments.projectTheming);
    if (isEligibleForTailoredOnboardingM2P5) return $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $5yUqp.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $5yUqp.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $5yUqp.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $5yUqp.JWM).experiments.isSampleProject);
    else variants.push((0, $5yUqp.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $5yUqp.JWM).experiments.trelloCrossflow);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $5yUqp.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3Iaiu.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3Iaiu.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.siteAdmin);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3Iaiu.JSM).taskVariants,
        taskList: (0, $3Iaiu.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createDevopsTasks = (taskGroupParent)=>{
    const variants = [];
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $h3PyW.DEVOPS).taskVariants,
        taskList: (0, $h3PyW.DEVOPS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    if ((0, $4R6GH.fg)('jira_tailored_onboarding_single_config')) {
        const variants = [];
        if (features?.hasBacklog) variants.push((0, $pDX5d.Feature).hasBacklog);
        if (features?.hasSprint) variants.push((0, $pDX5d.Feature).hasSprint);
        if (isEligibleForTailoredOnboardingM3) variants.push((0, $8VfDj.Experiment).tailoredOnboardingM3Eligible);
        if (isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
        if (teamType && (0, $jtI3q.isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType)(teamType)) variants.push(`teamType.${teamType}`);
        else variants.push('teamType.everythingElse');
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
            taskList: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
            taskGroupParent: taskGroupParent
        });
    }
    // Following the same pattern as other configs and using an array here
    // but right now only one value(team type) will ever be in this array
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingTailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING).getTaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS: isWizardSimplifyQS = false, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $jJca1.isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $jJca1.isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
    if (!(0, $4R6GH.fg)('jira_cleanup_devops_bundle_experiences') && isDevOpsProject) return $cb6c1b1dc7b1b225$var$createDevopsTasks(taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $cb6c1b1dc7b1b225$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jtI3q", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTailoredTeamType", () => $606262a699c9299e$export$8ea98ac9729b7e09);
$parcel$export(module.exports, "isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType", () => $606262a699c9299e$export$a40edd97e5cbfaa9);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $606262a699c9299e$export$26c385918d734203);

var $370Ye = parcelRequire("370Ye");
const $606262a699c9299e$export$8ea98ac9729b7e09 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredTeamTypes).includes(teamType);
};
const $606262a699c9299e$export$a40edd97e5cbfaa9 = (teamType)=>{
    return (0, $370Ye.tailoredTeamTypesWithSoftware).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    teamType);
};
const $606262a699c9299e$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("370Ye", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $06c84b7af2a23aee$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredTeamTypesWithSoftware", () => $06c84b7af2a23aee$export$7e2d6cf3886ecaf7);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $06c84b7af2a23aee$export$52c5394d6e6cfcf3);

const $06c84b7af2a23aee$export$a1fbb7d965e15a39 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098)
];
const $06c84b7af2a23aee$export$7e2d6cf3886ecaf7 = [
    ...$06c84b7af2a23aee$export$a1fbb7d965e15a39,
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];
const $06c84b7af2a23aee$export$52c5394d6e6cfcf3 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];

});


parcelRegister("1ffS1", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $ee93e5dd18635f6d$export$d1fa67c1ffb68871);
const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("ieqoN", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $353950c3dd35bbc6$export$8eeb199b23203523);
const $353950c3dd35bbc6$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("h3PyW", function(module, exports) {

$parcel$export(module.exports, "DEVOPS", () => $866b9189a2842e55$export$bb75b6064c92010c);

var $j6cCw = parcelRequire("j6cCw");
const $866b9189a2842e55$export$bb75b6064c92010c = {
    taskList: (0, $j6cCw.TASK_LIST),
    taskVariants: (0, $j6cCw.TASK_VARIANTS),
    experiment: (0, $j6cCw.Experiment)
};

});
parcelRegister("j6cCw", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7149b1f98b73c1fd$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "TASK_LIST", () => $7149b1f98b73c1fd$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7149b1f98b73c1fd$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $1AiUr = parcelRequire("1AiUr");
const $7149b1f98b73c1fd$export$4e0ab25c8a7e4009 = {};
const $7149b1f98b73c1fd$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $1AiUr.messages).rootTitle,
        items: [
            (0, $8Bc5A.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
            (0, $8Bc5A.DEVOPS_GET_TO_KNOW_JIRA_TASK),
            (0, $8Bc5A.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
            (0, $8Bc5A.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
            (0, $8Bc5A.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
            (0, $8Bc5A.DEVOPS_INVITE_TEAMMATES_TASK),
            (0, $8Bc5A.DEVOPS_FIND_HELP_TASK)
        ]
    }
});
const $7149b1f98b73c1fd$export$36f4d47dfe11b613 = {
    [(0, $8Bc5A.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_FIND_HELP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("1AiUr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6eae5132e152d792$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6eae5132e152d792$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("3Iaiu", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $56a077523ddf70fb$export$63f289f2da861d35);

var $58IQc = parcelRequire("58IQc");
const $56a077523ddf70fb$export$63f289f2da861d35 = {
    taskList: (0, $58IQc.JSM_TASK_LIST),
    taskVariants: (0, $58IQc.JSM_TASK_VARIANTS),
    userRole: (0, $58IQc.UserRole),
    experiments: (0, $58IQc.Experiments)
};

});
parcelRegister("58IQc", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $3c13225c81ad4b5c$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $3c13225c81ad4b5c$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $3c13225c81ad4b5c$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $3c13225c81ad4b5c$export$5b68aef408c932d9);

var $8Bc5A = parcelRequire("8Bc5A");

var $kTSRm = parcelRequire("kTSRm");
const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $kTSRm.messages).rootTitle,
        items: [
            (0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
    [(0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("kTSRm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1f6142c4170f38e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f1f6142c4170f38e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("aHo1U", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $563027753d017a60$export$4cfe6e52f2e72a54);

var $8VfDj = parcelRequire("8VfDj");
const $563027753d017a60$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8VfDj.TASK_LIST),
    taskVariants: (0, $8VfDj.TASK_VARIANTS),
    experiment: (0, $8VfDj.Experiment),
    experience: (0, $8VfDj.Experience),
    projectStyle: (0, $8VfDj.ProjectStyle),
    projectProperties: (0, $8VfDj.ProjectProperties),
    userRole: (0, $8VfDj.UserRole),
    edition: (0, $8VfDj.Edition),
    route: (0, $8VfDj.Route),
    permissions: (0, $8VfDj.Permissions),
    trait: (0, $8VfDj.Trait)
};

});
parcelRegister("8VfDj", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $ea3903bb15047c3b$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $ea3903bb15047c3b$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $ea3903bb15047c3b$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $ea3903bb15047c3b$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $ea3903bb15047c3b$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $ea3903bb15047c3b$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $ea3903bb15047c3b$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $ea3903bb15047c3b$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $ea3903bb15047c3b$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $ea3903bb15047c3b$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $ea3903bb15047c3b$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $ciLFO = parcelRequire("ciLFO");
const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    wizard: 'experiment.wizard',
    tailoredOnboardingM3Eligible: 'experiment.tailoredOnboardingM3Eligible',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $ea3903bb15047c3b$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $ea3903bb15047c3b$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
    (0, $8Bc5A.ADD_COLUMNS_TASK),
    (0, $8Bc5A.CREATE_PROJECT_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK),
    (0, $8Bc5A.FIND_HELP_TASK),
    (0, $8Bc5A.SET_UP_BOARD_TASK),
    (0, $8Bc5A.GET_MOBILE_APP_TASK),
    (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $8Bc5A.MONITOR_MANAGE_RISK_TASK),
    (0, $8Bc5A.SCRUM_ONBOARDING_TASK),
    (0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK),
    (0, $8Bc5A.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $8Bc5A.GET_STARTED_LIST_TASK),
    (0, $8Bc5A.CALENDAR_VIEW_TASK)
];
const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ciLFO.messages).rootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $ciLFO.messages).reverseTrialRootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $ciLFO.messages).reverseTrialCardTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK)
        ]
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).standardPlanTitle,
        items: [
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $8Bc5A.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
    ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
    ...$ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $8Bc5A.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $8Bc5A.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("ciLFO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $609e253829546460$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $609e253829546460$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("5yUqp", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $80382801c7786de6$export$3ff26c80cb588e12);

var $82B5j = parcelRequire("82B5j");

var $8jC8d = parcelRequire("8jC8d");

var $5PFhq = parcelRequire("5PFhq");
const $80382801c7786de6$export$3ff26c80cb588e12 = {
    taskList: (0, $82B5j.TASK_LIST),
    taskVariants: (0, $82B5j.TASK_VARIANTS),
    userRole: (0, $5PFhq.UserRole),
    experiments: (0, $8jC8d.Experiments)
};

});
parcelRegister("82B5j", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $3b1179694682c8c8$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $3b1179694682c8c8$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $8jC8d = parcelRequire("8jC8d");

var $aQMWP = parcelRequire("aQMWP");

var $5PFhq = parcelRequire("5PFhq");
const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $aQMWP.messages).rootTitle,
        items: [
            (0, $8Bc5A.JWM_CREATE_PROJECT_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK),
            (0, $8Bc5A.GET_STARTED_LIST_TASK),
            (0, $8Bc5A.JWM_CALENDAR_TASK),
            (0, $8Bc5A.JWM_TIMELINE_TASK),
            (0, $8Bc5A.JWM_BUILD_FORM_TASK),
            (0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_SHARE_PROJECT_TASK),
            (0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
    ...$3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
    ...$3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
    [(0, $8Bc5A.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("8jC8d", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $6cd173da51fb2ca8$export$c8d6ffd15214553a);
const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("aQMWP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40755a70921f89dd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40755a70921f89dd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5PFhq", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $637dacd99a3a1727$export$eb3485a690c2f0b8);
const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("5zzQl", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $f17c108f7b3045ad$export$20b82b4a32771893);

var $fNtu3 = parcelRequire("fNtu3");
const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $fNtu3.getConditional)(visibility, variants) : true;
const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, $fNtu3.getConditional)(position, variants);
const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("fNtu3", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $8978a3b25f57d9ac$export$fe3161cde0106bba);
const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("jJca1", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $6249819f9bc2846f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $6249819f9bc2846f$export$a972ed853ed1d469);

var $2vSU6 = parcelRequire("2vSU6");
const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $2vSU6.CORE_PROJECT);
const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});

parcelRegister("d7Knl", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING", () => $98ba598c6688dfac$export$861e712b5b639c2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $98ba598c6688dfac$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $98ba598c6688dfac$export$eb17ad7838835d2a);


var $8Bc5A = parcelRequire("8Bc5A");

var $57ZKw = parcelRequire("57ZKw");

var $i2O9c = parcelRequire("i2O9c");

var $643hq = parcelRequire("643hq");

var $2Ld7w = parcelRequire("2Ld7w");

var $1bW8Q = parcelRequire("1bW8Q");

var $9mlnS = parcelRequire("9mlnS");

var $aRLWM = parcelRequire("aRLWM");

var $8oUbS = parcelRequire("8oUbS");

var $f4rKN = parcelRequire("f4rKN");

var $3YqPl = parcelRequire("3YqPl");

var $xk58e = parcelRequire("xk58e");
const $98ba598c6688dfac$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$36f4d47dfe11b613 = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $aRLWM.MARKETING_VARIANTS),
    ...(0, $8oUbS.OPERATIONS_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$var$getTaskVariants = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e4824f74b9879164:
            return 0, $aRLWM.MARKETING_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52:
            return 0, $8oUbS.OPERATIONS_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$861e712b5b639c2a = {
    taskList: $98ba598c6688dfac$export$601c8c0f45aeb0a0,
    getTaskVariants: $98ba598c6688dfac$var$getTaskVariants
};
const $98ba598c6688dfac$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD),
            (0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG),
            (0, $8Bc5A.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $98ba598c6688dfac$export$83849aa73c0a20db = {
    taskList: $98ba598c6688dfac$export$2757f7b23d120b9b,
    taskVariants: (0, $xk58e.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $98ba598c6688dfac$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$be9c097e18825d4c = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $3YqPl.SOFTWARE_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b:
            return 0, $3YqPl.SOFTWARE_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$eb17ad7838835d2a = {
    taskList: $98ba598c6688dfac$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $98ba598c6688dfac$export$3c409334669aec75
};

});
parcelRegister("57ZKw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b241f4df6ba82218$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b241f4df6ba82218$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("i2O9c", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $c81c85368d94bebb$export$bdd338c80f8962df);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $c81c85368d94bebb$export$bdd338c80f8962df = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("pDX5d", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $c47e1ea5de95ecc4$export$26bc40b960693765);
$parcel$export(module.exports, "TeamTypeWithPrefix", () => $c47e1ea5de95ecc4$export$668a7c1cbabc62a);
$parcel$export(module.exports, "Feature", () => $c47e1ea5de95ecc4$export$6e91cf7616333d5);

const $c47e1ea5de95ecc4$export$26bc40b960693765 = {
    productManagement: (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    projectManagement: (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    design: (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    itSupport: (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    otherPersonal: (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    marketing: (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    operations: (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    software: (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b),
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'everythingElse'
};
const $c47e1ea5de95ecc4$export$668a7c1cbabc62a = {
    productManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $6784cbc7d62e5d7c$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $6784cbc7d62e5d7c$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $6784cbc7d62e5d7c$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $c47e1ea5de95ecc4$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint'
};

});


parcelRegister("643hq", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("2Ld7w", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $d62d711ad5ddd92f$export$a3c4cd8e420f13a);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $d62d711ad5ddd92f$export$a3c4cd8e420f13a = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("1bW8Q", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $09c03dfb484f3e93$export$a25e809b52945082);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $09c03dfb484f3e93$export$a25e809b52945082 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9mlnS", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $6398fc5437bfee58$export$916be3c140ae8c0);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $6398fc5437bfee58$export$916be3c140ae8c0 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("aRLWM", function(module, exports) {

$parcel$export(module.exports, "MARKETING_VARIANTS", () => $ca6dac271f81ec57$export$5580e2b7ba40f572);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $ca6dac271f81ec57$export$5580e2b7ba40f572 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("8oUbS", function(module, exports) {

$parcel$export(module.exports, "OPERATIONS_VARIANTS", () => $7ebba77bc28e7956$export$cd166ee66dc078f4);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $7ebba77bc28e7956$export$cd166ee66dc078f4 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("f4rKN", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $dc653043c34d0d58$export$7a0daeb069f34de3);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $dc653043c34d0d58$export$7a0daeb069f34de3 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("3YqPl", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $136badd6870fea88$export$76a143792cc73994);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $136badd6870fea88$export$76a143792cc73994 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("xk58e", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $70190108b7b6e00a$export$64855550cee11b78);

var $8Bc5A = parcelRequire("8Bc5A");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $70190108b7b6e00a$export$64855550cee11b78 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});




parcelRegister("75A1x", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f9427b1514e1931c$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("1Xkin", function(module, exports) {

$parcel$export(module.exports, "universalDispatch", () => $e706482dec5e8abf$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e706482dec5e8abf$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});


parcelRegister("cGE52", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d175a7a443e10f6d$export$d4c72bab9d6cc13a);

var $8Bc5A = parcelRequire("8Bc5A");
const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    isDevOpsProject: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $8Bc5A.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


parcelRegister("9TQ3l", function(module, exports) {

$parcel$export(module.exports, "AsyncJswOnboardingChecklistInternal", () => $9a33006f56b5e7d2$export$9f3262905af42485);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $9a33006f56b5e7d2$var$Checklist = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("dUc2E")).then(({ JswOnboardingChecklistFinal: JswOnboardingChecklistFinal })=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return JswOnboardingChecklistFinal;
    }), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/checklist/index.tsx"
});
const $9a33006f56b5e7d2$var$ChecklistInternalLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $9a33006f56b5e7d2$export$9f3262905af42485 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-checklist-view-internal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$ChecklistInternalLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$Checklist, null));

});
parcelRegister("dUc2E", function(module, exports) {

let $a1f9d8939f5cc76f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a1f9d8939f5cc76f$var$load("ahxSD"),
    $a1f9d8939f5cc76f$var$load("68Kzv"),
    $a1f9d8939f5cc76f$var$load("3NvtU"),
    $a1f9d8939f5cc76f$var$load("7zMjZ"),
    $a1f9d8939f5cc76f$var$load("a1dBM"),
    $a1f9d8939f5cc76f$var$load("0uhwF")
]).then(()=>parcelRequire('2wwLq'));

});



parcelRegister("eIh4F", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingButtonNext", () => $51c1715fc5801c45$export$bc3535037a418fa9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d8lsH = parcelRequire("d8lsH");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $ACELo = parcelRequire("ACELo");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $6jY6G = parcelRequire("6jY6G");

var $iuzc0 = parcelRequire("iuzc0");

var $ieDtd = parcelRequire("ieDtd");

var $lysGg = parcelRequire("lysGg");
const $51c1715fc5801c45$export$7127386abbb0f79c = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [selectedIssueValue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    const [viewValue] = (0, $ieDtd.useQueryParam)('view');
    const isInRoadMapRoute = (0, $1ffS1.isRoadmapRoute)(route?.name);
    const isInBacklogRoute = route?.name === 'software-backlog';
    const isInBoardRoute = route?.name === 'software-boards';
    const isInRapidBoardBacklogRoute = route?.name === 'rapidboard-backlog';
    const isInRapidBoardBoardRoute = route?.name === 'rapidboard-board';
    // CMP & TMP Roadmap, and TMP backlog & board use selectedIssue query param
    if ((isInRoadMapRoute || isInBacklogRoute || isInBoardRoute) && Boolean(selectedIssueValue)) return true;
    // CMP backlog use view="detail" query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBacklogRoute) return viewValue === 'detail';
    // CMP Active Sprints and Kanban board uses view=detail query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBoardRoute && viewValue === 'detail') return true;
    return false;
};
const $51c1715fc5801c45$export$bc3535037a418fa9 = ()=>{
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const isIssueViewOpened = $51c1715fc5801c45$export$7127386abbb0f79c();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const [{ showQuickstartPill: showQuickstartPill }] = (0, $iuzc0.useQuickstartPillVisibilityStore)();
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading cancelled for page load action
        (0, $353uQ.qsButtonAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonDismissInteraction))) // User interaction completed for QS Button dismiss action
        (0, $353uQ.qsButtonDismissInteraction).stop();
        if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) return;
        // check if quickstart panel is already shown in minimised state in right-hand sidebar
        if (currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID) && isRightSidePanelMinimised === true) return;
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            isRightSidePanelCollapsed: isRightSidePanelMinimised,
            isRightSidePanelMinimised: isRightSidePanelMinimised,
            currentRightSidebarPanelId: currentRightSidebarPanelId || '',
            openRightSidebarAsMinimised: true,
            openRightSidebarToTop: false,
            trigger: 'JswOnboardingButtonNext'
        });
    }, [
        isRightSidePanelMinimised,
        openRightSidebar,
        currentRightSidebarPanelId,
        quickstartStatus,
        createAnalyticsEvent
    ]);
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED || showQuickstartPill !== null && !showQuickstartPill && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.endsWith('/list')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 1,
        id: "software-onboarding-quickstart-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51c1715fc5801c45$var$QuickstartButtonContainer, {
        isIssueViewOpened: isIssueViewOpened,
        "data-testid": "software-onboarding-quickstart.ui.onboarding-button.onboarding-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lysGg.JswOnboardingChecklistButton), null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51c1715fc5801c45$var$QuickstartButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueViewOpened: isIssueViewOpened, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isIssueViewOpened ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ACELo", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $8d24666022201b4c$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $b71gk = parcelRequire("b71gk");

var $hvrWv = parcelRequire("hvrWv");
const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $hvrWv.useBottomRightCornerActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
};
const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d24666022201b4c$var$StyledOutlet = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hvrWv", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $4dcd4c0b25ba3fd4$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $4dcd4c0b25ba3fd4$export$de496fd0e0151c81);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, $3sQ5x.createStateHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, $3sQ5x.createActionsHook)((0, $5e5zm.layoutStore));

});


parcelRegister("lysGg", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistButton", () => $abb3d5d8a2c0e8b0$export$235000cc42ca709a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $paVJb = parcelRequire("paVJb");

var $d8lsH = parcelRequire("d8lsH");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");


var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $4i99S = parcelRequire("4i99S");
const $abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $paVJb.default));
const $abb3d5d8a2c0e8b0$export$235000cc42ca709a = ()=>{
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const [, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, setNudgeStep: setNudgeStep, setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const openChecklist = (0, $4i99S.useOpenChecklist)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [remoteStateFromHook] = (0, $cE2Qr.useJswOnboarding)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const onDismiss = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        (0, $353uQ.qsButtonDismissInteraction).start();
        nextSetChecklistIsDismissed(true);
        setNudgeStep((0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862));
        setHasNudgeActive(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $52Vcw.fireAnalyticsOnQuickstartDismiss)(analyticsEvent, {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }, 'button');
    }, [
        createAnalyticsEvent,
        nextSetChecklistIsDismissed,
        setNudgeStep,
        setHasNudgeActive,
        remoteStateFromHook
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading completed on page load action
        (0, $353uQ.qsButtonAutoLoadTime).stop();
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistMinimiseInteraction))) // User interaction completed for QS Checklist minimise action
        (0, $353uQ.qsChecklistMinimiseInteraction).stop();
    }, []);
    if (currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$TriggerWrapper, {
        reposition: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper, {
        isOpen: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED,
        title: "Quickstart",
        onClick: (event, analyticsEvent)=>{
            (0, $353uQ.qsButtonOpenInteraction).start();
            openChecklist({
                trigger: 'JswOnboardingChecklistButton'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533), {
                projectId: remoteStateFromHook.projectState?.projectId,
                productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
            });
        },
        onDismiss: onDismiss
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abb3d5d8a2c0e8b0$var$TriggerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { reposition: reposition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564vccv _syaz1gjq _80omtlke",
            __cmplp.reposition ? "_otyr8vuz" : "_otyridpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2OMDV", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $28422a5dfa4a4065$export$3e9ef96ba97ea9dc);

var $bG8wy = parcelRequire("bG8wy");
const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $bG8wy.default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $bG8wy = parcelRequire("bG8wy");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $bG8wy.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

// Used for analytics event context for secondary (floating button) view
const $8e02302c3f52a3b4$export$75cc63c8ac8ae533 = 'nuxOnboardingQuickstartButton';

parcelRegister("4i99S", function(module, exports) {

$parcel$export(module.exports, "useOpenChecklist", () => $5c528ffca81c6bae$export$318fa8576ad8aa73);

var $d8lsH = parcelRequire("d8lsH");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");
const $5c528ffca81c6bae$export$318fa8576ad8aa73 = ()=>{
    const [{ openTask: currentOpenTask }, { nextSetChecklistIsOpen: nextSetChecklistIsOpen, nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, nextOpenTask: nextOpenTask }] = (0, $cE2Qr.useJswOnboarding)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentPanelId = currentRightSidebarState?.panelId;
    const openChecklist = ({ trigger: trigger, openTask: openTask })=>{
        if (openTask && openTask !== currentOpenTask) nextOpenTask(openTask);
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), false, true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            currentRightSidebarPanelId: currentPanelId || '',
            openRightSidebarToTop: true,
            trigger: trigger
        });
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED) nextSetChecklistIsDismissed(false);
        else nextSetChecklistIsOpen(true);
    };
    return openChecklist;
};

});



parcelRegister("jTjyt", function(module, exports) {

let $e7b2529692ef9e01$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7b2529692ef9e01$var$load("6Oa3f").then(()=>parcelRequire('jVPxT'));

});


parcelRegister("5VgFy", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $a287374312b47606$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $lrCjX = parcelRequire("lrCjX");

var $h1Skt = parcelRequire("h1Skt");

var $2j8gO = parcelRequire("2j8gO");

var $l4RTn = parcelRequire("l4RTn");
const $a287374312b47606$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest }, ref)=>{
    const onClickHandler = (0, $l4RTn.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2j8gO.RouteLinkItem), {
        ref: ref,
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1Skt.LinkItem), {
        ref: ref,
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrCjX.default), {
        ref: ref,
        onClick: onClickHandler,
        ...rest
    });
});

});
parcelRegister("h1Skt", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $d01d9eadf1c4c537$export$532cb6865ebe8946);

var $5uXOq = parcelRequire("5uXOq");

var $eCx8Q = parcelRequire("eCx8Q");

var $9xqMZ = parcelRequire("9xqMZ");
const $d01d9eadf1c4c537$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, target: target, onClick: onClick, ...rest }, ref)=>{
    const navigate = (0, $9xqMZ.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCx8Q.default), {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ref: ref,
        ...rest
    });
});

});
parcelRegister("9xqMZ", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $58d3fdc92300b506$export$9770f232ac06a008);

var $5uXOq = parcelRequire("5uXOq");

var $lVJAU = parcelRequire("lVJAU");
const $58d3fdc92300b506$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useCallback: useCallback = (0, $5uXOq.useCallback) })=>{
    const { push: push } = useRouterActions();
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("2j8gO", function(module, exports) {

$parcel$export(module.exports, "RouteLinkItem", () => $51491ac4f945fa1d$export$5885e1e37551a766);

var $5uXOq = parcelRequire("5uXOq");

var $bYvZM = parcelRequire("bYvZM");

var $hjSul = parcelRequire("hjSul");
const $51491ac4f945fa1d$export$5885e1e37551a766 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ rel: rel, target: target, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYvZM.default), {
        component: (0, $hjSul.Link),
        rel: rel ?? (target === '_blank' ? 'noopener noreferrer' : ''),
        target: target,
        prefetch: "hover",
        ref: ref,
        ...props
    }));

});

parcelRegister("l4RTn", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $0a514b9f30dcd204$export$a81c45382e7253ac);

var $gDHs4 = parcelRequire("gDHs4");

var $2Ui4E = parcelRequire("2Ui4E");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");
const $0a514b9f30dcd204$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: useAnalyticsEvents = (0, $d8lsH.useAnalyticsEvents), useOverflowStatus: useOverflowStatus = (0, $gDHs4.useOverflowStatus), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) } = {})=>{
    const [, { off: closeMenu }] = useTopMenus();
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});
parcelRegister("2Ui4E", function(module, exports) {

$parcel$export(module.exports, "useTopMenus", () => $77ef209ff15299e4$export$6591d6b6c4546423);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $2qauD = parcelRequire("2qauD");
const { SwitchContainer: $77ef209ff15299e4$var$SwitchContainer, useSwitch: $77ef209ff15299e4$var$useSwitch } = (0, $2qauD.createSwitchController)('atlassian-navigation-top-menus');
const $77ef209ff15299e4$export$45ccf7b2695bac19 = $77ef209ff15299e4$var$SwitchContainer;
const $77ef209ff15299e4$var$useTopMenusBase = $77ef209ff15299e4$var$useSwitch;
const $77ef209ff15299e4$export$6591d6b6c4546423 = (props)=>{
    const switcher = $77ef209ff15299e4$var$useTopMenusBase(props);
    const [{ isOpen: isCommandPaletteOpen }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    const [isSwitchOpen, { off: off }] = switcher;
    (0, $5uXOq.useEffect)(()=>{
        if (isSwitchOpen && isCommandPaletteOpen) off();
    }, [
        isCommandPaletteOpen,
        isSwitchOpen,
        off
    ]);
    return switcher;
};

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $iXqE5.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $3sQ5x.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $3sQ5x.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $6dDSs.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});

parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $1CGxa = parcelRequire("1CGxa");

var $3e6Ej = parcelRequire("3e6Ej");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");

var $feUec = parcelRequire("feUec");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, $7Jxgt.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $7Jxgt.v4)() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $3e6Ej.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $1CGxa.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $feUec.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $3e6Ej.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $3e6Ej.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $1CGxa.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("feUec", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $dd73b01c41e7185b$export$7c0a9f4caaf7cfce);

var $5fc53 = parcelRequire("5fc53");

var $ctrpc = parcelRequire("ctrpc");
const $dd73b01c41e7185b$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $dd73b01c41e7185b$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $dd73b01c41e7185b$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $81f079589240b9b7$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $81f079589240b9b7$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $81f079589240b9b7$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $81f079589240b9b7$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $81f079589240b9b7$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $81f079589240b9b7$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $81f079589240b9b7$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $81f079589240b9b7$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $81f079589240b9b7$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $81f079589240b9b7$export$f4909db381566ce3);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $81f079589240b9b7$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $81f079589240b9b7$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$1e188101081be3f8 = 'forge/string';
const $81f079589240b9b7$export$caf3b3f20c0589b9 = 'forge/string-list';
const $81f079589240b9b7$export$9bdf08a1276e866c = 'forge/number';
const $81f079589240b9b7$export$996c3d3eb2880229 = 'forge/date';
const $81f079589240b9b7$export$578c5856bf684e2a = 'forge/datetime';
const $81f079589240b9b7$export$38791c0fdd0bcce = 'forge/user';
const $81f079589240b9b7$export$5c209e1debd6c274 = 'forge/user-list';
const $81f079589240b9b7$export$8646fecba9a8be61 = 'forge/group';
const $81f079589240b9b7$export$68b91cd2f2e6b810 = 'forge/group-list';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $81f079589240b9b7$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $81f079589240b9b7$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("ctrpc", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $a32e213c0a4381f7$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $a32e213c0a4381f7$export$f3b2b77402b2631f);

var $7Jxgt = parcelRequire("7Jxgt");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $8ikZj = parcelRequire("8ikZj");

var $bximr = parcelRequire("bximr");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $a32e213c0a4381f7$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $7Jxgt.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const FIELD_TYPE_MAP = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $8ikZj.FIELD_TYPE_MAP) : (0, $8ikZj.FIELD_TYPE_MAP_OLD);
    const fieldType = fieldTypeValue && FIELD_TYPE_MAP[fieldTypeValue] ? FIELD_TYPE_MAP[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $8ikZj.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $bximr.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes,
                assigneeId: assigneeId
            });
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
            const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireUIAnalytics)(params.analytics, `${(0, $8ikZj.START_ACTION_SUBJECT)} ${(0, $8ikZj.START_ACTION)}`, (0, $8ikZj.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $bximr.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $8ikZj.UNKNOWN_FIELD_IDS).includes(fieldKey) && (0, $4R6GH.fg)('one_event_rules_them_all_fg');
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $a32e213c0a4381f7$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireTrackAnalytics)(params.analytics, `${(0, $8ikZj.END_ACTION_SUBJECT)} ${(0, $8ikZj.END_ACTION)}`, (0, $8ikZj.END_ACTION_SUBJECT_ID), {
                ...attributes,
                ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                    is_new_1event: true
                }
            });
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const currentAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...currentAttributes,
                ...attributes
            });
        } else $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $bximr.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $a32e213c0a4381f7$export$87846400a9b428fc.reset();
    }
};
const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;

});
parcelRegister("8ikZj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $ba1d12fd09beb370$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $ba1d12fd09beb370$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $ba1d12fd09beb370$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $ba1d12fd09beb370$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $ba1d12fd09beb370$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $ba1d12fd09beb370$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $ba1d12fd09beb370$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP_OLD", () => $ba1d12fd09beb370$export$403ea87111529de);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $ba1d12fd09beb370$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $ba1d12fd09beb370$export$7d9dd31e187cb2db);

var $5fc53 = parcelRequire("5fc53");
const $ba1d12fd09beb370$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
const $ba1d12fd09beb370$export$3b3e3ac6d7f6e219 = 'add';
const $ba1d12fd09beb370$export$6137e1b2fcde2333 = 'remove';
const $ba1d12fd09beb370$export$6d8c364f9d389764 = 'unknown';
const $ba1d12fd09beb370$export$7d1d20ff891eeb26 = [
    $ba1d12fd09beb370$export$6d8c364f9d389764
];
const $ba1d12fd09beb370$export$403ea87111529de = {
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'versions',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.SPRINT_TYPE)]: 'link',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $5fc53.COMPONENTS_TYPE)]: 'components',
    [(0, $5fc53.DATE_CF_TYPE)]: 'date',
    [(0, $5fc53.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $5fc53.DESCRIPTION_TYPE)]: 'richText',
    [(0, $5fc53.DUE_DATE_TYPE)]: 'date',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $5fc53.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $5fc53.GOALS_CF_TYPE)]: 'goals',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.ISSUE_TYPE)]: 'issuetype',
    [(0, $5fc53.LABELS_CF_TYPE)]: 'labels',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.NUMBER_CF_TYPE)]: 'float',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.PARENT_TYPE)]: 'parent',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.PRIORITY_TYPE)]: 'priority',
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.RANK_CF_TYPE)]: 'rank',
    [(0, $5fc53.START_DATE_TYPE)]: 'date',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.SPRINT_TYPE)]: 'sprint',
    [(0, $5fc53.STATUS_TYPE)]: 'status',
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $5fc53.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'version',
    [(0, $5fc53.VOTES_TYPE)]: 'votes',
    [(0, $5fc53.WATCHES_TYPE)]: 'watchers'
};
const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("bximr", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $440267fcdb63291a$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $440267fcdb63291a$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $440267fcdb63291a$export$4cb0aa9574634a48);

var $8ikZj = parcelRequire("8ikZj");
const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $8ikZj.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $8ikZj.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $440267fcdb63291a$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $440267fcdb63291a$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});





parcelRegister("2qauD", function(module, exports) {

$parcel$export(module.exports, "createSwitchController", () => $a539fc33301c42ee$export$1856548326159ec8);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a539fc33301c42ee$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $iXqE5.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $gg7kZ.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $3sQ5x.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $5uXOq.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $5uXOq.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $5uXOq.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});




parcelRegister("6e9wd", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $0fd6665e618bdb77$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $0fd6665e618bdb77$export$6c2f3257abc4825b);

var $5uXOq = parcelRequire("5uXOq");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");
const $0fd6665e618bdb77$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        as: "ul",
        xcss: $0fd6665e618bdb77$var$removeDefaultListStyles
    }, children);
const $0fd6665e618bdb77$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        as: "li",
        xcss: $0fd6665e618bdb77$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $0fd6665e618bdb77$var$removeDefaultListStyles = (0, $aCJg8.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});

});

parcelRegister("lwZRC", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumPubTouchpoint", () => $6a708ba8cfda3999$export$ed538b2b0eb2751);

var $5uXOq = parcelRequire("5uXOq");

var $8xXpg = parcelRequire("8xXpg");
var $5gSBR = parcelRequire("5gSBR");

var $2Ui4E = parcelRequire("2Ui4E");

var $lmyls = parcelRequire("lmyls");

var $koVbs = parcelRequire("koVbs");

var $9Lu9c = parcelRequire("9Lu9c");

var $7CMCs = parcelRequire("7CMCs");

var $cNd4s = parcelRequire("cNd4s");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $cSD7y = parcelRequire("cSD7y");

var $9uGVy = parcelRequire("9uGVy");

var $ca1G2 = parcelRequire("ca1G2");

var $gyBod = parcelRequire("gyBod");

var $lk9cj = parcelRequire("lk9cj");

var $foK1Z = parcelRequire("foK1Z");
function $6a708ba8cfda3999$var$StandardToPremiumUpsellPubTouchpointImpl() {
    const [, { off: closeMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PROFILE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { product: product, edition: edition } = (0, $lk9cj.useProductAndEdition)();
    const { isEligibleForUpsellEa: isEligibleForUpsellEa, cohort: cohort } = (0, $ca1G2.useIsEligibleForUpsellEa)({
        product: product,
        edition: edition,
        isSiteAdmin: isSiteAdmin
    });
    const { hasFetched: hasFetchedDismissedEditionAwarenessPillState, isDismissed: hasDismissedEditionAwarenessPill } = (0, $9uGVy.useIsEditionAwarenessPillDismissed)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessStandardToPremiumPUB');
        closeMenu();
    }, [
        closeMenu,
        createAnalyticsEvent
    ]);
    let isPaidStandard = false;
    if (edition === 'standard') {
        if (product === 'jira') isPaidStandard = (0, $4R6GH.fg)('edition_awareness_upsell_jira_fg');
        if (product === 'jira-service-management') isPaidStandard = (0, $4R6GH.fg)('edition_awareness_upsell_jsm_fg');
    }
    const shouldShowTouchpoint = isEligibleForUpsellEa && cohort === 'treatment' && isPaidStandard && hasFetchedDismissedEditionAwarenessPillState && hasDismissedEditionAwarenessPill && product;
    if (shouldShowTouchpoint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "editionAwarenessStandardToPremiumPUB",
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), null, formatMessage((0, $foK1Z.default).upgrade)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gyBod.StandardToPremiumModalEntrypointTrigger), {
        cloudId: cloudId,
        product: product,
        onClick: handleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Lu9c.EditionAwarenessStandardPubTouchpoint), {
        product: product
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            cohort: cohort,
            flagKey: 'edition_awareness_upsell_jira_ab'
        }
    }));
    return null;
}
function $6a708ba8cfda3999$var$StandardToPremiumPubTouchpointWithErrorBoundary() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "editionAwarenessStandardToPremiumPubTouchpoint",
        packageName: "jiraEditionAwarenessForStandardToPremium",
        fallback: "unmount",
        teamName: "luna-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a708ba8cfda3999$var$StandardToPremiumUpsellPubTouchpointImpl, null));
}
const $6a708ba8cfda3999$export$ed538b2b0eb2751 = (0, $cSD7y.componentWithFG)('edition_awareness_upsell_jira_ab_fg', $6a708ba8cfda3999$var$StandardToPremiumPubTouchpointWithErrorBoundary, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));

});
parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("9uGVy", function(module, exports) {

$parcel$export(module.exports, "useIsEditionAwarenessPillDismissed", () => $16a1e29b9123e8d1$export$7cb865d6d91f9a4d);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $jPvhy = parcelRequire("jPvhy");
const $16a1e29b9123e8d1$export$7cb865d6d91f9a4d = ()=>{
    const [hasFetched, setHasFetched] = (0, $5uXOq.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg')) (0, $jPvhy.fetchEditionAwarenessPillDismissed)().then((result)=>{
            // if result is undefined, it means the call failed and we can't be certain if the user dismissed the pill or not
            if (result !== undefined) {
                setIsDismissed(!!result);
                setHasFetched(true);
            }
        });
    }, []);
    const handleDismiss = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg')) {
            setIsDismissed(true);
            (0, $jPvhy.setEditionAwarenessPillDismissed)(true);
        }
    }, []);
    return {
        hasFetched: hasFetched,
        isDismissed: isDismissed,
        handleDismiss: handleDismiss
    };
};

});
parcelRegister("jPvhy", function(module, exports) {

$parcel$export(module.exports, "setEditionAwarenessPillDismissed", () => $439f9424d8ca41fa$export$b0b754c480c139ac);
$parcel$export(module.exports, "fetchEditionAwarenessPillDismissed", () => $439f9424d8ca41fa$export$1eb6cd4dd0048115);

var $aHuqL = parcelRequire("aHuqL");

var $jcw0u = parcelRequire("jcw0u");

const $439f9424d8ca41fa$var$ProductKeyToHAMSMap = {
    jira: 'jira-software',
    'jira-product-discovery': 'jira-product-discovery',
    'jira-service-management': 'jira-servicedesk'
};
const $439f9424d8ca41fa$export$291d012eb0744b34 = (product)=>{
    return $439f9424d8ca41fa$var$ProductKeyToHAMSMap[product];
};
const $439f9424d8ca41fa$export$b0b754c480c139ac = async (value)=>{
    try {
        await (0, $aHuqL.userPreferenceAPI).set((0, $27f794e239d3d8c4$export$83e119fb36bc846a), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'setEditionAwarenessPillDismissed',
                packageName: (0, $27f794e239d3d8c4$export$52483b87432059f1)
            }
        });
    }
};
const $439f9424d8ca41fa$export$1eb6cd4dd0048115 = async ()=>{
    try {
        return await (0, $aHuqL.userPreferenceAPI).get((0, $27f794e239d3d8c4$export$83e119fb36bc846a));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode === 404) return null;
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'fetchEditionAwarenessPillDismissed',
                packageName: (0, $27f794e239d3d8c4$export$52483b87432059f1)
            }
        });
        return undefined;
    }
};

});
const $27f794e239d3d8c4$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $27f794e239d3d8c4$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';



parcelRegister("ca1G2", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForUpsellEa", () => $19c1cd17daaf5951$export$d937ac4841c15ef7);
/* eslint-disable jira/ff/unsafe-no-exposure */ /* eslint-disable jira/deprecations/ban-identifiers */ 

var $1laI5 = parcelRequire("1laI5");

var $5oBMG = parcelRequire("5oBMG");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");
const $19c1cd17daaf5951$export$d937ac4841c15ef7 = ({ product: product, edition: edition, isSiteAdmin: isSiteAdmin })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('edition_awareness_upsell_jira_ab');
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    // Enrollment logic
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const enrolled = cohort !== 'not-enrolled';
    // Trial State logic
    let productKey;
    switch(product){
        case 'jira':
            productKey = (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
            break;
        case 'jira-service-management':
            productKey = (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61);
            break;
        default:
    }
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const trialEndTime = entitlementDetails?.trialEndTime;
    const trialDaysLeft = (0, $1laI5.getTrialDaysLeft)(trialEndTime);
    const isInTrial = !entitlementDetails ? undefined : !!trialDaysLeft && trialDaysLeft > 0;
    const isEligibleForUpsellEa = edition === 'standard' && enrolled && isInTrial === false && isSiteAdmin && (0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg');
    return {
        isEligibleForUpsellEa: isEligibleForUpsellEa,
        cohort: cohort
    };
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("1laI5", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $39ed199f3e5d9f33$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $39ed199f3e5d9f33$export$1af4fd6f5c543149);

var $2vSU6 = parcelRequire("2vSU6");

const $39ed199f3e5d9f33$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $39ed199f3e5d9f33$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($39ed199f3e5d9f33$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $39ed199f3e5d9f33$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $39ed199f3e5d9f33$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $39ed199f3e5d9f33$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $2vSU6.SOFTWARE_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});

parcelRegister("5oBMG", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $3295ae4955475ae4$export$e02d6385b5d47f5d);

var $9OXo1 = parcelRequire("9OXo1");
const $3295ae4955475ae4$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});


parcelRegister("gyBod", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumModalEntrypointTrigger", () => $a2a14da66d3e934c$export$976615bbf89d8782);

var $5uXOq = parcelRequire("5uXOq");

var $lrCjX = parcelRequire("lrCjX");

var $2KAtx = parcelRequire("2KAtx");

var $j5c4k = parcelRequire("j5c4k");
var $iJZxX = parcelRequire("iJZxX");

var $hYoRS = parcelRequire("hYoRS");
const $a2a14da66d3e934c$export$976615bbf89d8782 = ({ children: children, cloudId: cloudId, product: product, onClick: onClick })=>{
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            product: product
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $hYoRS.standardToPremiumModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "standard-to-premium-modal",
        useInternalModal: true,
        modalProps: {
            width: 'x-large',
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true
        }
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j5c4k.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJZxX.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrCjX.default), {
            onClick: onClick,
            ref: ref
        }, children))));
};

});
parcelRegister("2KAtx", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $a17c22dd70443cfd$export$defad645fcc21c0a);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2Thxw = parcelRequire("2Thxw");

var $fMEf8 = parcelRequire("fMEf8");
var $kAVuS = parcelRequire("kAVuS");
var $b6pOP = parcelRequire("b6pOP");
var $cJFFz = parcelRequire("cJFFz");

var $57J83 = parcelRequire("57J83");

var $gHH2p = parcelRequire("gHH2p");

var $7NYq5 = parcelRequire("7NYq5");

var $4R6GH = parcelRequire("4R6GH");

var $9fuVs = parcelRequire("9fuVs");

var $c5vfY = parcelRequire("c5vfY");

var $7mPT9 = parcelRequire("7mPT9");

var $gJdig = parcelRequire("gJdig");

var $fiv1r = parcelRequire("fiv1r");

var $dWBzX = parcelRequire("dWBzX");
const $a17c22dd70443cfd$var$emptyObject = {};
const $a17c22dd70443cfd$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $gJdig.ModalContext));
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $5uXOq.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $gHH2p.default)(metricName);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6pOP.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFFz.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57J83.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMEf8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAVuS.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                    onClose: onClose,
                    ...(0, $4R6GH.fg)('jpo-31059_modal_close_behaviour_controls') ? {
                        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                        shouldCloseOnEscapePress: shouldCloseOnEscapePress
                    } : {}
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                ...(0, $4R6GH.fg)('jpo-31059_modal_close_behaviour_controls') ? {
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
                } : {}
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps
    ]);
    const triggerRef = (0, $dWBzX.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    if (forwardedRef != null) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = (0, $7mPT9.default)(triggerRef, forwardedRef);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return children({
            ref: ref
        });
    }
    return children({
        ref: triggerRef
    });
};

});
parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});

parcelRegister("7mPT9", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $d1da29f25d5b5e0a$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $d1da29f25d5b5e0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
    return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("dWBzX", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $01294bc664dce1e5$export$1ff47f24e06a5d2d);

var $5uXOq = parcelRequire("5uXOq");
const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
            }, $01294bc664dce1e5$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("hYoRS", function(module, exports) {

$parcel$export(module.exports, "standardToPremiumModalEntryPoint", () => $e5cfaf5eabd8c4a0$export$e2f72ec158f4526d);

var $cluFV = parcelRequire("cluFV");

var $29g2n = parcelRequire("29g2n");

const $e5cfaf5eabd8c4a0$export$e2f72ec158f4526d = (0, $29g2n.createEntryPoint)({
    root: (0, $cluFV.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("25Lmi"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "d31b6b17"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("25Lmi", function(module, exports) {

let $1860c8d771498367$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1860c8d771498367$var$load("lDnNJ").then(()=>parcelRequire('6Zwhu'));

});



parcelRegister("lk9cj", function(module, exports) {

$parcel$export(module.exports, "useProductAndEdition", () => $10793f21f1ca9c0d$export$b0f1c0403c557678);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $lpwtK = parcelRequire("lpwtK");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $4SswE = parcelRequire("4SswE");
const $10793f21f1ca9c0d$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { loading: loading, data: project } = (0, $lpwtK.useProject)();
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $5uXOq.useMemo)(()=>{
        if (loading) return;
        const type = (0, $2vSU6.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $2vSU6.SOFTWARE_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
    const localEdition = (0, $5uXOq.useMemo)(()=>{
        if (!projectType) return;
        return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType
    ]);
    const { product: product, edition: edition } = (0, $5uXOq.useMemo)(()=>{
        if (!projectType || !localEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $2vSU6.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $10793f21f1ca9c0d$var$getEaProduct(projectType),
            edition: $10793f21f1ca9c0d$var$getEaEdition(localEdition)
        };
    }, [
        localEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};
const $10793f21f1ca9c0d$var$getEaEdition = (e)=>{
    if (e === 'FREE_EDITION') return 'free';
    if (e === 'STANDARD_EDITION') return 'standard';
    if (e === 'PREMIUM_EDITION') return 'premium';
};
const $10793f21f1ca9c0d$var$getEaProduct = (p)=>{
    if (p === (0, $2vSU6.SOFTWARE_PROJECT)) return 'jira';
    if (p === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return 'jira-product-discovery';
    if (p === (0, $2vSU6.SERVICE_DESK_PROJECT)) return 'jira-service-management';
    if (p === (0, $2vSU6.CORE_PROJECT)) return 'jira';
};

});
parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

parcelRegister("4SswE", function(module, exports) {

$parcel$export(module.exports, "useSiteHasOnlyJira", () => $b6d886096eb5e5b4$export$8ce0db5ac54a6136);

var $cVzoY = parcelRequire("cVzoY");


var $9OXo1 = parcelRequire("9OXo1");
function $b6d886096eb5e5b4$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $cVzoY.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});
parcelRegister("cVzoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $386aacc800b616d8$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
    licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
    return result;
};

});



parcelRegister("foK1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f40dea63877669$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $11f40dea63877669$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgrade: {
        "id": "jira-edition-awareness-for-standard-to-premium.standard-to-premium-pub-touchpoint.menu.upgrade",
        "defaultMessage": "Upgrade"
    }
});

});


parcelRegister("ckmlX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cda9ec250c8f96e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8cda9ec250c8f96e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation-nav4.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation-nav4.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation-nav4.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation-nav4.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation-nav4.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation-nav4.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation-nav4.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation-nav4.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation-nav4.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});

parcelRegister("j6Dnq", function(module, exports) {

$parcel$export(module.exports, "ExtraItemsNav4", () => $f13d910bb1a99a5c$export$ee2972db91c46b97);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $5gSBR = parcelRequire("5gSBR");

var $hrlU6 = parcelRequire("hrlU6");

var $6cNb0 = parcelRequire("6cNb0");

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");

var $5VgFy = parcelRequire("5VgFy");

var $6e9wd = parcelRequire("6e9wd");
const $f13d910bb1a99a5c$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $f13d910bb1a99a5c$var$Item = ({ url: url, name: name, id: id, styleClass: styleClass, itemAriaLabel: itemAriaLabel, position: position, testId: testId })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const isDialog = styleClass && (0, $hrlU6.isConnectDialogWebItem)(styleClass);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (styleClass && webItemRef.current) connectHost.triggerWebItem(webItemRef.current, styleClass, url);
        });
    }, [
        isDialog,
        styleClass,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e9wd.MenuListItem), {
        key: url,
        ariaLabel: itemAriaLabel || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5VgFy.MenuItem), {
        ref: webItemRef,
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'jira',
            position: position
        },
        href: isDialog ? undefined : url,
        onClick: isDialog ? onClick : undefined,
        testId: testId
    }, name));
};
const $f13d910bb1a99a5c$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $f13d910bb1a99a5c$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f13d910bb1a99a5c$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};
const $f13d910bb1a99a5c$export$ee2972db91c46b97 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $f13d910bb1a99a5c$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true
    }, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f13d910bb1a99a5c$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};

});
parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("eUcfq"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");

var $wRU6t = parcelRequire("wRU6t");

var $jcw0u = parcelRequire("jcw0u");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: new Error((0, $wRU6t.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("eUcfq", function(module, exports) {

let $ad9fcbc8b7dd2263$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad9fcbc8b7dd2263$var$load("cDZc9").then(()=>parcelRequire('8vJyT'));

});





parcelRegister("904lL", function(module, exports) {

$parcel$export(module.exports, "useUserBoardId", () => $8c0c1ab8ec5b52ee$export$e6e895063f36c814);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $8c0c1ab8ec5b52ee$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $5uXOq.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $eusud.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});
parcelRegister("6yXtV", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $44de65c7edb80809$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $44de65c7edb80809$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $44de65c7edb80809$export$41e70078eeddaddc);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3sQ5x = parcelRequire("3sQ5x");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $44de65c7edb80809$export$ea2491906b753456 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $44de65c7edb80809$export$e6897aa59ee7aee5
});
const $44de65c7edb80809$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady
        }));
const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady,
            args: comparer
        }));

});


parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) return null;
    return entryPointReference;
};

});


parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jp5kW = parcelRequire("jp5kW");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) {
            // Delay clean up to prioritise render cycle in case
            // prior queries get used again
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
            });
        } else // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root) && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $1be876415a945060$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("cLIpE", function(module, exports) {

$parcel$export(module.exports, "Nav4ProfileMenuEntryPoint", () => $876c2695d1976e10$export$e30a856958207b6);

var $cluFV = parcelRequire("cluFV");

var $29g2n = parcelRequire("29g2n");

var $bVJxC = parcelRequire("bVJxC");

const $876c2695d1976e10$export$e30a856958207b6 = (0, $29g2n.createEntryPoint)({
    root: (0, $cluFV.JSResourceForInteraction)(()=>(parcelRequire("77UOv")), {
        moduleId: "18b1d8bb"
    }),
    getPreloadProps: ({ includeExtraMenuItems: includeExtraMenuItems })=>({
            queries: {
                profileMenuQuery: {
                    parameters: $bVJxC.default,
                    variables: {
                        includeExtraMenuItems: includeExtraMenuItems
                    }
                }
            }
        })
});

});
parcelRegister("bVJxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5925de38e3f3e959$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc9c2fcd14832ff6f021278465d2a9bc>>
 * @relayHash 73520ae724cd725d1b8a9eaf5e2c16fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2757426f0a0e166111d8064199946a10478bc2b410dc09def2c817aed218a3c8
const $5925de38e3f3e959$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2757426f0a0e166111d8064199946a10478bc2b410dc09def2c817aed218a3c8",
        "metadata": {},
        "name": "profileMenuQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5925de38e3f3e959$export$2e2bcd8739ae039 = $5925de38e3f3e959$var$node;

});

parcelRegister("77UOv", function(module, exports) {

let $530541de98dab6dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $530541de98dab6dc$var$load("fiCXI").then(()=>parcelRequire('eWrtG'));

});



parcelRegister("ihoTN", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $c48aa6999eaeefe6$export$3e157e0d79928990);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $c48aa6999eaeefe6$export$3e157e0d79928990 = ()=>(0, $5uXOq.useMemo)(()=>({
            shouldShow: (0, $j8DrX.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $j8DrX.default)('ajs-app-title')
        }), []);

});




parcelRegister("13iNl", function(module, exports) {

$parcel$export(module.exports, "recommendations", () => $56dde49bc4054ac6$export$b7e5cef71fa42514);

var $a334R = parcelRequire("a334R");


const $56dde49bc4054ac6$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $a334R.default));
    // Add your own templates
    return recommendationsList;
};
const $56dde49bc4054ac6$export$b7e5cef71fa42514 = $56dde49bc4054ac6$var$createRecommendationsList();

});
parcelRegister("a334R", function(module, exports) {

$parcel$export(module.exports, "default", () => $fccc347b1e897d64$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b5TAp = parcelRequire("b5TAp");

var $lCxEI = parcelRequire("lCxEI");
var $ayD7W = parcelRequire("ayD7W");

var $7l0wY = parcelRequire("7l0wY");

var $2xRxR = parcelRequire("2xRxR");

var $6YerV = parcelRequire("6YerV");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $90yGq = parcelRequire("90yGq");

var $2tT7R = parcelRequire("2tT7R");

var $cuYMh = parcelRequire("cuYMh");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $iKwST = parcelRequire("iKwST");

var $5ZJgM = parcelRequire("5ZJgM");

var $9SPvU = parcelRequire("9SPvU");

var $kwgZt = parcelRequire("kwgZt");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");

var $66CIA = parcelRequire("66CIA");

var $77N15 = parcelRequire("77N15");

var $hb557 = parcelRequire("hb557");

var $5RxQU = parcelRequire("5RxQU");

var $7Y8xQ = parcelRequire("7Y8xQ");
const $fccc347b1e897d64$export$da956fe610b96f73 = ()=>{
    const [moreInformationModal, setMoreInformationModal] = (0, $5uXOq.useState)(false);
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $cuYMh.useFireCrossFlowAnalyticsEvents)();
    const [, { setRecommendationDismissal: setRecommendationDismissal }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const accountId = (0, $90yGq.useAccountId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const crossFlow = (0, $lCxEI.useCrossFlow)();
    const environment = (0, $2tT7R.useEnvironment)();
    const jpdCloudCCPProductID = (0, $hb557.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    (0, $5uXOq.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        }, {
            navigationVersion: 'v3'
        });
        else (0, $jcw0u.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $5uXOq.useCallback)(async (templateId)=>{
        const extensions = (0, $b5TAp.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $b5TAp.Behaviours).LAND,
                    prompt: (0, $b5TAp.Prompts).NEXT,
                    options: {
                        targetTab: (0, $b5TAp.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) crossFlow.apiV1.open({
            journey: (0, $lCxEI.Journeys).GET_STARTED,
            targetProduct: (0, $ayD7W.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions,
            v1: true
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        openCrossFlow((0, $hb557.JPD_ROADMAP_KEY));
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        openCrossFlow
    ]);
    const onLearnMoreClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setMoreInformationModal(true);
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onLearnMoreClosed = (0, $5uXOq.useCallback)(()=>{
        setMoreInformationModal(false);
    }, []);
    const onDismissClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setRecommendationDismissal();
        if (accountId) (0, $89SaW.setUserProperties)(accountId, (0, $hb557.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>(0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: 'jiraAtlassianNavigationRecommendations',
                    teamName: 'navigation'
                }
            }));
    }, [
        accountId,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        setRecommendationDismissal
    ]);
    const onClickPrivacyPolicy = (0, $5uXOq.useCallback)(()=>{
        const clickedLinkBaseEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKwST.RecommendationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZJgM.RecommendationHeader), {
        title: formatMessage((0, $5RxQU.default).recommendedText),
        onDismissClicked: onDismissClicked,
        onLearnMoreClicked: onLearnMoreClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9SPvU.RecommendationMenuItem), {
        title: formatMessage((0, $5RxQU.default).projectTitleProductRoadmap),
        description: formatMessage((0, $5RxQU.default).projectDescriptionProductRoadmap),
        onClick: onRecommendationClicked,
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xRxR.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $5RxQU.default).lozengeText)),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $77N15.default), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kwgZt.RecommendationModal), {
        isOpen: moreInformationModal,
        onClose: onLearnMoreClosed,
        title: formatMessage((0, $5RxQU.default).reasonsModalTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $5RxQU.default).reasonsModalExplanation, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6YerV.default), {
                    as: "strong"
                }, chunks)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $5RxQU.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $5RxQU.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7l0wY.default), {
            appearance: "link",
            spacing: "none",
            href: (0, $hb557.DATA_PRIVACY_LINK),
            target: "_blank",
            onClick: onClickPrivacyPolicy
        }, formatMessage((0, $5RxQU.default).privacyPolicy))),
        primaryCta: formatMessage((0, $5RxQU.default).reasonsModalButtonOk)
    }));
};
const $fccc347b1e897d64$var$checkEligibility = async (recommendationContext, analyticsEvent)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, canCreateProject: canCreateProject, accountId: accountId, cloudId: cloudId, environment: environment, isInFedRamp: isInFedRamp } = recommendationContext;
    if ((0, $4R6GH.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $7Y8xQ.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (!canCreateProject) return {
        isEligible: false,
        reason: 'User cannot create projects'
    };
    if (isInFedRamp) return {
        isEligible: false,
        reason: 'User is in FedRamp'
    };
    const [dismissed, appRecommendations] = await Promise.all([
        (0, $89SaW.getUserProperty)(accountId, (0, $hb557.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY)).catch((error)=>{
            // If not found, then the user hasn't dismissed the ad.
            // 404 - user property not found,
            if (error.statusCode === 404) return false;
            const expectedErrors = [
                429,
                // rate limit exceeded
                401,
                // unauthorised
                403,
                // forbidden
                null,
                // client error
                undefined // client error
            ];
            // 50x - network errors
            // We shouldn't see the recommendation
            if (expectedErrors.includes(error.statusCode) || error.statusCode >= 500 || (0, $fZneA.isClientFetchError)(error)) return true;
            throw Error(`${error.statusCode}, JPD recommendation dismissal failed. ${error.name}: ${error.message}`, error);
        }),
        (0, $66CIA.fetchAppRecommendations)(cloudId, environment, analyticsEvent)
    ]);
    if (dismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((recommendation)=>recommendation?.entityId === (0, $hb557.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fccc347b1e897d64$export$2e2bcd8739ae039 = {
    key: (0, $hb557.JPD_RECOMMENDATION_KEY),
    shouldRender: async (recommendationContext, analyticsEvent)=>{
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).start();
        const { isEligible: isEligible, reason: reason } = await $fccc347b1e897d64$var$checkEligibility(recommendationContext, analyticsEvent);
        if ((0, $4R6GH.fg)('pm_jpd_reco_operational_event_activated')) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).success();
        return isEligible;
    },
    onLoadError: (error)=>{
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).failure();
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'loadJpdRecommendation',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    },
    Component: $fccc347b1e897d64$export$da956fe610b96f73
};

});
parcelRegister("2tT7R", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $6bd66e47d4948917$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $6bd66e47d4948917$export$b0d8f74f433a09c9);

var $9OXo1 = parcelRequire("9OXo1");
const $6bd66e47d4948917$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
};
const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
    const env = $6bd66e47d4948917$export$ea7ed2425832167d();
    return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("iKwST", function(module, exports) {

$parcel$export(module.exports, "RecommendationContainer", () => $3f1017feb0eddea7$export$97f31f44c68c1d5);

var $5uXOq = parcelRequire("5uXOq");

var $5gSBR = parcelRequire("5gSBR");

var $iXVV6 = parcelRequire("iXVV6");
const $3f1017feb0eddea7$export$97f31f44c68c1d5 = ({ children: children, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true
    }, children));

});

parcelRegister("5ZJgM", function(module, exports) {

$parcel$export(module.exports, "RecommendationHeader", () => $04eaa3b92b265d65$export$3beeaceb068c75b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7l0wY = parcelRequire("7l0wY");

var $lsVF8 = parcelRequire("lsVF8");

var $2FBMc = parcelRequire("2FBMc");

var $lrCjX = parcelRequire("lrCjX");
var $68Yq0 = parcelRequire("68Yq0");
var $5gSBR = parcelRequire("5gSBR");

var $dWgDh = parcelRequire("dWgDh");
var $aCJg8 = parcelRequire("aCJg8");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $9xvcL = parcelRequire("9xvcL");
const $04eaa3b92b265d65$export$3beeaceb068c75b1 = ({ title: title, onDismissClicked: onDismissClicked, onLearnMoreClicked: onLearnMoreClicked })=>{
    const [isActionsMenuOpen, setIsActionsMenuOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWgDh.default), {
        xcss: $04eaa3b92b265d65$var$HeadingItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsVF8.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWgDh.default), {
        xcss: $04eaa3b92b265d65$var$TitleItemStyles
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isActionsMenuOpen,
        placement: "bottom-start",
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-header.popup",
        messageType: "transactional",
        onClose: ()=>setIsActionsMenuOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $68Yq0.default), {
                onClick: (e)=>e.stopPropagation()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrCjX.default), {
                onClick: onDismissClicked
            }, formatMessage((0, $9xvcL.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrCjX.default), {
                onClick: onLearnMoreClicked
            }, formatMessage((0, $9xvcL.default).learnMoreButtonText)))),
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04eaa3b92b265d65$var$MeatballMenuTrigger, {
                ...triggerProps,
                appearance: "subtle",
                onClick: ()=>setIsActionsMenuOpen(()=>!isActionsMenuOpen),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2FBMc))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: formatMessage((0, $9xvcL.default).moreButtonLabel, {
                        title: title
                    })
                })
            }),
        shouldRenderToParent: true
    }));
};
const $04eaa3b92b265d65$var$HeadingItemStyles = (0, $aCJg8.xcss)({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    marginTop: 'space.050'
});
const $04eaa3b92b265d65$var$TitleItemStyles = (0, $aCJg8.xcss)({
    color: 'color.text.accent.gray'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04eaa3b92b265d65$var$MeatballMenuTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $7l0wY.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _4t3izwfg _1di6fg4m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $gFVv0 = parcelRequire("gFVv0");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFVv0.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $gFVv0 = parcelRequire("gFVv0");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $gFVv0.Popup), 'isOpen', 'content');

});


parcelRegister("9xvcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa08673ea438366b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa08673ea438366b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    moreButtonLabel: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.more-button-label",
        "defaultMessage": "More options for {title} section"
    }
});

});


parcelRegister("9SPvU", function(module, exports) {

$parcel$export(module.exports, "RecommendationMenuItem", () => $56fe10413c20ceb0$export$aab9ce3de285230c);

var $5uXOq = parcelRequire("5uXOq");

var $eCx8Q = parcelRequire("eCx8Q");

var $8fabB = parcelRequire("8fabB");
var $dWgDh = parcelRequire("dWgDh");
const $56fe10413c20ceb0$export$aab9ce3de285230c = ({ iconBefore: iconBefore, onClick: onClick, title: title, lozenge: lozenge = null, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCx8Q.default), {
        iconBefore: iconBefore,
        onClick: onClick,
        description: description,
        href: "#"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWgDh.default), {
        space: "space.100"
    }, title, lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), null, lozenge)));

});

parcelRegister("kwgZt", function(module, exports) {

$parcel$export(module.exports, "RecommendationModal", () => $6e7f095537455847$export$d5c06ba24e862b67);

var $5uXOq = parcelRequire("5uXOq");

var $7l0wY = parcelRequire("7l0wY");

var $fMEf8 = parcelRequire("fMEf8");
var $kAVuS = parcelRequire("kAVuS");
var $b6pOP = parcelRequire("b6pOP");
var $cJFFz = parcelRequire("cJFFz");
var $h9io3 = parcelRequire("h9io3");

var $6YerV = parcelRequire("6YerV");

var $7NYq5 = parcelRequire("7NYq5");
const $6e7f095537455847$export$d5c06ba24e862b67 = ({ isOpen: isOpen, onClose: onClose, title: title, body: body, primaryCta: primaryCta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9io3.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-modal.modal",
        messageType: "transactional",
        shouldCloseOnEscapePress: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6pOP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFFz.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMEf8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6YerV.default), {
        as: "p"
    }, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAVuS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7l0wY.default), {
        appearance: "primary",
        onClick: onClose
    }, primaryCta))));

});

parcelRegister("cmzJ2", function(module, exports) {

$parcel$export(module.exports, "useProjectMenuRecommendations", () => $5442a73b6e3e578d$export$d4048a5b8ab1acff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5hXPP = parcelRequire("5hXPP");
const $5442a73b6e3e578d$var$initialState = {
    status: 'idle'
};
const $5442a73b6e3e578d$var$store = (0, $iXqE5.createStore)({
    actions: $5hXPP.actions,
    initialState: $5442a73b6e3e578d$var$initialState,
    name: 'atlassian-navigation-recommendation'
});
const $5442a73b6e3e578d$export$d4048a5b8ab1acff = (0, $3sQ5x.createHook)($5442a73b6e3e578d$var$store);

});
parcelRegister("5hXPP", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5033aa90e3adb7fd$export$e324594224ef24da);

var $s7Ri8 = parcelRequire("s7Ri8");
const $5033aa90e3adb7fd$export$e95368803793838f = (recommendations, recommendationContext, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { status: status } = getState();
        if (status !== 'idle') return;
        setState({
            status: 'loading'
        });
        const shuffledRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($s7Ri8)))(recommendations);
        try {
            const recommendationStatus = await Promise.all(shuffledRecommendations.map(async (recommendation)=>{
                let isEnabled = false;
                try {
                    isEnabled = await recommendation.shouldRender(recommendationContext, analyticsEvent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    recommendation.onLoadError(error);
                }
                return {
                    key: recommendation.key,
                    isEnabled: isEnabled
                };
            }));
            const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
            setState({
                status: 'success',
                recommendationKey: selectedRecommendation?.key || null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                status: 'error',
                error: error
            });
        }
    };
const $5033aa90e3adb7fd$var$setRecommendationDismissal = ()=>({ setState: setState })=>{
        setState({
            recommendationKey: null
        });
    };
const $5033aa90e3adb7fd$export$e324594224ef24da = {
    loadRecommendations: $5033aa90e3adb7fd$export$e95368803793838f,
    setRecommendationDismissal: $5033aa90e3adb7fd$var$setRecommendationDismissal
};

});


parcelRegister("kklBj", function(module, exports) {

$parcel$export(module.exports, "projectsMenuDropdownRecommendationSelector", () => $4c06b486be8bb39b$export$2b83859c1548ffb5);
$parcel$export(module.exports, "projectsMenuDropdownLoadJpdRecommendation", () => $4c06b486be8bb39b$export$a784c5bbb21ea554);

var $jpBWy = parcelRequire("jpBWy");
var $Syify = parcelRequire("Syify");
const $4c06b486be8bb39b$export$2b83859c1548ffb5 = new (0, $Syify.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $jpBWy.ExperienceTypes).Experience,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).InlineResult
});
const $4c06b486be8bb39b$export$a784c5bbb21ea554 = new (0, $Syify.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $jpBWy.ExperienceTypes).Experience,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("66CIA", function(module, exports) {

$parcel$export(module.exports, "fetchAppRecommendations", () => $78725ead7cfc4b7c$export$8665956217263d00);

var $5rZL1 = parcelRequire("5rZL1");

var $8Uumt = parcelRequire("8Uumt");

var $8zOmE = parcelRequire("8zOmE");

var $fZneA = parcelRequire("fZneA");


var $6FSDe = parcelRequire("6FSDe");
const $78725ead7cfc4b7c$export$f2d50cdc12f57d0b = (0, $5rZL1.default);
const $78725ead7cfc4b7c$export$8665956217263d00 = async (cloudId, environment, analyticsEvent)=>{
    const appRecommendationState = (0, $6FSDe.getCachedAppRecommendationState)();
    if (appRecommendationState !== null && Date.now() - appRecommendationState.fetchRecommendationTimeStamp < (0, $3202ab0bf207425f$export$424ba99fce04562)) return appRecommendationState.appRecommendations ?? [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const data = await (0, $8Uumt.fetchQuery)(environment, $78725ead7cfc4b7c$export$f2d50cdc12f57d0b, {
        cloudId: cloudId
    }).toPromise().catch((err)=>{
        const expectedErrors = [
            401,
            // Unauthorised
            403,
            // Forbidden
            null,
            // Client error
            undefined // Client error
        ];
        if (expectedErrors.includes(err.statusCode) || (0, $fZneA.isClientFetchError)(err)) return {};
        throw Error(`App recommendation ${err.name} error: ${err.message}`, {
            cause: err
        });
    });
    const appRecommendations = data?.growthRecommendations?.recommendations?.data;
    if (!appRecommendations) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.fetchAppRecommendations empty', {
        response: `${JSON.stringify(data)}`
    });
    (0, $6FSDe.setCachedAppRecommendationState)({
        appRecommendations: appRecommendations,
        fetchRecommendationTimeStamp: Date.now()
    });
    return appRecommendations ?? [];
};

});
parcelRegister("5rZL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $739e1bf50f170603$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63d29fc2e4b7b13b5431ad6d77aafb97>>
 * @relayHash e631e61cba47acbda6811ed1a287d9f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86
const $739e1bf50f170603$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v2 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "growthRecommendations.recommendations.data.entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86",
            "metadata": {},
            "name": "fetchAppRecommendationsV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$739e1bf50f170603$var$node.hash = "eaaab66d3f41b01ce8e8a969a422ff60";
var $739e1bf50f170603$export$2e2bcd8739ae039 = $739e1bf50f170603$var$node;

});

const $3202ab0bf207425f$export$424ba99fce04562 = 600000;

parcelRegister("6FSDe", function(module, exports) {

$parcel$export(module.exports, "setCachedAppRecommendationState", () => $69d5e6aa5b3a01d0$export$4bb2da71ae03947f);
$parcel$export(module.exports, "getCachedAppRecommendationState", () => $69d5e6aa5b3a01d0$export$951c5f8396f4dcb);

var $bSSG7 = parcelRequire("bSSG7");
const $69d5e6aa5b3a01d0$var$store = (0, $bSSG7.createLocalStorageProvider)('projects-menu-jpd-recommendation');
const $69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE = 'app-recommendation-state';
function $69d5e6aa5b3a01d0$export$4bb2da71ae03947f(appRecommendationState) {
    $69d5e6aa5b3a01d0$var$store.set($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE, JSON.stringify(appRecommendationState));
}
function $69d5e6aa5b3a01d0$export$951c5f8396f4dcb() {
    const state = $69d5e6aa5b3a01d0$var$store.get($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE);
    return state ? JSON.parse(state) : null;
}
function $69d5e6aa5b3a01d0$export$a73955031198b1b8() {
    $69d5e6aa5b3a01d0$var$store.remove($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE);
}

});


parcelRegister("77N15", function(module, exports) {

$parcel$export(module.exports, "default", () => $29218c4ee11cd071$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jzjnR = parcelRequire("jzjnR");

var $9VPNI = parcelRequire("9VPNI");
const $29218c4ee11cd071$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jzjnR.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9VPNI))),
        name: "Jira Product Discovery Roadmap Template"
    });
};
var $29218c4ee11cd071$export$2e2bcd8739ae039 = $29218c4ee11cd071$var$ProductRoadmapProjectAvatar;

});
parcelRegister("9VPNI", function(module, exports) {
module.exports = new URL("product-roadmap-project-icon.7eb40fb0.svg", import.meta.url).toString();

});


parcelRegister("hb557", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $aa2162acaf3862c0$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $aa2162acaf3862c0$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $aa2162acaf3862c0$export$52b9dedc0088f8);
$parcel$export(module.exports, "DATA_PRIVACY_LINK", () => $aa2162acaf3862c0$export$aefe1c8741b24a28);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $aa2162acaf3862c0$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $aa2162acaf3862c0$export$29629758934356a6);

var $kMxGa = parcelRequire("kMxGa");
const $aa2162acaf3862c0$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $aa2162acaf3862c0$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $aa2162acaf3862c0$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $aa2162acaf3862c0$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $aa2162acaf3862c0$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $aa2162acaf3862c0$export$909712ccf16883d = 'jira.polaris:discovery';
const $aa2162acaf3862c0$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $kMxGa.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $kMxGa.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $kMxGa.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $kMxGa.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("5RxQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f55eacc0b9ee9dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f55eacc0b9ee9dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    projectDescription: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description",
        "defaultMessage": "Capture ideas with Jira Product Discovery"
    },
    projectDescriptionProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description-roadmap",
        "defaultMessage": "Jira Product Discovery project"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    recommendedText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.recommended-text",
        "defaultMessage": "Recommended"
    },
    dismissConfirmationTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    },
    reasonsModalButtonOkCapitalised: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok-capitalised",
        "defaultMessage": "OK"
    }
});

});

parcelRegister("7Y8xQ", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $b21ff31ac89e5c24$export$2ea69a0925803655);
const $b21ff31ac89e5c24$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});



parcelRegister("4keKa", function(module, exports) {

$parcel$export(module.exports, "RecommendationLoader", () => $f62159ce20629294$export$f17bc1d33db805f2);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $d8lsH = parcelRequire("d8lsH");

var $d40Fj = parcelRequire("d40Fj");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $dkqym = parcelRequire("dkqym");

var $hqBSi = parcelRequire("hqBSi");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $4jROM = parcelRequire("4jROM");

var $cmzJ2 = parcelRequire("cmzJ2");
const $f62159ce20629294$export$f17bc1d33db805f2 = ({ recommendations: recommendations })=>{
    const [, { loadRecommendations: loadRecommendations }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const accountId = (0, $90yGq.useAccountId)();
    const locale = (0, $DVljb.useLocale)();
    const cloudId = (0, $koeKL.useCloudId)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const [{ hasSuccessOnce: hasSuccessOnce, canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    const isInFedRamp = (0, $4jROM.isFedRamp)();
    (0, $5uXOq.useEffect)(()=>{
        if (hasSuccessOnce && accountId) loadRecommendations(recommendations, {
            locale: locale,
            accountId: accountId,
            cloudId: cloudId,
            licensedProducts: licensedProducts,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            edition: edition,
            environment: environment,
            canCreateProject: canCreateProject,
            isInFedRamp: isInFedRamp
        }, createAnalyticsEvent({}));
    }, [
        hasSuccessOnce,
        canCreateProject,
        accountId,
        loadRecommendations,
        createAnalyticsEvent,
        locale,
        cloudId,
        licensedProducts,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        edition,
        environment,
        recommendations,
        isInFedRamp
    ]);
    return null;
};

});
parcelRegister("d40Fj", function(module, exports) {

$parcel$export(module.exports, "useCreateProjectPermission", () => $2e786b3606f3b4dc$export$c92733e8f8c1640f);
$parcel$export(module.exports, "useCreateProjectPermissionActions", () => $2e786b3606f3b4dc$export$d2b8d6f60fe99e2a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kEnf8 = parcelRequire("kEnf8");
const $2e786b3606f3b4dc$var$Store = (0, $iXqE5.createStore)({
    name: 'create-project-permissions',
    initialState: {
        canCreateProject: false,
        canCreateClassicProject: false,
        canCreateNextGenProject: false,
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $kEnf8.actions
});
const $2e786b3606f3b4dc$export$5a47fbae725b8f2 = (0, $gg7kZ.createContainer)($2e786b3606f3b4dc$var$Store);
const $2e786b3606f3b4dc$export$c92733e8f8c1640f = (0, $3sQ5x.createHook)($2e786b3606f3b4dc$var$Store);
const $2e786b3606f3b4dc$export$d2b8d6f60fe99e2a = (0, $3sQ5x.createHook)($2e786b3606f3b4dc$var$Store, {
    selector: null
});

});
parcelRegister("kEnf8", function(module, exports) {

$parcel$export(module.exports, "actions", () => $005c9d409c181858$export$e324594224ef24da);

var $7f4tk = parcelRequire("7f4tk");
const $005c9d409c181858$export$963556ef97965f0b = async ()=>{
    const url = '/rest/internal/2/projectpermissions';
    const result = await (0, $7f4tk.default)(url);
    return result;
};
const $005c9d409c181858$var$handleFetch = ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const result = await $005c9d409c181858$export$963556ef97965f0b();
            setState({
                ...result,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                canCreateProject: false,
                canCreateClassicProject: false,
                canCreateNextGenProject: false,
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
const $005c9d409c181858$export$e324594224ef24da = {
    fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($005c9d409c181858$var$handleFetch());
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};

});


parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});

parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});


parcelRegister("9WcgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $430f11f9411f5e73$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $430f11f9411f5e73$var$LazyCustomThemeAdminFlag = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("fbpTO")), {
    ssr: false,
    moduleId: "./src/packages/theme/custom-theme-admin-flag/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$430f11f9411f5e73$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.jira.custom-theme-admin-flag",
        packageName: "customThemeAdminFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-theme-admin-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($430f11f9411f5e73$var$LazyCustomThemeAdminFlag, null)));

});
parcelRegister("fbpTO", function(module, exports) {

let $b0dbf923fc425ea3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0dbf923fc425ea3$var$load("iCMN4").then(()=>parcelRequire('jWgLY'));

});


parcelRegister("bcn6L", function(module, exports) {

$parcel$export(module.exports, "useFavoriteActions", () => $23bcf74af5f22e12$export$e17993c41bc4dc38);
$parcel$export(module.exports, "useFavoriteBoards", () => $23bcf74af5f22e12$export$896ce0ae2b68d03a);
$parcel$export(module.exports, "useFavoriteDashboards", () => $23bcf74af5f22e12$export$7f929adce53e9217);
$parcel$export(module.exports, "useFavoriteProjects", () => $23bcf74af5f22e12$export$e92f6fc9e0c6d135);
$parcel$export(module.exports, "useFavoriteFilters", () => $23bcf74af5f22e12$export$49e6afd92506d2b4);
$parcel$export(module.exports, "useFavoriteQueues", () => $23bcf74af5f22e12$export$b09f7ee747d8bc9);
$parcel$export(module.exports, "useFavoritePlans", () => $23bcf74af5f22e12$export$56f40dc3d5e1af94);
$parcel$export(module.exports, "FavoritesContainer", () => $23bcf74af5f22e12$export$878515009e0790e0);


var $20jWj = parcelRequire("20jWj");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $23bcf74af5f22e12$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $23bcf74af5f22e12$export$d4c72bab9d6cc13a = {
    [(0, $49a076eb01652100$export$f95f1a684a17f189)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6e58b6b0aa48a271)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6737b9227f60f39d)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$91a9dba2d38d9a6f)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$20f1031cc9fdf29e)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$eebccb886b064713)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    }
};
const $23bcf74af5f22e12$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'favourite-boards') acc[0, $49a076eb01652100$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'favourite-filters') acc[0, $49a076eb01652100$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'favourite-dashboards') acc[0, $49a076eb01652100$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'favourite-projects') acc[0, $49a076eb01652100$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'favourite-queues') acc[0, $49a076eb01652100$export$20f1031cc9fdf29e] = itemResponse.items;
        if (itemResponse.id === 'favourite-plans') acc[0, $49a076eb01652100$export$eebccb886b064713] = itemResponse.items;
        return acc;
    }, {});
const $23bcf74af5f22e12$var$loadFavoriteItems = (amount = (0, $7a1562bd0ca086b0$export$ea341e6cc435ed40), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $20jWj.fetchFavoriteItems)({
                count: amount,
                types: typesToFetch
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $23bcf74af5f22e12$var$transformItems(itemResponse);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $23bcf74af5f22e12$export$e324594224ef24da = {
    loadFavoriteAll: (amount)=>async (actions2, props)=>{
            $23bcf74af5f22e12$var$loadFavoriteItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined,
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$eebccb886b064713) : undefined
            ].filter(Boolean))(actions2);
        },
    loadFavouriteBoards: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$f95f1a684a17f189)
        ]),
    loadFavoriteProjects: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$91a9dba2d38d9a6f)
        ]),
    loadFavoriteDashboards: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$6e58b6b0aa48a271)
        ]),
    loadFavoriteFilters: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$6737b9227f60f39d)
        ]),
    loadFavouriteQueues: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$20f1031cc9fdf29e)
        ]),
    loadFavoritePlans: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$eebccb886b064713)
        ])
};
const $23bcf74af5f22e12$var$store = (0, $iXqE5.createStore)({
    name: (0, $7a1562bd0ca086b0$export$7a3d0824e907e616),
    actions: $23bcf74af5f22e12$export$e324594224ef24da,
    initialState: $23bcf74af5f22e12$export$d4c72bab9d6cc13a
});
const $23bcf74af5f22e12$export$e17993c41bc4dc38 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: null
});
const $23bcf74af5f22e12$export$896ce0ae2b68d03a = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$f95f1a684a17f189]
});
const $23bcf74af5f22e12$export$7f929adce53e9217 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6e58b6b0aa48a271]
});
const $23bcf74af5f22e12$export$e92f6fc9e0c6d135 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$91a9dba2d38d9a6f]
});
const $23bcf74af5f22e12$export$49e6afd92506d2b4 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6737b9227f60f39d]
});
const $23bcf74af5f22e12$export$b09f7ee747d8bc9 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$20f1031cc9fdf29e]
});
const $23bcf74af5f22e12$export$56f40dc3d5e1af94 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$eebccb886b064713]
});
const $23bcf74af5f22e12$export$878515009e0790e0 = (0, $gg7kZ.createContainer)($23bcf74af5f22e12$var$store);

});
const $49a076eb01652100$export$91a9dba2d38d9a6f = 'projects';
const $49a076eb01652100$export$ebb48b08205007c5 = 'issues';
const $49a076eb01652100$export$6737b9227f60f39d = 'filters';
const $49a076eb01652100$export$6e58b6b0aa48a271 = 'dashboards';
const $49a076eb01652100$export$20f1031cc9fdf29e = 'queues';
const $49a076eb01652100$export$f95f1a684a17f189 = 'boards';
const $49a076eb01652100$export$3c11110d46d67e8c = 'jwmBoards';
const $49a076eb01652100$export$5e2cc09b58170ca2 = 'addons';
const $49a076eb01652100$export$eebccb886b064713 = 'plans';
const $49a076eb01652100$export$1c2ea36059c73937 = 'alerts';

parcelRegister("20jWj", function(module, exports) {

$parcel$export(module.exports, "fetchFavoriteItems", () => $7a715a28552f71dc$export$ba7e2966560509a6);

var $6eBRn = parcelRequire("6eBRn");

var $ebyGx = parcelRequire("ebyGx");

var $5HnTq = parcelRequire("5HnTq");

var $fPruT = parcelRequire("fPruT");

const $7a715a28552f71dc$var$handleError = (error)=>{
    throw error;
};
// This is horrible but the API is wrong: the type returned is singular while
// everywhere else (even in add/remove) is plural
// @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
const $7a715a28552f71dc$var$convertTypeToPlural = ({ items: items, ...rest })=>({
        ...rest,
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        items: items.filter(Boolean).map((item)=>({
                ...item,
                type: `${item.type}s`
            }))
    });
const $7a715a28552f71dc$export$ba7e2966560509a6 = async ({ count: count, types: types = [
    (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
    (0, $49a076eb01652100$export$6e58b6b0aa48a271),
    (0, $49a076eb01652100$export$6737b9227f60f39d),
    (0, $49a076eb01652100$export$eebccb886b064713)
] })=>{
    const query = (0, $ebyGx.stringify)((0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(types.map((type)=>[
            type,
            count
        ])));
    const url = `/rest/internal/2/favourites?${query}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $7a715a28552f71dc$var$handleError(new (0, $fPruT.AuthenticationError)(`${errorCode}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const resp = await response.json();
        return resp.map($7a715a28552f71dc$var$convertTypeToPlural);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};
const $7a715a28552f71dc$export$77fc2acdef452939 = async (item)=>{
    const url = '/rest/internal/2/favourites';
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                entity: {
                    id: item.id,
                    type: item.type
                },
                beforeEntityPosition: null
            })
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};
const $7a715a28552f71dc$export$acbe6ca9570854bd = async (item)=>{
    const url = `/rest/internal/2/favourites/${item.type}/${item.id}`;
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'DELETE'
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};

});
parcelRegister("fPruT", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $95af1b43dc18895e$export$cf0c46b07324e9c5);
class $95af1b43dc18895e$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


const $7a1562bd0ca086b0$export$ea341e6cc435ed40 = 15;
const $7a1562bd0ca086b0$export$7a3d0824e907e616 = 'navigation-favourite-store';


parcelRegister("bBulW", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $60ceaac5e0b6e842$export$a55b02efe3d62583);

var $5uXOq = parcelRequire("5uXOq");

var $9uGVy = parcelRequire("9uGVy");

var $ca1G2 = parcelRequire("ca1G2");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");
var $d8lsH = parcelRequire("d8lsH");

var $cNd4s = parcelRequire("cNd4s");

var $l8ruj = parcelRequire("l8ruj");

var $erHBo = parcelRequire("erHBo");

var $gaVxP = parcelRequire("gaVxP");

var $koeKL = parcelRequire("koeKL");

var $jX0pr = parcelRequire("jX0pr");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $2tT7R = parcelRequire("2tT7R");

var $bQaTP = parcelRequire("bQaTP");

var $dof5Y = parcelRequire("dof5Y");
const $60ceaac5e0b6e842$export$c12287ea2271e73f = async (cloudId, traitName)=>{
    const traits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const foundTrait = traits.find((trait)=>trait.name === traitName);
    if (!foundTrait) return null;
    return foundTrait;
};
const $60ceaac5e0b6e842$var$EditionAwarenessPlatformInnerWithRTCheck = (props)=>{
    const { isReady: isReady, isInReverseTrial: isInReverseTrial, onOpenOnboardingMenu: onOpenOnboardingMenu, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen } = (0, $dof5Y.useReverseTrials)();
    // We need to wait for the reverse trial check to be complete before rendering the button
    const canRender = props.canRender && isReady;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erHBo.EditionAwareness), {
        ...props,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: onOpenOnboardingMenu,
        shouldAutoOpen: shouldAutoOpen,
        onAutoOpen: onAutoOpen,
        canRender: canRender
    });
};
const $60ceaac5e0b6e842$var$EditionAwarenessPlatformInner = (props)=>{
    const { isEligibleForUpsellEa: isEligibleForUpsellEa } = (0, $ca1G2.useIsEligibleForUpsellEa)({
        product: props.product,
        edition: props.edition,
        isSiteAdmin: Boolean(props.userRoles?.includes('SITE_ADMIN'))
    });
    return isEligibleForUpsellEa ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gaVxP.EditionAwarenessUpsell), (({ product: product, cloudId: cloudId, edition: edition, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton })=>({
            product: product,
            cloudId: cloudId,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton
        }))(props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erHBo.EditionAwareness), props);
};
const $60ceaac5e0b6e842$var$EditionAwarenessPlatform = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { product: product, edition: edition } = (0, $bQaTP.useProductAndEdition)();
    const { isDismissed: isDismissed, handleDismiss: handleDismiss } = (0, $9uGVy.useIsEditionAwarenessPillDismissed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const [siteType, setSiteType] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (siteType === undefined) {
            if (edition === 'free') {
                if ((0, $4R6GH.fg)('load_growth_cohort_trait')) $60ceaac5e0b6e842$export$c12287ea2271e73f(cloudId, 'growth_discount_cohort').then((trait)=>{
                    if (trait && (trait.value === 'EDU' || trait.value === 'ORG')) setSiteType(trait.value);
                    else setSiteType('UNKNOWN');
                }).catch((e)=>{
                    setSiteType(null);
                    const event = createAnalyticsEvent({});
                    (0, $jcw0u.default)({
                        event: event,
                        meta: {
                            id: 'editionAwarenessGrowthCohortTrait',
                            packageName: 'edition-awareness',
                            teamName: 'growth-tako'
                        },
                        error: e,
                        sendToPrivacyUnsafeSplunk: true
                    });
                });
                else setSiteType(null);
            } else setSiteType(null);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        edition,
        siteType
    ]);
    if (!product || !edition) return null;
    // We need to wait for the siteType to be set before rendering the button
    const canRender = siteType !== undefined;
    const editionAwarenessProps = {
        edition: edition,
        cloudId: cloudId,
        product: product,
        accountId: accountId,
        environment: environment,
        userRoles: isSiteAdmin ? [
            'SITE_ADMIN'
        ] : [],
        hasDismissedButton: isDismissed,
        onDismissButton: handleDismiss,
        siteType: siteType,
        canRender: canRender
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isSiteAdmin: isSiteAdmin,
            product: product,
            edition: edition
        }
    }, edition === 'premium' && product === 'jira' ? // We need to call a few hooks to check RT, could be cleaned up in the future
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessPlatformInnerWithRTCheck, editionAwarenessProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessPlatformInner, editionAwarenessProps));
};
const $60ceaac5e0b6e842$export$a55b02efe3d62583 = ()=>{
    // This component is not rendered on the server, we don't have enough information to determine if it will be renderer or not
    // Don't remove because it may cause the SSR to fail, at this point it because the EditonAwarenessButton is using useLazyLoadQuery
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "EditionAwareness",
        packageName: "jiraNavigationAppsSidebarEditionAwareness",
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessPlatform, null)));
};

});
parcelRegister("bQaTP", function(module, exports) {

$parcel$export(module.exports, "useProductAndEdition", () => $f3ac7751023fca6b$export$b0f1c0403c557678);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $lpwtK = parcelRequire("lpwtK");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $4SswE = parcelRequire("4SswE");
const $f3ac7751023fca6b$export$8aab08255f8e5ef0 = {
    FREE_EDITION: 'free',
    STANDARD_EDITION: 'standard',
    PREMIUM_EDITION: 'premium'
};
const $f3ac7751023fca6b$export$7e5a22794fbe56f2 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'jira',
    [(0, $2vSU6.CORE_PROJECT)]: 'jira',
    [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: 'jira-product-discovery',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'jira-service-management'
};
const $f3ac7751023fca6b$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { loading: loading, data: project } = (0, $lpwtK.useProject)();
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $5uXOq.useMemo)(()=>{
        if (loading) return;
        const type = (0, $2vSU6.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $2vSU6.SOFTWARE_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
    const applicationEdition = (0, $5uXOq.useMemo)(()=>{
        if (!projectType) return;
        if (siteHasOnlyJira) return (0, $ldyPw.getEditionForProject)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
        return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType,
        siteHasOnlyJira
    ]);
    const { product: product, edition: edition } = (0, $5uXOq.useMemo)(()=>{
        if (!projectType || !applicationEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $2vSU6.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $f3ac7751023fca6b$export$7e5a22794fbe56f2[projectType],
            edition: $f3ac7751023fca6b$export$8aab08255f8e5ef0[applicationEdition]
        };
    }, [
        applicationEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};

});

parcelRegister("dof5Y", function(module, exports) {

$parcel$export(module.exports, "useReverseTrials", () => $2f6c07d56684e27e$export$8f6d4c7745b1e143);

var $5uXOq = parcelRequire("5uXOq");

var $eYvmm = parcelRequire("eYvmm");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $4i99S = parcelRequire("4i99S");

var $jOXuX = parcelRequire("jOXuX");


var $9yQlD = parcelRequire("9yQlD");
const $2f6c07d56684e27e$export$8f6d4c7745b1e143 = ()=>{
    const openChecklist = (0, $4i99S.useOpenChecklist)();
    const [{ currentTaskGroupParent: currentTaskGroupParent }, { changeTaskGroupParent: changeTaskGroupParent, nextOpenTask: nextOpenTask }] = (0, $cE2Qr.useJswOnboarding)();
    const { isInReverseTrial: isInReverseTrial, isReady: isRTReady } = (0, $eYvmm.useInReverseTrial)();
    const { isReady: isTOReady, isTailoredOnboardingM3EnabledAndEligible: isTailoredOnboardingM3EnabledAndEligible, isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isTailoredOnboardingScrumAndSoftwareKanbanEnabled } = (0, $jOXuX.useIsTailoredOnboardingEnabledAndEligible)();
    const onOpenOnboardingMenu = (0, $5uXOq.useCallback)(()=>{
        const taskGroupToEnter = (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK);
        if (currentTaskGroupParent !== taskGroupToEnter) changeTaskGroupParent(taskGroupToEnter);
        openChecklist({
            trigger: 'ReverseTrialPopup'
        });
        nextOpenTask((0, $8Bc5A.ADVANCED_ROADMAPS_TASK), {
            closeNudge: true
        });
    }, [
        currentTaskGroupParent,
        openChecklist,
        nextOpenTask,
        changeTaskGroupParent
    ]);
    const shouldAutoOpen = (0, $5uXOq.useMemo)(()=>{
        if (isInReverseTrial) {
            const onboardingStartedTimestamp = Number((0, $9yQlD.localStorageProvider).get((0, $6784cbc7d62e5d7c$export$69fe8832c4f79a32)));
            if (onboardingStartedTimestamp) {
                const threeDays = 259200000;
                // If the user has onboarded 3 or more days ago, force open the premium popup
                if (Date.now() - onboardingStartedTimestamp > threeDays) // The check for `jsw_ea_popover_open_vs_close` experiment is performed on platform
                return true;
            }
        }
        return false;
    }, [
        isInReverseTrial
    ]);
    const onAutoOpen = (0, $5uXOq.useCallback)(()=>(0, $9yQlD.localStorageProvider).remove((0, $6784cbc7d62e5d7c$export$69fe8832c4f79a32)), []);
    if (!isRTReady || !isTOReady) return {
        isReady: false,
        isInReverseTrial: undefined,
        onOpenOnboardingMenu: undefined,
        shouldAutoOpen: undefined,
        onAutoOpen: undefined
    };
    // The check for `jira_rt_quickstart_m1` experiment is performed on platform
    const hidePremiumFeatureItem = isTailoredOnboardingM3EnabledAndEligible || isTailoredOnboardingScrumAndSoftwareKanbanEnabled;
    return {
        isReady: true,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: hidePremiumFeatureItem ? undefined : onOpenOnboardingMenu,
        shouldAutoOpen: shouldAutoOpen,
        onAutoOpen: shouldAutoOpen ? onAutoOpen : undefined
    };
};

});
parcelRegister("eYvmm", function(module, exports) {

$parcel$export(module.exports, "useInReverseTrial", () => $8a55417384eda66a$export$76f7829aa123c9c4);

var $dkqym = parcelRequire("dkqym");

var $4R6GH = parcelRequire("4R6GH");

var $70Wxp = parcelRequire("70Wxp");
/**
 * This hook is used to check if the user is signed up in a reverse trial
 * and also user is within the attribution window
 * which identify the user is currently in the 'first' reverse trial
 */ const $8a55417384eda66a$var$ATTRIBUTION_WINDOW = 45; // days
const $8a55417384eda66a$var$MILLISECONDS_IN_DAY = 8640000000;
const $8a55417384eda66a$export$76f7829aa123c9c4 = ()=>{
    const firstActivationDate = (0, $dkqym.useFirstActivationDateMs)();
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $70Wxp.useFetchOnboardingReverseTrial)();
    if (isReady) return {
        isInReverseTrial: (0, $4R6GH.fg)('is_current_in_reverse_trial_feature_gate') ? premiumTrialOnSignup && !!firstActivationDate && Date.now() - firstActivationDate <= $8a55417384eda66a$var$ATTRIBUTION_WINDOW * $8a55417384eda66a$var$MILLISECONDS_IN_DAY : premiumTrialOnSignup,
        isReady: isReady
    };
    return {
        isInReverseTrial: undefined,
        isReady: isReady
    };
};

});
parcelRegister("70Wxp", function(module, exports) {

$parcel$export(module.exports, "useFetchOnboardingReverseTrial", () => $5ec4a2aef6f6d0e2$export$349fbee95cd03b58);

var $5uXOq = parcelRequire("5uXOq");

var $AK64q = parcelRequire("AK64q");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gh567 = parcelRequire("gh567");

var $7aHUB = parcelRequire("7aHUB");
const $5ec4a2aef6f6d0e2$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-reverse-trial',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $7aHUB.actions
});
const $5ec4a2aef6f6d0e2$export$6758b294795e1644 = (0, $3sQ5x.createHook)($5ec4a2aef6f6d0e2$var$store);
const $5ec4a2aef6f6d0e2$export$349fbee95cd03b58 = ()=>{
    const isTargetedForReverseTrials = (0, $gh567.useIsTargetedForReverseTrials)();
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { getPremiumTrialOnSignup: getPremiumTrialOnSignup }] = $5ec4a2aef6f6d0e2$export$6758b294795e1644();
    (0, $5uXOq.useEffect)(()=>{
        if (isTargetedForReverseTrials && !fetchedOnce && !isFetching && data === undefined) // @ts-expect-error Arguments for the rest parameter 'args' were not provided.
        getPremiumTrialOnSignup();
    }, [
        data,
        fetchedOnce,
        getPremiumTrialOnSignup,
        isFetching,
        isTargetedForReverseTrials
    ]);
    if (!isTargetedForReverseTrials) // If not targeted, no fetching is done. Data is ready to be read
    return {
        premiumTrialOnSignup: undefined,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: true
    };
    return {
        premiumTrialOnSignup: data?.premiumTrialOnSignup,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: fetchedOnce && !isFetching
    };
};

});
parcelRegister("AK64q", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $e18633c22e50182e$export$aaed2d023c5dc2c);
const $e18633c22e50182e$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("gh567", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $b8cd58920d764600$export$897219a3ca9649b9);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $b8cd58920d764600$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const jswEdition = (0, $k9JTq.useAppEditions)().software;
    if ((0, $4R6GH.fg)('jsw_reverse_trials_feature_gate')) {
        const isCurrentProjectJSW = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
        if (jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
        return false;
    }
    return false;
};

});

parcelRegister("7aHUB", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9bc9ce12e98e96a1$export$e324594224ef24da);

var $7bRcT = parcelRequire("7bRcT");

var $bfWlw = parcelRequire("bfWlw");
const $9bc9ce12e98e96a1$var$getPremiumTrialOnSignup = (0, $7bRcT.cachedEndpointCall)((0, $bfWlw.getOnboardingPremiumTrialWithRethrow));
const $9bc9ce12e98e96a1$export$e324594224ef24da = {
    getPremiumTrialOnSignup: $9bc9ce12e98e96a1$var$getPremiumTrialOnSignup
};

});
parcelRegister("7bRcT", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $69bbbca5d7164078$export$9ab04ab45a9b99da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $69bbbca5d7164078$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});




parcelRegister("jOXuX", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingScrumAndSoftwareKanbanEnabled", () => $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137);
$parcel$export(module.exports, "isTailoredOnboardingEnabled", () => $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingScrumAndSoftwareKanban", () => $4b94b4e85c1e2fc8$export$713219ba4b63fe78);
$parcel$export(module.exports, "useIsTailoredOnboardingEnabledAndEligible", () => $4b94b4e85c1e2fc8$export$46047e5fecf4cae5);
$parcel$export(module.exports, "isTailoredOnboardingEnabledWithExposure", () => $4b94b4e85c1e2fc8$export$142e2425d224298f);
$parcel$export(module.exports, "useIsTailoredOnboardingM2p5EligibleWithExposure", () => $4b94b4e85c1e2fc8$export$fd0589feb622f26b);
$parcel$export(module.exports, "useIsScrumProject", () => $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bNm1d = parcelRequire("bNm1d");

var $gQEFa = parcelRequire("gQEFa");

var $dAfqg = parcelRequire("dAfqg");

var $e5wyW = parcelRequire("e5wyW");

var $58GFP = parcelRequire("58GFP");


var $cNd4s = parcelRequire("cNd4s");

var $8zOmE = parcelRequire("8zOmE");

var $d8lsH = parcelRequire("d8lsH");

var $43qGj = parcelRequire("43qGj");
const $4b94b4e85c1e2fc8$export$7889b94f54c2d416 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_m3');
    return (0, $4R6GH.fg)('tailored_onboarding_m3_gate') && expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_scrum_and_software_kanban');
    return expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$f9b7a643200046ae = ()=>{
    return $4b94b4e85c1e2fc8$export$7889b94f54c2d416() || $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137();
};
const $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira_tailored_onboarding_shared_experiment_check'), $4b94b4e85c1e2fc8$export$f9b7a643200046ae, $4b94b4e85c1e2fc8$export$7889b94f54c2d416);
const $4b94b4e85c1e2fc8$export$54c132e77bb6d105 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    if (isKanbanTemplate && !isSoftwareTeamType && $4b94b4e85c1e2fc8$export$7889b94f54c2d416()) return true;
    return false;
};
const $4b94b4e85c1e2fc8$export$713219ba4b63fe78 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin, fireExposure: fireExposure = false, analyticEvent: analyticEvent })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isScrumTemplate = templateKey?.startsWith((0, $58GFP.SCRUM_TEAM_MANAGED_KEY));
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    // Software Kanban or Scrum all Team Types
    if (isKanbanTemplate && isSoftwareTeamType || isScrumTemplate) {
        // User is eligible for experiment. Fires exposure for those in control too here
        if (fireExposure) {
            analyticEvent && (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredOnboardingWithScrumAndSoftwareKanban personalised', {
                teamType: teamType,
                templateKey: templateKey,
                isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false)
            });
            return (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false);
        }
        if ($4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return true;
    }
    return false;
};
const $4b94b4e85c1e2fc8$export$5188e1ffa34f6a91 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    return $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    }) || $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
};
const $4b94b4e85c1e2fc8$export$68df71de32509eb9 = ()=>{
    const isEnabled = $4b94b4e85c1e2fc8$export$7889b94f54c2d416();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $gQEFa.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isTmpKanban = !!templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    const isEligible = isSiteAdmin && isTmpKanban && !isSoftwareTeamType && isSoftwareProject;
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$var$useIsTailoredOnboardingM3EnabledWithScrumAndSoftwareKanbanSupport = ()=>{
    const isEnabled = $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $gQEFa.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isTailoredOnboardingM3EnabledAndEligible = $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    const isTailoredOnboardingEnabledWithScrumAndSoftware = $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isTailoredOnboardingM3EnabledAndEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isEnabled && isTailoredOnboardingEnabledWithScrumAndSoftware,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$46047e5fecf4cae5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira_tailored_onboarding_shared_experiment_check'), $4b94b4e85c1e2fc8$var$useIsTailoredOnboardingM3EnabledWithScrumAndSoftwareKanbanSupport, $4b94b4e85c1e2fc8$export$68df71de32509eb9);
const $4b94b4e85c1e2fc8$export$7be3a325d4c5384 = ({ isTmpKanban: isTmpKanban, isSoftwareTeamType: isSoftwareTeamType, isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType })=>{
    if (isSiteAdmin && isTmpKanban && !isSoftwareTeamType && (0, $4R6GH.fg)('tailored_onboarding_m3_gate')) {
        (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    return false;
};
const $4b94b4e85c1e2fc8$export$469220ca30dc2e8 = ({ isTmpKanban: // eslint-disable-next-line @typescript-eslint/no-unused-vars
isTmpKanban, isSoftwareTeamType: // eslint-disable-next-line @typescript-eslint/no-unused-vars
isSoftwareTeamType, isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType, templateKey: templateKey })=>{
    if ($4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    })) {
        (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            templateKey: templateKey,
            isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    return $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin,
        fireExposure: true,
        analyticEvent: analyticEvent
    });
};
const $4b94b4e85c1e2fc8$export$142e2425d224298f = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira_tailored_onboarding_shared_experiment_check'), $4b94b4e85c1e2fc8$export$469220ca30dc2e8, $4b94b4e85c1e2fc8$export$7be3a325d4c5384);
const $4b94b4e85c1e2fc8$export$fd0589feb622f26b = ({ isBusinessProject: isBusinessProject, isTrelloCrossflow: isTrelloCrossflow, isOnboarding: isOnboarding })=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isBasicEligible = isSiteAdmin && isBusinessProject && !isTrelloCrossflow;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: isBasicEligible
    });
    const isTargettedTeamType = ![
        (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
        (0, $6784cbc7d62e5d7c$export$e4824f74b9879164)
    ].includes(teamType ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const fireOnce = (0, $5uXOq.useRef)(false);
    if (!isBasicEligible) return {
        isEligible: false,
        isReady: true
    };
    if (!teamTypeIsReady) return {
        isEligible: undefined,
        isReady: false
    };
    if (isBusinessProject && isSiteAdmin && isTargettedTeamType) {
        if (!fireOnce.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'tailoredM2p5 exposed', {
                teamType: teamType,
                isOnboarding: isOnboarding,
                isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false)
            });
            fireOnce.current = true;
        }
        return {
            isEligible: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false),
            isReady: true,
            teamType: teamType
        };
    }
    return {
        isEligible: false,
        isReady: true,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4 = ()=>{
    if (!$4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = (0, $43qGj.useFeatures)();
    return (data?.hasSprint && data?.hasBacklog) ?? false;
};

});
parcelRegister("bNm1d", function(module, exports) {

$parcel$export(module.exports, "useUserEmailDomain", () => $e92819165abac823$export$f95c1c6f997ec47f);
$parcel$export(module.exports, "useAtlassianAccount", () => $e92819165abac823$export$19d38f479bd18098);
$parcel$export(module.exports, "useTeamTypeShortHand", () => $e92819165abac823$export$1a086dfae472ccfe);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $9yQlD = parcelRequire("9yQlD");


var $asmQK = parcelRequire("asmQK");

var $2LmB4 = parcelRequire("2LmB4");
const $e92819165abac823$export$d4c72bab9d6cc13a = {
    isFetching: false,
    wasFetchedOnce: false,
    fetchError: null
};
const $e92819165abac823$var$Store = (0, $iXqE5.createStore)({
    initialState: $e92819165abac823$export$d4c72bab9d6cc13a,
    actions: $2LmB4.actions,
    name: 'atlassian-account'
});
const $e92819165abac823$var$loggedInEmailDomainSelector = (0, $6dDSs.createSelector)((state)=>state.data, (accountInfo)=>{
    if (!accountInfo) return null;
    const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
    return loggedInEmailDomain;
});
const $e92819165abac823$export$2a9b22328f7b68fa = (0, $3sQ5x.createHook)($e92819165abac823$var$Store, {
    selector: $e92819165abac823$var$loggedInEmailDomainSelector
});
const $e92819165abac823$export$f95c1c6f997ec47f = (isEligibleToCall = true)=>{
    const [loggedInEmailDomain, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$2a9b22328f7b68fa();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligibleToCall && !loggedInEmailDomain) fetchAtlassianAccountData();
    }, [
        fetchAtlassianAccountData,
        isEligibleToCall,
        loggedInEmailDomain
    ]);
    return {
        data: loggedInEmailDomain
    };
};
const $e92819165abac823$export$19d38f479bd18098 = (0, $3sQ5x.createHook)($e92819165abac823$var$Store);
const $e92819165abac823$export$1a086dfae472ccfe = ({ shouldFetch: shouldFetch })=>{
    const [{ data: atlassianAccountData, isFetching: isFetching, wasFetchedOnce: wasFetchedOnce }, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$19d38f479bd18098();
    const localStorageTeamTypeShorthand = (0, $9yQlD.localStorageProvider).get((0, $6784cbc7d62e5d7c$export$c06666264cd35603));
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && !localStorageTeamTypeShorthand && !isFetching && !wasFetchedOnce) fetchAtlassianAccountData({
            source: 'useTeamTypeShortHand'
        });
    }, [
        fetchAtlassianAccountData,
        isFetching,
        localStorageTeamTypeShorthand,
        shouldFetch,
        wasFetchedOnce
    ]);
    if (localStorageTeamTypeShorthand) return {
        isReady: true,
        teamType: localStorageTeamTypeShorthand
    };
    if (!shouldFetch) return {
        isReady: true,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
    if (atlassianAccountData?.extendedProfile.teamType && !localStorageTeamTypeShorthand) (0, $9yQlD.localStorageProvider).set((0, $6784cbc7d62e5d7c$export$c06666264cd35603), (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData.extendedProfile.teamType));
    return {
        isReady: !isFetching && wasFetchedOnce,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
};

});
parcelRegister("9yQlD", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $816fbeb16311dd64$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $816fbeb16311dd64$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $816fbeb16311dd64$export$aa821bfb3308a1f5);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");




const $816fbeb16311dd64$export$f119d83aa936d634 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("asmQK", function(module, exports) {

$parcel$export(module.exports, "mapUserSegmentationFullToShorthand", () => $2244820289929c87$export$8897f7082e20c8df);

const $2244820289929c87$export$8897f7082e20c8df = (teamTypeFromMe)=>{
    switch(teamTypeFromMe){
        case 0, $6784cbc7d62e5d7c$export$e07d1fa2da8ed874:
            return 0, $6784cbc7d62e5d7c$export$572242e58bd07594;
        case 0, $6784cbc7d62e5d7c$export$76dcec3f438d9e56:
            return 0, $6784cbc7d62e5d7c$export$d7de553940261eba;
        case 0, $6784cbc7d62e5d7c$export$9a574c301f67ba30:
            return 0, $6784cbc7d62e5d7c$export$4c29d0d04c15e55d;
        case 0, $6784cbc7d62e5d7c$export$363ec144a94029c8:
            return 0, $6784cbc7d62e5d7c$export$3950f7f841bf94b6;
        case 0, $6784cbc7d62e5d7c$export$df0fb32d68ae1e78:
            return 0, $6784cbc7d62e5d7c$export$881249b988b6030f;
        case 0, $6784cbc7d62e5d7c$export$d9c0e3e59442fb4:
            return 0, $6784cbc7d62e5d7c$export$e4824f74b9879164;
        case 0, $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3:
            return 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52;
        case 0, $6784cbc7d62e5d7c$export$a5dce388adf922bd:
            return 0, $6784cbc7d62e5d7c$export$1a65d50c4a641bb4;
        case 0, $6784cbc7d62e5d7c$export$e1473b31a257caff:
            return 0, $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2;
        case 0, $6784cbc7d62e5d7c$export$699265ec8ad9a740:
            return 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b;
        case 0, $6784cbc7d62e5d7c$export$85657457db93c2c2:
            return 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74;
        case 0, $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd:
            return 0, $6784cbc7d62e5d7c$export$79685802e8ff1098;
        case 0, $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3:
            return 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24;
        case 0, $6784cbc7d62e5d7c$export$7b60378c3b4372e9:
            return 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d;
        default:
            return teamTypeFromMe;
    }
};

});

parcelRegister("2LmB4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $263b01c2e713c075$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $fBogR = parcelRequire("fBogR");
const $263b01c2e713c075$export$e324594224ef24da = {
    fetchAtlassianAccountData: ({ source: source } = {})=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching, wasFetchedOnce: wasFetchedOnce } = getState();
            if (isFetching || wasFetchedOnce) return;
            setState({
                isFetching: true
            });
            try {
                const data = await (0, $fBogR.getAtlassianAccountWithRethrow)({
                    source: source
                });
                if (data !== null) setState({
                    data: data
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    wasFetchedOnce: true
                });
            }
        }
};

});
parcelRegister("fBogR", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $284b5d88f7e7a408$export$1f20b0741dc598bc);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $284b5d88f7e7a408$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $eusud.performGetRequestWithRetry)((0, $53b7c6a1de61c1d4$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $53b7c6a1de61c1d4$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("gQEFa", function(module, exports) {

$parcel$export(module.exports, "useFetchInitialProjectTemplateName", () => $be0087b09b981e14$export$b11629f839f2f12a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $ggwAD = parcelRequire("ggwAD");
const $be0087b09b981e14$export$d4c72bab9d6cc13a = {};
const $be0087b09b981e14$var$store = (0, $iXqE5.createStore)({
    name: 'jira-initial-project-template-name',
    initialState: $be0087b09b981e14$export$d4c72bab9d6cc13a,
    actions: $ggwAD.actions
});
const $be0087b09b981e14$export$ee6e247e51917971 = (0, $3sQ5x.createHook)($be0087b09b981e14$var$store);
const $be0087b09b981e14$export$b11629f839f2f12a = ({ shouldFetch: shouldFetch, projectId: projectId })=>{
    const [state, { fetchInitialProjectTemplateName: fetchInitialProjectTemplateName }] = $be0087b09b981e14$export$ee6e247e51917971();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && projectId) fetchInitialProjectTemplateName(`${projectId}`);
    }, [
        fetchInitialProjectTemplateName,
        projectId,
        shouldFetch
    ]);
    if (!projectId) return {
        data: undefined,
        isReady: true
    };
    if (!shouldFetch) return {
        // Still return the data if it's already fetched
        // leave it to consumer to decide what to do with it
        data: state[`${projectId}`]?.templateKey,
        isReady: true
    };
    return {
        data: state[`${projectId}`]?.templateKey,
        isReady: state[`${projectId}`]?.fetchStatus === 'fetched'
    };
};

});
parcelRegister("ggwAD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7361e67f73cde4dc$export$e324594224ef24da);

var $2y6my = parcelRequire("2y6my");
const $7361e67f73cde4dc$export$e324594224ef24da = {
    fetchInitialProjectTemplateName: (0, $2y6my.fetchInitialProjectTemplateNameWithRethrow)
};

});
parcelRegister("2y6my", function(module, exports) {

$parcel$export(module.exports, "fetchInitialProjectTemplateNameWithRethrow", () => $a69f9ed7a08e4d60$export$c837cab65def4654);

var $1sYcL = parcelRequire("1sYcL");

var $jcw0u = parcelRequire("jcw0u");

var $5fQRY = parcelRequire("5fQRY");
const $a69f9ed7a08e4d60$export$c837cab65def4654 = (projectId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const currentState = getState();
            const currentStateForProjectId = currentState[projectId];
            if (currentStateForProjectId?.fetchStatus === 'fetched' || currentStateForProjectId?.fetchStatus === 'fetching') return;
            const localStorageInitialProjectTemplateName = (0, $5fQRY.getLocalStorageInitialProjectTemplateName)({
                projectId: projectId
            });
            if (localStorageInitialProjectTemplateName) {
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: localStorageInitialProjectTemplateName
                    }
                });
                return;
            }
            setState({
                [projectId]: {
                    ...currentStateForProjectId,
                    fetchStatus: 'fetching'
                }
            });
            const response = await (0, $1sYcL.get)('', {
                consumerMeta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: '@atlassian/jira-onboarding-core',
                    teamName: 'Jlove-Makkuro'
                },
                projectId: projectId,
                projectProperties: [
                    'initial.project.template.name'
                ]
            });
            const templateKey = response?.project?.['initial.project.template.name'];
            if (templateKey) {
                (0, $5fQRY.setLocalStorageInitialProjectTemplateName)({
                    projectId: projectId,
                    templateKey: templateKey
                });
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: templateKey
                    }
                });
            } else setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                }
            });
            setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        }
    };

});
parcelRegister("5fQRY", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$82cce58d3eca5268);
$parcel$export(module.exports, "setLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$8767e71370b25cc2);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fa50145683a10f14$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('jira-initial-project-template-name');
const $fa50145683a10f14$export$82cce58d3eca5268 = ({ projectId: projectId })=>{
    try {
        return $fa50145683a10f14$var$localStorageProvider.get(projectId);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getLocalStorageInitialProjectTemplateName');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'getLocalStorageInitialProjectTemplateName',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
        return undefined;
    }
};
const $fa50145683a10f14$export$8767e71370b25cc2 = ({ projectId: projectId, templateKey: templateKey })=>{
    try {
        $fa50145683a10f14$var$localStorageProvider.set(projectId, templateKey);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('localStorageSetOnboardingPersonalisationResponse');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
    }
};

});




parcelRegister("43qGj", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $64d4caaed133b77d$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $4bPSV = parcelRequire("4bPSV");

var $hDSPU = parcelRequire("hDSPU");

var $iHqA4 = parcelRequire("iHqA4");

var $j8sa8 = parcelRequire("j8sa8");
const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $hDSPU.useSidebarFeatureToggled)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $4bPSV.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $5uXOq.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $iHqA4.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4bPSV", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4795c1c4367ea315$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");
const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("hDSPU", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $605ea180d8f833cc$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $605ea180d8f833cc$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $605ea180d8f833cc$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6wyfe = parcelRequire("6wyfe");
const $605ea180d8f833cc$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $605ea180d8f833cc$var$store = (0, $iXqE5.createStore)({
    name: 'feature-toggle',
    initialState: $605ea180d8f833cc$var$initialState,
    actions: $6wyfe.actions
});
const $605ea180d8f833cc$export$fc97652867e5867e = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store);
const $605ea180d8f833cc$export$207b461610a7fca6 = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $605ea180d8f833cc$export$9eef668f94562feb = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("6wyfe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $158a47dbcbb0832b$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");

var $3Jf4N = parcelRequire("3Jf4N");

var $czzsL = parcelRequire("czzsL");

var $iZZTd = parcelRequire("iZZTd");

var $ke207 = parcelRequire("ke207");
const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $iZZTd.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $czzsL.filterAndSort)(data);
                (0, $czzsL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $3Jf4N.getFeatureMap)({
            isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $3Jf4N.getFeatureMap)();
        if ((0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $3Jf4N.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $czzsL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $ke207.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $158a47dbcbb0832b$export$e324594224ef24da = {
    fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
    updateFeature: $158a47dbcbb0832b$var$updateFeature,
    syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
    clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
};

});
parcelRegister("3Jf4N", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $d07f845012e39eac$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $d07f845012e39eac$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $d07f845012e39eac$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $d07f845012e39eac$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $d07f845012e39eac$export$f5e4c120ac01b615);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $4qUU4 = parcelRequire("4qUU4");

var $3Pfb4 = parcelRequire("3Pfb4");

var $3yMMj = parcelRequire("3yMMj");

var $1iPSV = parcelRequire("1iPSV");

var $5MGz1 = parcelRequire("5MGz1");

var $giya4 = parcelRequire("giya4");
const $d07f845012e39eac$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yMMj))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            'software-list'
        ]
    }
};
const $d07f845012e39eac$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($giya4))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qUU4))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Pfb4))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1iPSV))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, $8QpSo.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($giya4))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qUU4))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Pfb4))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1iPSV))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5MGz1))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});

parcelRegister("czzsL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $0a04151ee5a00965$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $0a04151ee5a00965$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $0a04151ee5a00965$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $0a04151ee5a00965$export$5da1e8c5ba5c0dc2);

var $hqTkp = parcelRequire("hqTkp");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $3Jf4N = parcelRequire("3Jf4N");
const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $jcw0u.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});

parcelRegister("iZZTd", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $140b4a0769fd2090$export$c20100b185d41ab0);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $eusud.performGetRequest)((0, $8djOx.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8djOx", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $45a3789113fa4e8b$export$3f9939d302766b52);
const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("ke207", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $1ce9149bd154bcf9$export$61f6bbb745b3a3);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $eusud.performPutRequest)((0, $8djOx.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("iHqA4", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $b80f211a69d994c6$export$2946f555c6f48127);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1J3t1 = parcelRequire("1J3t1");

var $1XJ20 = parcelRequire("1XJ20");

var $hDSPU = parcelRequire("hDSPU");

var $j8sa8 = parcelRequire("j8sa8");
const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $hDSPU.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $5uXOq.useRef)(false);
    const previousData = (0, $1XJ20.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $5uXOq.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("j8sa8", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $d568e02a383436d9$export$7deca16ba2d9eb74);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $dkqym = parcelRequire("dkqym");
const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});






parcelRegister("hwY9o", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $d4fd492eb2e40a4e$export$9923361bd43fa030);

var $5uXOq = parcelRequire("5uXOq");

var $lmyls = parcelRequire("lmyls");

var $7v7MP = parcelRequire("7v7MP");

var $5dB4r = parcelRequire("5dB4r");
function $d4fd492eb2e40a4e$export$9923361bd43fa030() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7v7MP.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5dB4r.AppSwitcherTrigger), null));
}

});
parcelRegister("7v7MP", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $6b518e11974f2558$export$b70f1d8bd509b358);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

const $6b518e11974f2558$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $5uXOq.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `${(0, $0c0ba767096dfef6$export$4766f0c4b6fe35dc)}.${id}`,
        packageName: (0, $0c0ba767096dfef6$export$b8b9d90f9e5bd72b),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});
const $0c0ba767096dfef6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $0c0ba767096dfef6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $0c0ba767096dfef6$export$9934c8d98fd9e572 = 'atlassianSwitcher';


parcelRegister("5dB4r", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherTrigger", () => $a8bf655658f4721c$export$dc8723dff0e69fcb);

var $5uXOq = parcelRequire("5uXOq");

var $7HgmV = parcelRequire("7HgmV");


var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $5EVwR = parcelRequire("5EVwR");

var $izWh3 = parcelRequire("izWh3");

var $21e8k = parcelRequire("21e8k");
function $a8bf655658f4721c$export$dc8723dff0e69fcb() {
    const [isOpen, { on: openMenu, off: closeMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).APP_SWITCHER);
    const triggerAnalytics = (0, $7HgmV.useNavigationItemAnalytics)({
        navigationItemId: (0, $0c0ba767096dfef6$export$9934c8d98fd9e572)
    });
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            isOpen: isOpen,
            onClose: closeMenu,
            onOpen: onOpen
        }), [
        isOpen,
        closeMenu,
        onOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $5EVwR.AppSwitcherIntegrationEntrypoint), entryPointParams);
    const entrypointRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $izWh3.AppSwitcherPlaceholderButton), {
        onOpen: onOpen,
        ref: entrypointRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "app-switcher-content",
        packageName: "jira-navigation-apps-topnav4-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $21e8k.AppSwitcherPlaceholderWithLoadingPopup), null),
        errorFallback: "flag",
        runtimeProps: entryPointParams
    }));
}

});
parcelRegister("7HgmV", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $bc1fd758f3d9a30e$export$444d136efe970fd3);

var $5uXOq = parcelRequire("5uXOq");

var $gDHs4 = parcelRequire("gDHs4");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");
function $bc1fd758f3d9a30e$export$444d136efe970fd3({ navigationItemId: navigationItemId }) {
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
}

});

parcelRegister("5EVwR", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherIntegrationEntrypoint", () => $daebaf75796cc394$export$7b5dbeab5e41f2a4);

var $cluFV = parcelRequire("cluFV");

var $29g2n = parcelRequire("29g2n");

const $daebaf75796cc394$export$7b5dbeab5e41f2a4 = (0, $29g2n.createEntryPoint)({
    root: (0, $cluFV.JSResourceForInteraction)(()=>(parcelRequire("5oZLj")), {
        moduleId: "9be44a41"
    }),
    getPreloadProps: (params)=>({
            extraProps: params
        })
});

});
parcelRegister("5oZLj", function(module, exports) {

let $3eef1a5063e6037c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3eef1a5063e6037c$var$load("kfrgo").then(()=>parcelRequire('2Z7LQ'));

});


parcelRegister("izWh3", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderButton", () => $e454bff21ac6d401$export$46b00316abad4d7b);

var $5uXOq = parcelRequire("5uXOq");

var $KWXOy = parcelRequire("KWXOy");

var $aQl8U = parcelRequire("aQl8U");

var $8d48V = parcelRequire("8d48V");

var $0WtYF = parcelRequire("0WtYF");

var $cSD7y = parcelRequire("cSD7y");
const $e454bff21ac6d401$export$46b00316abad4d7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)($e454bff21ac6d401$var$AppSwitcherPBWithRef);
function $e454bff21ac6d401$var$AppSwitcherPBWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8d48V.AppSwitcher), {
        label: (0, $0WtYF.SwitchToTooltipText),
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowser, {
        ref: ref,
        onOpen: onOpen,
        onMouseEnter: onMouseEnter
    });
}
const $e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowser = /*#__PURE__*/ (0, $5uXOq.forwardRef)($e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowserWithRef);
function $e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowserWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e454bff21ac6d401$var$AppSwitcherLightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8d48V.AppSwitcher), {
        ref: ref,
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $0WtYF.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    }));
}
const $e454bff21ac6d401$var$AppSwitcherLightWrapper = (0, $cSD7y.componentWithFG)('app_switcher_spotlight_gate', $e454bff21ac6d401$var$SpotLightWrapper, (0, $5uXOq.Fragment));
function $e454bff21ac6d401$var$SpotLightWrapper(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
        name: "app-switcher-spotlight"
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KWXOy.EngagementSpotlight), {
        engagementId: "app-switcher-spotlight"
    }));
}

});

parcelRegister("21e8k", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderWithLoadingPopup", () => $b3f4dfbdd92538a6$export$35c8740d616fd043);

var $5uXOq = parcelRequire("5uXOq");

var $kImV8 = parcelRequire("kImV8");

var $dd5Pg = parcelRequire("dd5Pg");
var $5ZYd9 = parcelRequire("5ZYd9");
var $aCJg8 = parcelRequire("aCJg8");

var $jgJNO = parcelRequire("jgJNO");

var $8d48V = parcelRequire("8d48V");

var $0WtYF = parcelRequire("0WtYF");
function $b3f4dfbdd92538a6$export$35c8740d616fd043() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f4dfbdd92538a6$var$SkeletonContent, null),
        isOpen: true,
        messageId: "navigation-apps-topnav4-app-switcher.ui.trigger.popup.loading.popup",
        messageType: "transactional",
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: $b3f4dfbdd92538a6$var$Trigger
    });
}
function $b3f4dfbdd92538a6$var$Trigger(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8d48V.AppSwitcher), {
        ...triggerProps,
        label: (0, $0WtYF.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    });
}
function $b3f4dfbdd92538a6$var$SkeletonContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZYd9.default), {
        xcss: $b3f4dfbdd92538a6$var$containerStyles,
        rowGap: "space.200",
        columnGap: "space.150",
        templateColumns: "32px 1fr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f4dfbdd92538a6$var$SkeletonItems, null));
}
function $b3f4dfbdd92538a6$var$SkeletonItems() {
    return Array.from({
        length: 5
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kImV8.default), {
            width: "32px",
            height: "32px",
            isShimmering: true,
            borderRadius: "8px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dd5Pg.default), {
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kImV8.default), {
            width: "100%",
            height: "10px",
            isShimmering: true,
            borderRadius: "4px"
        }))));
}
const $b3f4dfbdd92538a6$var$containerStyles = (0, $aCJg8.xcss)({
    width: '250px',
    padding: 'space.200'
});

});



parcelRegister("jzLyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a4f4791eb95a6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

const $f6a4f4791eb95a6a$var$LazyNav4RolloutAnalytics = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("30cfl")).then(({ Nav4RolloutAnalytics: Nav4RolloutAnalytics })=>Nav4RolloutAnalytics), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/rollout/analytics/src/index.tsx"
});
const $f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-nav4-rollout-analytics",
        fallback: "unmount",
        packageName: "jiraNavigationAppsSidebarNav4RolloutAnalytics",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-nav4-rollout-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6a4f4791eb95a6a$var$LazyNav4RolloutAnalytics, null)));
$f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics.displayName = 'AsyncNav4RolloutAnalytics';
var $f6a4f4791eb95a6a$export$2e2bcd8739ae039 = $f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics;

});
parcelRegister("30cfl", function(module, exports) {

let $22fadf0f358f1395$var$load = (parcelRequire("28QjX"))(4);
module.exports = $22fadf0f358f1395$var$load("3TrjM").then(()=>parcelRequire('1O92x'));

});


parcelRegister("apeap", function(module, exports) {

$parcel$export(module.exports, "useRecentActions", () => $c11b2121dbe8e38b$export$5c0647984dfa7d27);
$parcel$export(module.exports, "useRecentAllSingleList", () => $c11b2121dbe8e38b$export$9a54f46f5b7734c);
$parcel$export(module.exports, "useWorkedOnAllSingleList", () => $c11b2121dbe8e38b$export$e8278a7bcff1ec98);
$parcel$export(module.exports, "useRecentBoards", () => $c11b2121dbe8e38b$export$3731bd023be4f71);
$parcel$export(module.exports, "useRecentDashboards", () => $c11b2121dbe8e38b$export$81cb5beef51d43ca);
$parcel$export(module.exports, "useRecentProjects", () => $c11b2121dbe8e38b$export$f6b9a13c4ec08b45);
$parcel$export(module.exports, "useRecentFilters", () => $c11b2121dbe8e38b$export$8d2bfb6d3657bae2);
$parcel$export(module.exports, "useRecentQueues", () => $c11b2121dbe8e38b$export$8756abb0bb90a56e);
$parcel$export(module.exports, "RecentsContainer", () => $c11b2121dbe8e38b$export$5de14a1c1400859e);


var $165Uv = parcelRequire("165Uv");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $c11b2121dbe8e38b$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $c11b2121dbe8e38b$export$d4c72bab9d6cc13a = {
    [(0, $49a076eb01652100$export$f95f1a684a17f189)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6e58b6b0aa48a271)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6737b9227f60f39d)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$91a9dba2d38d9a6f)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$20f1031cc9fdf29e)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    workedOn: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    all: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    }
};
const $c11b2121dbe8e38b$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'quick-search-boards') acc[0, $49a076eb01652100$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'quick-search-filters') acc[0, $49a076eb01652100$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'quick-search-dashboards') acc[0, $49a076eb01652100$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'quick-search-projects') acc[0, $49a076eb01652100$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'quick-search-queues') acc[0, $49a076eb01652100$export$20f1031cc9fdf29e] = itemResponse.items;
        return acc;
    }, {});
const $c11b2121dbe8e38b$var$transformWorkedOnItems = (response)=>// select the right data and rename it
    response.data.activities.myActivities.workedOn.nodes.map(({ object: { id: id, localResourceId: localResourceId, name: name, extension: extension, iconUrl: iconUrl, url: url, containers: containers, type: type } })=>({
            id: id,
            localResourceId: localResourceId,
            title: name,
            metadata: extension.issueKey,
            avatarUrl: iconUrl,
            url: url,
            attributes: {
                containerName: containers.find((container)=>container.type === 'PROJECT')?.name
            },
            type: `${type.toLowerCase()}s`
        }));
const $c11b2121dbe8e38b$var$getQueryConfig = (amount, types)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    types.reduce((acc, type)=>{
        acc[type] = amount;
        return acc;
    }, {});
const $c11b2121dbe8e38b$var$loadRecentItems = (amount = (0, $e706d38cada11fb1$export$22ea57e66775a6b2), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $165Uv.fetchRecentItems)({
                counts: $c11b2121dbe8e38b$var$getQueryConfig(amount, typesToFetch)
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $c11b2121dbe8e38b$var$transformItems(itemResponse || []);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$var$loadRecentItemsSingleList = (amount = (0, $e706d38cada11fb1$export$5f1b6c5e9d257e5e), types)=>async ({ setState: setState, getState: getState })=>{
        if (types.length) try {
            const promise = (0, $165Uv.fetchRecentItemsSingleList)({
                types: types,
                limit: amount
            });
            const loadingState = {
                all: {
                    ...getState().all,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const responseState = {
                all: {
                    items: itemResponse != null ? itemResponse[0].items : [],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                all: {
                    ...getState().all,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$var$loadWorkedOnItems = (amount = (0, $e706d38cada11fb1$export$8666f31c8873bff))=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        try {
            const promise = (0, $165Uv.fetchWorkedOnItems)({
                cloudId: cloudId,
                amount: amount
            });
            const loadingState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const transformedItems = $c11b2121dbe8e38b$var$transformWorkedOnItems(itemResponse);
            const responseState = {
                workedOn: {
                    items: transformedItems,
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            // @ts-expect-error - TS2345 - Argument of type '{ workedOn: { items: { id: string | number; localResourceId: string; title: string; metadata: string; avatarUrl: string; url: string; attributes: { containerName: string | null | undefined; }; type: string; }[]; ... 4 more ...; hasSuccessOnce: boolean; }; }' is not assignable to parameter of type 'Partial<State>'.
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$export$e324594224ef24da = {
    loadRecentAll: (amount)=>async (actions2, props)=>{
            $c11b2121dbe8e38b$var$loadRecentItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadRecentAllSingleList: (amount)=>async (actions2, props)=>{
            $c11b2121dbe8e38b$var$loadRecentItemsSingleList(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                (0, $49a076eb01652100$export$ebb48b08205007c5),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadWorkedOnAllSingleList: $c11b2121dbe8e38b$var$loadWorkedOnItems,
    loadRecentBoards: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$f95f1a684a17f189)
        ]),
    loadRecentProjects: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$91a9dba2d38d9a6f)
        ]),
    loadRecentDashboards: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$6e58b6b0aa48a271)
        ]),
    loadRecentFilters: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$6737b9227f60f39d)
        ]),
    loadRecentQueues: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$20f1031cc9fdf29e)
        ])
};
const $c11b2121dbe8e38b$var$store = (0, $iXqE5.createStore)({
    name: (0, $e706d38cada11fb1$export$eb2b39783d051b9),
    actions: $c11b2121dbe8e38b$export$e324594224ef24da,
    initialState: $c11b2121dbe8e38b$export$d4c72bab9d6cc13a
});
const $c11b2121dbe8e38b$export$5c0647984dfa7d27 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: null
});
const $c11b2121dbe8e38b$export$9a54f46f5b7734c = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state.all
});
const $c11b2121dbe8e38b$export$e8278a7bcff1ec98 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state.workedOn
});
const $c11b2121dbe8e38b$export$3731bd023be4f71 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$f95f1a684a17f189]
});
const $c11b2121dbe8e38b$export$81cb5beef51d43ca = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6e58b6b0aa48a271]
});
const $c11b2121dbe8e38b$export$f6b9a13c4ec08b45 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$91a9dba2d38d9a6f]
});
const $c11b2121dbe8e38b$export$8d2bfb6d3657bae2 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6737b9227f60f39d]
});
const $c11b2121dbe8e38b$export$8756abb0bb90a56e = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$20f1031cc9fdf29e]
});
const $c11b2121dbe8e38b$export$5de14a1c1400859e = (0, $gg7kZ.createContainer)($c11b2121dbe8e38b$var$store);

});
parcelRegister("165Uv", function(module, exports) {

$parcel$export(module.exports, "fetchRecentItems", () => $892c454fe92da960$export$20d49db97b653a7b);
$parcel$export(module.exports, "fetchRecentItemsSingleList", () => $892c454fe92da960$export$a00963dad78984b8);
$parcel$export(module.exports, "fetchWorkedOnItems", () => $892c454fe92da960$export$f3763cb0ecc90572);

var $ebyGx = parcelRequire("ebyGx");


var $5HnTq = parcelRequire("5HnTq");

var $fPruT = parcelRequire("fPruT");

const $892c454fe92da960$var$PATH_BUCKETED = '/rest/internal/2/productsearch/search';
const $892c454fe92da960$var$PATH_SINGLE_LIST = '/rest/internal/2/productsearch/singleRecentList';
// dummy handle error
const $892c454fe92da960$var$handleError = (error)=>{
    throw error;
};
const $892c454fe92da960$var$toQuery = ({ counts: counts })=>// @ts-expect-error - TS2769 - No overload matches this call.
    Object.keys(counts) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, itemType)=>{
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<ItemType, number>>'.
        result.push(`${itemType}=${counts[itemType]}`);
        return result;
    }, []).join(',');
const $892c454fe92da960$export$20d49db97b653a7b = async ({ counts: counts })=>{
    const url = `${$892c454fe92da960$var$PATH_BUCKETED}?${(0, $ebyGx.stringify)({
        counts: $892c454fe92da960$var$toQuery({
            counts: counts
        }),
        type: Object.keys(counts).join(',')
    })}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        if (status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};
const $892c454fe92da960$export$a00963dad78984b8 = async ({ types: types, limit: limit })=>{
    const url = $892c454fe92da960$var$PATH_SINGLE_LIST;
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                groups: [
                    {
                        types: types,
                        limit: limit
                    }
                ]
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        if (status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};
const $892c454fe92da960$export$f3763cb0ecc90572 = async ({ cloudId: cloudId, amount: amount })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: 'jira_NavigationActivity',
                query: (0, $ec61554fda4e6d64$export$2b91517d6d5b4365),
                variables: {
                    first: amount,
                    cloudID: cloudId
                }
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

const $ec61554fda4e6d64$export$2b91517d6d5b4365 = `
fragment NavigationActivityItem on ActivitiesItem {
  id
  timestamp
  object {
    id
    name
    localResourceId
    type
    url
    iconUrl
    containers {
      name
      type
    }
    extension {
      ... on ActivitiesJiraIssue {
        issueKey
      }
    }
  }
}

query jira_NavigationActivity($first: Int, $cloudID: ID!) {
  activities {
    myActivities {
      workedOn(
        first: $first,
        filters: [
          {
            type: AND,
            arguments: {
              cloudIds: [$cloudID],
              products: [JIRA, JIRA_BUSINESS, JIRA_SOFTWARE, JIRA_OPS, JIRA_SERVICE_DESK]
            }
          }
        ]
      ) {
        nodes {
          ...NavigationActivityItem
        }
      }
    }
  }
}

`;


const $e706d38cada11fb1$export$eb2b39783d051b9 = 'navigation-recents-store';
const $e706d38cada11fb1$export$22ea57e66775a6b2 = 5;
const $e706d38cada11fb1$export$8666f31c8873bff = 10;
const $e706d38cada11fb1$export$5f1b6c5e9d257e5e = 20;


parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $51nlc = parcelRequire("51nlc");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("l0cYe", function(module, exports) {

$parcel$export(module.exports, "NavigationSuccessTrackerForNav3", () => $35aca48cac64f980$export$9013eebe7301dfe1);

var $5uXOq = parcelRequire("5uXOq");

var $g0Gtc = parcelRequire("g0Gtc");

var $3bQtK = parcelRequire("3bQtK");

var $7XYc4 = parcelRequire("7XYc4");

var $8CVvd = parcelRequire("8CVvd");

var $6jY6G = parcelRequire("6jY6G");

var $Mp6qH = parcelRequire("Mp6qH");
const $35aca48cac64f980$var$EmptyFragment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $35aca48cac64f980$var$NavigationSuccessTracker = ({ children: children })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const ViewExperienceSuccessTrackerComponent = route.isRedirect === true ? $35aca48cac64f980$var$EmptyFragment : (0, $g0Gtc.ExperienceSuccessTracker);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewExperienceSuccessTrackerComponent, {
        location: "atlassian-navigation-main",
        parentProviders: null,
        failureEventAttributes: null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN)
    }));
};
const $35aca48cac64f980$export$9013eebe7301dfe1 = (0, $7XYc4.componentWithCondition)((0, $8CVvd.getWillShowNav3), $35aca48cac64f980$var$NavigationSuccessTracker, (0, $5uXOq.Fragment));

});
parcelRegister("Mp6qH", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $d722fd8ef23adae6$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $d722fd8ef23adae6$export$d57b6b390e78d90f);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", () => $d722fd8ef23adae6$export$ea341e6cc435ed40);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", () => $d722fd8ef23adae6$export$cb66c02d110b1531);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", () => $d722fd8ef23adae6$export$22ea57e66775a6b2);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $d722fd8ef23adae6$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $d722fd8ef23adae6$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$6037915bf3452cf3);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$286c2faa2103eb9c);
$parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$c0d6ac131d4391b9);
$parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$8d9442dfaec4086f);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", () => $d722fd8ef23adae6$export$3014c5ec440d8824);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $d722fd8ef23adae6$export$69cbedccc0df48);
$parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", () => $d722fd8ef23adae6$export$1935aad1d702494c);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $d722fd8ef23adae6$export$cc578bc72d7a7308);
const $d722fd8ef23adae6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $d722fd8ef23adae6$export$d57b6b390e78d90f = 'navigation';
const $d722fd8ef23adae6$export$ea341e6cc435ed40 = 15;
const $d722fd8ef23adae6$export$cb66c02d110b1531 = 10;
const $d722fd8ef23adae6$export$22ea57e66775a6b2 = 5;
const $d722fd8ef23adae6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $d722fd8ef23adae6$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant',
    ROVO_DEMAND_TESTS: 'rovoDemandTests'
};
const $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $d722fd8ef23adae6$export$6037915bf3452cf3 = 'profile-spotlight';
const $d722fd8ef23adae6$export$286c2faa2103eb9c = 'help-spotlight';
const $d722fd8ef23adae6$export$c0d6ac131d4391b9 = 'search-spotlight';
const $d722fd8ef23adae6$export$8d9442dfaec4086f = 'projects-spotlight';
const $d722fd8ef23adae6$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $d722fd8ef23adae6$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $d722fd8ef23adae6$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $d722fd8ef23adae6$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;

});


parcelRegister("eoNiZ", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $96d5309c36bfdfee$export$93d4e7f90805808f);
$parcel$export(module.exports, "useNav4Theme", () => $96d5309c36bfdfee$export$b761e7abf0bdf352);

var $5uXOq = parcelRequire("5uXOq");

var $iqPPI = parcelRequire("iqPPI");

var $iNHQz = parcelRequire("iNHQz");
var $iH68k = parcelRequire("iH68k");

var $9MAC1 = parcelRequire("9MAC1");

var $2Ql51 = parcelRequire("2Ql51");

var $bt2pf = parcelRequire("bt2pf");

var $ihBhD = parcelRequire("ihBhD");
const $96d5309c36bfdfee$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $96d5309c36bfdfee$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($96d5309c36bfdfee$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $iNHQz.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $ihBhD.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $96d5309c36bfdfee$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $iH68k.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $2Ql51.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $96d5309c36bfdfee$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $9MAC1.useTheme)();
    const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
    const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bt2pf.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $iqPPI.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};
const $96d5309c36bfdfee$export$b761e7abf0bdf352 = ()=>{
    /**
   * The colors chosen by the site admin in the site settings
   */ const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $9MAC1.useTheme)();
    /**
   * Whether the user is currently using dark mode,
   * or their configured preference if this is SSR.
   */ const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
    /**
   * The adjusted background color.
   *
   * When the user is in dark mode, the lightness of the background color is capped.
   */ const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    /**
   * Creates / updates a theme-color meta tag:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
   *
   * Some browsers will use this to change the color of their UI.
   */ (0, $5uXOq.useEffect)(()=>{
        (0, $bt2pf.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return {
        backgroundColor: bg,
        highlightColor: highlightColor
    };
};

});
parcelRegister("9MAC1", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $a1f770a9d49220c1$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $a1f770a9d49220c1$export$11eb671888ed6e7d);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $LtWMd = parcelRequire("LtWMd");
const $a1f770a9d49220c1$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $a1f770a9d49220c1$var$Store = (0, $iXqE5.createStore)({
    name: 'theme',
    initialState: $a1f770a9d49220c1$var$initialState,
    actions: $LtWMd
});
const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, $51nlc.createSubscriber)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, $3sQ5x.createHook)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, $gg7kZ.createContainer)($a1f770a9d49220c1$var$Store, {
    onInit: $LtWMd.bootstrap
});

});
parcelRegister("LtWMd", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $9594f0aa641d3463$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $9594f0aa641d3463$export$722fbec263ad908a);

const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $7952ec90897ac284$exports).N0 || ajsHighlightColor !== (0, $7952ec90897ac284$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #0C66E4)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});
var $7952ec90897ac284$exports = {};

$parcel$export($7952ec90897ac284$exports, "R50", () => $7952ec90897ac284$export$4b84fd0e2c617bd);
$parcel$export($7952ec90897ac284$exports, "R75", () => $7952ec90897ac284$export$b34b069eff244586);
$parcel$export($7952ec90897ac284$exports, "R100", () => $7952ec90897ac284$export$be802dd0d8b57f35);
$parcel$export($7952ec90897ac284$exports, "R200", () => $7952ec90897ac284$export$60847d42f9da92a6);
$parcel$export($7952ec90897ac284$exports, "R300", () => $7952ec90897ac284$export$4a7404f376229999);
$parcel$export($7952ec90897ac284$exports, "R400", () => $7952ec90897ac284$export$2010d0fb4295b346);
$parcel$export($7952ec90897ac284$exports, "R500", () => $7952ec90897ac284$export$2837b5a1a71d5c02);
$parcel$export($7952ec90897ac284$exports, "Y50", () => $7952ec90897ac284$export$8d9596b529bbb9cf);
$parcel$export($7952ec90897ac284$exports, "Y75", () => $7952ec90897ac284$export$41060a744ab0b7ae);
$parcel$export($7952ec90897ac284$exports, "Y100", () => $7952ec90897ac284$export$1cc05bbbf340e559);
$parcel$export($7952ec90897ac284$exports, "Y200", () => $7952ec90897ac284$export$5aae31392d72caaa);
$parcel$export($7952ec90897ac284$exports, "Y300", () => $7952ec90897ac284$export$c6930421db9fa514);
$parcel$export($7952ec90897ac284$exports, "Y400", () => $7952ec90897ac284$export$59619663aa6500fb);
$parcel$export($7952ec90897ac284$exports, "Y500", () => $7952ec90897ac284$export$874739ea9e379ab6);
$parcel$export($7952ec90897ac284$exports, "G50", () => $7952ec90897ac284$export$8a6341c32b6a3ee6);
$parcel$export($7952ec90897ac284$exports, "G75", () => $7952ec90897ac284$export$69a3bf21b9686c2b);
$parcel$export($7952ec90897ac284$exports, "G100", () => $7952ec90897ac284$export$afbce1382ec95f73);
$parcel$export($7952ec90897ac284$exports, "G200", () => $7952ec90897ac284$export$747d86715d4175de);
$parcel$export($7952ec90897ac284$exports, "G300", () => $7952ec90897ac284$export$940e1f69e873f202);
$parcel$export($7952ec90897ac284$exports, "G400", () => $7952ec90897ac284$export$a49394138f7b8e85);
$parcel$export($7952ec90897ac284$exports, "G500", () => $7952ec90897ac284$export$6fa04827ac68a4fb);
$parcel$export($7952ec90897ac284$exports, "B50", () => $7952ec90897ac284$export$226de0355ed012f8);
$parcel$export($7952ec90897ac284$exports, "B75", () => $7952ec90897ac284$export$8c13c2ee36917869);
$parcel$export($7952ec90897ac284$exports, "B100", () => $7952ec90897ac284$export$ecfc1dff386a3e7a);
$parcel$export($7952ec90897ac284$exports, "B200", () => $7952ec90897ac284$export$215b7063051591f1);
$parcel$export($7952ec90897ac284$exports, "B300", () => $7952ec90897ac284$export$e62e8919cca44969);
$parcel$export($7952ec90897ac284$exports, "B400", () => $7952ec90897ac284$export$b3de0ae08da2ce64);
$parcel$export($7952ec90897ac284$exports, "B500", () => $7952ec90897ac284$export$a6ee3d71bc067634);
$parcel$export($7952ec90897ac284$exports, "B600", () => $7952ec90897ac284$export$67f15409e87642a1);
$parcel$export($7952ec90897ac284$exports, "B700", () => $7952ec90897ac284$export$f0539dbc42dbb067);
$parcel$export($7952ec90897ac284$exports, "P50", () => $7952ec90897ac284$export$363e4475840015bb);
$parcel$export($7952ec90897ac284$exports, "P75", () => $7952ec90897ac284$export$4b0a4417ed59760f);
$parcel$export($7952ec90897ac284$exports, "P100", () => $7952ec90897ac284$export$6011520a64d9a187);
$parcel$export($7952ec90897ac284$exports, "P200", () => $7952ec90897ac284$export$a7175d4e9206bc80);
$parcel$export($7952ec90897ac284$exports, "P300", () => $7952ec90897ac284$export$b48405b95304b5a1);
$parcel$export($7952ec90897ac284$exports, "P400", () => $7952ec90897ac284$export$c71e4279dd54a18d);
$parcel$export($7952ec90897ac284$exports, "P500", () => $7952ec90897ac284$export$147899de772240ec);
$parcel$export($7952ec90897ac284$exports, "T50", () => $7952ec90897ac284$export$2cf711fe14c66f06);
$parcel$export($7952ec90897ac284$exports, "T75", () => $7952ec90897ac284$export$7a8f4d33f6f9772c);
$parcel$export($7952ec90897ac284$exports, "T100", () => $7952ec90897ac284$export$776c9c497ef08533);
$parcel$export($7952ec90897ac284$exports, "T200", () => $7952ec90897ac284$export$69cb3ca10c1e330e);
$parcel$export($7952ec90897ac284$exports, "T300", () => $7952ec90897ac284$export$9dc1ef0f3f48059b);
$parcel$export($7952ec90897ac284$exports, "T400", () => $7952ec90897ac284$export$7c835c78b6fcdef8);
$parcel$export($7952ec90897ac284$exports, "T500", () => $7952ec90897ac284$export$6036577f95c3877e);
$parcel$export($7952ec90897ac284$exports, "N0", () => $7952ec90897ac284$export$29a4f05edc054374);
$parcel$export($7952ec90897ac284$exports, "N10", () => $7952ec90897ac284$export$e655ef011c4aa1a2);
$parcel$export($7952ec90897ac284$exports, "N20", () => $7952ec90897ac284$export$9fdfb749e33cdf97);
$parcel$export($7952ec90897ac284$exports, "N30", () => $7952ec90897ac284$export$3e51e8f1440314ba);
$parcel$export($7952ec90897ac284$exports, "N40", () => $7952ec90897ac284$export$1ce2d1575d444ceb);
$parcel$export($7952ec90897ac284$exports, "N50", () => $7952ec90897ac284$export$8754fc7e6d8b3000);
$parcel$export($7952ec90897ac284$exports, "N60", () => $7952ec90897ac284$export$c2e91cbeada39b8b);
$parcel$export($7952ec90897ac284$exports, "N70", () => $7952ec90897ac284$export$5f71e19f3a7ad9de);
$parcel$export($7952ec90897ac284$exports, "N80", () => $7952ec90897ac284$export$eaa8c8a70ac22806);
$parcel$export($7952ec90897ac284$exports, "N90", () => $7952ec90897ac284$export$7c87d337fb91a97d);
$parcel$export($7952ec90897ac284$exports, "N100", () => $7952ec90897ac284$export$d6447c357493214f);
$parcel$export($7952ec90897ac284$exports, "N200", () => $7952ec90897ac284$export$f563ee71e9ee74cd);
$parcel$export($7952ec90897ac284$exports, "N300", () => $7952ec90897ac284$export$e2ef2124cf4024b1);
$parcel$export($7952ec90897ac284$exports, "N400", () => $7952ec90897ac284$export$eece5f492e429f08);
$parcel$export($7952ec90897ac284$exports, "N500", () => $7952ec90897ac284$export$c39c0fe0f26207ae);
$parcel$export($7952ec90897ac284$exports, "N600", () => $7952ec90897ac284$export$7090862dc3038a9f);
$parcel$export($7952ec90897ac284$exports, "N700", () => $7952ec90897ac284$export$ad0bacf983b7ddaa);
$parcel$export($7952ec90897ac284$exports, "N800", () => $7952ec90897ac284$export$7d61b15e0da132af);
$parcel$export($7952ec90897ac284$exports, "N900", () => $7952ec90897ac284$export$fbda843f0a27fe96);
$parcel$export($7952ec90897ac284$exports, "N10A", () => $7952ec90897ac284$export$791e57b27ca738ef);
$parcel$export($7952ec90897ac284$exports, "N20A", () => $7952ec90897ac284$export$8d43898f60b96a82);
$parcel$export($7952ec90897ac284$exports, "N30A", () => $7952ec90897ac284$export$920c0d5c49070351);
$parcel$export($7952ec90897ac284$exports, "N40A", () => $7952ec90897ac284$export$46987b49aab6d1a8);
$parcel$export($7952ec90897ac284$exports, "N50A", () => $7952ec90897ac284$export$7d3359664e8bb0e5);
$parcel$export($7952ec90897ac284$exports, "N60A", () => $7952ec90897ac284$export$d2d3bedfb276cac0);
$parcel$export($7952ec90897ac284$exports, "N70A", () => $7952ec90897ac284$export$6e5e7499ff054f6d);
$parcel$export($7952ec90897ac284$exports, "N80A", () => $7952ec90897ac284$export$59264b346c877fa7);
$parcel$export($7952ec90897ac284$exports, "N90A", () => $7952ec90897ac284$export$d092757d7c64925c);
$parcel$export($7952ec90897ac284$exports, "N100A", () => $7952ec90897ac284$export$486ab785e4bac3c6);
$parcel$export($7952ec90897ac284$exports, "N200A", () => $7952ec90897ac284$export$fba592bbc6419fea);
$parcel$export($7952ec90897ac284$exports, "N300A", () => $7952ec90897ac284$export$13609db0e6812ab8);
$parcel$export($7952ec90897ac284$exports, "N400A", () => $7952ec90897ac284$export$fbae4efaa892d883);
$parcel$export($7952ec90897ac284$exports, "N500A", () => $7952ec90897ac284$export$f13946d26f440ce6);
$parcel$export($7952ec90897ac284$exports, "N600A", () => $7952ec90897ac284$export$19f58225ac52a306);
$parcel$export($7952ec90897ac284$exports, "N700A", () => $7952ec90897ac284$export$6384f09da70e7b62);
$parcel$export($7952ec90897ac284$exports, "N800A", () => $7952ec90897ac284$export$d0dccc730683edc2);
$parcel$export($7952ec90897ac284$exports, "DN900", () => $7952ec90897ac284$export$2f6319cf7d736c2a);
$parcel$export($7952ec90897ac284$exports, "DN800", () => $7952ec90897ac284$export$95126bc8884d6634);
$parcel$export($7952ec90897ac284$exports, "DN700", () => $7952ec90897ac284$export$8338d8c35d44ff1);
$parcel$export($7952ec90897ac284$exports, "DN600", () => $7952ec90897ac284$export$5368d76ae4fbbda7);
$parcel$export($7952ec90897ac284$exports, "DN500", () => $7952ec90897ac284$export$9f0a771d16ec8d36);
$parcel$export($7952ec90897ac284$exports, "DN400", () => $7952ec90897ac284$export$abcf8c38338b4aa5);
$parcel$export($7952ec90897ac284$exports, "DN300", () => $7952ec90897ac284$export$97e81faa16a182c7);
$parcel$export($7952ec90897ac284$exports, "DN200", () => $7952ec90897ac284$export$bfe21c59123ecf33);
$parcel$export($7952ec90897ac284$exports, "DN100", () => $7952ec90897ac284$export$ee82aa2ea6a1558);
$parcel$export($7952ec90897ac284$exports, "DN90", () => $7952ec90897ac284$export$682927c6ed76be02);
$parcel$export($7952ec90897ac284$exports, "DN80", () => $7952ec90897ac284$export$91fd9994c5be9757);
$parcel$export($7952ec90897ac284$exports, "DN70", () => $7952ec90897ac284$export$d281fbfe3cff2df6);
$parcel$export($7952ec90897ac284$exports, "DN60", () => $7952ec90897ac284$export$3902c91d8b98a753);
$parcel$export($7952ec90897ac284$exports, "DN50", () => $7952ec90897ac284$export$8e8133c1ba5845b5);
$parcel$export($7952ec90897ac284$exports, "DN40", () => $7952ec90897ac284$export$33ff357f6620b39);
$parcel$export($7952ec90897ac284$exports, "DN30", () => $7952ec90897ac284$export$633847cf062b69e0);
$parcel$export($7952ec90897ac284$exports, "DN20", () => $7952ec90897ac284$export$9776a6e503bdbf76);
$parcel$export($7952ec90897ac284$exports, "DN10", () => $7952ec90897ac284$export$6c813d5160dff5db);
$parcel$export($7952ec90897ac284$exports, "DN0", () => $7952ec90897ac284$export$3d4f271a500072a);
$parcel$export($7952ec90897ac284$exports, "DN800A", () => $7952ec90897ac284$export$fe151285c22759ec);
$parcel$export($7952ec90897ac284$exports, "DN700A", () => $7952ec90897ac284$export$a101c6190d0da34);
$parcel$export($7952ec90897ac284$exports, "DN600A", () => $7952ec90897ac284$export$4b16f52932fda51);
$parcel$export($7952ec90897ac284$exports, "DN500A", () => $7952ec90897ac284$export$a74bcd7b9845b0d8);
$parcel$export($7952ec90897ac284$exports, "DN400A", () => $7952ec90897ac284$export$9209c179316d1751);
$parcel$export($7952ec90897ac284$exports, "DN300A", () => $7952ec90897ac284$export$88f55133f636c8dd);
$parcel$export($7952ec90897ac284$exports, "DN200A", () => $7952ec90897ac284$export$51126f85d1009512);
$parcel$export($7952ec90897ac284$exports, "DN100A", () => $7952ec90897ac284$export$a069b547bd23af78);
$parcel$export($7952ec90897ac284$exports, "DN90A", () => $7952ec90897ac284$export$40cce05af3b2600a);
$parcel$export($7952ec90897ac284$exports, "DN80A", () => $7952ec90897ac284$export$b78942185925a0d);
$parcel$export($7952ec90897ac284$exports, "DN70A", () => $7952ec90897ac284$export$e058fb44b8eaafca);
$parcel$export($7952ec90897ac284$exports, "DN60A", () => $7952ec90897ac284$export$92b0b8de26920c18);
$parcel$export($7952ec90897ac284$exports, "DN50A", () => $7952ec90897ac284$export$67564f7459d3fc9e);
$parcel$export($7952ec90897ac284$exports, "DN40A", () => $7952ec90897ac284$export$77868e1ca884ffa3);
$parcel$export($7952ec90897ac284$exports, "DN30A", () => $7952ec90897ac284$export$2afd71d7d3ea2cd5);
$parcel$export($7952ec90897ac284$exports, "DN20A", () => $7952ec90897ac284$export$f2a0acaab9972c70);
$parcel$export($7952ec90897ac284$exports, "DN10A", () => $7952ec90897ac284$export$9ab70e67d6475361);
$parcel$export($7952ec90897ac284$exports, "T30", () => $7952ec90897ac284$export$d2adc5dedf09fced);
$parcel$export($7952ec90897ac284$exports, "L50", () => $7952ec90897ac284$export$f51762073d2bb381);
$parcel$export($7952ec90897ac284$exports, "L75", () => $7952ec90897ac284$export$95e26d54def96891);
// Reds
const $7952ec90897ac284$export$4b84fd0e2c617bd = '#FFEBE6';
const $7952ec90897ac284$export$b34b069eff244586 = '#FFBDAD';
const $7952ec90897ac284$export$be802dd0d8b57f35 = '#FF8F73';
const $7952ec90897ac284$export$60847d42f9da92a6 = '#FF7452';
const $7952ec90897ac284$export$4a7404f376229999 = '#FF5630';
const $7952ec90897ac284$export$2010d0fb4295b346 = '#DE350B';
const $7952ec90897ac284$export$2837b5a1a71d5c02 = '#BF2600';
const $7952ec90897ac284$export$8d9596b529bbb9cf = '#FFFAE6';
const $7952ec90897ac284$export$41060a744ab0b7ae = '#FFF0B3';
const $7952ec90897ac284$export$1cc05bbbf340e559 = '#FFE380';
const $7952ec90897ac284$export$5aae31392d72caaa = '#FFC400';
const $7952ec90897ac284$export$c6930421db9fa514 = '#FFAB00';
const $7952ec90897ac284$export$59619663aa6500fb = '#FF991F';
const $7952ec90897ac284$export$874739ea9e379ab6 = '#FF8B00';
const $7952ec90897ac284$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7952ec90897ac284$export$69a3bf21b9686c2b = '#ABF5D1';
const $7952ec90897ac284$export$afbce1382ec95f73 = '#79F2C0';
const $7952ec90897ac284$export$747d86715d4175de = '#57D9A3';
const $7952ec90897ac284$export$940e1f69e873f202 = '#36B37E';
const $7952ec90897ac284$export$a49394138f7b8e85 = '#00875A';
const $7952ec90897ac284$export$6fa04827ac68a4fb = '#006644';
const $7952ec90897ac284$export$226de0355ed012f8 = '#DEEBFF';
const $7952ec90897ac284$export$8c13c2ee36917869 = '#B3D4FF';
const $7952ec90897ac284$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7952ec90897ac284$export$215b7063051591f1 = '#2684FF';
const $7952ec90897ac284$export$e62e8919cca44969 = '#0065FF';
const $7952ec90897ac284$export$b3de0ae08da2ce64 = '#0052CC';
const $7952ec90897ac284$export$a6ee3d71bc067634 = '#0747A6';
const $7952ec90897ac284$export$67f15409e87642a1 = '#669DF1';
const $7952ec90897ac284$export$f0539dbc42dbb067 = '#8FB8F6';
const $7952ec90897ac284$export$363e4475840015bb = '#EAE6FF';
const $7952ec90897ac284$export$4b0a4417ed59760f = '#C0B6F2';
const $7952ec90897ac284$export$6011520a64d9a187 = '#998DD9';
const $7952ec90897ac284$export$a7175d4e9206bc80 = '#8777D9';
const $7952ec90897ac284$export$b48405b95304b5a1 = '#6554C0';
const $7952ec90897ac284$export$c71e4279dd54a18d = '#5243AA';
const $7952ec90897ac284$export$147899de772240ec = '#403294';
const $7952ec90897ac284$export$2cf711fe14c66f06 = '#E6FCFF';
const $7952ec90897ac284$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7952ec90897ac284$export$776c9c497ef08533 = '#79E2F2';
const $7952ec90897ac284$export$69cb3ca10c1e330e = '#00C7E6';
const $7952ec90897ac284$export$9dc1ef0f3f48059b = '#00B8D9';
const $7952ec90897ac284$export$7c835c78b6fcdef8 = '#00A3BF';
const $7952ec90897ac284$export$6036577f95c3877e = '#008DA6';
const $7952ec90897ac284$export$29a4f05edc054374 = '#FFFFFF';
const $7952ec90897ac284$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7952ec90897ac284$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7952ec90897ac284$export$3e51e8f1440314ba = '#EBECF0';
const $7952ec90897ac284$export$1ce2d1575d444ceb = '#DFE1E6';
const $7952ec90897ac284$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7952ec90897ac284$export$c2e91cbeada39b8b = '#B3BAC5';
const $7952ec90897ac284$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7952ec90897ac284$export$eaa8c8a70ac22806 = '#97A0AF';
const $7952ec90897ac284$export$7c87d337fb91a97d = '#8993A4';
const $7952ec90897ac284$export$d6447c357493214f = '#7A869A';
const $7952ec90897ac284$export$f563ee71e9ee74cd = '#6B778C';
const $7952ec90897ac284$export$e2ef2124cf4024b1 = '#5E6C84';
const $7952ec90897ac284$export$eece5f492e429f08 = '#505F79';
const $7952ec90897ac284$export$c39c0fe0f26207ae = '#42526E';
const $7952ec90897ac284$export$7090862dc3038a9f = '#344563';
const $7952ec90897ac284$export$ad0bacf983b7ddaa = '#253858';
const $7952ec90897ac284$export$7d61b15e0da132af = '#172B4D';
const $7952ec90897ac284$export$fbda843f0a27fe96 = '#091E42';
const $7952ec90897ac284$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7952ec90897ac284$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7952ec90897ac284$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7952ec90897ac284$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7952ec90897ac284$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7952ec90897ac284$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7952ec90897ac284$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7952ec90897ac284$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7952ec90897ac284$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7952ec90897ac284$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7952ec90897ac284$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7952ec90897ac284$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7952ec90897ac284$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7952ec90897ac284$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7952ec90897ac284$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7952ec90897ac284$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7952ec90897ac284$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7952ec90897ac284$export$2f6319cf7d736c2a = '#E6EDFA';
const $7952ec90897ac284$export$95126bc8884d6634 = '#DCE5F5';
const $7952ec90897ac284$export$8338d8c35d44ff1 = '#CED9EB';
const $7952ec90897ac284$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7952ec90897ac284$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7952ec90897ac284$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7952ec90897ac284$export$97e81faa16a182c7 = '#8C9CB8';
const $7952ec90897ac284$export$bfe21c59123ecf33 = '#7988A3';
const $7952ec90897ac284$export$ee82aa2ea6a1558 = '#67758F';
const $7952ec90897ac284$export$682927c6ed76be02 = '#56637A';
const $7952ec90897ac284$export$91fd9994c5be9757 = '#455166';
const $7952ec90897ac284$export$d281fbfe3cff2df6 = '#3B475C';
const $7952ec90897ac284$export$3902c91d8b98a753 = '#313D52';
const $7952ec90897ac284$export$8e8133c1ba5845b5 = '#283447';
const $7952ec90897ac284$export$33ff357f6620b39 = '#202B3D';
const $7952ec90897ac284$export$633847cf062b69e0 = '#1B2638';
const $7952ec90897ac284$export$9776a6e503bdbf76 = '#121A29';
const $7952ec90897ac284$export$6c813d5160dff5db = '#0E1624';
const $7952ec90897ac284$export$3d4f271a500072a = '#0D1424';
const $7952ec90897ac284$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7952ec90897ac284$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7952ec90897ac284$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7952ec90897ac284$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7952ec90897ac284$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7952ec90897ac284$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7952ec90897ac284$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7952ec90897ac284$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7952ec90897ac284$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7952ec90897ac284$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7952ec90897ac284$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7952ec90897ac284$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7952ec90897ac284$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7952ec90897ac284$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7952ec90897ac284$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7952ec90897ac284$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7952ec90897ac284$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7952ec90897ac284$export$d2adc5dedf09fced = '#292A2E';
const $7952ec90897ac284$export$f51762073d2bb381 = '#94C748';
const $7952ec90897ac284$export$95e26d54def96891 = '#B3DF72';



parcelRegister("bt2pf", function(module, exports) {

$parcel$export(module.exports, "addThemeColor", () => $274a73c0f1d6297a$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getHead = ()=>document.head || document.querySelector('head');
const $274a73c0f1d6297a$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $274a73c0f1d6297a$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $274a73c0f1d6297a$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("ihBhD", function(module, exports) {

$parcel$export(module.exports, "capLightness", () => $dbd7508aaed6851f$export$8b5544bab97b10dd);
const $dbd7508aaed6851f$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $dbd7508aaed6851f$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $dbd7508aaed6851f$var$rgbFromHex = (input)=>{
    const fullHex = $dbd7508aaed6851f$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $dbd7508aaed6851f$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $dbd7508aaed6851f$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $dbd7508aaed6851f$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $dbd7508aaed6851f$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $dbd7508aaed6851f$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $dbd7508aaed6851f$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $dbd7508aaed6851f$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $dbd7508aaed6851f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $dbd7508aaed6851f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $dbd7508aaed6851f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $dbd7508aaed6851f$var$rgbToLch = (rgb)=>$dbd7508aaed6851f$var$labToLch($dbd7508aaed6851f$var$xyzToLab($dbd7508aaed6851f$var$rgbToXyz(rgb)));
const $dbd7508aaed6851f$var$lchToRgb = (lch)=>$dbd7508aaed6851f$var$xyzToRgb($dbd7508aaed6851f$var$labToXyz($dbd7508aaed6851f$var$lchToLab(lch)));
const $dbd7508aaed6851f$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $dbd7508aaed6851f$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $dbd7508aaed6851f$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $dbd7508aaed6851f$var$clamp(capPercent, 0, 100);
    return $dbd7508aaed6851f$var$rgbToHex($dbd7508aaed6851f$var$lchToRgb(lch));
};

});


parcelRegister("cibbb", function(module, exports) {

$parcel$export(module.exports, "TopNav3", () => $aa4de88b490eda4d$export$658e2de86b367732);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $bWmoi = parcelRequire("bWmoi");

var $1eJCs = parcelRequire("1eJCs");
const $aa4de88b490eda4d$export$658e2de86b367732 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('blu-6139_sync_load_nav4_top_bar', 'isEnabled', false), (0, $bWmoi.TopNavAsync), (0, $1eJCs.TopNavSync));

});
parcelRegister("bWmoi", function(module, exports) {

$parcel$export(module.exports, "TopNavAsync", () => $ab2ac48f46df03ff$export$44495c3894c87663);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $58ST7 = parcelRequire("58ST7");

const $ab2ac48f46df03ff$export$44495c3894c87663 = (0, $58ST7.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("1eJCs"))).then(({ TopNavSync: TopNavSync })=>TopNavSync);
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/top-nav/sync.tsx"
});

});
parcelRegister("1eJCs", function(module, exports) {

$parcel$export(module.exports, "TopNavSync", () => $d3216ffc7db3f41d$export$c095e90014f78159);
/* sync.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5ZiVU = parcelRequire("5ZiVU");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $bBulW = parcelRequire("bBulW");

var $6jY6G = parcelRequire("6jY6G");

var $cZpsT = parcelRequire("cZpsT");

var $dWQF5 = parcelRequire("dWQF5");

var $jyW1v = parcelRequire("jyW1v");

var $6RKvu = parcelRequire("6RKvu");

var $96WTB = parcelRequire("96WTB");

var $crC7i = parcelRequire("crC7i");

var $klog1 = parcelRequire("klog1");

var $7bwNu = parcelRequire("7bwNu");

var $ag3PC = parcelRequire("ag3PC");

var $2YzXO = parcelRequire("2YzXO");

var $1mNGt = parcelRequire("1mNGt");

var $lbp13 = parcelRequire("lbp13");

var $a5zoF = parcelRequire("a5zoF");

var $jSplz = parcelRequire("jSplz");

var $3bzLW = parcelRequire("3bzLW");

var $cvQRb = parcelRequire("cvQRb");

var $9i62K = parcelRequire("9i62K");

var $el0Fl = parcelRequire("el0Fl");

var $6U0zt = parcelRequire("6U0zt");

var $fwJYI = parcelRequire("fwJYI");

var $eoNiZ = parcelRequire("eoNiZ");

var $jUhOq = parcelRequire("jUhOq");

var $inFGE = parcelRequire("inFGE");
/*
    The DiscoverMore component is from experiment TBLZ-197, so rather than updating the Atlassian Navigation
    package we are extending the renderNotifications prop for now.
    If this experiment is productionised, we will move the code into the appropriate location.
*/ const $d3216ffc7db3f41d$var$RenderNotificationsWithConversationAssistant = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUhOq.ConversationAssistant), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inFGE.Notifications), null));
};
const $d3216ffc7db3f41d$var$SearchWithoutProps = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwJYI.Search), null);
const $d3216ffc7db3f41d$var$EditionAwarenessAndSearch = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3216ffc7db3f41d$var$EditionAwarenessWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBulW.EditionAwareness), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3216ffc7db3f41d$var$SearchWithoutProps, null));
const $d3216ffc7db3f41d$export$c095e90014f78159 = ()=>{
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const showAssets = (0, $9i62K.useShowAssets)();
    const showRoadmaps = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const PrimaryMenuItemsNav3 = (0, $5uXOq.useMemo)(()=>[
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mNGt.OpenOverflowMenuForPlansSpotlightObserver), {
                key: "arj-open-overflow-menu-for-plans-spotlight-observer"
            }),
            !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbp13.YourWorkDropdown), {
                key: "yourWorkDropdown"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a5zoF.Projects), {
                key: "projects"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSplz.Filters), {
                key: "filters"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bzLW.Dashboards), {
                key: "dashboards"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cvQRb.People), {
                key: "people"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mNGt.Plans), {
                key: "plans"
            }),
            showRoadmaps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $el0Fl.Roadmaps), {
                key: "roadmaps"
            }),
            showAssets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9i62K.Insight), {
                key: "insight"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U0zt.Addons), {
                key: "addons"
            })
        ].filter(Boolean), [
        isAnonymous,
        showAssets,
        showRoadmaps
    ]); // @ts-expect-error - Type 'string' is not assignable to type 'RouteName'.
    const ssrPlaceholderEnabledRoutes = [
        ...(0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') ? [
            'global-issue-navigator',
            'software-issue-navigator',
            'issue-navigator-classic',
            'servicedesk-issues',
            'issue-navigator-core'
        ] : [],
        ...(0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv') ? [
            'issue'
        ] : [],
        ...(0, $4R6GH.fg)('add_nav_ssr_placeholder_for_board_and_backlog') ? [
            'rapidboard-board',
            'rapidboard-backlog'
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZiVU.AtlassianNavigation), {
        primaryItems: PrimaryMenuItemsNav3,
        label: formatMessage((0, $jyW1v.default).topNav),
        moreLabel: formatMessage((0, $jyW1v.default).more),
        renderAppSwitcher: (0, $6RKvu.AppSwitcher),
        renderCreate: (0, $96WTB.Create),
        renderHelp: (0, $crC7i.Help),
        renderNotifications: $d3216ffc7db3f41d$var$RenderNotificationsWithConversationAssistant,
        renderProductHome: (0, $klog1.ProductHome),
        renderProfile: (0, $7bwNu.Profile),
        renderSearch: $d3216ffc7db3f41d$var$EditionAwarenessAndSearch,
        renderSettings: (0, $ag3PC.Settings),
        renderSignIn: (0, $2YzXO.SignIn),
        theme: theme,
        testId: (0, $6cNb0.testIdGenerate)(null),
        isServer: false,
        isSSRPlaceholderEnabled: ssrPlaceholderEnabledRoutes.includes(route.name)
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3216ffc7db3f41d$var$EditionAwarenessWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi _j2s1glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dWQF5", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumEdition", () => $901349e77566565e$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $901349e77566565e$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $901349e77566565e$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $901349e77566565e$export$304793dd2c5f4db0);

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $901349e77566565e$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    if ((0, $4R6GH.fg)('polaris_force-premium')) return true;
    const jpdEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $ldyPw.toEdition)((0, $ldyPw.PREMIUM_EDITION));
};
const $901349e77566565e$export$642bac71144485ad = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jpdEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $ldyPw.toEdition)((0, $ldyPw.STANDARD_EDITION));
};
const $901349e77566565e$export$a94405ffcb20c356 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    const isStandard = $901349e77566565e$export$642bac71144485ad();
    if (!(0, $4R6GH.fg)('jpd_issues_relationships')) return false;
    if (isStandard && (0, $4R6GH.fg)('jpd_issues_relationships_eap_lighthouse_customer')) return true;
    return isPremium;
};

});

parcelRegister("jyW1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $8abfadba6a4f23da$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8abfadba6a4f23da$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    topNav: {
        "id": "atlassian-navigation.top-nav",
        "defaultMessage": "Primary"
    },
    more: {
        "id": "atlassian-navigation.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("6RKvu", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $133f3cac4f90ffa1$export$9923361bd43fa030);

var $5uXOq = parcelRequire("5uXOq");

var $9jFq3 = parcelRequire("9jFq3");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");
const $133f3cac4f90ffa1$var$AppSwitcher = ({ AppSwitcherIntegration: AppSwitcherIntegration = (0, $9jFq3.AppSwitcher), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics) })=>{
    const [isOpen, { on: openMenu, off: closeMenu }] = useTopMenus((0, $lmyls.MENU_ID).APP_SWITCHER);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).APP_SWITCHER
    });
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppSwitcherIntegration, {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: closeMenu
    });
};
const $133f3cac4f90ffa1$export$9923361bd43fa030 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($133f3cac4f90ffa1$var$AppSwitcher, props));

});
parcelRegister("9jFq3", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $20a8f1ac93bd5269$export$9923361bd43fa030);

var $5uXOq = parcelRequire("5uXOq");

var $KWXOy = parcelRequire("KWXOy");

var $aQl8U = parcelRequire("aQl8U");

var $ksLsv = parcelRequire("ksLsv");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

var $4R6GH = parcelRequire("4R6GH");

var $gMP0k = parcelRequire("gMP0k");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $20a8f1ac93bd5269$var$LazyAppSwitcher = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("jHrTp")).then((module)=>module.AppSwitcher), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation-switcher-integration/src/main.tsx"
});
const $20a8f1ac93bd5269$var$AppSwitcherWithSpotlight = (props)=>{
    return (0, $4R6GH.fg)('app_switcher_spotlight_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
        name: "app-switcher-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gMP0k.AppSwitcherLight), props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KWXOy.EngagementSpotlight), {
        engagementId: "app-switcher-spotlight"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gMP0k.AppSwitcherLight), props);
};
const $20a8f1ac93bd5269$export$9923361bd43fa030 = (props)=>{
    const checkJpdCrossJoinNudgeEligibility = (0, $ksLsv.useJpdCrossJoinNudgeEligibility)();
    const showConfluenceCrossJoinNudge = (0, $ksLsv.useCrossJoinNudge)();
    const showJpdCrossJoinNudge = (0, $ksLsv.useJpdCrossJoinNudge)();
    (0, $5uXOq.useEffect)(()=>{
        checkJpdCrossJoinNudgeEligibility().then((isEligible)=>isEligible ? showJpdCrossJoinNudge() : showConfluenceCrossJoinNudge());
    }, [
        checkJpdCrossJoinNudgeEligibility,
        showConfluenceCrossJoinNudge,
        showJpdCrossJoinNudge
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        $20a8f1ac93bd5269$var$LazyAppSwitcher.preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "app-switcher.integration.async",
        packageName: "NavigationIntegrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gMP0k.AppSwitcherLight), null)
    }, props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20a8f1ac93bd5269$var$LazyAppSwitcher, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20a8f1ac93bd5269$var$AppSwitcherWithSpotlight, {
        onOpen: props.onOpen,
        onMouseEnter: handleMouseEnter
    })));
};

});
parcelRegister("ksLsv", function(module, exports) {

$parcel$export(module.exports, "useCrossJoinNudge", () => $d9661dec9418aa61$export$3c6c113f7a90d3c8);
$parcel$export(module.exports, "useCrossJoinNudgeYourWorkEligibility", () => $d9661dec9418aa61$export$1708bc6112f5b6aa);
$parcel$export(module.exports, "CrossJoinNudgeYourWork", () => $d9661dec9418aa61$export$eb1ab086083a0ea3);
$parcel$export(module.exports, "useJpdCrossJoinNudgeEligibility", () => $d9661dec9418aa61$export$cf17b7d2f952c993);
$parcel$export(module.exports, "useJpdCrossJoinNudge", () => $d9661dec9418aa61$export$b59148260d6e0135);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $hqBSi = parcelRequire("hqBSi");

var $lODMY = parcelRequire("lODMY");
var $lVJAU = parcelRequire("lVJAU");

var $2q33c = parcelRequire("2q33c");

var $eRI0j = parcelRequire("eRI0j");

var $1e3dw = parcelRequire("1e3dw");

var $dxdji = parcelRequire("dxdji");

var $3yRDf = parcelRequire("3yRDf");

var $kB1IK = parcelRequire("kB1IK");

var $iVil7 = parcelRequire("iVil7");

var $j2ykK = parcelRequire("j2ykK");

var $e1J1K = parcelRequire("e1J1K");

var $8mTEW = parcelRequire("8mTEW");

var $aLcWc = parcelRequire("aLcWc");

var $25NDO = parcelRequire("25NDO");

var $iu3ma = parcelRequire("iu3ma");

var $fVgtE = parcelRequire("fVgtE");

var $eCsnX = parcelRequire("eCsnX");

var $4kGsO = parcelRequire("4kGsO");

var $fmenl = parcelRequire("fmenl");

var $khNyR = parcelRequire("khNyR");
const $d9661dec9418aa61$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $d9661dec9418aa61$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $d9661dec9418aa61$var$MAX_FEATURE_VISIT_COUNT = 3;
const $d9661dec9418aa61$export$3c6c113f7a90d3c8 = ()=>{
    const sessionId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const getNudgeRecommendations = (0, $j2ykK.useNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const cloudId = (0, $koeKL.useCloudId)();
    const getFilteredCollaborators = (0, $dxdji.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $d9661dec9418aa61$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $eCsnX.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $4kGsO.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $fVgtE.useRequestAccessErrorFlag)();
    const { getNudgeState: getNudgeStateV2a, setNudgeDismissed: setNudgeDismissedV2a } = (0, $kB1IK.useNudgeStateV2a)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const userId = (0, $90yGq.useAccountId)() || '';
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const isYourWorkRoute = (0, $lODMY.useIsActiveRoute)('your-work');
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            if (isYourWorkRoute) return;
            if (!licensedProducts.confluence) return;
            if ((0, $1e3dw.isFeatureVisited)('crossJoinNudgesConfluence', 30)) return;
            if (await (0, $aLcWc.isSiteOptedOut)(cloudId)) {
                (0, $eRI0j.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return;
            }
            if (await (0, $iVil7.hasProductAccess)('confluence', cloudId)) return;
            if (!await (0, $e1J1K.fetchIsRequestAccessCapable)('confluence', cloudId)) return;
            if (!await (0, $8mTEW.isSite7DaysOld)('confluence', cloudId)) return;
            // Since V2A Rollout to 100%, all nudge will use V2A Logic
            if (await getNudgeStateV2a() === 'DISMISSED') return;
            const featureVisitedCount = await (0, $1e3dw.getFeatureVisitedCount)(userId);
            if (featureVisitedCount >= $d9661dec9418aa61$var$MAX_FEATURE_VISIT_COUNT) return;
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $2q33c.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesConfluence', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('confluence');
                } catch  {
                    showErrorFlag('confluence');
                }
            };
            const users = await getFilteredCollaborators();
            const isContextualBandit = users.length === 0;
            const entityId = isContextualBandit ? await getNudgeRecommendations() : undefined;
            showRequestAccessPromptFlag({
                users: users,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissedV2a,
                snoozeFor30Days: ()=>(0, $1e3dw.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                integration: 'crossJoinNudgesConfluence',
                isContextualBandit: isContextualBandit,
                entityId: entityId,
                featureVisitedCount: featureVisitedCount
            });
            (0, $1e3dw.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eRI0j.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeRecommendations,
        getNudgeStateV2a,
        isYourWorkRoute,
        licensedProducts.confluence,
        push,
        setNudgeDismissedV2a,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        userId
    ]);
};
const $d9661dec9418aa61$export$1708bc6112f5b6aa = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { isVisited: isVisited } = (0, $1e3dw.useSnooze)('crossJoinNudgesYourWork');
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { getNudgeState: getNudgeState } = (0, $kB1IK.useNudgeStateYourWork)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const [isEligible, setIsEligible] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const checkEligibility = async ()=>{
            try {
                if (!licensedProducts.confluence) return;
                if (isVisited()) return;
                if (await (0, $aLcWc.isSiteOptedOut)(cloudId)) {
                    (0, $eRI0j.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesYourWork');
                    return;
                }
                if (await getNudgeState() === 'DISMISSED') return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluenceAccessCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                const hasAccessToConfluence = await (0, $iVil7.fetchCachedAccessCheck)(createAnalyticsEvent, 'confluence', cloudId, 'jiraYourWork');
                if (hasAccessToConfluence === null) return;
                if (hasAccessToConfluence) return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                const isRaCapable = await (0, $e1J1K.fetchCachedIsConfluenceRACapable)(createAnalyticsEvent, cloudId, 'jiraYourWork');
                if (isRaCapable === null) return;
                if (!isRaCapable) return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'siteAgeCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                if (!await (0, $8mTEW.isSite7DaysOld)('confluence', cloudId)) return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promotionalCard eligibleCheckSucceeded', {
                    touchpoint: 'jiraYourWork'
                });
                setIsEligible(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eRI0j.fireErrorAnalytics)('useCrossJoinNudgeYourWorkEligibility', error, {
                    cloudId: cloudId
                });
            }
        };
        checkEligibility();
    }, [
        cloudId,
        getNudgeState,
        isVisited,
        licensedProducts.confluence,
        createAnalyticsEvent
    ]);
    return isEligible;
};
const $d9661dec9418aa61$var$CrossJoinNudgeYourWorkWithChecks = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const userId = (0, $90yGq.useAccountId)() || '';
    const showSuccessFlag = (0, $4kGsO.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $fVgtE.useRequestAccessErrorFlag)();
    const { setNudgeDismissed: setNudgeDismissed } = (0, $kB1IK.useNudgeStateYourWork)();
    const { snoozeFor7Days: snoozeFor7Days, snoozeFor30Days: snoozeFor30Days, increaseVisitedCount: increaseVisitedCount } = (0, $1e3dw.useSnooze)('crossJoinNudgesYourWork');
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(false);
    const { collaborators: collaborators, isLoading: isCollaboratorsLoading } = (0, $25NDO.useCollaborators)(true);
    const { visitedCount: visitedCount, isLoading: isVisitedCountLoading } = (0, $iu3ma.useVisitedCount)(true, 'crossJoinNudgesYourWork');
    const onDismiss = (0, $5uXOq.useCallback)(()=>{
        snoozeFor7Days();
        increaseVisitedCount(visitedCount + 1);
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard dismissed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        visitedCount,
        increaseVisitedCount,
        snoozeFor7Days
    ]);
    const onSubmit = (0, $5uXOq.useCallback)(async ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard submitted', 'crossJoinNudges');
        try {
            const accessStatus = await (0, $2q33c.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesYourWork', createAnalyticsEvent);
            (0, $e1J1K.resetRACapableCache)();
            if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
            else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') {
                showSuccessFlag();
                setIsDismissed(true);
            } else {
                showErrorFlag('confluence');
                setNudgeDismissed();
                setIsDismissed(true);
            }
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promotionalCard submitError', {
                err: err
            });
            showErrorFlag('confluence');
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showSuccessFlag,
        userId
    ]);
    const onSnooze = (0, $5uXOq.useCallback)(()=>{
        snoozeFor30Days();
        increaseVisitedCount(visitedCount + 1);
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard snoozed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        visitedCount,
        increaseVisitedCount,
        snoozeFor30Days
    ]);
    const onOptOut = (0, $5uXOq.useCallback)(()=>{
        setNudgeDismissed();
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard optedOut', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        setNudgeDismissed
    ]);
    let secondaryAction;
    switch(visitedCount){
        case 0:
            secondaryAction = 'none';
            break;
        case 1:
            secondaryAction = 'snooze';
            break;
        default:
            secondaryAction = 'opt-out';
    }
    const onRender = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard shown', 'crossJoinNudges', {
            secondaryAction: secondaryAction,
            collaborators: collaborators.length
        });
    }, [
        collaborators.length,
        createAnalyticsEvent,
        secondaryAction
    ]);
    const shouldShow = !isCollaboratorsLoading && !isVisitedCountLoading && !isDismissed;
    return shouldShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khNyR.CrossJoinNudgeYourWorkCard), {
        collaborators: collaborators,
        onRender: onRender,
        onDismiss: secondaryAction === 'none' ? onDismiss : onSnooze,
        onSubmit: onSubmit,
        onSnooze: secondaryAction === 'snooze' ? onSnooze : undefined,
        onOptOut: secondaryAction === 'opt-out' ? onOptOut : undefined
    }) : null;
};
const $d9661dec9418aa61$export$eb1ab086083a0ea3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmenl.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9661dec9418aa61$var$CrossJoinNudgeYourWorkWithChecks, null));
const $d9661dec9418aa61$export$cf17b7d2f952c993 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const isJpdRoute = (0, $lODMY.useIsActiveRoute)('polaris-ideas');
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            if ((0, $1e3dw.isFeatureVisited)('crossJoinNudgesJiraToJpd', 30)) return false;
            if (isJpdRoute) return false;
            const eligibilityResponse = await (0, $3yRDf.checkJpdCrossJoinNudgeEligibility)({
                cloudId: cloudId,
                licensedProducts: licensedProducts
            });
            if (!eligibilityResponse.eligible) {
                if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $eRI0j.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return false;
            }
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eRI0j.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
            return false;
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        isJpdRoute,
        licensedProducts
    ]);
};
const $d9661dec9418aa61$export$b59148260d6e0135 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const userId = (0, $90yGq.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $dxdji.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $d9661dec9418aa61$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $eCsnX.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $4kGsO.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $fVgtE.useRequestAccessErrorFlag)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount } = (0, $1e3dw.useSnooze)('crossJoinNudgesJiraToJpd');
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $kB1IK.useNudgeStateJiraToJpd)();
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $2q33c.requestAccess)('jira-product-discovery', cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            const isUserOptOut = await getNudgeState() === 'DISMISSED';
            const featureVisitedCount = await getVisitedCount();
            if (isUserOptOut || featureVisitedCount >= $d9661dec9418aa61$var$MAX_FEATURE_VISIT_COUNT) return;
            showRequestAccessPromptFlag({
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissed,
                snoozeFor30Days: snoozeFor30Days,
                integration: 'crossJoinNudgesJiraToJpd',
                featureVisitedCount: featureVisitedCount
            });
            increaseVisitedCount(featureVisitedCount + 1);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eRI0j.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeState,
        getVisitedCount,
        increaseVisitedCount,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor30Days,
        userId
    ]);
};

});
parcelRegister("2q33c", function(module, exports) {

$parcel$export(module.exports, "requestAccess", () => $340b4be4ceadd42a$export$cd9e5995821603e1);

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $eRI0j = parcelRequire("eRI0j");
const $340b4be4ceadd42a$var$URL = '/gateway/api/invitations/v1/access-requests/request';
const $340b4be4ceadd42a$export$cd9e5995821603e1 = async (product, cloudId, userId, integration, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    try {
        const response = await (0, $7f4tk.default)($340b4be4ceadd42a$var$URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource
            })
        });
        const { results: results } = response;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eRI0j.fireErrorAnalytics)(integration, error);
        throw new Error(`${integration} request access error`);
    }
};

});
parcelRegister("eRI0j", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $befbec547801077a$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireSiteOptedOutAnalytics", () => $befbec547801077a$export$b6a30d1aef42926f);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
const $befbec547801077a$export$a27c21aa3ed8f0f1 = (id, error, attributes = {})=>(0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraCrossJoinNudges'
        },
        attributes: attributes,
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
const $befbec547801077a$export$b6a30d1aef42926f = (createAnalyticsEvent, integration)=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
        flagKey: 'NON_CONTEXTUAL_CJNS',
        ineligibilityReason: 'SITE_OPTED_OUT',
        integration: integration
    });
};

});


parcelRegister("1e3dw", function(module, exports) {

$parcel$export(module.exports, "isFeatureVisited", () => $6d6d9cc23b530639$export$262c003deb93a450);
$parcel$export(module.exports, "snoozeFeatureFor30Days", () => $6d6d9cc23b530639$export$788659dbff920e5f);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $6d6d9cc23b530639$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $6d6d9cc23b530639$export$41554dcbb74e65ef);
$parcel$export(module.exports, "useSnooze", () => $6d6d9cc23b530639$export$26ba987533188b38);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $2lgIf = parcelRequire("2lgIf");
const $6d6d9cc23b530639$var$VISITED_COUNT_KEY = 'CROSS_JOIN_NUDGE_CONFLUENCE_VISITED_COUNT';
const $6d6d9cc23b530639$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $6d6d9cc23b530639$var$crossJoinNudgeVisitedCache = (0, $bSSG7.createLocalStorageProvider)('cross-join-nudge-visited');
const $6d6d9cc23b530639$var$visitedKeys = {
    crossJoinNudgesConfluence: 'cross.join.nudges.confluence.visited',
    crossJoinNudgesJiraToJpd: 'cross.join.nudges.jpd.visited',
    crossJoinNudgesYourWork: 'cross.join.nudges.your.work'
};
const $6d6d9cc23b530639$export$262c003deb93a450 = (integration, snoozeForDays)=>{
    try {
        if ($6d6d9cc23b530639$var$getFeatureVisited(integration)) return true;
        $6d6d9cc23b530639$var$setFeatureVisited(integration, snoozeForDays);
        // A small cohort of users have local storage completely disabled.
        // This code detects that and always returns visited=true for those users
        if (!$6d6d9cc23b530639$var$getFeatureVisited(integration)) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $6d6d9cc23b530639$var$setFeatureVisited = (integration, numOfDaysSnoozed)=>{
    const key = $6d6d9cc23b530639$var$visitedKeys[integration];
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $6d6d9cc23b530639$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $6d6d9cc23b530639$var$crossJoinNudgeVisitedCache.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $6d6d9cc23b530639$export$7a91674e4b755c4b = (integration)=>{
    $6d6d9cc23b530639$var$setFeatureVisited(integration, 7);
};
const $6d6d9cc23b530639$export$788659dbff920e5f = (integration)=>{
    $6d6d9cc23b530639$var$setFeatureVisited(integration, 30);
};
const $6d6d9cc23b530639$var$getFeatureVisited = (integration)=>{
    const key = $6d6d9cc23b530639$var$visitedKeys[integration];
    const snoozeUntilTimestampString = $6d6d9cc23b530639$var$crossJoinNudgeVisitedCache.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $6d6d9cc23b530639$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $6d6d9cc23b530639$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $2lgIf.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $6d6d9cc23b530639$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $6d6d9cc23b530639$var$VISITED_COUNT_KEY)=>{
    await (0, $2lgIf.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};
const $6d6d9cc23b530639$export$26ba987533188b38 = (integration)=>{
    const key = $6d6d9cc23b530639$var$visitedKeys[integration];
    const accountId = (0, $90yGq.useAccountId)() || '';
    const countKey = `${key}.count`;
    return (0, $5uXOq.useMemo)(()=>({
            snoozeFor7Days: ()=>$6d6d9cc23b530639$export$7a91674e4b755c4b(integration),
            snoozeFor30Days: ()=>$6d6d9cc23b530639$export$788659dbff920e5f(integration),
            getVisitedCount: ()=>$6d6d9cc23b530639$export$64c6861c3bbd89a2(accountId, countKey),
            increaseVisitedCount: (incrementedCount)=>$6d6d9cc23b530639$export$41554dcbb74e65ef(accountId, incrementedCount, countKey),
            isVisited: ()=>$6d6d9cc23b530639$var$getFeatureVisited(integration)
        }), [
        accountId,
        countKey,
        integration
    ]);
};

});
parcelRegister("2lgIf", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $a2f0508e2b69d572$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $a2f0508e2b69d572$export$b3126db2ef6e34ed);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $a2f0508e2b69d572$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $a2f0508e2b69d572$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $a2f0508e2b69d572$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinNudges'
            },
            error: error
        });
    }
};
const $a2f0508e2b69d572$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $a2f0508e2b69d572$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("dxdji", function(module, exports) {

$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $05df166a7944f9a9$export$b05786e1a14be004);
$parcel$export(module.exports, "useFilteredUsersFromCollaborationGraph", () => $05df166a7944f9a9$export$4509f086e4a8422);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $9OXo1 = parcelRequire("9OXo1");

var $62RUt = parcelRequire("62RUt");
const $05df166a7944f9a9$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $05df166a7944f9a9$export$b05786e1a14be004 = (cloudId)=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $05df166a7944f9a9$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $eusud.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined && en.userProfile?.account_type !== 'app' && en.userProfile?.account_status !== 'deactivated' && en.userProfile?.account_status !== 'deleted').map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};
const $05df166a7944f9a9$export$4509f086e4a8422 = (cloudId, targetProduct, maxCollaborators)=>{
    const getCollaborators = $05df166a7944f9a9$export$b05786e1a14be004(cloudId);
    return (0, $5uXOq.useCallback)(async ()=>{
        const collaborators = await getCollaborators();
        let collaboratorsOnTargetProduct;
        if (targetProduct === 'confluence') collaboratorsOnTargetProduct = await (0, $62RUt.getConfluenceUsers)(collaborators, cloudId);
        else collaboratorsOnTargetProduct = await (0, $62RUt.getUsersWithProductAccess)(cloudId, targetProduct, collaborators);
        return collaboratorsOnTargetProduct.slice(0, maxCollaborators);
    }, [
        cloudId,
        getCollaborators,
        targetProduct,
        maxCollaborators
    ]);
};

});
parcelRegister("62RUt", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUsers", () => $1080fa8edae179da$export$71bcfe5bb11155f7);
$parcel$export(module.exports, "getUsersWithProductAccess", () => $1080fa8edae179da$export$a68fadaa3a8b5e25);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $1080fa8edae179da$var$URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';
const $1080fa8edae179da$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        if (!collaborators || collaborators.length === 0) return [];
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $7f4tk.default)($1080fa8edae179da$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $1080fa8edae179da$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $1080fa8edae179da$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};
const $1080fa8edae179da$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $1080fa8edae179da$export$a68fadaa3a8b5e25 = async (cloudId, product, collaborators)=>{
    const accountIds = collaborators.map((u)=>u.id);
    const lackingAccess = await (0, $7f4tk.default)($1080fa8edae179da$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });
    return collaborators.filter((c)=>!lackingAccess.includes(c.id));
};

});


parcelRegister("3yRDf", function(module, exports) {

$parcel$export(module.exports, "checkJpdCrossJoinNudgeEligibility", () => $d99d20f3b9663c7b$export$db3bc6af881f6bd0);

var $iVil7 = parcelRequire("iVil7");

var $e1J1K = parcelRequire("e1J1K");

var $8mTEW = parcelRequire("8mTEW");

var $aLcWc = parcelRequire("aLcWc");
const $d99d20f3b9663c7b$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, licensedProducts: licensedProducts })=>{
    if (!licensedProducts['jira-product-discovery']) return {
        eligible: false,
        ineligibilityReason: 'NO_JPD_LICENCE'
    };
    if (await (0, $aLcWc.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (!await (0, $8mTEW.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (await (0, $iVil7.hasProductAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (!await (0, $e1J1K.fetchIsRequestAccessCapable)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};

});
parcelRegister("iVil7", function(module, exports) {

$parcel$export(module.exports, "hasProductAccess", () => $543bba9bf251c6d1$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $543bba9bf251c6d1$export$cd2f9bc003d00b45);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $543bba9bf251c6d1$var$URL = '/gateway/api/permissions/permitted';
const $543bba9bf251c6d1$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $7f4tk.default)($543bba9bf251c6d1$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $543bba9bf251c6d1$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $543bba9bf251c6d1$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $543bba9bf251c6d1$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $543bba9bf251c6d1$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            $543bba9bf251c6d1$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("e1J1K", function(module, exports) {

$parcel$export(module.exports, "fetchIsRequestAccessCapable", () => $b1d9429bb117b963$export$c75518284e8dee24);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $b1d9429bb117b963$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $b1d9429bb117b963$export$5191fc85eb825b4b);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $b1d9429bb117b963$export$c75518284e8dee24 = async (product, cloudId)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    const response = await (0, $7f4tk.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
};
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $b1d9429bb117b963$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $b1d9429bb117b963$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $b1d9429bb117b963$var$crossJoinApiCache.get($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $b1d9429bb117b963$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $b1d9429bb117b963$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $b1d9429bb117b963$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        $b1d9429bb117b963$var$crossJoinApiCache.set($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $b1d9429bb117b963$export$5191fc85eb825b4b = ()=>{
    $b1d9429bb117b963$var$crossJoinApiCache.remove($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});

parcelRegister("8mTEW", function(module, exports) {

$parcel$export(module.exports, "isSite7DaysOld", () => $f2be65df141d6690$export$23b7746c9e6ae406);

var $jX0pr = parcelRequire("jX0pr");
const $f2be65df141d6690$var$ACTIVATION_TRAITS = {
    confluence: 'confluence.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate'
};
const $f2be65df141d6690$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const siteTraits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $f2be65df141d6690$var$findAndCheckActivationDate(product, siteTraits);
};
const $f2be65df141d6690$var$findAndCheckActivationDate = (product, traits)=>{
    const traitName = $f2be65df141d6690$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};

});

parcelRegister("aLcWc", function(module, exports) {

$parcel$export(module.exports, "isSiteOptedOut", () => $8240992145844482$export$3475487c10c1ac17);

var $jX0pr = parcelRequire("jX0pr");
const $8240992145844482$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};

});


parcelRegister("kB1IK", function(module, exports) {

$parcel$export(module.exports, "useNudgeStateV2a", () => $b95457efaa0607a0$export$1721ab60f4854021);
$parcel$export(module.exports, "useNudgeStateYourWork", () => $b95457efaa0607a0$export$766742495b6411cb);
$parcel$export(module.exports, "useNudgeStateJiraToJpd", () => $b95457efaa0607a0$export$13bdd3f195e673d5);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $2lgIf = parcelRequire("2lgIf");
const $b95457efaa0607a0$var$getNudgeState = async (key, accountId)=>{
    if (!accountId) return 'NONE';
    const nudgeState = await (0, $2lgIf.getUserProperty)({
        accountId: accountId,
        propertyKey: key,
        defaultValue: 'NONE'
    });
    return nudgeState.value;
};
const $b95457efaa0607a0$var$setNudgeDismissState = async (key, accountId)=>{
    if (!accountId) return;
    await (0, $2lgIf.setUserProperty)({
        accountId: accountId,
        propertyKey: key,
        propertyValue: 'DISMISSED'
    });
};
const $b95457efaa0607a0$var$useNudgeState = (key)=>{
    const accountId = (0, $90yGq.useAccountId)();
    return (0, $5uXOq.useMemo)(()=>({
            getNudgeState: ()=>$b95457efaa0607a0$var$getNudgeState(key, accountId),
            setNudgeDismissed: ()=>$b95457efaa0607a0$var$setNudgeDismissState(key, accountId)
        }), [
        accountId,
        key
    ]);
};
const $b95457efaa0607a0$export$1721ab60f4854021 = ()=>$b95457efaa0607a0$var$useNudgeState('CROSS_JOIN_NUDGES_CONFLUENCE_V2A');
const $b95457efaa0607a0$export$766742495b6411cb = ()=>$b95457efaa0607a0$var$useNudgeState('CROSS_JOIN_NUDGES_YOUR_WORK');
const $b95457efaa0607a0$export$13bdd3f195e673d5 = ()=>$b95457efaa0607a0$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_JPD');

});

parcelRegister("j2ykK", function(module, exports) {

$parcel$export(module.exports, "useNudgeRecommendations", () => $121d391ba9d9ad8d$export$20e6812ba5f3fc39);

var $5uXOq = parcelRequire("5uXOq");

var $4UALF = parcelRequire("4UALF");

var $jcw0u = parcelRequire("jcw0u");

var $16v4H = parcelRequire("16v4H");

var $koeKL = parcelRequire("koeKL");

var $j68Ae = parcelRequire("j68Ae");
const $121d391ba9d9ad8d$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudge';
function $121d391ba9d9ad8d$export$20e6812ba5f3fc39({ sessionId: sessionId }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const subProduct = (0, $16v4H.useSubProduct)();
    const contextResolver = (0, $5uXOq.useCallback)(()=>({
            product: 'jira',
            useCase: $121d391ba9d9ad8d$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $4UALF.default)({
        contextResolver: contextResolver
    });
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            const result = await getRecommendations(1, $121d391ba9d9ad8d$var$asEntityIdList((0, $j68Ae.EntityList)));
            const { response: { data: data } = {} } = result;
            // This type assertion is necessary because useRecommendations don't support generic entityId
            const recommendedEntityId = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'recommendationFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'groot-growth'
                },
                error: error
            });
            throw new Error('Get nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
const $121d391ba9d9ad8d$var$asEntityIdList = (entities)=>entities.map((entity)=>({
            entityId: entity
        }));

});
parcelRegister("16v4H", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $f7eda04ad2dc7e84$export$246e1e2a5c86a633);
$parcel$export(module.exports, "useSubProduct", () => $f7eda04ad2dc7e84$export$16aa2ad52cd8992a);

var $4DPZY = parcelRequire("4DPZY");
const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("j68Ae", function(module, exports) {

$parcel$export(module.exports, "EntityList", () => $06f3a0084a41bde1$export$8bb466c13870163e);
$parcel$export(module.exports, "getDynamicMessages", () => $06f3a0084a41bde1$export$b916a1b5c615f6eb);

var $rrn66 = parcelRequire("rrn66");
const $06f3a0084a41bde1$export$8bb466c13870163e = [
    'nudgeCandidate01',
    'nudgeCandidate02',
    'nudgeCandidate03',
    'nudgeCandidate04',
    'nudgeCandidate05',
    'nudgeCandidate06',
    'nudgeCandidate07'
];
const $06f3a0084a41bde1$var$messageVariantsKeyMap = {
    default: {
        title: 'title',
        description: 'description',
        joinButton: 'joinButton'
    },
    nudgeCandidate01: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04: {
        title: 'titleNudgeCandidate04',
        description: 'descriptionNudgeCandidate04',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05: {
        title: 'titleNudgeCandidate05',
        description: 'descriptionNudgeCandidate05',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07',
        joinButton: 'joinButtonNudgeCandidate07'
    }
};
const $06f3a0084a41bde1$export$b916a1b5c615f6eb = (isContextualBandit, entityId)=>{
    // Handle case when entityId is unexpected
    if (!(entityId in $06f3a0084a41bde1$var$messageVariantsKeyMap)) return undefined;
    // If v2B is not enabled we just passthrough default message keys
    const usedEntityId = isContextualBandit ? entityId : 'default';
    const titleKey = $06f3a0084a41bde1$var$messageVariantsKeyMap[usedEntityId].title;
    const descriptionKey = $06f3a0084a41bde1$var$messageVariantsKeyMap[usedEntityId].description;
    const joinButtonKey = $06f3a0084a41bde1$var$messageVariantsKeyMap[usedEntityId].joinButton;
    return {
        title: (0, $rrn66.messages)[titleKey],
        description: (0, $rrn66.messages)[descriptionKey],
        joinButton: (0, $rrn66.messages)[joinButtonKey]
    };
};

});
parcelRegister("rrn66", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7f6fd96fbb5dfa11$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7f6fd96fbb5dfa11$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title",
        "defaultMessage": "Your team is now using Confluence"
    },
    titleNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01",
        "defaultMessage": "Join your teammates in Confluence"
    },
    titleNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02",
        "defaultMessage": "Collaborate together in Confluence"
    },
    titleNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03",
        "defaultMessage": "Your team is working in Confluence"
    },
    titleNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04",
        "defaultMessage": "Unify your projects in Confluence"
    },
    titleNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05",
        "defaultMessage": "Bring projects together in Confluence"
    },
    titleNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06",
        "defaultMessage": "Create a single source of truth"
    },
    titleNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07",
        "defaultMessage": "Create a single source of truth"
    },
    description: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    descriptionNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01",
        "defaultMessage": "Create a single source of truth for project decisions and software documentation."
    },
    descriptionNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02",
        "defaultMessage": "Capture, consolidate, and share team knowledge, in one centralized place."
    },
    descriptionNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03",
        "defaultMessage": "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04",
        "defaultMessage": "Organize project information and sync it to Jira tasks to track and hit your goals faster."
    },
    descriptionNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05",
        "defaultMessage": "Capture information in project pages and sync to Jira tasks to track your milestones."
    },
    descriptionNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06",
        "defaultMessage": "Consolidate information in one place and sync to Jira tasks for automatic updates."
    },
    descriptionNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07",
        "defaultMessage": "Join your team in Confluence to consolidate project information in one place."
    },
    joinButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07",
        "defaultMessage": "Join Confluence"
    },
    remindMeLaterButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button",
        "defaultMessage": "Remind me later"
    },
    notInterestedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.not-interested-button",
        "defaultMessage": "Not interested"
    },
    urgencyTitle: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.urgency-title",
        "defaultMessage": "{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}"
    },
    titleJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-jpd-nudge",
        "defaultMessage": "Join your team in using Jira Product Discovery"
    },
    descriptionJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-jpd-nudge",
        "defaultMessage": "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    getStartedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.get-started-button",
        "defaultMessage": "Get started"
    },
    doNotShowAgainButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.do-not-show-again-button",
        "defaultMessage": "Don't show again"
    }
});

});



parcelRegister("25NDO", function(module, exports) {

$parcel$export(module.exports, "useCollaborators", () => $e74b148a91bec82c$export$1ccc4f4de0326402);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $dxdji = parcelRequire("dxdji");

var $62RUt = parcelRequire("62RUt");
const $e74b148a91bec82c$export$1ccc4f4de0326402 = (isEnrolled)=>{
    const [collaborators, setCollaborators] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const cloudId = (0, $koeKL.useCloudId)();
    const getCollaborators = (0, $dxdji.useUsersFromCollaborationGraph)(cloudId);
    (0, $5uXOq.useEffect)(()=>{
        const fetch = async ()=>{
            try {
                const users = await getCollaborators();
                if (!!users && users.length !== 0) {
                    const confluenceUsers = await (0, $62RUt.getConfluenceUsers)(users, cloudId);
                    setCollaborators(confluenceUsers);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useCollaborators',
                        packageName: 'jiraCrossJoinNudges'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                setIsLoading(false);
            }
        };
        if (isEnrolled) fetch();
    }, [
        cloudId,
        getCollaborators,
        isEnrolled
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            collaborators: collaborators,
            isLoading: isLoading
        }), [
        collaborators,
        isLoading
    ]);
};

});

parcelRegister("iu3ma", function(module, exports) {

$parcel$export(module.exports, "useVisitedCount", () => $4e26577f827b3885$export$fb7c0ffa45d7cd29);

var $5uXOq = parcelRequire("5uXOq");

var $1e3dw = parcelRequire("1e3dw");
const $4e26577f827b3885$export$fb7c0ffa45d7cd29 = (isEnrolled, integration)=>{
    const [visitedCount, setVisitedCount] = (0, $5uXOq.useState)(0);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const { getVisitedCount: getVisitedCount } = (0, $1e3dw.useSnooze)(integration);
    (0, $5uXOq.useEffect)(()=>{
        const fetch = async ()=>{
            const count = await getVisitedCount();
            setVisitedCount(count);
            setIsLoading(false);
        };
        if (isEnrolled) fetch();
    }, [
        getVisitedCount,
        isEnrolled
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            visitedCount: visitedCount,
            isLoading: isLoading
        }), [
        visitedCount,
        isLoading
    ]);
};

});

parcelRegister("fVgtE", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessErrorFlag", () => $c964d6607e689cdd$export$d8e2d94eec4efe85);

var $5uXOq = parcelRequire("5uXOq");

var $fvINg = parcelRequire("fvINg");

var $4R6GH = parcelRequire("4R6GH");

var $fHfPB = parcelRequire("fHfPB");
var $3KRpp = parcelRequire("3KRpp");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $jiuN9 = parcelRequire("jiuN9");

var $dcbMS = parcelRequire("dcbMS");

var $jhRnv = parcelRequire("jhRnv");
const $c964d6607e689cdd$export$d8e2d94eec4efe85 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    return (0, $5uXOq.useCallback)((product)=>{
        const id = `error-${(0, $dcbMS.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c964d6607e689cdd$export$e1d0d64874873c8b, {
                    ...props,
                    id: id,
                    product: product,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $c964d6607e689cdd$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $c964d6607e689cdd$export$e1d0d64874873c8b = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $jhRnv.messages).title, {
            productDisplayName: (0, $jiuN9.ProductDisplayNames)[props.product]
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $jhRnv.messages).description), (0, $4R6GH.fg)('replace-anchor-with-link__groot-growth') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvINg.default), {
            href: $c964d6607e689cdd$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $jhRnv.messages).action)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: $c964d6607e689cdd$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $jhRnv.messages).action)), "."))
    });
};

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $58ST7 = parcelRequire("58ST7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $58ST7.lazyForPaint)(()=>(parcelRequire("jGauN")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $58ST7.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("jGauN")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $58ST7.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("k9NnZ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $58ST7.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("k9NnZ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("jGauN", function(module, exports) {

let $e53a14cfa63dcf77$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e53a14cfa63dcf77$var$load("7FkEF"),
    $e53a14cfa63dcf77$var$load("68Kzv"),
    $e53a14cfa63dcf77$var$load("3NvtU"),
    $e53a14cfa63dcf77$var$load("7zMjZ"),
    $e53a14cfa63dcf77$var$load("a1dBM"),
    $e53a14cfa63dcf77$var$load("htNXN")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("k9NnZ", function(module, exports) {

let $eacaf4ea6def0ae6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eacaf4ea6def0ae6$var$load("2w7Ku").then(()=>parcelRequire('5pz6a'));

});


parcelRegister("jiuN9", function(module, exports) {

$parcel$export(module.exports, "ProductDisplayNames", () => $27198ad0b5fea339$export$46d857911d19ac95);
const $27198ad0b5fea339$export$46d857911d19ac95 = {
    confluence: 'Confluence',
    'jira-product-discovery': 'Jira Product Discovery'
};

});

parcelRegister("dcbMS", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $390ca3140b8da28e$export$567fc7097e064344);
let $390ca3140b8da28e$var$id = 0;
const $390ca3140b8da28e$export$567fc7097e064344 = ()=>{
    $390ca3140b8da28e$var$id += 1;
    return String($390ca3140b8da28e$var$id);
};

});

parcelRegister("jhRnv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a71831a465b380b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1a71831a465b380b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-error-flag.title",
        "defaultMessage": "We couldn't add you to {productDisplayName}"
    },
    description: {
        "id": "cross-join-nudges.request-access-error-flag.description",
        "defaultMessage": "Try again in a few minutes. If you still aren't able to join, "
    },
    action: {
        "id": "cross-join-nudges.request-access-error-flag.action",
        "defaultMessage": "contact support"
    }
});

});


parcelRegister("eCsnX", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessPromptFlag", () => $3517fb24263f5c55$export$233a6a0aca8c9091);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $90yGq = parcelRequire("90yGq");

var $koVbs = parcelRequire("koVbs");

var $j68Ae = parcelRequire("j68Ae");

var $dcbMS = parcelRequire("dcbMS");

var $rrn66 = parcelRequire("rrn66");

var $c62ZK = parcelRequire("c62ZK");
const $3517fb24263f5c55$export$233a6a0aca8c9091 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const userId = (0, $90yGq.useAccountId)() || '';
    return (0, $5uXOq.useCallback)(({ users: users, onOptout: onOptout, onSubmit: onSubmit, snoozeFor30Days: snoozeFor30Days, integration: integration, isContextualBandit: isContextualBandit = false, entityId: entityId = 'default', sessionId: sessionId = '', featureVisitedCount: featureVisitedCount = 0 })=>{
        const id = `request-access-${(0, $dcbMS.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        const eventAttributes = {
            collaborators: users.length,
            userId: userId,
            isContextualBandit: isContextualBandit,
            entityId: entityId,
            sessionId: sessionId,
            featureVisitedCount: featureVisitedCount
        };
        const submit = async ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', integration, eventAttributes);
            dismissTheFlag();
            await onSubmit();
        };
        const dismiss = ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', integration, eventAttributes);
            dismissTheFlag();
        };
        const dismissAndOptout = ()=>{
            dismiss();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag optedOut', integration, eventAttributes);
            onOptout();
        };
        const dismissAndSnooze = ()=>{
            dismissTheFlag();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, eventAttributes);
            snoozeFor30Days();
        };
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', integration, eventAttributes);
        const cjnMessages = $3517fb24263f5c55$export$690fb20bf40f4dd8(formatMessage, integration, isContextualBandit, entityId, featureVisitedCount);
        const avatarOrientation = integration === 'crossJoinNudgesJiraToJpd' ? 'horizontal' : 'vertical';
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c62ZK.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndOptout,
                    onSubmit: submit,
                    avatarOrientation: avatarOrientation,
                    messages: cjnMessages,
                    featureVisitedCount: featureVisitedCount
                })
        });
    }, [
        formatMessage,
        createAnalyticsEvent,
        dismissFlag,
        showFlag,
        userId
    ]);
};
const $3517fb24263f5c55$export$690fb20bf40f4dd8 = (formatMessage, integration, isContextualBandit, entityId, featureVisitedCount)=>{
    if (integration === 'crossJoinNudgesJiraToJpd') return {
        title: formatMessage((0, $rrn66.messages).titleJpdNudge),
        description: formatMessage((0, $rrn66.messages).descriptionJpdNudge),
        joinButton: formatMessage((0, $rrn66.messages).getStartedButton),
        remindMeLaterButton: formatMessage((0, $rrn66.messages).remindMeLaterButton),
        notInterestedButton: formatMessage((0, $rrn66.messages).doNotShowAgainButton)
    };
    if (integration === 'crossJoinNudgesConfluence') {
        const dynamicMessages = (0, $j68Ae.getDynamicMessages)(isContextualBandit, entityId) || (0, $rrn66.messages);
        const infoFlagTitle = isContextualBandit ? formatMessage((0, $rrn66.messages).title) : formatMessage((0, $rrn66.messages).urgencyTitle, {
            viewCount: featureVisitedCount
        });
        return {
            title: infoFlagTitle,
            description: formatMessage(dynamicMessages.description),
            joinButton: formatMessage(dynamicMessages.joinButton),
            remindMeLaterButton: formatMessage((0, $rrn66.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $rrn66.messages).notInterestedButton)
        };
    }
    throw new Error(`Unexpected integration ${integration}`);
};

});
parcelRegister("c62ZK", function(module, exports) {

$parcel$export(module.exports, "RequestAccessPromptFlag", () => $d6fe99398ee70a31$export$9b8813c3601640da);
/* flag-common.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8esKE = parcelRequire("8esKE");

var $dWgDh = parcelRequire("dWgDh");
var $168Yy = parcelRequire("168Yy");
var $57J83 = parcelRequire("57J83");
var $aCJg8 = parcelRequire("aCJg8");

var $3KRpp = parcelRequire("3KRpp");

var $2zDkN = parcelRequire("2zDkN");

var $9Rp90 = parcelRequire("9Rp90");
const $d6fe99398ee70a31$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptoutAndDismiss: onOptoutAndDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, messages: messages, avatarOrientation: avatarOrientation, featureVisitedCount: featureVisitedCount, ...props })=>{
    const handleOnSubmit = (0, $5uXOq.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const customFlagFooterProps = (0, $5uXOq.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $2zDkN.noop)
                }
            ],
            linkComponent: ()=>{
                let secondETA = null;
                if (featureVisitedCount === 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $168Yy.default), {
                    xcss: $d6fe99398ee70a31$var$linkButtonStyles,
                    onClick: onSnoozeAndDismiss
                }, messages.remindMeLaterButton);
                else if (featureVisitedCount > 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $168Yy.default), {
                    xcss: $d6fe99398ee70a31$var$linkButtonStyles,
                    onClick: onOptoutAndDismiss
                }, messages.notInterestedButton);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWgDh.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $168Yy.default), {
                    xcss: $d6fe99398ee70a31$var$linkButtonStyles,
                    onClick: handleOnSubmit
                }, messages.joinButton), !!secondETA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                    className: (0, $bwpsq.default)([
                        "_1kt95qml _fntnutpp _eid3utpp"
                    ])
                }), secondETA);
            }
        }), [
        featureVisitedCount,
        handleOnSubmit,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $5uXOq.useMemo)(()=>{
        return users.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Rp90.FlagCompatibleAvatarGroup), {
            alignment: avatarOrientation,
            maxAvatarCount: 2,
            tooltipPosition: "bottom",
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            size: "small",
            boundariesElement: "scrollParent"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8esKE))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        });
    }, [
        users,
        avatarOrientation
    ]);
    const FLAG_MESSAGE_TYPE = 'marketing';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: featureVisitedCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: messages.title,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57J83.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, $bwpsq.default)([
                "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0ccj1k _1yyj11wp _sudp1e54 _otyru2gc"
            ])
        }, messages.description)),
        icon: customIcon,
        messageType: FLAG_MESSAGE_TYPE,
        messageId: "cross-join-nudges.ui.request-access-prompt-flag.info-flag.request-access-prompt-flag"
    });
};
const $d6fe99398ee70a31$var$linkButtonStyles = (0, $aCJg8.xcss)({
    maxWidth: '150',
    maxHeight: '3lh',
    overflow: 'hidden',
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: '0',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    cursor: 'pointer',
    padding: '0',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $d6fe99398ee70a31$var$linkButtonSeparatorStyles = null;
const $d6fe99398ee70a31$var$mainContentContainerStyles = null;

});
parcelRegister("2zDkN", function(module, exports) {

$parcel$export(module.exports, "noop", () => $8dec5faa18776ff2$export$8793edee2d425525);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $8dec5faa18776ff2$export$8793edee2d425525 = ()=>{};

});

parcelRegister("9Rp90", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $28afe71c94c1415f$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bXfAE = parcelRequire("bXfAE");

var $OMGbo = parcelRequire("OMGbo");

var $2zDkN = parcelRequire("2zDkN");
const $28afe71c94c1415f$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $28afe71c94c1415f$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $28afe71c94c1415f$export$29beada2d5f93289 = ({ alignment: alignment, maxAvatarCount: maxAvatarCount, tooltipPosition: tooltipPosition, data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $5uXOq.useMemo)(()=>$28afe71c94c1415f$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $OMGbo.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ // @ts-ignore
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, $2zDkN.noop),
        ...props
    });
    if (alignment === 'vertical') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28afe71c94c1415f$var$VerticalAvatarGroupContainer, null, avatarGroup);
    return avatarGroup;
};
const $28afe71c94c1415f$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount })=>{
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $28afe71c94c1415f$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $28afe71c94c1415f$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $28afe71c94c1415f$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $28afe71c94c1415f$var$OVERFLOW_USER_MARKER
    });
const $28afe71c94c1415f$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXfAE.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28afe71c94c1415f$var$AvatarOverflowCountContainer, null, `+${Math.min(overflowCount, $28afe71c94c1415f$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $28afe71c94c1415f$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhkm7j4 _syaz1fxt _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $28afe71c94c1415f$var$VerticalAvatarGroupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogvv1bp4 _3mc9idpf _1hlaidpf _1qu0x0bf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("4kGsO", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessSuccessFlag", () => $4a287e4fddaeb389$export$184b02cbba392fc0);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
var $3KRpp = parcelRequire("3KRpp");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $dcbMS = parcelRequire("dcbMS");

var $dJlGU = parcelRequire("dJlGU");
const $4a287e4fddaeb389$export$184b02cbba392fc0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    return (0, $5uXOq.useCallback)(()=>{
        const id = `success-${(0, $dcbMS.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a287e4fddaeb389$export$567128fc1024c9cf, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $4a287e4fddaeb389$export$567128fc1024c9cf = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $dJlGU.messages).title),
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $dJlGU.messages).description))
    });
};

});
parcelRegister("dJlGU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $49198865101fe328$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $49198865101fe328$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-success-flag.title",
        "defaultMessage": "A request was sent to your admins"
    },
    description: {
        "id": "cross-join-nudges.request-access-success-flag.description",
        "defaultMessage": "You'll receive an email once they've reviewed it."
    }
});

});


parcelRegister("fmenl", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $14caa3dc0d5e6e39$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $jcw0u = parcelRequire("jcw0u");
const $14caa3dc0d5e6e39$export$e926676385687eaf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        onError: (_, error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'cross-join-nudges-your-work-error-boundary'
                },
                error: error
            });
        }
    }, children);

});

parcelRegister("khNyR", function(module, exports) {

$parcel$export(module.exports, "CrossJoinNudgeYourWorkCard", () => $910a9b371bd7ff78$export$7ac60ccf67d54f65);

var $5uXOq = parcelRequire("5uXOq");

var $OMGbo = parcelRequire("OMGbo");

var $dCuHC = parcelRequire("dCuHC");

var $8fabB = parcelRequire("8fabB");
var $dWgDh = parcelRequire("dWgDh");
var $aCJg8 = parcelRequire("aCJg8");

var $5aHb0 = parcelRequire("5aHb0");

var $aeQu0 = parcelRequire("aeQu0");

var $jPyhe = parcelRequire("jPyhe");

var $8tL4t = parcelRequire("8tL4t");

var $gar40 = parcelRequire("gar40");

var $29qxd = parcelRequire("29qxd");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $kQvK1 = parcelRequire("kQvK1");
const $910a9b371bd7ff78$var$Actions = ({ onSubmit: onSubmit, onSnooze: onSnooze, onOptOut: onOptOut, collaborators: collaborators })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWgDh.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCuHC.default), {
        onClick: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $kQvK1.messages).joinYourTeam,
        values: {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name.split(' ')[0]
        }
    })), onSnooze && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCuHC.default), {
        appearance: "subtle",
        onClick: onSnooze
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kQvK1.messages).remindMeLater)), onOptOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCuHC.default), {
        appearance: "subtle",
        onClick: onOptOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kQvK1.messages).notInterested)));
const $910a9b371bd7ff78$var$Avatars = ({ collaborators: collaborators })=>{
    const data = [
        (0, (/*@__PURE__*/$parcel$interopDefault($gar40))),
        (0, (/*@__PURE__*/$parcel$interopDefault($aeQu0))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jPyhe))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8tL4t)))
    ].map((src)=>({
            name: '',
            src: src
        }));
    for (const [i, user] of collaborators.entries())data[i] = {
        name: user.name,
        src: user.avatar
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        xcss: $910a9b371bd7ff78$var$AvatarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $OMGbo.default), {
        appearance: "stack",
        data: data,
        maxCount: 4,
        size: "large",
        borderColor: "white",
        testId: "cross-join-nudges.ui.your-work-widget.ui"
    }));
};
const $910a9b371bd7ff78$export$7ac60ccf67d54f65 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onRender: onRender, collaborators: collaborators, onDismiss: onDismiss, ...actionsProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    onRender();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        xcss: $910a9b371bd7ff78$var$Wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($910a9b371bd7ff78$var$Avatars, {
        collaborators: collaborators
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aHb0.PromotionalCard), {
        header: formatMessage((0, $kQvK1.messages).header, {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($29qxd))),
        imageAltText: formatMessage((0, $kQvK1.messages).imageAltText),
        description: formatMessage((0, $kQvK1.messages).description),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($910a9b371bd7ff78$var$Actions, {
            ...actionsProps,
            collaborators: collaborators
        }),
        reason: formatMessage((0, $kQvK1.messages).tooltip),
        analyticsSource: "cross-join-nudges-your-work",
        onDismiss: onDismiss
    }));
});
const $910a9b371bd7ff78$var$AvatarWrapper = (0, $aCJg8.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: '144px',
    top: '35px'
});
const $910a9b371bd7ff78$var$Wrapper = (0, $aCJg8.xcss)({
    display: 'inline-block',
    position: 'relative'
});

});
parcelRegister("5aHb0", function(module, exports) {

$parcel$export(module.exports, "PromotionalCard", () => $e71e2c86ce67b28e$export$418393e556a23457);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $g9vsp = parcelRequire("g9vsp");

var $lsVF8 = parcelRequire("lsVF8");

var $2IauN = parcelRequire("2IauN");

var $5HxSv = parcelRequire("5HxSv");

var $c63mb = parcelRequire("c63mb");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $bVZ71 = parcelRequire("bVZ71");
const $e71e2c86ce67b28e$export$418393e556a23457 = ({ imageUrl: imageUrl, imageAltText: imageAltText, header: header, description: description, primaryAction: primaryAction, reason: reason, analyticsSource: analyticsSource, isDismissLoading: isDismissLoading, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: analyticsSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Wrapper, null, onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9vsp.default), {
        appearance: "subtle",
        spacing: "none",
        isLoading: isDismissLoading,
        "aria-label": formatMessage((0, $bVZ71.default).dismiss),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2IauN))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-warning-inverse, #172B4D)"
        }),
        onClick: (e, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${analyticsSource}Dismiss`);
            onDismiss();
        }
    })), imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$ImageContainer, {
        imageUrl: imageUrl
    }, imageAltText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "img",
        "aria-label": imageAltText
    }) : null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsVF8.default), {
        size: "medium",
        as: "h2"
    }, header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Description, null, description), primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c63mb.default), {
        content: reason,
        onShow: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'promotionalCardInfo')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$FooterContent, {
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5HxSv))), {
        LEGACY_size: "small",
        label: ""
    }), formatMessage((0, $bVZ71.default).footerContent))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _bfhkvuon _16qs9g9j _1bsb1gwv _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _c71lckbl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$ImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { imageUrl: imageUrl, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ntxwly": (0, $lD23V.default)(`url(${__cmplp.imageUrl})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1lrw1dfr _4t3ibv7e _1bsb1osq _1itklex0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19pkutpp _otyrutpp _syaz1fxt _c71l1wqb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _1e0c1txw _1bah1h6o _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$FooterContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _11c81o8v _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iv47k _1xi21ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVZ71", function(module, exports) {

$parcel$export(module.exports, "default", () => $a789b7df29ddb8f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a789b7df29ddb8f2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismiss: {
        "id": "home-common-ui.promotional-card.dismiss",
        "defaultMessage": "Close"
    },
    footerContent: {
        "id": "home-common-ui.promotional-card.footer-content",
        "defaultMessage": "Why am I seeing this?"
    }
});

});


parcelRegister("aeQu0", function(module, exports) {
module.exports = new URL("Angie.ce60f296.svg", import.meta.url).toString();

});

parcelRegister("jPyhe", function(module, exports) {
module.exports = new URL("Ed.d7b4103d.svg", import.meta.url).toString();

});

parcelRegister("8tL4t", function(module, exports) {
module.exports = new URL("More.e627945d.svg", import.meta.url).toString();

});

parcelRegister("gar40", function(module, exports) {
module.exports = new URL("Norah.1b131c52.svg", import.meta.url).toString();

});

parcelRegister("29qxd", function(module, exports) {
module.exports = new URL("generic-background.3268bb58.svg", import.meta.url).toString();

});

parcelRegister("kQvK1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f46761a434cbf7ed$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f46761a434cbf7ed$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    header: {
        "id": "cross-join-nudges.your-work.header",
        "defaultMessage": "{collaborators, plural, =0 {Your team is using Confluence} one {{collaborator} is using Confluence} other {{collaborator} and others are using Confluence}}"
    },
    description: {
        "id": "cross-join-nudges.your-work.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    joinYourTeam: {
        "id": "cross-join-nudges.your-work.join-your-team",
        "defaultMessage": "{collaborators, plural, one {Join {collaborator}} other {Join your team}}"
    },
    remindMeLater: {
        "id": "cross-join-nudges.your-work.remind-me-later",
        "defaultMessage": "Remind me later"
    },
    notInterested: {
        "id": "cross-join-nudges.your-work.not-interested",
        "defaultMessage": "Not interested"
    },
    tooltip: {
        "id": "cross-join-nudges.your-work.tooltip",
        "defaultMessage": "You're seeing this suggestion because you may want to use Confluence to work with the same people you work with in Jira. Your Jira teammates already use Confluence."
    },
    imageAltText: {
        "id": "cross-join-nudges.your-work.image-alt-text",
        "defaultMessage": "Your team collaborating on a document in Confluence"
    }
});

});



parcelRegister("gMP0k", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherLight", () => $eedf22ad32c5f711$export$3787c612f09492c8);

var $5uXOq = parcelRequire("5uXOq");

var $9WtD8 = parcelRequire("9WtD8");

var $buNYF = parcelRequire("buNYF");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $8d48V = parcelRequire("8d48V");

var $0WtYF = parcelRequire("0WtYF");
const $eedf22ad32c5f711$export$3787c612f09492c8 = ({ onOpen: onOpen, onMouseEnter: onMouseEnter })=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) {
            if ((0, $4R6GH.fg)('jira_nav4_beta_drop_2')) // TODO: when cleaning up we can probably remove the Nav 4 server branch
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8d48V.AppSwitcher), {
                label: (0, $0WtYF.SwitchToTooltipText)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buNYF.Nav4SkeletonSwitcherButton), {
                label: ""
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buNYF.SkeletonSwitcherButton), {
            label: ""
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8d48V.AppSwitcher), {
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $0WtYF.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    });
    // @ts-expect-error - TS2741 - Property 'tooltip' is missing in type '{ onClick: (() => void) | undefined; }' but required in type 'BaseIconButtonProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WtD8.AppSwitcher), {
        onClick: onOpen,
        onMouseEnter: onMouseEnter
    });
};

});

parcelRegister("jHrTp", function(module, exports) {

let $e577ab5b9d1ace6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e577ab5b9d1ace6c$var$load("CRGx6").then(()=>parcelRequire('djIOy'));

});


parcelRegister("4uXxK", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $7f8668208bdb1964$export$b70f1d8bd509b358);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $Mp6qH = parcelRequire("Mp6qH");
const $7f8668208bdb1964$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $5uXOq.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `${(0, $Mp6qH.TOP_LEVEL_ERROR_BOUNDARY_ID)}.${id}`,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});

parcelRegister("iPj86", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $e639936782444614$export$444d136efe970fd3);

var $5uXOq = parcelRequire("5uXOq");

var $gDHs4 = parcelRequire("gDHs4");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");
const $e639936782444614$export$444d136efe970fd3 = ({ navigationItemId: navigationItemId })=>{
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
};

});


parcelRegister("96WTB", function(module, exports) {

$parcel$export(module.exports, "Create", () => $c8d9a30d843c92d0$export$8ade6fcbf3a7de5d);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $7kxNZ = parcelRequire("7kxNZ");

var $jp0tf = parcelRequire("jp0tf");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9YT0J = parcelRequire("9YT0J");

var $c0dQj = parcelRequire("c0dQj");

var $6cNb0 = parcelRequire("6cNb0");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $f5nIZ = parcelRequire("f5nIZ");

var $kxEY7 = parcelRequire("kxEY7");

var $cZpsT = parcelRequire("cZpsT");

var $2YP9W = parcelRequire("2YP9W");

var $Mp6qH = parcelRequire("Mp6qH");

var $3S5gG = parcelRequire("3S5gG");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $ktmuI = parcelRequire("ktmuI");

var $8fSk0 = parcelRequire("8fSk0");

var $twalS = parcelRequire("twalS");
const $c8d9a30d843c92d0$var$noop = ()=>undefined;
const $c8d9a30d843c92d0$var$Create = ({ AkCreate: AkCreate = (0, $3S5gG.Create), NudgeTooltip: NudgeTooltip = (0, $kxEY7.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $jp0tf.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $7kxNZ.useIsInitialLoadLegacyIssueCreate) })=>{
    const testId = (0, $6cNb0.testIdGenerate)('create');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    (0, $9YT0J.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $5uXOq.useRef)(false);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        if (isAnonymous && !gicOptInStateOverridden.current) {
            update(()=>({
                    gicOptInStatus: {
                        isEnabled: true
                    }
                }));
            gicOptInStateOverridden.current = true;
        }
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).start();
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $twalS.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $hULKg.GENERIC_GLOBAL_CREATE_BUTTON),
                        ...isMobileExperienceEnabled ? {
                            displayMinimizableButtons: false,
                            displayCreateAnotherIssueToggle: false,
                            triggerPointKey: (0, $hULKg.MOBILE_GLOBAL_CREATE_BUTTON)
                        } : {}
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $de7681b8672bb382$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $2YZCu.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $de7681b8672bb382$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage((0, $8fSk0.default).create),
        testId: testId,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8fSk0.default).createButtonAriaLabelIssueTermRefresh : (0, $8fSk0.default).createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCreate, {
        onClick: $c8d9a30d843c92d0$var$noop,
        text: formatMessage((0, $8fSk0.default).create),
        testId: testId,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8fSk0.default).createButtonAriaLabelIssueTermRefresh : (0, $8fSk0.default).createButtonAriaLabel)
    });
};
const $c8d9a30d843c92d0$export$8ade6fcbf3a7de5d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8d9a30d843c92d0$var$Create, props));

});
parcelRegister("7kxNZ", function(module, exports) {

$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $c1839ac195702930$export$8a73e89ffc4b9342);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c1839ac195702930$var$initialState = {
    isInitialLoad: true
};
const $c1839ac195702930$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $c1839ac195702930$var$store = (0, $iXqE5.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $c1839ac195702930$var$initialState,
    actions: $c1839ac195702930$export$e324594224ef24da
});
const $c1839ac195702930$export$8a73e89ffc4b9342 = (0, $3sQ5x.createHook)($c1839ac195702930$var$store);

});

parcelRegister("jp0tf", function(module, exports) {

$parcel$export(module.exports, "default", () => $16da541e59a26adc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");

var $4R6GH = parcelRequire("4R6GH");

var $iKCxj = parcelRequire("iKCxj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16da541e59a26adc$export$2e2bcd8739ae039 = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $iKCxj.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $6BZYo.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api.showCreateDialog({});
        (0, $iKCxj.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};

});
parcelRegister("iKCxj", function(module, exports) {

$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $d3fc7ef6ccbf5390$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $d3fc7ef6ccbf5390$export$b5c5d408bb7fd104);

var $dvqhI = parcelRequire("dvqhI");

var $ccNll = parcelRequire("ccNll");
const $d3fc7ef6ccbf5390$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $ccNll.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $ccNll.legacyIssueCreateTransitionInteraction).start();
        (0, $ccNll.legacyIssueCreateCombinedInteraction).start();
    }
};
const $d3fc7ef6ccbf5390$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $dvqhI.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $ccNll.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $ccNll.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $ccNll.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("dvqhI", function(module, exports) {

$parcel$export(module.exports, "apiReady", () => $548c078b9ef136c5$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
let $548c078b9ef136c5$var$currentBridge;
const $548c078b9ef136c5$export$330fb1a04c974aad = async ()=>{
    if ($548c078b9ef136c5$var$currentBridge) return $548c078b9ef136c5$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $548c078b9ef136c5$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("ccNll", function(module, exports) {

$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $d1196bb7209b7b8b$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $d1196bb7209b7b8b$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $d1196bb7209b7b8b$export$52353a8848646ccd);

var $ktw2A = parcelRequire("ktw2A");
const $d1196bb7209b7b8b$export$2bc24132dfd54487 = (0, $ktw2A.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $d1196bb7209b7b8b$export$ba0054dee3105c90 = (0, $ktw2A.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $d1196bb7209b7b8b$export$52353a8848646ccd = (0, $ktw2A.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



const $de7681b8672bb382$export$d983e94cf86f65d = 'global-create-button';
const $de7681b8672bb382$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("9YT0J", function(module, exports) {

$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $d36676d86816c70e$export$9086117e14a55509);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $c0dQj = parcelRequire("c0dQj");

var $5rzqz = parcelRequire("5rzqz");

var $dAfqg = parcelRequire("dAfqg");

var $cn7wb = parcelRequire("cn7wb");
const $d36676d86816c70e$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const hasUserSeenMiniModal = (0, $5uXOq.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $cn7wb.usePersistentIssueCreateModalViewResource)();
    const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $5uXOq.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * Mobile is also opting out of having any mini modal discoverability and not interacting with any of the discoverability state
	 * for if the user returns to desktop.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM && !isMobileExperienceEnabled);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM,
        isMobileExperienceEnabled
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("5rzqz", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $0a31d64d52b4b5e9$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $0a31d64d52b4b5e9$export$558a195c5bfe3787);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $1Nspv = parcelRequire("1Nspv");

var $bGrWH = parcelRequire("bGrWH");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $f5nIZ = parcelRequire("f5nIZ");

var $2YP9W = parcelRequire("2YP9W");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $hULKg = parcelRequire("hULKg");

var $cKWWX = parcelRequire("cKWWX");

var $6k7U1 = parcelRequire("6k7U1");
const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $bGrWH.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $hULKg.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null
};
const $0a31d64d52b4b5e9$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $6k7U1.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $6k7U1.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                if ((0, $4R6GH.fg)('fix-gryf-a11y-issues')) {
                    /*
					 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
					 * so that we can store the reference of this
					 * and use that to re-focus the button whenever the modal is closed
					 */ let triggerButton;
                    const handleButtonClick = (event)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const triggerButtonTarget = event.target;
                        triggerButton = triggerButtonTarget?.closest('button');
                        triggerButton?.focus();
                    };
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.addEventListener('click', handleButtonClick);
                    setTimeout(()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        document.removeEventListener('click', handleButtonClick);
                    }, 0);
                    setTimeout(()=>{
                        setState({
                            ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                            ...isDiscoverabilityPushEnabled && {
                                minimizableModalView: nextModalView,
                                persistentModalView: currentState.persistentModalView,
                                ...(0, $6k7U1.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                            },
                            inProgressIssueID: (0, $7Jxgt.v4)(),
                            isSubsequentLoad: currentState.isSubsequentLoad,
                            isModalOpen: true,
                            wasModalRetriggered: currentState.isModalOpen,
                            ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
                                triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                            } : {},
                            ...nextState,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
                            triggerButtonRef: triggerButton || document.activeElement
                        });
                    }, 0);
                } else setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $6k7U1.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, $7Jxgt.v4)(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                    } : {},
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $1Nspv.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $0a31d64d52b4b5e9$var$store = (0, $iXqE5.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
    actions: $0a31d64d52b4b5e9$export$e324594224ef24da
});
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, $3sQ5x.createStateHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, $3sQ5x.createActionsHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
    const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
    const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $cKWWX.useSitePickerContext)();
    return (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, $51nlc.createSubscriber)($0a31d64d52b4b5e9$var$store);
function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
        const { data: data } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("1Nspv", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $ff7fb599b8d98642$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $ff7fb599b8d98642$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $ff7fb599b8d98642$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $ff7fb599b8d98642$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $ff7fb599b8d98642$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $ff7fb599b8d98642$export$b2d8f8edec75f571);

var $jpBWy = parcelRequire("jpBWy");
var $Syify = parcelRequire("Syify");
const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, $Syify.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $jpBWy.ExperienceTypes).Experience,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $ff7fb599b8d98642$export$7d25d25bed94d6e2 = new (0, $Syify.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $jpBWy.ExperienceTypes).Operation,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).Custom
});
const $ff7fb599b8d98642$export$fda88e8e14acb615 = new (0, $Syify.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $jpBWy.ExperienceTypes).Operation,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).Custom
});
const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, $Syify.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $jpBWy.ExperienceTypes).Load,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).PageSegmentLoad
});
const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, $Syify.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $jpBWy.ExperienceTypes).Experience,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, $Syify.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $jpBWy.ExperienceTypes).Experience,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("bGrWH", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $4aabf2a0e09eb856$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $4aabf2a0e09eb856$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $4aabf2a0e09eb856$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $4aabf2a0e09eb856$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $4aabf2a0e09eb856$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $4aabf2a0e09eb856$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $4aabf2a0e09eb856$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $4aabf2a0e09eb856$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $4aabf2a0e09eb856$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $4aabf2a0e09eb856$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
    ...$4aabf2a0e09eb856$export$74ab3898ae683660,
    $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
    $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
    $4aabf2a0e09eb856$export$aac4661200ba4104,
    $4aabf2a0e09eb856$export$a23c32d5cf54cba0
];
const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
    [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
};
const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("hULKg", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $62659eb193cd5c9c$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $62659eb193cd5c9c$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $62659eb193cd5c9c$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $62659eb193cd5c9c$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $62659eb193cd5c9c$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $62659eb193cd5c9c$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $62659eb193cd5c9c$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $62659eb193cd5c9c$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $62659eb193cd5c9c$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $62659eb193cd5c9c$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $62659eb193cd5c9c$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $62659eb193cd5c9c$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $62659eb193cd5c9c$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $62659eb193cd5c9c$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $62659eb193cd5c9c$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $62659eb193cd5c9c$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $62659eb193cd5c9c$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $62659eb193cd5c9c$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $62659eb193cd5c9c$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $62659eb193cd5c9c$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $62659eb193cd5c9c$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $62659eb193cd5c9c$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $62659eb193cd5c9c$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $62659eb193cd5c9c$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $62659eb193cd5c9c$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $62659eb193cd5c9c$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $62659eb193cd5c9c$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $62659eb193cd5c9c$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $62659eb193cd5c9c$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $62659eb193cd5c9c$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $62659eb193cd5c9c$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_ISSUE_COMMENT", () => $62659eb193cd5c9c$export$220cd7b39e0b57a);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $62659eb193cd5c9c$export$ab926dced0f69c1e);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $62659eb193cd5c9c$export$7a8328e1f8bd992b);
const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $62659eb193cd5c9c$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $62659eb193cd5c9c$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $62659eb193cd5c9c$export$220cd7b39e0b57a = 'jira-issue-comment';
const $62659eb193cd5c9c$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $62659eb193cd5c9c$export$7a8328e1f8bd992b = [
    $62659eb193cd5c9c$export$7e9cfd1f59e60910,
    $62659eb193cd5c9c$export$708499dcd016e5e9,
    $62659eb193cd5c9c$export$e1c8789144c4c810,
    $62659eb193cd5c9c$export$c5afabb7a17e802
];

});

parcelRegister("cKWWX", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $c8055d212e869a3c$export$f8b5aae013e4cf77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $c8055d212e869a3c$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
    actions: $c8055d212e869a3c$export$e324594224ef24da
});
const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, $3sQ5x.createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);

});

parcelRegister("6k7U1", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $8a2e4df39a48d5af$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $8a2e4df39a48d5af$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $8a2e4df39a48d5af$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $8a2e4df39a48d5af$export$720579602bb055a2);

var $3e6Ej = parcelRequire("3e6Ej");

var $1Nspv = parcelRequire("1Nspv");

var $gEaAu = parcelRequire("gEaAu");

var $huY3x = parcelRequire("huY3x");
const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $1Nspv.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $gEaAu.globalIssueCreateModalLoadSubsequent) : (0, $gEaAu.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $3e6Ej.default)('global-issue.create-modal-subsequent');
    else (0, $3e6Ej.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $huY3x.startGlobalIssueCreateTTIWithAdjustments)();
};
const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("gEaAu", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $ee246606338fc99e$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $ee246606338fc99e$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $ee246606338fc99e$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $ee246606338fc99e$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $ee246606338fc99e$export$c1592e4d8d98963e);

var $ktw2A = parcelRequire("ktw2A");
const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, $ktw2A.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, $ktw2A.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $ee246606338fc99e$export$4b2382574525bb0f = (0, $ktw2A.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, $ktw2A.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $ee246606338fc99e$export$c1592e4d8d98963e = (0, $ktw2A.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("huY3x", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $06c7e44c59602f0c$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $06c7e44c59602f0c$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $06c7e44c59602f0c$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $06c7e44c59602f0c$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $06c7e44c59602f0c$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $06c7e44c59602f0c$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @atlassian/jira-packages-controllers-use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @atlassian/jira-packages-controllers-use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $ktw2A = parcelRequire("ktw2A");
const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, $ktw2A.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
};
const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
};
const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});



parcelRegister("cn7wb", function(module, exports) {

$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $c55164aa1e8f5a83$export$20dbed3226e737bc);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $2YP9W = parcelRequire("2YP9W");


var $3X1Xr = parcelRequire("3X1Xr");
const $c55164aa1e8f5a83$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $3X1Xr.persistentIssueCreateModalViewResource));
    const updateView = (0, $5uXOq.useCallback)(async (view)=>{
        try {
            await (0, $aHuqL.userPreferenceAPI).set((0, $fa76c7a777da2375$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $5uXOq.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $aHuqL.userPreferenceAPI).set((0, $fa76c7a777da2375$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';



parcelRegister("kxEY7", function(module, exports) {

$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $6b9c90b8c1e1a472$export$fc0840474cb1fce9);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

var $dsvCp = parcelRequire("dsvCp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6b9c90b8c1e1a472$var$NavigationCreateIssueButtonLazy = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("bIyQ8")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-create-issue/index.tsx"
});
const $6b9c90b8c1e1a472$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $dsvCp.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b9c90b8c1e1a472$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d)
    }, children)));
};

});
parcelRegister("bBbEG", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $383be1d115a6551b$export$3915a8814b99f0b);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $8Bc5A = parcelRequire("8Bc5A");
const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("lkem5", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $3df8b034ebbd68e5$export$9171acf2e93b7d4d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $30rnQ = parcelRequire("30rnQ");
const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $30rnQ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});


parcelRegister("dsvCp", function(module, exports) {

$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $6331d14932d8e8e2$export$b687eb4905cdc15a);

var $heI7y = parcelRequire("heI7y");
const $6331d14932d8e8e2$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $heI7y.useHasOpened)();
    return hasOpened;
};

});
parcelRegister("heI7y", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $c02ba9c4f48115f2$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $h97QA = parcelRequire("h97QA");
const $c02ba9c4f48115f2$var$actions = {
    setHasOpened: $h97QA.setHasOpened
};
const $c02ba9c4f48115f2$var$initialState = {
    hasOpened: false
};
const $c02ba9c4f48115f2$var$Store = (0, $iXqE5.createStore)({
    initialState: $c02ba9c4f48115f2$var$initialState,
    actions: $c02ba9c4f48115f2$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $c02ba9c4f48115f2$export$cbaabcded53b5c1f = (0, $3sQ5x.createHook)($c02ba9c4f48115f2$var$Store);

});
parcelRegister("h97QA", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $68011af9f70af395$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $68011af9f70af395$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $68011af9f70af395$export$2e2bcd8739ae039 = $68011af9f70af395$export$c4743c64a7c42294;

});



parcelRegister("bIyQ8", function(module, exports) {

let $887ed43b6dd24d98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $887ed43b6dd24d98$var$load("g1Qck").then(()=>parcelRequire('9NAtJ'));

});


parcelRegister("3S5gG", function(module, exports) {

$parcel$export(module.exports, "Create", () => $321e94af7b02d9cb$export$8ade6fcbf3a7de5d);

var $5uXOq = parcelRequire("5uXOq");

var $8bHFJ = parcelRequire("8bHFJ");

var $9LSSV = parcelRequire("9LSSV");

var $dCuHC = parcelRequire("dCuHC");

var $lUSty = parcelRequire("lUSty");

var $8fabB = parcelRequire("8fabB");

var $4R6GH = parcelRequire("4R6GH");

var $kvHKs = parcelRequire("kvHKs");

var $2gP8z = parcelRequire("2gP8z");

var $3HwlS = parcelRequire("3HwlS");

var $iX9It = parcelRequire("iX9It");
// This id is required to ensure pollinator tests work between Nav3 and Nav4
const $321e94af7b02d9cb$var$TEST_ID_NAV_4 = 'atlassian-navigation--create-button';
const $321e94af7b02d9cb$export$8ade6fcbf3a7de5d = (props)=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) {
            if ((0, $4R6GH.fg)('jira_nav4_beta_drop_2')) // TODO: when cleaning up we can probably remove the Nav 4 server branch
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iX9It.CreateButton), {
                testId: $321e94af7b02d9cb$var$TEST_ID_NAV_4
            }, props.text);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCuHC.default), {
                appearance: "primary",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lUSty))),
                testId: props.testId
            }, props.text);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9LSSV.SkeletonCreateButton), {
            text: props.text,
            testId: props.testId
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { onClick: onClick, text: text } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
            name: (0, $kvHKs.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iX9It.CreateButton), {
            onClick: onClick,
            testId: $321e94af7b02d9cb$var$TEST_ID_NAV_4
        }, text)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bHFJ.Create), props);
};

});
parcelRegister("2gP8z", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $bac5b90628bba66f$export$e29577842f211e22);

var $5uXOq = parcelRequire("5uXOq");

var $aQl8U = parcelRequire("aQl8U");

var $axUP7 = parcelRequire("axUP7");
const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $bac5b90628bba66f$export$e29577842f211e22 = (0, $axUP7.withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);

});
parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $a90dv = parcelRequire("a90dv");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $a90dv.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});




parcelRegister("ktmuI", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $903a8c36bcdb4b23$export$177dc7755a3f80f2);

var $jpBWy = parcelRequire("jpBWy");
var $Syify = parcelRequire("Syify");
var $64uiu = parcelRequire("64uiu");
const $903a8c36bcdb4b23$export$177dc7755a3f80f2 = new (0, $Syify.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $jpBWy.ExperienceTypes).Operation,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).Custom,
    until: (0, $64uiu.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $903a8c36bcdb4b23$export$2b83859c1548ffb5 = new (0, $Syify.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $jpBWy.ExperienceTypes).Experience,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).InlineResult
});
const $903a8c36bcdb4b23$export$a784c5bbb21ea554 = new (0, $Syify.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $jpBWy.ExperienceTypes).Experience,
    performanceType: (0, $jpBWy.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("8fSk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d702f6d77050354f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d702f6d77050354f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    create: {
        "id": "atlassian-navigation.create.create",
        "defaultMessage": "Create"
    },
    createButtonAriaLabel: {
        "id": "atlassian-navigation.create.create-button-aria-label",
        "defaultMessage": "Create issue"
    },
    createButtonAriaLabelIssueTermRefresh: {
        "id": "atlassian-navigation.create.create-button-aria-label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("twalS", function(module, exports) {

$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $ea9b0b430c82f5e1$export$fc4d210bb6a1528a);

var $gKZoD = parcelRequire("gKZoD");

var $Mp6qH = parcelRequire("Mp6qH");
const $ea9b0b430c82f5e1$export$fc4d210bb6a1528a = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $Mp6qH.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);
};

});


parcelRegister("crC7i", function(module, exports) {

$parcel$export(module.exports, "Help", () => $2e020bcbc529c0ab$export$1be7516c0280bee8);

var $5uXOq = parcelRequire("5uXOq");

var $KWXOy = parcelRequire("KWXOy");

var $aQl8U = parcelRequire("aQl8U");

var $9TWlK = parcelRequire("9TWlK");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $g8I5C = parcelRequire("g8I5C");

var $3HwlS = parcelRequire("3HwlS");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $1XJ20 = parcelRequire("1XJ20");

var $4DPZY = parcelRequire("4DPZY");

var $ajOhG = parcelRequire("ajOhG");

var $heI7y = parcelRequire("heI7y");

var $cZpsT = parcelRequire("cZpsT");

var $cSD7y = parcelRequire("cSD7y");

var $dAfqg = parcelRequire("dAfqg");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $1bshq = parcelRequire("1bshq");

var $8dSZI = parcelRequire("8dSZI");

var $iPj86 = parcelRequire("iPj86");

var $5ofLo = parcelRequire("5ofLo");

var $kPpft = parcelRequire("kPpft");
const $2e020bcbc529c0ab$var$Badge = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ofLo.Badge), props);
};
const $2e020bcbc529c0ab$var$SpotlightTargetComponent = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5788-spotlight-help-button'), $2e020bcbc529c0ab$var$JWMFeedbackSpotlightWrapper, $2e020bcbc529c0ab$var$SpotlightTargetComponentOriginal);
function $2e020bcbc529c0ab$var$SpotlightTargetComponentOriginal({ children: children }) {
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTarget, {
        name: (0, $Mp6qH.HELP_SPOTLIGHT_KEY)
    }, children), (0, $4R6GH.fg)('add_engagement_spotlight_to_navbar_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KWXOy.EngagementSpotlight), {
        name: (0, $Mp6qH.HELP_SPOTLIGHT_KEY)
    }));
}
function $2e020bcbc529c0ab$var$SpotlightTarget({ children: children, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
}
function $2e020bcbc529c0ab$var$JWMFeedbackSpotlightWrapper({ children: children }) {
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((kids)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajOhG.FeedbackNudgeAsync), null, kids), []);
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    const [isUnloaded] = (0, $cE2Qr.useIsDismissed)();
    const [openTask] = (0, $cE2Qr.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $8Bc5A.JWM_FEEDBACK_TASK) && shouldShowNudge) setHasNudgeActive(true);
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive
    ]);
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTargetComponentOriginal, null, children);
}
function $2e020bcbc529c0ab$var$HelpOld() {
    const [{ data: projectData }] = (0, $4DPZY.useContainerContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).HELP);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $8dSZI.useHelpButtonState)();
    const helpButtonRef = (0, $5uXOq.useRef)(null);
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) isProjectSimplified = projectData.project.isSimplified;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attributes = {
        helpPanelVersion: (0, $6BNJk.HELP_PANEL_VERSION),
        helpPanelType: 'inProductHelp',
        nextGenProject: isProjectSimplified
    };
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $1XJ20.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'help');
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
        else openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        closeAllMenus();
        setNavigationData({
            articleId: {
                id: '',
                type: (0, $9TWlK.ARTICLE_TYPE).HELP_ARTICLE
            },
            history: []
        });
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            isOpened: !isPanelOpen
        });
    }, [
        triggerAnalytics,
        attributes,
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        closeCurrentRightSidebar,
        openRightSidebar
    ]);
    const badge = (0, $5uXOq.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$Badge, {
            isNotificationCleared: releaseNotesNotifications === 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    const TriggerComponent = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-help${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTargetComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bshq.Help), {
            ...triggerProps,
            isSelected: isMenuOpen,
            badge: badge,
            onClick: onClick,
            tooltip: formatMessage((0, $kPpft.default).tooltip),
            label: formatMessage((0, $kPpft.default).label),
            ref: helpButtonRef
        }))), [
        testIdPrefix,
        isMenuOpen,
        badge,
        onClick,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!currentRightSidebarState?.isCollapsed && releaseNotesNotifications !== 0) setReleaseNotesNotifications(0);
    }, [
        releaseNotesNotifications,
        setReleaseNotesNotifications,
        currentRightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed) openMenu();
        else {
            closeMenu();
            if (isHelpPanelOpenedPreviously?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        openMenu,
        topMenusValue
    ]);
    if ((0, $3HwlS.getWillShowNav4)() && // eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
    (0, $6s1PB.expVal)('jira_nav4_hot_113350_changes', 'keys', []).includes('blu-6050-render-help-button-once')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
        "data-vc": `atlassian-navigation-help${false ? '-ssr' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTargetComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bshq.Help), {
        "aria-expanded": false,
        "aria-haspopup": false,
        isSelected: isMenuOpen,
        badge: badge,
        onClick: onClick,
        tooltip: formatMessage((0, $kPpft.default).tooltip),
        label: formatMessage((0, $kPpft.default).label),
        ref: helpButtonRef
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerComponent, {
        "aria-expanded": false,
        "aria-haspopup": false
    });
}
function $2e020bcbc529c0ab$var$HelpNew() {
    const isProjectSimplified = (0, $dAfqg.useIsSimplifiedProject)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).HELP);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $8dSZI.useHelpButtonState)();
    const helpButtonRef = (0, $5uXOq.useRef)(null);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attributes = {
        helpPanelVersion: (0, $6BNJk.HELP_PANEL_VERSION),
        helpPanelType: 'inProductHelp',
        nextGenProject: isProjectSimplified
    };
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $1XJ20.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'help');
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
        else openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        closeAllMenus();
        setNavigationData({
            articleId: {
                id: '',
                type: (0, $9TWlK.ARTICLE_TYPE).HELP_ARTICLE
            },
            history: []
        });
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            isOpened: !isPanelOpen
        });
    }, [
        triggerAnalytics,
        attributes,
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        closeCurrentRightSidebar,
        openRightSidebar
    ]);
    const badge = (0, $5uXOq.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ofLo.BadgeWithoutClient), {
            releaseNotesNotifications: releaseNotesNotifications ?? 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    // Restore the notifications count when the help panel is opened and the notifications count is not 0
    // We explicitly check for the collapsed state, as currentRightSidebarState is null when the sidebar is closed
    // and we don't want to set the notifications count to 0 in that case
    const shouldRestoreNotificationsCount = currentRightSidebarState?.isCollapsed === false && releaseNotesNotifications !== 0;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRestoreNotificationsCount) setReleaseNotesNotifications(0);
    }, [
        setReleaseNotesNotifications,
        shouldRestoreNotificationsCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed) openMenu();
        else {
            closeMenu();
            if (isHelpPanelOpenedPreviously?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        openMenu,
        topMenusValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
        "data-vc": `atlassian-navigation-help${false ? '-ssr' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTargetComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bshq.Help), {
        "aria-expanded": false,
        "aria-haspopup": false,
        isSelected: isMenuOpen,
        badge: badge,
        onClick: onClick,
        tooltip: formatMessage((0, $kPpft.default).tooltip),
        label: formatMessage((0, $kPpft.default).label),
        ref: helpButtonRef
    })));
}
const $2e020bcbc529c0ab$export$5d792f79638040b8 = (0, $cSD7y.componentWithFG)('nav_help_icon_vc90_top_offender_improvements', $2e020bcbc529c0ab$var$HelpNew, $2e020bcbc529c0ab$var$HelpOld);
const $2e020bcbc529c0ab$var$MemoizedHelpWithErrorBoundary = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$export$5d792f79638040b8, null)));
const $2e020bcbc529c0ab$var$HelpWithErrorBoundaryOld = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$export$5d792f79638040b8, null));
const $2e020bcbc529c0ab$export$1be7516c0280bee8 = (0, $cSD7y.componentWithFG)('nav_help_icon_vc90_top_offender_improvements', $2e020bcbc529c0ab$var$MemoizedHelpWithErrorBoundary, $2e020bcbc529c0ab$var$HelpWithErrorBoundaryOld);

});
parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});
parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $9Id1q = parcelRequire("9Id1q");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $9Id1q.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $9Id1q.layers).navigation(),
    card: (0, $9Id1q.layers).card(),
    dialog: (0, $9Id1q.layers).dialog(),
    navigation: (0, $9Id1q.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $9Id1q.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $9Id1q.layers).navigation() - 1,
    layer: (0, $9Id1q.layers).layer(),
    blanket: (0, $9Id1q.layers).blanket(),
    modal: (0, $9Id1q.layers).modal(),
    flag: (0, $9Id1q.layers).flag(),
    spotlight: (0, $9Id1q.layers).spotlight(),
    tooltip: (0, $9Id1q.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});


parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $3sQ5x.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $3sQ5x.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $iXqE5 = parcelRequire("iXqE5");

var $958ua = parcelRequire("958ua");
let $465615692863cce9$var$iphStorage;
const $465615692863cce9$var$createStorage = ()=>{
    if ($465615692863cce9$var$iphStorage) return $465615692863cce9$var$iphStorage;
    $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
    return $465615692863cce9$var$iphStorage;
};
const $465615692863cce9$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $465615692863cce9$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $3d7d84f3bc65155e$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $d0FDY = parcelRequire("d0FDY");
var $bCEqD = parcelRequire("bCEqD");
var $h6ps7 = parcelRequire("h6ps7");
var $PXxk8 = parcelRequire("PXxk8");
var $kjHnI = parcelRequire("kjHnI");
var $8NEd0 = parcelRequire("8NEd0");
var $geLBa = parcelRequire("geLBa");
var $f5jx2 = parcelRequire("f5jx2");
var $aRBNw = parcelRequire("aRBNw");
var $jj1PG = parcelRequire("jj1PG");
var $giiB1 = parcelRequire("giiB1");
var $iVQ6Q = parcelRequire("iVQ6Q");

var $3HwlS = parcelRequire("3HwlS");

var $a0mkp = parcelRequire("a0mkp");
var $bxysd = parcelRequire("bxysd");
var $1DfMg = parcelRequire("1DfMg");
var $2qlIh = parcelRequire("2qlIh");
var $8Q5qe = parcelRequire("8Q5qe");
var $h3eUp = parcelRequire("h3eUp");
var $kSdEw = parcelRequire("kSdEw");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q5qe.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geLBa.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxysd.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d0FDY.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSdEw.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jj1PG.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6ps7.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3eUp.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjHnI.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3eUp.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PXxk8.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DfMg.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8NEd0.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCEqD.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0mkp.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRBNw.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2qlIh.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5jx2.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $giiB1.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iVQ6Q.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iVQ6Q.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $94b23a6d7f5b7958$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $94b23a6d7f5b7958$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $94b23a6d7f5b7958$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $94b23a6d7f5b7958$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $94b23a6d7f5b7958$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $94b23a6d7f5b7958$export$aeff86a16f13529);

});
// dimension vars
const $94b23a6d7f5b7958$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $94b23a6d7f5b7958$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $94b23a6d7f5b7958$export$c103b605cd368aed = 'rightSidebarWidth';
const $94b23a6d7f5b7958$export$fa34f417972d6341 = 'rightPanelWidth';
const $94b23a6d7f5b7958$export$3a6a779d9181047c = 'topNavigationHeight';
const $94b23a6d7f5b7958$export$bcd94a6a792e7f96 = 'bannerHeight';
const $94b23a6d7f5b7958$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $94b23a6d7f5b7958$export$344062f7cfc9528e = 'left-panel';
const $94b23a6d7f5b7958$export$c7139cc2d6110b5f = 'right-panel';
const $94b23a6d7f5b7958$export$238d30785c4bca84 = 'banner';
const $94b23a6d7f5b7958$export$bec6dca2e63de4ae = 'top-navigation';
const $94b23a6d7f5b7958$export$d1213e82613ff4df = 'content';
const $94b23a6d7f5b7958$export$be83e7118304b28e = 56;
const $94b23a6d7f5b7958$export$4a98ee0bd1ae362 = 56;
const $94b23a6d7f5b7958$export$539e68c09584883a = 240;
const $94b23a6d7f5b7958$export$b92df8810d2fcd01 = 280;
const $94b23a6d7f5b7958$export$c3e41153b9288bcf = 368;
const $94b23a6d7f5b7958$export$c4d6152f86ea28f6 = 368;
const $94b23a6d7f5b7958$export$46acf8758e9e2636 = 20;
const $94b23a6d7f5b7958$export$70740f5ad8360a78 = 16;
const $94b23a6d7f5b7958$export$991d5285ad765a3d = 240;
const $94b23a6d7f5b7958$export$6949d4f32b161684 = 200;
const $94b23a6d7f5b7958$export$d6e7e8af042815bb = 350;
const $94b23a6d7f5b7958$export$3749e1104328fde4 = 300;
const $94b23a6d7f5b7958$export$1074d925b0b82be5 = 200;
const $94b23a6d7f5b7958$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $94b23a6d7f5b7958$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $94b23a6d7f5b7958$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $94b23a6d7f5b7958$export$70c702a8c5895f03 = 'data-grab-area-line';
const $94b23a6d7f5b7958$export$48a43f91e4becf4e = 'data-grab-area';
const $94b23a6d7f5b7958$export$dac2fb31a9f6844d = 'data-resize-button';
const $94b23a6d7f5b7958$export$9ecd22db14e6c70e = 'data-resize-control';
const $94b23a6d7f5b7958$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $94b23a6d7f5b7958$export$206a08f7f8beb554 = 'Skip to:';
const $94b23a6d7f5b7958$export$659ee746b31b360d = 'data-layout-container';
const $94b23a6d7f5b7958$export$f963aecf2d4465bd = `var(--${$94b23a6d7f5b7958$export$cbfb0f5b2869b17b}, 0px)`;
const $94b23a6d7f5b7958$export$750459958906793 = `var(--${$94b23a6d7f5b7958$export$fa34f417972d6341}, 0px)`;
const $94b23a6d7f5b7958$export$f897e1ed9f8ed251 = `var(--${$94b23a6d7f5b7958$export$a30f2e00489a8957}, 0px)`;
const $94b23a6d7f5b7958$export$b44ab66843c05a69 = `var(--${$94b23a6d7f5b7958$export$c103b605cd368aed}, 0px)`;
const $94b23a6d7f5b7958$export$aeff86a16f13529 = `var(--${$94b23a6d7f5b7958$export$3a6a779d9181047c}, 0px)`;
const $94b23a6d7f5b7958$export$ed7cc0d417ee89e = `var(--${$94b23a6d7f5b7958$export$bcd94a6a792e7f96}, 0px)`;
const $94b23a6d7f5b7958$export$d2fa14f05b61e66 = `var(--${$94b23a6d7f5b7958$export$b6744d31294864fd}, ${$94b23a6d7f5b7958$export$991d5285ad765a3d}px)`;





parcelRegister("ajOhG", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $9b3ebbbcc2dff472$export$be3f2958452e7be9);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b3ebbbcc2dff472$var$FeedbackNudgeLazy = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("h3EYG")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $9b3ebbbcc2dff472$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b3ebbbcc2dff472$var$FeedbackNudgeLazy, null, children)));
$9b3ebbbcc2dff472$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("h3EYG", function(module, exports) {

let $c6b280d0bf132372$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c6b280d0bf132372$var$load("gt003").then(()=>parcelRequire('5YJ1A'));

});


parcelRegister("1bshq", function(module, exports) {

$parcel$export(module.exports, "Help", () => $a05c7042ce796542$export$1be7516c0280bee8);

var $5uXOq = parcelRequire("5uXOq");

var $dv9Rw = parcelRequire("dv9Rw");

var $83PYV = parcelRequire("83PYV");

var $3HwlS = parcelRequire("3HwlS");

var $1MuhD = parcelRequire("1MuhD");

var $6s1PB = parcelRequire("6s1PB");
const $a05c7042ce796542$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (!(0, $6s1PB.expVal)('blu-6875-nav4-perf-help-button', 'cohort', false) && false) {
        if ((0, $3HwlS.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83PYV.Nav4SkeletonHelpButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83PYV.SkeletonHelpButton), {
            label: props.tooltip
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MuhD.Help), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            ref: ref
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dv9Rw.Help), buttonProps);
});

});

parcelRegister("8dSZI", function(module, exports) {

$parcel$export(module.exports, "useHelpButtonState", () => $dbb456bea3760752$export$e3d3de46b23d1ede);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $a6zkS = parcelRequire("a6zkS");
const $dbb456bea3760752$export$53f45136e435c2fd = 'help_button_ui_state';
const $dbb456bea3760752$export$e3d3de46b23d1ede = ()=>{
    const [releaseNotesNotifications, setReleaseNotesNotifications] = (0, $5uXOq.useState)(null);
    const [userReleaseNotesNotifications, setUserReleaseNotesNotifications] = (0, $5uXOq.useState)(null);
    const accountId = (0, $90yGq.useAccountId)();
    const updateData = (0, $5uXOq.useCallback)(()=>{
        if (userReleaseNotesNotifications !== null) {
            const newReleaseNotesNotificationsValue = userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;
            if (releaseNotesNotifications !== null) {
                if (userReleaseNotesNotifications !== releaseNotesNotifications) {
                    const remoteData = {
                        helpPanelMenu: {
                            releaseNotesNotifications: releaseNotesNotifications
                        }
                    };
                    (0, $a6zkS.updateHelpButtonState)(accountId, remoteData);
                }
            } else setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
        }
    }, [
        accountId,
        releaseNotesNotifications,
        userReleaseNotesNotifications
    ]);
    const restoreReleaseNotesNotifications = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId) {
            const userPropertiesHelpButtonValue = await (0, $a6zkS.getHelpButtonState)(accountId);
            setUserReleaseNotesNotifications(userPropertiesHelpButtonValue?.releaseNotesNotifications);
        } else setUserReleaseNotesNotifications(0);
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userReleaseNotesNotifications === null) restoreReleaseNotesNotifications();
        else updateData();
    }, [
        userReleaseNotesNotifications,
        restoreReleaseNotesNotifications,
        updateData
    ]);
    return {
        releaseNotesNotifications: releaseNotesNotifications,
        setReleaseNotesNotifications: setReleaseNotesNotifications
    };
};

});
parcelRegister("a6zkS", function(module, exports) {

$parcel$export(module.exports, "updateHelpButtonState", () => $67d0104a4e9a215c$export$c70764abdc0ffd52);
$parcel$export(module.exports, "getHelpButtonState", () => $67d0104a4e9a215c$export$9716b2ae6c8887b0);

var $8QpSo = parcelRequire("8QpSo");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

const $67d0104a4e9a215c$export$c70764abdc0ffd52 = async (accountId, data)=>{
    if (accountId !== null) try {
        await (0, $89SaW.setUserProperties)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd), JSON.stringify(data));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'updateServerHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
};
const $67d0104a4e9a215c$var$getHelpButtonStateNew = (0, $8QpSo.default)(async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
});
const $67d0104a4e9a215c$var$getHelpButtonStateOld = async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
};
const $67d0104a4e9a215c$export$9716b2ae6c8887b0 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-properties-iv-llc-unnecessary-api'), $67d0104a4e9a215c$var$getHelpButtonStateNew, $67d0104a4e9a215c$var$getHelpButtonStateOld);

});
const $2c95e3030594e0a4$export$53f45136e435c2fd = 'help_button_ui_state';



parcelRegister("5ofLo", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $04b8d99d5802ffbb$export$37acb3580601e69a);
$parcel$export(module.exports, "BadgeWithoutClient", () => $04b8d99d5802ffbb$export$56864788d737a7a1);

var $5uXOq = parcelRequire("5uXOq");

var $5GQJV = parcelRequire("5GQJV");

var $kspz4 = parcelRequire("kspz4");

var $admgR = parcelRequire("admgR");
class $04b8d99d5802ffbb$var$MockNotificationLogClient extends (0, $5GQJV.NotificationLogClient) {
    constructor(countValue){
        super('', ''), this.count = 0;
        this.count = countValue;
    }
    countUnseenNotifications() {
        return Promise.resolve({
            count: this.count
        });
    }
}
const $04b8d99d5802ffbb$var$emptyClient = new $04b8d99d5802ffbb$var$MockNotificationLogClient(0);
const $04b8d99d5802ffbb$export$32bd6ac078326cec = async (isNotificationCleared)=>{
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const notificationLogProvider = (0, $5uXOq.useMemo)(()=>new $04b8d99d5802ffbb$var$MockNotificationLogClient(releaseNotesNotifications), [
        releaseNotesNotifications
    ]);
    const result = await Promise.resolve(isNotificationCleared || false || releaseNotesNotifications === 0 ? $04b8d99d5802ffbb$var$emptyClient : notificationLogProvider);
    return result;
};
const $04b8d99d5802ffbb$export$37acb3580601e69a = ({ isNotificationCleared: isNotificationCleared })=>{
    const [notifications, setNotifications] = (0, $5uXOq.useState)(0);
    const notificationLogProvider = $04b8d99d5802ffbb$export$32bd6ac078326cec(isNotificationCleared);
    (0, $5uXOq.useEffect)(()=>{
        const initNotifications = async ()=>{
            const result = await notificationLogProvider;
            setNotifications(result.count);
        };
        initNotifications();
    }, [
        notificationLogProvider
    ]);
    return notifications > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $admgR.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, notifications) : null;
};
const $04b8d99d5802ffbb$export$56864788d737a7a1 = ({ releaseNotesNotifications: releaseNotesNotifications = 0 })=>{
    return releaseNotesNotifications > 0 && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $admgR.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, releaseNotesNotifications) : null;
};

});
parcelRegister("admgR", function(module, exports) {

$parcel$export(module.exports, "LazyNotifications", () => $c9ac2a12d590e98a$export$eebecbd0322becdd);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

var $Mp6qH = parcelRequire("Mp6qH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c9ac2a12d590e98a$var$Notifications = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("ejRQR")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/badge/src/index.tsx"
});
const $c9ac2a12d590e98a$export$eebecbd0322becdd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "help.atlaskit-badge",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-notification-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9ac2a12d590e98a$var$Notifications, props)));

});
parcelRegister("ejRQR", function(module, exports) {

let $a6cc9cd3544f9bde$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a6cc9cd3544f9bde$var$load("48dQk").then(()=>parcelRequire('2WdjF'));

});



parcelRegister("kPpft", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66fc02bdc2bad41$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e66fc02bdc2bad41$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.help.tooltip",
        "defaultMessage": "Help"
    },
    label: {
        "id": "atlassian-navigation.help.label",
        "defaultMessage": "Help"
    }
});

});


parcelRegister("klog1", function(module, exports) {

$parcel$export(module.exports, "ProductHome", () => $0ec9a9378b2b1a20$export$32d61f70e04b6020);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jkEhV = parcelRequire("jkEhV");
var $lOSvz = parcelRequire("lOSvz");

var $b91a8 = parcelRequire("b91a8");
var $d6slE = parcelRequire("d6slE");
var $2oh2c = parcelRequire("2oh2c");
var $b4sEB = parcelRequire("b4sEB");
var $aanzu = parcelRequire("aanzu");
var $3S1TU = parcelRequire("3S1TU");
var $7aEWG = parcelRequire("7aEWG");
var $kkdDT = parcelRequire("kkdDT");

var $5SQiQ = parcelRequire("5SQiQ");
var $7Nu76 = parcelRequire("7Nu76");

var $63CfG = parcelRequire("63CfG");
var $2klN0 = parcelRequire("2klN0");

var $fQKPr = parcelRequire("fQKPr");
var $8Jv2L = parcelRequire("8Jv2L");

var $2aZJo = parcelRequire("2aZJo");
var $40TsR = parcelRequire("40TsR");

var $8fabB = parcelRequire("8fabB");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $kJP8l = parcelRequire("kJP8l");

var $7frKt = parcelRequire("7frKt");

var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $52wwV = parcelRequire("52wwV");

var $iPj86 = parcelRequire("iPj86");

var $b2u1Z = parcelRequire("b2u1Z");

var $l6mLM = parcelRequire("l6mLM");
const $0ec9a9378b2b1a20$export$6d49a893c897b0cc = {
    jira: {
        icon: (0, $2oh2c.JiraIcon),
        logo: (0, $b4sEB.JiraLogo)
    },
    serviceDesk: {
        icon: (0, $7aEWG.JiraServiceManagementIcon),
        logo: (0, $kkdDT.JiraServiceManagementLogo)
    },
    'product-discovery': {
        icon: (0, $aanzu.JiraProductDiscoveryIcon),
        logo: (0, $3S1TU.JiraProductDiscoveryLogo)
    },
    'customer-service': {
        icon: (0, $b91a8.AtlassianIcon),
        logo: (0, $d6slE.AtlassianLogo)
    }
};
const $0ec9a9378b2b1a20$export$c133be38c8dacddb = {
    jira: {
        icon: (0, $5SQiQ.JiraIcon),
        logo: (0, $7Nu76.JiraLogo)
    },
    serviceDesk: {
        icon: (0, $63CfG.JiraServiceManagementIcon),
        logo: (0, $2klN0.JiraServiceManagementLogo)
    },
    'product-discovery': {
        icon: (0, $fQKPr.JiraProductDiscoveryIcon),
        logo: (0, $8Jv2L.JiraProductDiscoveryLogo)
    },
    'customer-service': {
        icon: (0, $2aZJo.CustomerServiceManagementIcon),
        logo: (0, $40TsR.CustomerServiceManagementLogo)
    }
};
const $0ec9a9378b2b1a20$var$ProductHome = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $0ec9a9378b2b1a20$var$ProductHomeNew, $0ec9a9378b2b1a20$var$ProductHomeOld);
const $0ec9a9378b2b1a20$export$32d61f70e04b6020 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$ProductHome, props));
function $0ec9a9378b2b1a20$var$ProductHomeOld({ AkCustomProductHome: AkCustomProductHome = (0, $jkEhV.default), AkProductHome: AkProductHome = (0, $lOSvz.default), useCustomLogo: useCustomLogo = (0, $52wwV.useCustomLogo), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useProductName: useProductName = (0, $kJP8l.useProductName), useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useSiteTitle: useSiteTitle = (0, $b2u1Z.useSiteTitle) }) {
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const productName = useProductName();
    const siteTitleData = useSiteTitle();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    if (logoUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCustomProductHome, {
        iconUrl: logoUrl,
        logoUrl: logoUrl,
        logoAlt: formatMessage((0, $l6mLM.default).customLogoAltText),
        iconAlt: formatMessage((0, $l6mLM.default).customIconAltText),
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
    const label = $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName);
    const { icon: Icon, logo: Logo } = $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, undefined, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProductHome, {
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
}
function $0ec9a9378b2b1a20$var$ProductHomeNew({ useCustomLogo: useCustomLogo = (0, $52wwV.useCustomLogo), useCustomIcon: useCustomIcon = (0, $52wwV.useCustomIcon), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useProductName: useProductName = (0, $kJP8l.useProductName), useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions) }) {
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const iconUrl = useCustomIcon();
    const productName = useProductName();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    const { icon: ProductIcon, logo: ProductLogo } = $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, testIdPrefix);
    const Logo = (0, $5uXOq.useMemo)(()=>logoUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$CustomImgNav4, {
                alt: formatMessage((0, $l6mLM.default).customLogoAltText),
                src: logoUrl,
                testId: `${testIdPrefix}-logo`
            }) : ProductLogo, [
        logoUrl,
        ProductLogo,
        formatMessage,
        testIdPrefix
    ]);
    const Icon = (0, $5uXOq.useMemo)(()=>logoUrl && iconUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$CustomImgNav4, {
                alt: formatMessage((0, $l6mLM.default).customIconAltText),
                src: iconUrl,
                testId: `${testIdPrefix}-icon`
            }) : ProductIcon, [
        logoUrl,
        iconUrl,
        ProductIcon,
        testIdPrefix,
        formatMessage
    ]);
    const label = $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        testId: `${testIdPrefix}-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7frKt.NavLogo), {
        label: label,
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome
    }));
} // formatMessage is intentionally an any type due to absence of easily importable type, and because actual
// type definition contains any as well!
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName) {
    let label = '';
    if (productName === 'serviceDesk') label = formatMessage((0, $l6mLM.default).jsmLogoLabel);
    else if (productName === 'product-discovery') label = formatMessage((0, $l6mLM.default).jpdLogoLabel);
    else if (productName === 'customer-service') label = formatMessage((0, $l6mLM.default).jcsLogoLabel);
    else label = formatMessage((0, $l6mLM.default).jiraLogoLabel);
    return label;
} /**
   * Due to typescript limitations (props type clashes), we need to handle the icon and logo components differently for the
   * new and old navigation apps. This function returns the appropriate components based on the product name.
   */ 
function $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, testIdPrefix, label) {
    const productKey = productName === 'core' || productName === 'software' ? 'jira' : productName;
    const { icon: OldIconComponent, logo: OldLogoComponent } = $0ec9a9378b2b1a20$export$6d49a893c897b0cc[productKey];
    const { icon: NewIconComponent, logo: NewLogoComponent } = $0ec9a9378b2b1a20$export$c133be38c8dacddb[productKey];
    const createComponent = (Component, type)=>(props)=>{
            const additionalProps = {}; // Nav v3 sets a testId, Nav v4 sets a label
            if (testIdPrefix) additionalProps.testId = `${testIdPrefix}-${type}`;
            if (label) additionalProps.label = label;
             // Casting required due to complexities of the different component prop types
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ...additionalProps
            });
        };
    const oldIcon = createComponent(OldIconComponent, 'icon');
    const oldLogo = createComponent(OldLogoComponent, 'logo');
    const newIcon = createComponent(NewIconComponent, 'icon');
    const newLogo = createComponent(NewLogoComponent, 'logo');
    return (0, $4R6GH.fg)('platform-team25-app-icon-tiles') ? {
        icon: newIcon,
        logo: newLogo
    } : {
        icon: oldIcon,
        logo: oldLogo
    };
}
function $0ec9a9378b2b1a20$var$CustomImgNav4({ alt: alt, src: src, testId: testId }) {
    if ((0, $4R6GH.fg)('blu-6671-nav4-ssr-flash')) // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        style: {
            height: '24px'
        },
        src: src,
        alt: alt,
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        alt: alt,
        "data-testid": testId
    });
}

});
parcelRegister("kJP8l", function(module, exports) {

$parcel$export(module.exports, "useProductName", () => $fbc3e5a1ff3e1b43$export$dde400a84de238be);

var $daoB1 = parcelRequire("daoB1");

var $kLseK = parcelRequire("kLseK");
const $fbc3e5a1ff3e1b43$export$dde400a84de238be = ()=>{
    const appPermissions = (0, $daoB1.useApplicationPermissions)();
    return (0, $kLseK.getProductName)(appPermissions);
};

});
parcelRegister("kLseK", function(module, exports) {

$parcel$export(module.exports, "getProductName", () => $255564fdcf8ca770$export$aa3f36fe5dd1f237);

var $4R6GH = parcelRequire("4R6GH");
const $255564fdcf8ca770$export$aa3f36fe5dd1f237 = (permissions)=>{
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
        return ([
            {
                condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'software'
            },
            {
                condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'serviceDesk'
            },
            {
                condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'core'
            },
            {
                condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasCustomerServiceAccess,
                value: 'product-discovery'
            },
            {
                condition: hasCustomerServiceAccess && !hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
                value: 'customer-service'
            }
        ].find((item)=>item.condition) || {
            value: 'jira'
        }).value;
    }
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
    return ([
        {
            condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'software'
        },
        {
            condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'core'
        },
        {
            condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
            value: 'product-discovery'
        }
    ].find((item)=>item.condition) || {
        value: 'jira'
    }).value;
};

});


parcelRegister("52wwV", function(module, exports) {

$parcel$export(module.exports, "useCustomLogo", () => $aa86f48989803edf$export$9891fb86d6b41647);
$parcel$export(module.exports, "useCustomIcon", () => $aa86f48989803edf$export$9e69c21df0138642);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $aa86f48989803edf$export$9891fb86d6b41647 = ()=>(0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-lf-top-adg3-logourl'), []);
const $aa86f48989803edf$export$9e69c21df0138642 = ()=>(0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-fspage-favicon'), []);

});

parcelRegister("b2u1Z", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $fc4a3f770cbe7bdc$export$3e157e0d79928990);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $fc4a3f770cbe7bdc$export$3e157e0d79928990 = ()=>(0, $5uXOq.useMemo)(()=>({
            shouldShow: (0, $j8DrX.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $j8DrX.default)('ajs-app-title')
        }), []);

});

parcelRegister("l6mLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $874346879bf58ddf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $874346879bf58ddf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customLogoAltText: {
        "id": "atlassian-navigation.product-home.custom-logo-alt-text",
        "defaultMessage": "Jira homepage"
    },
    customIconAltText: {
        "id": "atlassian-navigation.product-home.custom-icon-alt-text",
        "defaultMessage": "Custom Jira icon"
    },
    jiraLogoLabel: {
        "id": "atlassian-navigation.product-home.jira-logo-label",
        "defaultMessage": "Go to your Jira homepage"
    },
    jsmLogoLabel: {
        "id": "atlassian-navigation.product-home.jsm-logo-label",
        "defaultMessage": "Go to your Jira Service Management homepage"
    },
    jpdLogoLabel: {
        "id": "atlassian-navigation.product-home.jpd-logo-label",
        "defaultMessage": "Go to your Jira Product Discovery homepage"
    },
    jcsLogoLabel: {
        "id": "atlassian-navigation.product-home.jcs-logo-label",
        "defaultMessage": "Go to your Jira Customer Service homepage"
    }
});

});


parcelRegister("7bwNu", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $4d6ab55be4705ca2$export$5120f2d0b8d4cab8);

var $5uXOq = parcelRequire("5uXOq");

var $KWXOy = parcelRequire("KWXOy");

var $1oJEA = parcelRequire("1oJEA");

var $jzjnR = parcelRequire("jzjnR");

var $aQl8U = parcelRequire("aQl8U");

var $gFVv0 = parcelRequire("gFVv0");

var $ytxX5 = parcelRequire("ytxX5");

var $ixNeq = parcelRequire("ixNeq");

var $kaHBi = parcelRequire("kaHBi");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");


var $cE2Qr = parcelRequire("cE2Qr");

var $cYlk7 = parcelRequire("cYlk7");

var $2Ql51 = parcelRequire("2Ql51");

var $3t5QD = parcelRequire("3t5QD");

var $9yzc5 = parcelRequire("9yzc5");

var $4QigF = parcelRequire("4QigF");

var $7uSIc = parcelRequire("7uSIc");

var $koeKL = parcelRequire("koeKL");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $1yM7R = parcelRequire("1yM7R");

var $k7xP2 = parcelRequire("k7xP2");

var $ebznH = parcelRequire("ebznH");

var $ixpv2 = parcelRequire("ixpv2");
const $4d6ab55be4705ca2$var$SpotlightTargetDI = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $4d6ab55be4705ca2$var$handleMouseEnter = ()=>{
    (0, $4QigF.LazyOpenMenuItem).preload();
    (0, $9yzc5.NavigationProfileNavItemWrapperNudgeLazy).preload();
};
const $4d6ab55be4705ca2$var$Nav3Profile = ({ AkProfile: AkProfile = (0, $1oJEA.Profile), Avatar: Avatar = (0, $jzjnR.default), Menu: Menu = (0, $ebznH.Menu), Popup: Popup = (0, $gFVv0.default), SpotlightTarget: SpotlightTarget = $4d6ab55be4705ca2$var$SpotlightTargetDI, useCurrentUser: useCurrentUser = (0, $cYlk7.useCurrentUser), useExperienceStart: useExperienceStart = (0, $kaHBi.useExperienceStart), useIntl: useIntl = (0, $aWse0.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus), useUserBoardId: useUserBoardId = (0, $1yM7R.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu }] = useTopMenus((0, $lmyls.MENU_ID).PROFILE);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE
    });
    const { data: { user: user } } = useCurrentUser();
    const onStart = useExperienceStart({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE,
        analyticsSource: 'atlassian-navigation'
    });
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(isMenuOpen);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $ixNeq.useUserTraits)();
    const fetchUserTraits = (0, $ixNeq.useFetchUserTraitsOld)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const cloudId = (0, $koeKL.useCloudId)();
    const setUserTraitsIfNotAvailable = (0, $5uXOq.useCallback)(async ()=>{
        if (user.isAnonymous) return;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        user.isAnonymous,
        userTraits?.attributes,
        fetchUserTraits,
        setUserTraits
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onStart();
        loadForgePersonalSettingsItem({
            cloudId: cloudId,
            isAnonymous: user.isAnonymous
        });
        toggleMenu();
        triggerAnalytics();
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics,
        loadForgePersonalSettingsItem,
        cloudId,
        user.isAnonymous
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        userBoardId,
        userBoardOwnerAccountId,
        testIdPrefix
    ]);
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: (0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862) === nudgeStep && hasNudgeActive,
            Wrapper: (0, $9yzc5.NavigationProfileNavItemWrapperNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProfile, {
            ...triggerProps,
            icon: // NOTE: This SpotlightTarget can be used throughout Jira not just within
            // the current package. They're often used for onboarding or changeboarding
            // experiences and allow an Atlaskit spotlight to be attached to page elements.
            // If you need to change this, make sure you check where the target ID is being used
            // and contact the relevant team as necessary. This Sourcegraph link should help :)
            // http://go/src/PROFILE_SPOTLIGHT_KEY
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
                name: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                src: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
                size: "small",
                borderColor: "transparent"
            })),
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $ixpv2.default).tooltip),
            onMouseEnter: $4d6ab55be4705ca2$var$handleMouseEnter,
            "aria-label": formatMessage((0, $ixpv2.default).tooltip),
            id: "atlassian-navigation.ui.profile.icon"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KWXOy.EngagementSpotlight), {
            engagementId: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
        })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage,
        isMenuOpen,
        onClick,
        testIdPrefix,
        user,
        nudgeStep,
        hasNudgeActive
    ]);
    if (user.isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: Trigger,
        label: formatMessage((0, $ixpv2.default).tooltip),
        role: "menu"
    });
};
const $4d6ab55be4705ca2$var$Nav4Profile = ({ AccountMenu: AccountMenu = (0, $ytxX5.AccountMenuNav3), AkProfile: AkProfile = (0, $1oJEA.Profile), Avatar: Avatar = (0, $jzjnR.default), MenuNav4: MenuNav4 = (0, $k7xP2.MenuNav4), useCurrentUser: useCurrentUser = (0, $cYlk7.useCurrentUser), useIntl: useIntl = (0, $aWse0.useIntlV2), useUserBoardId: useUserBoardId = (0, $1yM7R.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { theme: theme, setTheme: setTheme } = (0, $2Ql51.useThemePreference)();
    const { data: { user: user } } = useCurrentUser();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & User)'.
    const emailAddress = user.emailAddress || '';
    const atlassianSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(emailAddress);
    const switchAccountLink = (0, $2EqxS.useSwitchAccountLink)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(false);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    if (user.isAnonymous) return null;
    if (false && !(0, $4R6GH.fg)('jira_nav4_beta_drop_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProfile, {
        "aria-haspopup": true,
        "aria-expanded": false,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'trigger'),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
            size: "small",
            borderColor: "transparent"
        }),
        tooltip: formatMessage((0, $ixpv2.default).tooltip),
        "aria-label": formatMessage((0, $ixpv2.default).tooltip),
        id: "atlassian-navigation.ui.profile.icon"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccountMenu, {
        testId: testIdPrefix,
        // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & User)'.
        name: user.displayName,
        // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & User)'.
        picture: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
        email: emailAddress,
        viewProfileLink: profileLink,
        manageProfileLink: atlassianSettingsLink,
        switchAccountLink: switchAccountLink,
        logOutLink: "/logout",
        onThemeChange: setTheme,
        currentTheme: theme,
        extraMenuItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuNav4, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        })
    });
};
const $4d6ab55be4705ca2$var$Profile = (props)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Nav4Profile, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Nav3Profile, props);
const $4d6ab55be4705ca2$export$5120f2d0b8d4cab8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Profile, props));

});
parcelRegister("ixNeq", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $5e172a254cf471a7$export$d5a27009aa54a078);
$parcel$export(module.exports, "useUserTraits", () => $5e172a254cf471a7$export$49363c8b904e0dc7);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $5e172a254cf471a7$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $5e172a254cf471a7$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $5e172a254cf471a7$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $eusud.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $5e172a254cf471a7$var$actions = {
    setUserTraits: $5e172a254cf471a7$var$setUserTraits,
    fetchUserTraits: $5e172a254cf471a7$var$fetchUserTraits,
    addUserTrait: $5e172a254cf471a7$var$addUserTrait
};
const $5e172a254cf471a7$var$initialState = {
    attributes: null
};
const $5e172a254cf471a7$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    return (0, $5uXOq.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $eusud.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $5e172a254cf471a7$export$6e688ed53ae076d5 = (0, $iXqE5.createStore)({
    initialState: $5e172a254cf471a7$var$initialState,
    actions: $5e172a254cf471a7$var$actions,
    name: 'UserTraits'
});
const $5e172a254cf471a7$export$49363c8b904e0dc7 = (0, $3sQ5x.createHook)($5e172a254cf471a7$export$6e688ed53ae076d5);
const $5e172a254cf471a7$export$4f249a943026a90b = (0, $3sQ5x.createActionsHook)($5e172a254cf471a7$export$6e688ed53ae076d5);

});

parcelRegister("aWse0", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $6b28e3c9e1c89fbd$export$d82607073b68786);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $koVbs.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("3t5QD", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $44a5067dcee1bfd9$export$56d544c4f479b7fb);

var $5uXOq = parcelRequire("5uXOq");
const $44a5067dcee1bfd9$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});

parcelRegister("9yzc5", function(module, exports) {

$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeLazy", () => $e1b30bf1670573e8$export$3651b15d92c1c280);
$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeAsync", () => $e1b30bf1670573e8$export$deb2cae843941204);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

const $e1b30bf1670573e8$export$3651b15d92c1c280 = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("cG2jc")).then((exportedModule)=>exportedModule.NavigationProfileNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-profile/index.tsx"
});
const $e1b30bf1670573e8$export$deb2cae843941204 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: "asyncProfileNudge",
        fallback: children,
        attributes: {
            NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID: $6784cbc7d62e5d7c$export$7aa8bceae32c7862
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-profile-nav-item-wrapper-nudge-lazy",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1b30bf1670573e8$export$3651b15d92c1c280, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862)
    }, children)));
$e1b30bf1670573e8$export$deb2cae843941204.displayName = 'NavigationProfileNavItemWrapperNudgeAsync';

});
parcelRegister("cG2jc", function(module, exports) {

let $93ab32b622f32547$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93ab32b622f32547$var$load("jMa49").then(()=>parcelRequire('doFig'));

});


parcelRegister("7uSIc", function(module, exports) {

$parcel$export(module.exports, "useForgePersonalSettingsItems", () => $bf0aca3f9b0d9b8d$export$455fadc65ea0bef0);

var $9XE6b = parcelRequire("9XE6b");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $1C2yb = parcelRequire("1C2yb");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $bf0aca3f9b0d9b8d$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
const $bf0aca3f9b0d9b8d$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ setState: setState, getState: getState })=>{
        const { fetchForgeModule: fetchForgeModule, isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch personalSettings items since they are implemented elsewhere.
            if ((0, $3HwlS.getWillShowNav4)()) return;
            const promise = fetchForgeModule({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: false,
                types: [
                    (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
                ],
                source: (0, $k2DRb.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const personalSettingsPageData = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)) || [];
            const items = personalSettingsPageData.map((extension)=>({
                    id: extension.id,
                    title: extension.properties.title,
                    avatarUrl: extension.properties.icon,
                    url: $bf0aca3f9b0d9b8d$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
                }));
            setState({
                items: items,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError instanceof Error ? fetchError : null,
                promise: null
            });
        }
    };
const $bf0aca3f9b0d9b8d$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            await dispatch($bf0aca3f9b0d9b8d$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
        }
};
const $bf0aca3f9b0d9b8d$export$a51e606fadb150f6 = (defaults)=>{
    const initialState = {
        fetchForgeModule: defaults.fetchForgeModule,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'forge-personal-settings-items-store',
        actions: $bf0aca3f9b0d9b8d$var$actions,
        initialState: initialState
    });
    const ForgePersonalSettingsItemsTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, fetchError: fetchError, promise: promise, isFetching: isFetching })=>({
            items: items,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const ForgePersonalSettingsItemsSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'ForgePersonalSettingsItemsSubscriber',
        selector: selector
    });
    const useForgePersonalSettingsItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        ForgePersonalSettingsItemsSubscriber: ForgePersonalSettingsItemsSubscriber,
        useForgePersonalSettingsItems: useForgePersonalSettingsItems,
        ForgePersonalSettingsItemsTestContainer: ForgePersonalSettingsItemsTestContainer
    };
};
const { useForgePersonalSettingsItems: $bf0aca3f9b0d9b8d$export$455fadc65ea0bef0 } = $bf0aca3f9b0d9b8d$export$a51e606fadb150f6({
    fetchForgeModule: (0, $iVaKa.fetchModules)
});

});
parcelRegister("1C2yb", function(module, exports) {

$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $63706130a90445cd$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $63706130a90445cd$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $63706130a90445cd$export$1a7321c4210a3049);
const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
const $63706130a90445cd$export$cff16c3a6aa7a3a9 = `${$63706130a90445cd$export$a974f4af282a75ba}/digests`;
const $63706130a90445cd$export$1fffbb6055aa320a = `${$63706130a90445cd$export$a974f4af282a75ba}/apps`;
const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
function $63706130a90445cd$export$db9e3ccc1e5e3317() {
    return $63706130a90445cd$export$693b70d1bcef8627;
}
function $63706130a90445cd$export$88a45ae8c4b1c664() {
    return $63706130a90445cd$export$2321c59d517801c8;
}
function $63706130a90445cd$export$64a672523a583594() {
    return $63706130a90445cd$export$21946ea4c58fd4c9;
}
function $63706130a90445cd$export$1a7321c4210a3049() {
    return $63706130a90445cd$export$1fffbb6055aa320a;
}

});


parcelRegister("1yM7R", function(module, exports) {

$parcel$export(module.exports, "useUserBoardId", () => $c7748d5d5fa92b7a$export$e6e895063f36c814);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $c7748d5d5fa92b7a$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $5uXOq.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $eusud.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});

parcelRegister("k7xP2", function(module, exports) {

$parcel$export(module.exports, "MenuNav4", () => $b62ef795f8dd8307$export$60113ca6a29c7a92);
/* main-nav4.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8xXpg = parcelRequire("8xXpg");
var $5gSBR = parcelRequire("5gSBR");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dAfqg = parcelRequire("dAfqg");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");

var $lwZRC = parcelRequire("lwZRC");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dgPkW = parcelRequire("dgPkW");

var $cEIWv = parcelRequire("cEIWv");
const $b62ef795f8dd8307$export$60113ca6a29c7a92 = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const showQuickstartOpenMenuItem = showInJwmProjects || showInSoftwareProjects || showInJsmProjects;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, showQuickstartOpenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $d4B4Y.MenuItem)
    }), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true,
        testId: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $cEIWv.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $cEIWv.default).yourBoards))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwZRC.StandardToPremiumPubTouchpoint), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgPkW.ExtraItemsNav4), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    }));
};

});
parcelRegister("d4B4Y", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $ac79b65b740c9d18$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $lrCjX = parcelRequire("lrCjX");

var $jngLf = parcelRequire("jngLf");

var $9YfZr = parcelRequire("9YfZr");

var $6oGXD = parcelRequire("6oGXD");
const $ac79b65b740c9d18$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest }, ref)=>{
    const onClickHandler = (0, $6oGXD.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YfZr.RouteLinkItem), {
        ref: ref,
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jngLf.LinkItem), {
        ref: ref,
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrCjX.default), {
        ref: ref,
        onClick: onClickHandler,
        ...rest
    });
});

});
parcelRegister("jngLf", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $3ef5556c5063294d$export$532cb6865ebe8946);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bYvZM = parcelRequire("bYvZM");
var $eCx8Q = parcelRequire("eCx8Q");

var $4R6GH = parcelRequire("4R6GH");

var $iMorU = parcelRequire("iMorU");

var $gRLNg = parcelRequire("gRLNg");
const $3ef5556c5063294d$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, target: target, onClick: onClick, ...rest }, ref)=>{
    const Item = (0, $4R6GH.fg)('jfp-a11y-team_interactive-elements-nesting') ? (0, $bYvZM.default) : $3ef5556c5063294d$export$8c0773eab230d49e;
    const navigate = (0, $gRLNg.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Item, {
        ...(0, $4R6GH.fg)('jfp-a11y-team_interactive-elements-nesting') && {
            component: (0, $iMorU.WithUnwrappedInteractiveChildren)((0, $eCx8Q.default))
        },
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ref: ref,
        ...rest
    });
});
const $3ef5556c5063294d$export$8c0773eab230d49e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eCx8Q.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nrm18uv _1a3b18uv _9oik18uv _c2wa1kw7 _4fpr1kw7 _1bnx1kw7 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMorU", function(module, exports) {

$parcel$export(module.exports, "WithUnwrappedInteractiveChildren", () => $92ab6ba4ea3c960d$export$aecb71b5768388c7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $92ab6ba4ea3c960d$var$MenuItemCss = null;
const $92ab6ba4ea3c960d$var$StretchedBlanketCss = null;
// This blank space is needed to enforce React Router to render the empty anchor tag
const $92ab6ba4ea3c960d$var$BLANKET_CONTENT = ' ';
const $92ab6ba4ea3c960d$export$aecb71b5768388c7 = (InteractiveBlanket)=>/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_kqswh2mm",
                className
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InteractiveBlanket, {
            ref: ref,
            ...props,
            className: (0, $bwpsq.default)([
                "_kqswstnw _1bsb1osq _4t3i1osq _154ize3t _1ltvze3t _1cwg1i6y _13ro1i6y _1bg41i6y _1ah31i6y"
            ])
        }, $92ab6ba4ea3c960d$var$BLANKET_CONTENT), children));

});

parcelRegister("gRLNg", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $f019fb7f0ef5833c$export$9770f232ac06a008);

var $5uXOq = parcelRequire("5uXOq");

var $lVJAU = parcelRequire("lVJAU");
const $f019fb7f0ef5833c$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useCallback: useCallback = (0, $5uXOq.useCallback) })=>{
    const { push: push } = useRouterActions();
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("9YfZr", function(module, exports) {

$parcel$export(module.exports, "RouteLinkItem", () => $3031a27cd367c26b$export$5885e1e37551a766);

var $5uXOq = parcelRequire("5uXOq");

var $bYvZM = parcelRequire("bYvZM");

var $4R6GH = parcelRequire("4R6GH");

var $hjSul = parcelRequire("hjSul");

var $iMorU = parcelRequire("iMorU");
const $3031a27cd367c26b$export$5885e1e37551a766 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ rel: rel, target: target, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYvZM.default), {
        component: (0, $4R6GH.fg)('jfp-a11y-team_interactive-elements-nesting') ? (0, $iMorU.WithUnwrappedInteractiveChildren)((0, $hjSul.Link)) : (0, $hjSul.Link),
        rel: rel ?? (target === '_blank' ? 'noopener noreferrer' : ''),
        target: target,
        prefetch: "hover",
        ref: ref,
        ...props
    }));

});

parcelRegister("6oGXD", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $a8a7ed1bfe9b49e0$export$a81c45382e7253ac);

var $gDHs4 = parcelRequire("gDHs4");

var $2Ui4E = parcelRequire("2Ui4E");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");
const $a8a7ed1bfe9b49e0$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: useAnalyticsEvents = (0, $d8lsH.useAnalyticsEvents), useOverflowStatus: useOverflowStatus = (0, $gDHs4.useOverflowStatus), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) } = {})=>{
    const [, { off: closeMenu }] = useTopMenus();
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});


parcelRegister("7ilb8", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $44f127900c12f92a$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $44f127900c12f92a$export$6c2f3257abc4825b);

var $5uXOq = parcelRequire("5uXOq");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");
const $44f127900c12f92a$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        as: "ul",
        xcss: $44f127900c12f92a$var$removeDefaultListStyles
    }, children);
const $44f127900c12f92a$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        as: "li",
        xcss: $44f127900c12f92a$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $44f127900c12f92a$var$removeDefaultListStyles = (0, $aCJg8.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});

});

parcelRegister("dgPkW", function(module, exports) {

$parcel$export(module.exports, "ExtraItems", () => $78c0b34ec312aabb$export$56021421a935c353);
$parcel$export(module.exports, "ExtraItemsNav4", () => $78c0b34ec312aabb$export$ee2972db91c46b97);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $5gSBR = parcelRequire("5gSBR");

var $hrlU6 = parcelRequire("hrlU6");

var $6cNb0 = parcelRequire("6cNb0");

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");
const $78c0b34ec312aabb$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $78c0b34ec312aabb$var$Item = ({ url: url, name: name, id: id, styleClass: styleClass, itemAriaLabel: itemAriaLabel, position: position, testId: testId })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const isDialog = styleClass && (0, $hrlU6.isConnectDialogWebItem)(styleClass);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (styleClass && webItemRef.current) connectHost.triggerWebItem(webItemRef.current, styleClass, url);
        });
    }, [
        isDialog,
        styleClass,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        key: url,
        ariaLabel: itemAriaLabel || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        ref: webItemRef,
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'jira',
            position: position
        },
        href: isDialog ? undefined : url,
        onClick: isDialog ? onClick : undefined,
        testId: testId
    }, name));
};
const $78c0b34ec312aabb$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $78c0b34ec312aabb$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c0b34ec312aabb$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};
const $78c0b34ec312aabb$export$ee2972db91c46b97 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $78c0b34ec312aabb$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true
    }, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c0b34ec312aabb$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};

});

parcelRegister("cEIWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $521f3eedcdcca1a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $521f3eedcdcca1a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});


parcelRegister("ebznH", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $32d3ea680525e18b$export$d9b273488cd8ce6f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $KWXOy = parcelRequire("KWXOy");

var $2xRxR = parcelRequire("2xRxR");

var $8xXpg = parcelRequire("8xXpg");
var $5gSBR = parcelRequire("5gSBR");

var $aQl8U = parcelRequire("aQl8U");

var $ixNeq = parcelRequire("ixNeq");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $1C2yb = parcelRequire("1C2yb");

var $cYlk7 = parcelRequire("cYlk7");

var $dAfqg = parcelRequire("dAfqg");

var $fDWVs = parcelRequire("fDWVs");

var $7ziML = parcelRequire("7ziML");

var $d1xZH = parcelRequire("d1xZH");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");

var $90yGq = parcelRequire("90yGq");

var $lwZRC = parcelRequire("lwZRC");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $ag3sS = parcelRequire("ag3sS");

var $7ilb8 = parcelRequire("7ilb8");

var $5DUZ0 = parcelRequire("5DUZ0");

var $dgPkW = parcelRequire("dgPkW");

var $4WZuY = parcelRequire("4WZuY");

var $cEIWv = parcelRequire("cEIWv");

var $fUv6Z = parcelRequire("fUv6Z");

var $3CMYn = parcelRequire("3CMYn");
const $32d3ea680525e18b$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const accountId = (0, $90yGq.useAccountId)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const profileParams = {
        subPath: accountId
    };
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testId, 'footer');
    const [upgradeEditionMenuShown, setUpgradeEditionMenuShown] = (0, $5uXOq.useState)(false);
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const [userTraits] = (0, $ixNeq.useUserTraits)();
    const showNotificationsNewLozenge = (0, $5uXOq.useMemo)(()=>{
        const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
        const aWeekAgo = new Date(Date.now() - 604800000);
        let isNewUser = false;
        if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
        return !isNewUser;
    }, [
        userTraits
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // The Spotlight components listen to the resize event to
        // update their positioning. This will fix Spotlights pulse overlap
        // that are shown on Menu items. Without this the pulse are located
        /// at incorrect position.
        setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.dispatchEvent(new Event('resize'));
        }, 0);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId,
        role: "dialog",
        "aria-labelledby": "atlassian-navigation-account-dialog-heading",
        className: (0, $bwpsq.default)([
            "_syaz1fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'account')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        id: "atlassian-navigation-account-dialog-heading",
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'account', 'heading')
    }, formatMessage((0, $cEIWv.default).account)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5DUZ0.AccountDetails // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    ), {
        email: user.emailAddress || '',
        userFullname: user.userFullname,
        avatarSrc: user.avatarUrls ? user.avatarUrls['32x32'] : undefined,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'account')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwZRC.StandardToPremiumPubTouchpoint), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: upgradeEditionMenuShown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3CMYn.UpgradeEditionMenuItem), {
        setUpgradeEditionMenuShown: setUpgradeEditionMenuShown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: upgradeEditionMenuShown || !upgradeEditionMenuShown,
        testId: testIdContent
    }, (showInJwmProjects || showInSoftwareProjects || showInJsmProjects) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $d4B4Y.MenuItem)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $cEIWv.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'profile',
            menuItemType: 'jira',
            position: 0
        },
        href: profileLink,
        params: profileParams,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-profile'),
        to: (0, $fDWVs.peopleProfilesRoute)
    }, formatMessage((0, $cEIWv.default).profile))), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $cEIWv.default).yourBoards))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'personal-settings',
            menuItemType: 'jira',
            position: 2 + boardOffset
        },
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-personal-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $cEIWv.default).personalSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
        name: "notifications-menu-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'notifications',
            menuItemType: 'jira',
            position: 3 + boardOffset
        },
        href: (0, $1C2yb.getNotificationsPersonalSettingsPath)(),
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-notifications'),
        to: (0, $d1xZH.notificationsPersonalSettingsRoute),
        iconAfter: showNotificationsNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xRxR.default), {
            appearance: "new"
        }, formatMessage((0, $cEIWv.default).new)) : null
    }, formatMessage((0, $cEIWv.default).notifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KWXOy.EngagementSpotlight), {
        engagementId: "notifications-menu-spotlight"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUv6Z.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-theme'),
        itemPosition: 4 + boardOffset
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgPkW.ExtraItems), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WZuY.ForgeItems), {
        startPosition: 6 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true,
        testId: testIdFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdFooter, 'items')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'logout',
            menuItemType: 'action',
            position: 0
        },
        href: "/logout",
        testId: (0, $6cNb0.testIdConcat)(testIdFooter, 'items', 'item-log-out')
    }, formatMessage((0, $cEIWv.default).logout))))));
};
const $32d3ea680525e18b$var$styles = null;

});
parcelRegister("fDWVs", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRoute", () => $44b234ae71647fd2$export$1338132568be849);
const $44b234ae71647fd2$export$1338132568be849 = {
    name: 'people-index',
    path: '/jira/people/:subPath?'
};

});

parcelRegister("7ziML", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $bac161cf2450c76e$export$7a6c9715a86f906b);
const $bac161cf2450c76e$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

parcelRegister("d1xZH", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $de84b22e790c56d0$export$55ab09b9d6beb8be);
const $de84b22e790c56d0$export$55ab09b9d6beb8be = {
    name: 'personal-settings-notifications',
    path: '/jira/settings/personal/notifications'
};

});

parcelRegister("ag3sS", function(module, exports) {

$parcel$export(module.exports, "MenuLayout", () => $a3bb5b7f7abc0b96$export$dc2a07138b27c65b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $68Yq0 = parcelRequire("68Yq0");

var $gwIPs = parcelRequire("gwIPs");
const $a3bb5b7f7abc0b96$export$dc2a07138b27c65b = ({ children: children, isWide: isWide = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3bb5b7f7abc0b96$var$Wrapper, {
        isWide: isWide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $68Yq0.default), {
        maxHeight: $a3bb5b7f7abc0b96$var$maxHeight
    }, children));
const $a3bb5b7f7abc0b96$var$starStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3bb5b7f7abc0b96$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWide: isWide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d8u6ab": (0, $lD23V.default)(__cmplp.isWide ? `${(0, $gwIPs.gridSize) * 40}px` : `${(0, $gwIPs.gridSize) * 29.25}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul911kg _p12f1c3h _107nidpf _js70kb7n _nqzgkb7n _ziy7kb7n",
            __cmplp.className
        ])
    });
});
const $a3bb5b7f7abc0b96$var$maxHeight = `calc(100vh - ${(0, $gwIPs.gridSize) * 25}px)`;

});

parcelRegister("5DUZ0", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $a1d7ada73782364f$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jzjnR = parcelRequire("jzjnR");

var $c3q7f = parcelRequire("c3q7f");

var $eCx8Q = parcelRequire("eCx8Q");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $8ZSbf = parcelRequire("8ZSbf");
const $a1d7ada73782364f$export$66e04d0aacdb3b2 = ({ email: email, userFullname: userFullname, avatarSrc: avatarSrc, testId: testId })=>{
    const atlassianSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$8f1912fff52a55aa, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$33e9904f45a9e453, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzjnR.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$e0d971bef63c8b8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$101fbca3a406e1fd, null, userFullname), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, email)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'manage-account',
            menuItemType: 'account',
            position: 1
        },
        href: atlassianSettingsLink,
        testId: (0, $6cNb0.testIdConcat)(testId, 'manage-account'),
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c3q7f))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, formatMessage((0, $8ZSbf.default).manageAccount)))));
};
const $a1d7ada73782364f$export$8f1912fff52a55aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eCx8Q.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$33e9904f45a9e453 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$e0d971bef63c8b8f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8ZSbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $818e6cdec46716cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $818e6cdec46716cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageAccount: {
        "id": "atlassian-navigation.profile.menu.account-details.manage-account",
        "defaultMessage": "Manage account"
    }
});

});


parcelRegister("4WZuY", function(module, exports) {

$parcel$export(module.exports, "ForgeItems", () => $46180a8b75e73408$export$ee772b0fa73d37fd);

var $5uXOq = parcelRequire("5uXOq");

var $7uSIc = parcelRequire("7uSIc");

var $1rTGO = parcelRequire("1rTGO");

var $lLB03 = parcelRequire("lLB03");

var $k2DRb = parcelRequire("k2DRb");

var $l1LNZ = parcelRequire("l1LNZ");

var $h0JHu = parcelRequire("h0JHu");

var $e0AC8 = parcelRequire("e0AC8");

var $6cNb0 = parcelRequire("6cNb0");

var $1C2yb = parcelRequire("1C2yb");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");
const $46180a8b75e73408$var$BaseForgeItems = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const [{ items: forgeStoreItems }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const shouldTriggerForgeScreenEvent = forgeStoreItems && forgeStoreItems.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (forgeStoreItems || []).map((item, idx)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(item.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: item.id,
            ariaLabel: itemAriaLabel || ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'profileNavigationMenuItem',
                menuItemId: item.id,
                menuItemType: 'jira',
                position: startPosition + idx
            },
            href: `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1LNZ.ForgeIcon), {
                url: item.avatarUrl
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
            extensionEnvType: item.environmentType,
            extensionEnvKey: item.environmentKey,
            extensionName: item.title,
            autoTruncate: true
        })));
    }), shouldTriggerForgeScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $46180a8b75e73408$export$ee772b0fa73d37fd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLB03.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46180a8b75e73408$var$BaseForgeItems, props));

});
parcelRegister("1rTGO", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $abbdb580491d9d09$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $abbdb580491d9d09$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $abbdb580491d9d09$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $abbdb580491d9d09$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $abbdb580491d9d09$export$14e56d7f5d3f917c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $eOGyv = parcelRequire("eOGyv");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $dd7Uh = parcelRequire("dd7Uh");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");
const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: (0, $6MtPV.createAttributes)(attributes)
    });
const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $dd7Uh.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $eOGyv.useHasForgeAccess)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]);
    const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, (0, $9BrHy.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: fireEvent
    });
};
const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6MtPV.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hBuqR.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $k2DRb.CUSTOM_FIELD_MODULE) || extensionModule === (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $k2DRb.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $k2DRb.GLOBAL_PAGE_MODULE),
        (0, $k2DRb.ISSUE_ACTION_MODULE),
        (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
        (0, $k2DRb.ISSUE_CONTEXT_MODULE),
        (0, $k2DRb.ISSUE_GLANCE_MODULE),
        (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $k2DRb.ISSUE_PANEL_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.ADMIN_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $k2DRb.BACKLOG_ACTION_MODULE),
        (0, $k2DRb.BOARD_ACTION_MODULE),
        (0, $k2DRb.SPRINT_ACTION_MODULE),
        (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $5uXOq.useRef)(performance.now());
        const isCustomUI = (0, $3mOWa.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $9BrHy.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        }) : (0, $9BrHy.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $5uXOq.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $5uXOq.useCallback)(()=>{
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $dd7Uh.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("3mOWa", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $e79bbc527e600bd1$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $e79bbc527e600bd1$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $e79bbc527e600bd1$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $e79bbc527e600bd1$export$42b85bc9b386c977);

var $gccSB = parcelRequire("gccSB");
const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("eOGyv", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);

var $cZpsT = parcelRequire("cZpsT");
const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("isuse", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $1df0619a43ad69d9$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bG8wy = parcelRequire("bG8wy");
// eslint-disable-next-line jira/react/no-class-components
class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, $bG8wy.default)()($1df0619a43ad69d9$var$MountEventComponent);

});

parcelRegister("dd7Uh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $7d829a81d29f9e72$export$add44f896fb31ba3);

var $hBuqR = parcelRequire("hBuqR");

var $8uOa6 = parcelRequire("8uOa6");
const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("2RhPB", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $3fba0b567cec1fe0$export$5d3b06ab08af139e);

var $3mOWa = parcelRequire("3mOWa");

var $e0AC8 = parcelRequire("e0AC8");
const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $3mOWa.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $10bc2a9e37d5a5bb$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("lLB03", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8f6f5ad08b6537de$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8f6f5ad08b6537de$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $8f6f5ad08b6537de$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $8f6f5ad08b6537de$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        ...props,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("l1LNZ", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $59ad601e153227ad$export$fe0464db4dc93ab4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bcgic = parcelRequire("bcgic");

var $k4j3t = parcelRequire("k4j3t");
const $59ad601e153227ad$export$fe0464db4dc93ab4 = ({ url: url })=>{
    return url && String(url).trim().length > 0 ? /*#__PURE__*/ $5uXOq.createElement((0, $k4j3t.IconCustom), {
        shouldChangeFillColor: false,
        url: url
    }) : /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcgic))), {
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    });
};

});
parcelRegister("k4j3t", function(module, exports) {

$parcel$export(module.exports, "IconCustom", () => $0744fb0e35ced980$export$5b6504ec6adf0047);

var $5uXOq = parcelRequire("5uXOq");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");

var $ljMUk = parcelRequire("ljMUk");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $0744fb0e35ced980$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $0744fb0e35ced980$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        xcss: $0744fb0e35ced980$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
        type: "matrix",
        values: $0744fb0e35ced980$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && (0, $ljMUk.checkForSvg)(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
};
const $0744fb0e35ced980$var$styles = (0, $aCJg8.xcss)({
    display: 'inline-block',
    margin: 'space.025',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
});

});
parcelRegister("ljMUk", function(module, exports) {

$parcel$export(module.exports, "checkForSvg", () => $c203648fb17df2d9$export$9a369805b0fabb72);
const $c203648fb17df2d9$export$9a369805b0fabb72 = (url)=>{
    const fileType = url.split(/#|\?/)[0].split('.').pop();
    // falsey check is for Ts
    return fileType ? fileType.trim() === 'svg' : false;
};

});



parcelRegister("h0JHu", function(module, exports) {

$parcel$export(module.exports, "ExtensionTitle", () => $8acb929a7e4cf7fc$export$3aa4a75e461c581c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");

var $k2DRb = parcelRequire("k2DRb");

var $fl3Yy = parcelRequire("fl3Yy");
const $8acb929a7e4cf7fc$var$shouldShowEnv = (extensionEnvType)=>[
        (0, $k2DRb.STAGING_ENVIRONMENT),
        (0, $k2DRb.DEVELOPMENT_ENVIRONMENT)
    ].includes(extensionEnvType);
const $8acb929a7e4cf7fc$var$ExtensionTitleText = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, autoTruncate: autoTruncate })=>{
    if (!autoTruncate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, text, " ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        xcss: $8acb929a7e4cf7fc$var$extensionTitleTextWrapperStyles
    }, text);
});
const $8acb929a7e4cf7fc$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName, autoTruncate: autoTruncate })=>{
    if (!$8acb929a7e4cf7fc$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, extensionName);
    const Wrapper = autoTruncate ? $8acb929a7e4cf7fc$var$TruncatableExtensionTitleWrapper : $8acb929a7e4cf7fc$var$ExtensionTitleWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8acb929a7e4cf7fc$var$ExtensionTitleText, {
        text: (0, $fl3Yy.nameWithCustomEnvironment)(extensionName, extensionEnvType, extensionEnvKey),
        autoTruncate: !!autoTruncate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
        environmentType: extensionEnvType
    }));
};
const $8acb929a7e4cf7fc$var$extensionTitleTextWrapperStyles = (0, $aCJg8.xcss)({
    paddingRight: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8acb929a7e4cf7fc$var$ExtensionTitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});
const $8acb929a7e4cf7fc$var$TruncatableExtensionTitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fl3Yy", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $730173a4987fa3e4$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $730173a4987fa3e4$export$f9338c21ba7c7334);

var $5uXOq = parcelRequire("5uXOq");

var $2xRxR = parcelRequire("2xRxR");

var $k2DRb = parcelRequire("k2DRb");

var $ousew = parcelRequire("ousew");

var $8Je4V = parcelRequire("8Je4V");
const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $k2DRb.DEVELOPMENT_ENVIRONMENT:
            return (0, $8Je4V.messages).developmentEnvironmentLozenge;
        case 0, $k2DRb.STAGING_ENVIRONMENT:
            return (0, $8Je4V.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xRxR.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), labelKey)) : null;
};
const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("8Je4V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $838ac71f7259b5ef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $838ac71f7259b5ef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});




parcelRegister("fUv6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86718ba415abca4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

var $e2wv7 = parcelRequire("e2wv7");

const $f86718ba415abca4$export$31f1740ae531af94 = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("dxLOV")), {
    moduleId: "./src/packages/navigation-apps/theme-switcher-menu/src/index.tsx"
});
const $f86718ba415abca4$var$AsyncThemeSwitcherItem = ({ testId: testId, itemPosition: itemPosition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav-theme-options-list-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2wv7.default), {
            testId: testId,
            itemPosition: itemPosition,
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f86718ba415abca4$export$31f1740ae531af94, {
        renderTriggerButton: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2wv7.default), {
                testId: testId,
                itemPosition: itemPosition,
                ...props
            })
    }));
var $f86718ba415abca4$export$2e2bcd8739ae039 = $f86718ba415abca4$var$AsyncThemeSwitcherItem;

});
parcelRegister("e2wv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fbe3dba557d8dae$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $e4fCM = parcelRequire("e4fCM");

var $lrCjX = parcelRequire("lrCjX");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $1lFrC = parcelRequire("1lFrC");
const $0fbe3dba557d8dae$var$TriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, itemPosition: itemPosition, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrCjX.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
        ref: ref,
        onClick: (e)=>{
            e.stopPropagation();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationMenuItem'
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'profileNavigationMenuItem', {
                menuItemId: 'theme',
                menuItemType: 'jira',
                position: itemPosition
            });
        },
        testId: testId,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e4fCM))), {
            spacing: "spacious",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fbe3dba557d8dae$var$Text, null, formatMessage((0, $1lFrC.default).text)));
});
var $0fbe3dba557d8dae$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0fbe3dba557d8dae$var$TriggerButton;
const $0fbe3dba557d8dae$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1lFrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8ea74039b76a2c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fe8ea74039b76a2c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    text: {
        "id": "atlassian-navigation.profile.menu.theme-switcher-item.trigger-button.text",
        "defaultMessage": "Theme"
    }
});

});


parcelRegister("dxLOV", function(module, exports) {

let $9dc37393b6e2e4f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9dc37393b6e2e4f6$var$load("awKpe").then(()=>parcelRequire('dFrEV'));

});


parcelRegister("3CMYn", function(module, exports) {

$parcel$export(module.exports, "UpgradeEditionMenuItem", () => $f3e948dade64bc0d$export$30403e009ec5f9cd);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c3q7f = parcelRequire("c3q7f");

var $2xRxR = parcelRequire("2xRxR");

var $8xXpg = parcelRequire("8xXpg");

var $iMd5l = parcelRequire("iMd5l");

var $cVzoY = parcelRequire("cVzoY");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $aWse0 = parcelRequire("aWse0");

var $lpwtK = parcelRequire("lpwtK");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $d8lsH = parcelRequire("d8lsH");

var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $eZxaN = parcelRequire("eZxaN");

var $cMquZ = parcelRequire("cMquZ");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");


var $5s42E = parcelRequire("5s42E");
const $f3e948dade64bc0d$export$4a94253c58c6e2cb = ({ product: product })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const productEdition = product ? (0, $iMd5l.getProductEdition)(product, tenantContext) : (0, $ldyPw.FREE_EDITION);
    const trialLength = (0, $eZxaN.getTrialLength)(productEdition, (0, $ldyPw.STANDARD_EDITION));
    const freeEditionMenuItemInfo = (0, $5s42E.getFreeEditionMenuItem)((0, $aWse0.useIntlV2), trialLength);
    const [, { mountUpflowModal: mountUpflowModal }] = (0, $cMquZ.useUpflowModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        eventName: (0, $8f22f2c66c400ef9$export$23de212b4b92e749),
        attributes: {
            currentEdition: productEdition,
            growthFeature: (0, $8f22f2c66c400ef9$export$2c864ccb7debe0d4),
            touchpointId: freeEditionMenuItemInfo.touchpointId,
            flowId: freeEditionMenuItemInfo.flowId,
            computedProduct: product
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), null, freeEditionMenuItemInfo.heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'persistentUpgradeNavigationMenuItem',
            menuItemId: freeEditionMenuItemInfo.touchpointId,
            menuItemType: 'action',
            position: 0
        },
        onClick: ()=>{
            const analyticEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, (0, $8f22f2c66c400ef9$export$2b421d13e998fdbb), {
                currentEdition: productEdition,
                growthFeature: (0, $8f22f2c66c400ef9$export$2c864ccb7debe0d4),
                touchpointId: freeEditionMenuItemInfo.touchpointId,
                flowId: freeEditionMenuItemInfo.flowId,
                computedProduct: product
            });
            if (product && freeEditionMenuItemInfo.displayUpflowModal === true) mountUpflowModal({
                targetEdition: (0, $ldyPw.STANDARD_EDITION),
                product: product,
                flow: (0, $8f22f2c66c400ef9$export$195e756c24f2ef95),
                touchpointId: freeEditionMenuItemInfo.touchpointId
            });
        },
        href: (0, $5s42E.getHref)(freeEditionMenuItemInfo, product),
        target: product ? undefined : '_blank',
        iconAfter: product ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c3q7f))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, freeEditionMenuItemInfo.content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3e948dade64bc0d$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xRxR.default), {
        appearance: freeEditionMenuItemInfo.lozengeAppearance,
        isBold: true
    }, freeEditionMenuItemInfo.tagContent, ' '))))));
};
const $f3e948dade64bc0d$var$UpgradeEditionMenuItemOld = ({ setUpgradeEditionMenuShown: setUpgradeEditionMenuShown })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectData, loading: projectDataLoading } = (0, $lpwtK.useProject)();
    if (projectDataLoading) return null;
    const { isSiteAdmin: isSiteAdmin } = tenantContext;
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const applicationKey = (0, $5s42E.getActivePageApplicationKey)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    projectData?.type, explicitlyLicensedProducts);
    if (!(0, $5s42E.shouldRenderMenuItem)(isSiteAdmin, applicationKey, explicitlyLicensedProducts, tenantContext)) {
        setUpgradeEditionMenuShown(false);
        return null;
    } // Add separator bar in the menu
    setUpgradeEditionMenuShown(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $8f22f2c66c400ef9$export$5fa54bc771a7eb8f),
        packageName: (0, $8f22f2c66c400ef9$export$b8b9d90f9e5bd72b),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3e948dade64bc0d$export$4a94253c58c6e2cb, {
        product: applicationKey
    }));
};
const $f3e948dade64bc0d$var$UpgradeEditionMenuItemNew = ({ setUpgradeEditionMenuShown: setUpgradeEditionMenuShown })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectData, loading: projectDataLoading } = (0, $lpwtK.useProject)();
    const { isSiteAdmin: isSiteAdmin } = tenantContext;
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const applicationKey = (0, $5s42E.getActivePageApplicationKey)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    projectData?.type, explicitlyLicensedProducts);
    const shouldRender = (0, $5s42E.shouldRenderMenuItem)(isSiteAdmin, applicationKey, explicitlyLicensedProducts, tenantContext);
    (0, $5uXOq.useEffect)(()=>{
        if (projectDataLoading) return;
         // Add separator bar in the menu if the menu item should be rendered
        setUpgradeEditionMenuShown(shouldRender);
    }, [
        projectDataLoading,
        setUpgradeEditionMenuShown,
        shouldRender
    ]);
    if (projectDataLoading) return null;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $8f22f2c66c400ef9$export$5fa54bc771a7eb8f),
        packageName: (0, $8f22f2c66c400ef9$export$b8b9d90f9e5bd72b),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3e948dade64bc0d$export$4a94253c58c6e2cb, {
        product: applicationKey
    }));
};
const $f3e948dade64bc0d$export$30403e009ec5f9cd = (0, $cSD7y.componentWithFG)('jira-concurrent-update-while-rendering', $f3e948dade64bc0d$var$UpgradeEditionMenuItemNew, $f3e948dade64bc0d$var$UpgradeEditionMenuItemOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3e948dade64bc0d$var$LozengeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMd5l", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $658df12da4e62335$export$53e066a63a960439);

const $658df12da4e62335$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("eZxaN", function(module, exports) {

$parcel$export(module.exports, "getTrialLength", () => $5e237061bb3a578d$export$23d271f9e8cb9c4);

var $ldyPw = parcelRequire("ldyPw");

const $5e237061bb3a578d$export$23d271f9e8cb9c4 = (currentEdition, targetEdition)=>{
    if (currentEdition === (0, $ldyPw.FREE_EDITION) && targetEdition === (0, $ldyPw.STANDARD_EDITION)) return 0, $554094dc1f31a42a$export$b7a3952d12e24333;
    return 0, $554094dc1f31a42a$export$940ef4a039f45970;
};

});
const $554094dc1f31a42a$export$b7a3952d12e24333 = 14;
const $554094dc1f31a42a$export$940ef4a039f45970 = 30;


parcelRegister("cMquZ", function(module, exports) {

$parcel$export(module.exports, "useUpflowModal", () => $85614d266b32fe16$export$7025cc2729b71e44);

var $ldyPw = parcelRequire("ldyPw");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

const $85614d266b32fe16$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $ldyPw.FREE_EDITION)
};
const $85614d266b32fe16$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $85614d266b32fe16$var$Store = (0, $iXqE5.createStore)({
    name: (0, $3a066fc4381e3c91$export$675a4427bf3750a2),
    initialState: $85614d266b32fe16$var$initialState,
    actions: $85614d266b32fe16$var$actions
});
const $85614d266b32fe16$export$6d73384be122c2dd = (0, $51nlc.createSubscriber)($85614d266b32fe16$var$Store);
const $85614d266b32fe16$export$e672be732bd57171 = (0, $gg7kZ.createContainer)($85614d266b32fe16$var$Store);
const $85614d266b32fe16$export$7025cc2729b71e44 = (0, $3sQ5x.createHook)($85614d266b32fe16$var$Store);

});
const $3a066fc4381e3c91$export$675a4427bf3750a2 = 'upflow-modal-store';


const $8f22f2c66c400ef9$export$195e756c24f2ef95 = 'persistent-upgrade';
const $8f22f2c66c400ef9$export$2c864ccb7debe0d4 = 'persistentUpgrade';
const $8f22f2c66c400ef9$export$b8b9d90f9e5bd72b = 'persistentUpgrade';
const $8f22f2c66c400ef9$export$5fa54bc771a7eb8f = 'persistentUpgradeMenu';
const $8f22f2c66c400ef9$export$2b421d13e998fdbb = 'persistentUpgradeMenu clicked';
const $8f22f2c66c400ef9$export$23de212b4b92e749 = 'persistentUpgradeMenu viewed';

parcelRegister("5s42E", function(module, exports) {

$parcel$export(module.exports, "shouldRenderMenuItem", () => $19aa5f523a249503$export$6335c904eace2f3);
$parcel$export(module.exports, "getFreeEditionMenuItem", () => $19aa5f523a249503$export$cce6104d08ee5a15);
$parcel$export(module.exports, "getActivePageApplicationKey", () => $19aa5f523a249503$export$44df08af6d5522d3);
$parcel$export(module.exports, "getHref", () => $19aa5f523a249503$export$81842c1ae19d378b);

var $2vSU6 = parcelRequire("2vSU6");

var $iMd5l = parcelRequire("iMd5l");


var $ldyPw = parcelRequire("ldyPw");

var $if9zJ = parcelRequire("if9zJ");
const $19aa5f523a249503$var$isFreeEdition = (product, tenantContext)=>{
    const productEdition = (0, $iMd5l.getProductEdition)(product, tenantContext);
    return productEdition === (0, $ldyPw.FREE_EDITION);
};
const $19aa5f523a249503$var$productIsJSMOrJSW = (product)=>product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d) || product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61);
const $19aa5f523a249503$var$hasFreeJSMOrJSW = (explicitlyLicensedProducts, tenantContext)=>explicitlyLicensedProducts.some((product)=>$19aa5f523a249503$var$productIsJSMOrJSW(product) && $19aa5f523a249503$var$isFreeEdition(product, tenantContext));
const $19aa5f523a249503$export$6335c904eace2f3 = (isSiteAdmin, product, explicitlyLicensedProducts, tenantContext)=>{
    if (!isSiteAdmin) return false;
    if (!product) // If we're on a product-agnostic page (e.g "Your Work") we can still render the menu item
    // as long as there is a free JSM or JSW. The menu item will link to the "Manage Subscriptions" page.
    return $19aa5f523a249503$var$hasFreeJSMOrJSW(explicitlyLicensedProducts, tenantContext);
    // If we're in JSM or JSW Free, render the menu item.
    if (product && $19aa5f523a249503$var$productIsJSMOrJSW(product)) return $19aa5f523a249503$var$isFreeEdition(product, tenantContext);
    return false;
};
const $19aa5f523a249503$export$cce6104d08ee5a15 = (intl, trialLength)=>({
        heading: intl().formatMessage((0, $if9zJ.default).upgrade),
        content: intl().formatMessage((0, $if9zJ.default).tryStandardPlan),
        tagContent: intl().formatMessage((0, $if9zJ.default).trialPeriod, {
            trialLength: trialLength
        }),
        lozengeAppearance: 'inprogress',
        touchpointId: 'preTrialMenu',
        flowId: 'upgradeFlow',
        displayUpflowModal: true
    });
const $19aa5f523a249503$export$636823a5af1468e4 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $19aa5f523a249503$export$b6487772e5a4e151 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $19aa5f523a249503$export$44df08af6d5522d3 = (projectType, explicitlyLicensedProducts)=>{
    const applicationKey = $19aa5f523a249503$export$b6487772e5a4e151(projectType);
    if (applicationKey !== null) return applicationKey;
    // If applicationKey is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $19aa5f523a249503$export$81842c1ae19d378b = (freeEditionMenuItemInfo, product)=>{
    if (!product) return '/admin/billing/applications';
    return freeEditionMenuItemInfo.href ? freeEditionMenuItemInfo.href(freeEditionMenuItemInfo.touchpointId) : '';
};

});
parcelRegister("if9zJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4771b447ad228e16$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4771b447ad228e16$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgrade: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.upgrade",
        "defaultMessage": "Upgrade"
    },
    tryStandardPlan: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.try-standard-plan",
        "defaultMessage": "Try the Standard plan"
    },
    trialPeriod: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.trial-period",
        "defaultMessage": "free {trialLength}-day trial"
    }
});

});




parcelRegister("ixpv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2baac40d089a40ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2baac40d089a40ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.profile.tooltip",
        "defaultMessage": "Your profile and settings"
    }
});

});


parcelRegister("ag3PC", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $f891c4e4f71955d4$export$c72f6eaae7b9adff);

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $5gSBR = parcelRequire("5gSBR");

var $kaHBi = parcelRequire("kaHBi");

var $4R6GH = parcelRequire("4R6GH");

var $itmJb = parcelRequire("itmJb");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $jgJNO = parcelRequire("jgJNO");

var $cZpsT = parcelRequire("cZpsT");

var $lKuhp = parcelRequire("lKuhp");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $cSD7y = parcelRequire("cSD7y");

var $Mp6qH = parcelRequire("Mp6qH");

var $amOJR = parcelRequire("amOJR");

var $iPj86 = parcelRequire("iPj86");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $4uXxK = parcelRequire("4uXxK");

var $hrU50 = parcelRequire("hrU50");

var $3Ug2v = parcelRequire("3Ug2v");

var $asDBE = parcelRequire("asDBE");
const $f891c4e4f71955d4$export$c72f6eaae7b9adff = (0, $cSD7y.componentWithFG)('settings-icon-perf-vc90-improvements', /*#__PURE__*/ (0, $5uXOq.memo)($f891c4e4f71955d4$var$SettingsNoMemo), $f891c4e4f71955d4$var$SettingsNoMemo);
function $f891c4e4f71955d4$var$SettingsNoMemo() {
    const SettingsMenu = (0, $cSD7y.componentWithFG)('blu-3339-nav4-topnav-settings-entrypoint', $f891c4e4f71955d4$var$SettingsContainer, $f891c4e4f71955d4$var$SettingsInner);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SettingsMenu, null));
}
function $f891c4e4f71955d4$var$SettingsContainer() {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f891c4e4f71955d4$var$SettingsInner, null);
}
function $f891c4e4f71955d4$var$SettingsInner() {
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // remove when cleaning up fg: blu-3339-nav4-topnav-settings-entrypoint
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [isOpen, { toggle: toggleMenu, off: closeMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).SETTINGS);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS
    });
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $3HwlS.getWillShowNav4)()) onStart();
        toggleMenu();
        triggerAnalytics({
            shownCommandPalettePrompt: isAdmin
        });
    }, [
        isAdmin,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'settings');
    // replace this with useId from react 18 when stable
    const id = (0, $22Gxp.useUID)();
    const titleId = `top-navigation-settings-header-${id}-title`;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3Ug2v.settingsMenuEntryPoint), {});
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-settings${false ? '-ssr' : ''}`
        }, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lKuhp.Settings), {
            ...triggerProps,
            ref: (element)=>{
                if ((0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint')) triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            isSelected: isOpen,
            interactionName: "nav4-topNav-settings",
            label: formatMessage((0, $asDBE.default).settings)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amOJR.Settings), {
            ...triggerProps,
            ref: (element)=>{
                if ((0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint')) triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            tooltip: formatMessage((0, $asDBE.default).settings),
            isSelected: isOpen
        })), [
        formatMessage,
        isOpen,
        onClick,
        testIdPrefix,
        triggerRef
    ]);
    const content = (0, $5uXOq.useCallback)(()=>(0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            id: "nav4-topNav-settings",
            entryPointReferenceSubject: entryPointReferenceSubject,
            packageName: (0, $Mp6qH.PACKAGE_NAME),
            errorFallback: "flag",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
                isWide: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
                isScrollable: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), {
                testIdPrefix: testIdPrefix
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6WLja.MenuSkeletonFooter), {
                testIdPrefix: testIdPrefix
            }))),
            runtimeProps: {
                testIdPrefix: testIdPrefix,
                titleId: titleId
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrU50.Menu), {
            testIdPrefix: testIdPrefix,
            titleId: titleId
        }), [
        entryPointReferenceSubject,
        testIdPrefix,
        titleId
    ]);
    // remove when cleaning up fg: blu-3339-nav4-topnav-settings-entrypoint
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        titleId: titleId,
        isOpen: isOpen,
        content: content,
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "atlassian-navigation.ui.settings.popup",
        messageType: "transactional",
        trigger: Trigger,
        label: formatMessage((0, $asDBE.default).settings),
        shouldRenderToParent: true
    });
}

});
parcelRegister("amOJR", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $70f9abb464fd04b1$export$c72f6eaae7b9adff);

var $5uXOq = parcelRequire("5uXOq");

var $1h9MK = parcelRequire("1h9MK");

var $eC0VQ = parcelRequire("eC0VQ");

var $3HwlS = parcelRequire("3HwlS");
const $70f9abb464fd04b1$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0VQ.Nav4SkeletonSettingsButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0VQ.SkeletonSettingsButton), {
            label: props.tooltip
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1h9MK.Settings), buttonProps);
});

});

parcelRegister("9TMfX", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonContent", () => $4a37f7ab6d486120$export$8db7a6d33c26b25f);

var $5uXOq = parcelRequire("5uXOq");

var $afkYk = parcelRequire("afkYk");
var $2Thxw = parcelRequire("2Thxw");

var $6cNb0 = parcelRequire("6cNb0");
const $4a37f7ab6d486120$export$8db7a6d33c26b25f = ({ testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $afkYk.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        hasIcon: true,
        width: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        hasIcon: true,
        width: "50%"
    }));

});

parcelRegister("6WLja", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonFooter", () => $a62f60b9f9c94621$export$efa6bae06cf20a1);

var $5uXOq = parcelRequire("5uXOq");

var $2Thxw = parcelRequire("2Thxw");

var $6cNb0 = parcelRequire("6cNb0");
const $a62f60b9f9c94621$export$efa6bae06cf20a1 = ({ testIdPrefix: testIdPrefix, numItems: numItems = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        width: "50%"
    }), numItems >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        width: "50%"
    }));

});

parcelRegister("hrU50", function(module, exports) {

$parcel$export(module.exports, "MenuWithEntryPoint", () => $c4588c969d854f97$export$677b98f370fe145);
$parcel$export(module.exports, "Menu", () => $c4588c969d854f97$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5gSBR = parcelRequire("5gSBR");
var $afkYk = parcelRequire("afkYk");
var $2Thxw = parcelRequire("2Thxw");

var $5U49F = parcelRequire("5U49F");

var $8J6rn = parcelRequire("8J6rn");

var $7CMCs = parcelRequire("7CMCs");

var $3bQtK = parcelRequire("3bQtK");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $daoB1 = parcelRequire("daoB1");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $l8ruj = parcelRequire("l8ruj");

var $Mp6qH = parcelRequire("Mp6qH");

var $ag3sS = parcelRequire("ag3sS");

var $jNHMi = parcelRequire("jNHMi");

var $e57bL = parcelRequire("e57bL");

var $asDBE = parcelRequire("asDBE");

var $6svfi = parcelRequire("6svfi");

var $b59xm = parcelRequire("b59xm");
function $c4588c969d854f97$export$677b98f370fe145({ props: { testIdPrefix: testIdPrefix, titleId: titleId } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4588c969d854f97$export$d9b273488cd8ce6f, {
        testIdPrefix: testIdPrefix,
        titleId: titleId
    });
}
const $c4588c969d854f97$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, titleId: titleId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const appPermissions = (0, $daoB1.useApplicationPermissions)();
    const manageUsersPermission = (0, $jNHMi.useManageUsersPermission)();
    const { isOpsAdmin: isOpsAdmin, loading: isOgTenantInfoLoading } = (0, $8J6rn.useOgTenantInfo)();
    const willShowNav4 = (0, $3HwlS.getWillShowNav4)();
    const settingsNavigationItems = (0, $5uXOq.useMemo)(()=>(0, $5U49F.getGlobalSettingsAdminItems)(formatMessage, appPermissions, {
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin,
            manageUsersPermission: manageUsersPermission,
            isOpsAdmin: isOpsAdmin
        }, willShowNav4), [
        formatMessage,
        appPermissions,
        isAdmin,
        isSiteAdmin,
        manageUsersPermission,
        willShowNav4,
        isOpsAdmin
    ]);
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!willShowNav4) onSuccess();
    }, [
        onSuccess,
        willShowNav4
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdHeader = (0, $6cNb0.testIdConcat)(testId, 'header');
    if (willShowNav4) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-topNav-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).SETTINGS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6svfi.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e57bL.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $afkYk.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b59xm.Warning), {
        testIdPrefix: testId
    }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4588c969d854f97$var$SettingsTitle, {
        ...testIdHeader != null ? {
            'data-testid': testIdHeader
        } : {},
        id: titleId
    }, formatMessage((0, $asDBE.default).settings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6svfi.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e57bL.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading || isOgTenantInfoLoading && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $afkYk.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Thxw.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b59xm.Warning), {
        testIdPrefix: testId
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4588c969d854f97$var$SettingsTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8lodh _ca0q1ejb _u5f31ejb _n3tdu2gc _19bvv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5U49F", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $a2085cc62fde1196$export$be58b4326e23250f);
$parcel$export(module.exports, "getGlobalSettingsAdminItems", () => $a2085cc62fde1196$export$d637bf5a394b4534);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8fabB = parcelRequire("8fabB");
var $dd5Pg = parcelRequire("dd5Pg");
var $6YerV = parcelRequire("6YerV");
var $aCJg8 = parcelRequire("aCJg8");

var $fiYaq = parcelRequire("fiYaq");

var $1KhNh = parcelRequire("1KhNh");

var $fR6Z9 = parcelRequire("fR6Z9");

var $dyhus = parcelRequire("dyhus");

var $gp0ou = parcelRequire("gp0ou");

var $bcgic = parcelRequire("bcgic");

var $caFC2 = parcelRequire("caFC2");

var $a6cca = parcelRequire("a6cca");

var $1iPSV = parcelRequire("1iPSV");

var $8Ai3d = parcelRequire("8Ai3d");

var $gr4RF = parcelRequire("gr4RF");

var $c3q7f = parcelRequire("c3q7f");

var $ugFif = parcelRequire("ugFif");

var $f88X3 = parcelRequire("f88X3");

var $6FNR2 = parcelRequire("6FNR2");

var $96iWb = parcelRequire("96iWb");

var $4R6GH = parcelRequire("4R6GH");

var $6awYZ = parcelRequire("6awYZ");

var $4jROM = parcelRequire("4jROM");

var $2f2jJ = parcelRequire("2f2jJ");

var $8K9T4 = parcelRequire("8K9T4");

var $dzeHJ = parcelRequire("dzeHJ");

var $6lwNs = parcelRequire("6lwNs");

var $3JGmH = parcelRequire("3JGmH");
const $a2085cc62fde1196$var$getApplicationsMenuLink = (appPermissions)=>{
    if (appPermissions.hasSoftwareAccess) return '/jira/settings/products/jira-software-configuration';
    if (appPermissions.hasServiceDeskAccess) return '/jira/settings/products/jira-service-management-configuration';
    return '/plugins/servlet/applinks/listApplicationLinks';
};
const $a2085cc62fde1196$export$f3a5db2467c22913 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gr4RF))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$3055c15ea575d46c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gp0ou))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$43db94b81c32328a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6cca))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$583f26efcd800ae2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1iPSV))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$627b4c7b9568cd5d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcgic))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$4464648b9631e67f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Ai3d))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$7b659dc9c22493b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fR6Z9))), {
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($caFC2))),
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$var$getAdminSectionOld = (formatMessage, appPermissions)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        sideHeading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$b79014a8ad5d31bf, {
                "aria-label": formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMacScreenReader : (0, $6lwNs.default).jiraSettingsCommandPaletteOtherScreenReader)
            }, formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMac : (0, $6lwNs.default).jiraSettingsCommandPaletteOther, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6YerV.default), {
                        as: "strong",
                        size: "small",
                        color: "inherit"
                    }, chunks),
                wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$CommandPaletteShortcutsContainer, null, chunks),
                key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$KeyboardShortcut, null, chunks),
                command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$KeyboardShortcut, {
                        isMeta: true
                    }, chunks)
            })),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $6lwNs.default).system),
                type: 'Item',
                before: $a2085cc62fde1196$export$f3a5db2467c22913
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $a2085cc62fde1196$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: $a2085cc62fde1196$export$3055c15ea575d46c
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $6lwNs.default).projects),
                type: 'Item',
                before: $a2085cc62fde1196$export$43db94b81c32328a
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).WORK : (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesIssueTermRefresh : (0, $6lwNs.default).issues),
                type: 'Item',
                before: $a2085cc62fde1196$export$583f26efcd800ae2
            },
            ...(0, $4R6GH.fg)('add_apps_management_to_fedramp') || !(0, $4jROM.isFedRamp)() ? [
                {
                    goTo: 'root/global-settings/addons',
                    id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                    legacyId: 'admin_plugins_menu',
                    href: (0, $6awYZ.getEmceeDiscoverLink)({
                        source: 'side_nav_find_new_addons'
                    }),
                    text: formatMessage((0, $6lwNs.default).addons),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$627b4c7b9568cd5d
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$var$getAdminSectionNew = (formatMessage, appPermissions)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        heading: formatMessage((0, $6lwNs.default).jiraAdminSettings),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $6lwNs.default).system),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6FNR2))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).systemDescription)
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $a2085cc62fde1196$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fiYaq))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).productsDescription)
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $6lwNs.default).projects),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f88X3))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).projectsDescription)
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).WORK : (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesIssueTermRefresh : (0, $6lwNs.default).issues),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dyhus))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesDescriptionIssueTermRefresh : (0, $6lwNs.default).issuesDescription)
            },
            ...(0, $4R6GH.fg)('add_apps_management_to_fedramp') || !(0, $4jROM.isFedRamp)() ? [
                {
                    goTo: 'root/global-settings/addons',
                    id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                    legacyId: 'admin_plugins_menu',
                    href: (0, $8K9T4.manageAppsRoute).path,
                    text: formatMessage((0, $6lwNs.default).addons),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1KhNh))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    description: formatMessage((0, $6lwNs.default).appsDescription)
                }
            ] : [],
            {
                id: 'keyboad-shortcut-tip',
                type: 'Content',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
                        as: "li",
                        xcss: $a2085cc62fde1196$var$jiraCommandPalletteTipContainerStyles,
                        "aria-label": formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMacScreenReader : (0, $6lwNs.default).jiraSettingsCommandPaletteOtherScreenReader)
                    }, formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMac : (0, $6lwNs.default).jiraSettingsCommandPaletteOther, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6YerV.default), {
                                size: "small"
                            }, chunks),
                        wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
                                xcss: $a2085cc62fde1196$var$commandPalleteShortcutStyles
                            }, chunks),
                        key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dd5Pg.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $a2085cc62fde1196$var$keyboardShortcutStyles
                            }, chunks),
                        command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dd5Pg.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $a2085cc62fde1196$var$keyboardShortcutStyles
                            }, chunks)
                    }))
            }
        ]
    });
const $a2085cc62fde1196$export$8c65af5cbebd63ff = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        heading: formatMessage((0, $6lwNs.default).atlassianAdminSettings),
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $6lwNs.default).userManagement),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96iWb))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ugFif))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $6lwNs.default).userManagementDescription)
                }
            ] : [],
            ...isSiteAdmin && !(0, $4jROM.isFedRamp)() ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $6lwNs.default).billing),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fR6Z9))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ugFif))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $6lwNs.default).billingDescription)
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$export$ed6905715e0eb76 = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $6lwNs.default).userManagement),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$4464648b9631e67f,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c3q7f))), {
                            LEGACY_size: "small"
                        }),
                    target: '_blank'
                }
            ] : [],
            ...isSiteAdmin && !(0, $4jROM.isFedRamp)() ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $6lwNs.default).billing),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$7b659dc9c22493b,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c3q7f))), {
                            LEGACY_size: "small"
                        }),
                    target: '_blank'
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$export$b77c692c620409dc = (formatMessage)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).OPS_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: '/jira/settings/products/ops/role-assignment',
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fiYaq))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).productsDescription)
            }
        ]
    });
const $a2085cc62fde1196$export$d637bf5a394b4534 = (formatMessage, appPermissions, userRoles, willShowNav4)=>{
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, manageUsersPermission: manageUsersPermission } = userRoles;
    const result = [];
    if (isAdmin) {
        const getAdminSection = willShowNav4 ? $a2085cc62fde1196$var$getAdminSectionNew : $a2085cc62fde1196$var$getAdminSectionOld;
        result.push(getAdminSection(formatMessage, appPermissions));
    }
    // Adding these items to the end because `manageUsersPermission` may change after the initial
    // render because it is determined by an async API call. It will need to be the responsibility
    // of the consumer to show a loading state if needed.
    if (isSiteAdmin || manageUsersPermission.loading === false && manageUsersPermission.canManageUsers) {
        const getSiteAdminSection = willShowNav4 ? $a2085cc62fde1196$export$8c65af5cbebd63ff : $a2085cc62fde1196$export$ed6905715e0eb76;
        result.push(getSiteAdminSection(formatMessage, userRoles.isSiteAdmin, manageUsersPermission.canManageUsers));
    }
    if (!willShowNav4 && !userRoles.isAdmin && userRoles.isOpsAdmin && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update')) result.push($a2085cc62fde1196$export$b77c692c620409dc(formatMessage));
    return result;
};
const $a2085cc62fde1196$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dark: dark, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c116y _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg",
            __cmplp.dark ? "_11q7cdhy" : "_11q7b29m",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$CommandPaletteShortcutsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpv77o _1e0c116y",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$KeyboardShortcut = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.FilledLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1bsb1wug _1ul9dlk8 _4t3idlk8 _16jlidpf _vwz4wk7l _y3gn1h6o _ca0qidpf _u5f3v77o _n3tdidpf _19bvv77o _vchhusvi _1p1dglyw",
            __cmplp.isMeta ? "_1wyb1bt6" : "_1wybc4v4",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$export$b79014a8ad5d31bf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _k48pi7a9 _syaz1dyx _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$commandPalleteShortcutStyles = (0, $aCJg8.xcss)({
    display: 'inline-flex',
    gap: 'space.025'
});
const $a2085cc62fde1196$var$jiraCommandPalletteTipContainerStyles = (0, $aCJg8.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginInlineStart: 'space.200',
    marginBlock: 'space.200',
    color: 'color.text.subtle',
    listStyleType: 'none'
});
const $a2085cc62fde1196$var$keyboardShortcutStyles = (0, $aCJg8.xcss)({
    minWidth: '14px',
    height: '14px',
    backgroundColor: 'color.background.accent.blue.subtlest',
    color: 'color.text.subtle',
    padding: 'space.025',
    borderRadius: 'border.radius',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("6awYZ", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $3f6cbde73539e62b$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $3f6cbde73539e62b$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $3f6cbde73539e62b$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $3f6cbde73539e62b$export$350ca33eed6a2742);
const $3f6cbde73539e62b$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $3f6cbde73539e62b$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $3f6cbde73539e62b$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $3f6cbde73539e62b$export$f26dabf284aefb17 = (params)=>{
    const link = '/jira/marketplace/discover';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};
const $3f6cbde73539e62b$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams)=>$3f6cbde73539e62b$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`);
const $3f6cbde73539e62b$export$7ab8c48f9081e976 = (params)=>{
    const link = '/jira/marketplace/manage/app-requests';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};
const $3f6cbde73539e62b$export$350ca33eed6a2742 = (params)=>{
    const link = '/jira/marketplace/manage/promotions';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("dzeHJ", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $0f9445e21ac061f1$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $0f9445e21ac061f1$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $0f9445e21ac061f1$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0f9445e21ac061f1$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx31l7b _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6lwNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f568e348dc45627$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f568e348dc45627$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "navigation-next.navigation-views.root.common.settings",
        "defaultMessage": "Jira settings"
    },
    system: {
        "id": "navigation-next.navigation-views.root.global-settings.home.system",
        "defaultMessage": "System"
    },
    applications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.applications",
        "defaultMessage": "Products"
    },
    projects: {
        "id": "navigation-next.navigation-views.root.global-settings.home.projects",
        "defaultMessage": "Projects"
    },
    issues: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues",
        "defaultMessage": "Issues"
    },
    addons: {
        "id": "navigation-next.navigation-views.root.global-settings.home.addons",
        "defaultMessage": "Apps"
    },
    recommendations: {
        "id": "navigation-next.navigation-views.root.global-settings.home.recommendations",
        "defaultMessage": "Recommendations"
    },
    userManagement: {
        "id": "navigation-next.navigation-views.root.global-settings.home.user-management",
        "defaultMessage": "User management"
    },
    billing: {
        "id": "navigation-next.navigation-views.root.global-settings.home.billing",
        "defaultMessage": "Billing"
    },
    discoverApplications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.discover-applications",
        "defaultMessage": "Discover applications"
    },
    jiraSettingsCommandPaletteMac: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><command>\u2318</command><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteOther: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><key>Ctrl</key><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteMacScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac-screen-reader",
        "defaultMessage": "Tip: Try command K to search Jira settings"
    },
    jiraSettingsCommandPaletteOtherScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other-screen-reader",
        "defaultMessage": "Tip: Try control K to search Jira settings"
    },
    'site-admin': {
        "id": "navigation-apps.settings-drawer.section.site-admin",
        "defaultMessage": "Atlassian admin"
    },
    'system-admin': {
        "id": "navigation-apps.settings-drawer.section.system-admin",
        "defaultMessage": "Jira settings"
    },
    'ops-admin': {
        "id": "navigation-apps.settings-drawer.section.ops-admin",
        "defaultMessage": "Jira settings"
    },
    'trusted-user': {
        "id": "navigation-apps.settings-drawer.section.trusted-user",
        "defaultMessage": "Atlassian admin"
    },
    'personal-settings': {
        "id": "navigation-apps.settings-drawer.section.personal-settings",
        "defaultMessage": "Personal settings"
    },
    'admin-system-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-system-menu",
        "defaultMessage": "Manage your general configuration, global permissions, look and feel and more."
    },
    'admin-applications-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-applications-menu",
        "defaultMessage": "Manage your Jira products' settings and integrations."
    },
    'admin-manage-project-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-manage-project-menu",
        "defaultMessage": "Manage your project settings, categories, and more."
    },
    'admin-issues-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu",
        "defaultMessage": "Configure your issue types, workflows, screens, custom fields and more."
    },
    'admin-issues-menu-issue-term-refresh': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu-issue-term-refresh",
        "defaultMessage": "Configure your work types, workflows, screens, custom fields and more."
    },
    'admin-plugins-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-plugins-menu",
        "defaultMessage": "Add and manage Jira Marketplace apps."
    },
    'user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.user-management-section",
        "defaultMessage": "Add users, groups, and manage access requests."
    },
    'admin-billing-section': {
        "id": "navigation-apps.settings-drawer.section.item.admin-billing-section",
        "defaultMessage": "Update your billing details, manage your subscriptions and more."
    },
    'trusted-admin-user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.trusted-admin-user-management-section",
        "defaultMessage": "Invite users to your site."
    },
    'discover-applications-section': {
        "id": "navigation-apps.settings-drawer.section.item.discover-applications-section",
        "defaultMessage": "Try more Atlassian products."
    },
    // NAV4 Messages
    personalJiraSettings: {
        "id": "atlassian-navigation-nav4.common.settings-content.personal-jira-settings",
        "defaultMessage": "Personal Jira settings"
    },
    jiraAdminSettings: {
        "id": "atlassian-navigation-nav4.common.settings-content.jira-admin-settings",
        "defaultMessage": "Jira admin settings"
    },
    systemDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.system-description",
        "defaultMessage": "Manage general configuration, security, automation, user interface, and more"
    },
    productsDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.products-description",
        "defaultMessage": "Manage Jira products' access, settings, and integrations"
    },
    projectsDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.projects-description",
        "defaultMessage": "Manage project settings, categories, and more"
    },
    issuesDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description",
        "defaultMessage": "Configure issue types, workflows, screens, fields, and more"
    },
    appsDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.apps-description",
        "defaultMessage": "Add and manage Jira Marketplace apps and integrations"
    },
    atlassianAdminSettings: {
        "id": "atlassian-navigation-nav4.common.settings-content.atlassian-admin-settings",
        "defaultMessage": "Atlassian admin settings"
    },
    userManagementDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.user-management-description",
        "defaultMessage": "Manage users, groups, and access requests"
    },
    billingDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.billing-description",
        "defaultMessage": "Update your billing details, manage subscriptions, and more"
    },
    issuesIssueTermRefresh: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    issuesDescriptionIssueTermRefresh: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description-issue-term-refresh",
        "defaultMessage": "Configure work types, workflows, screens, fields, and more"
    }
});

});

parcelRegister("3JGmH", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => $421ed2d9886b9bc8$export$7266225366740ba0);
$parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$4718c8ac53a477e1);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$b23679adb37958a8);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => $421ed2d9886b9bc8$export$9cc74e3c0b8831f9);
const $421ed2d9886b9bc8$export$7266225366740ba0 = {
    SETTINGS_TITLE: 'settings-title',
    SITE_ADMIN: 'site-admin',
    SYSTEM_ADMIN: 'system-admin',
    OPS_ADMIN: 'ops-admin',
    TRUSTED_USER: 'trusted-user',
    PERSONAL: 'personal-settings'
};
const $421ed2d9886b9bc8$export$4718c8ac53a477e1 = {
    SYSTEM: 'admin-system-menu',
    APPLICATIONS: 'admin-applications-menu',
    ISSUES: 'admin-issues-menu',
    WORK: 'admin-issues-menu-issue-term-refresh',
    PLUGINS: 'admin-plugins-menu',
    RECOMMENDATIONS: 'admin-recommendations',
    MANAGE_PROJECTS: 'admin-manage-project-menu'
};
const $421ed2d9886b9bc8$export$b23679adb37958a8 = {
    USER_MANAGEMENT: 'user-management-section',
    BILLING: 'admin-billing-section'
};
const $421ed2d9886b9bc8$export$9cc74e3c0b8831f9 = {
    USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
    BILLING: '/admin/billing-preview?referrerName=JIRA'
};

});


parcelRegister("8J6rn", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $31f27587daf0b28f$export$990ea9ff15ca04f7);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $daoB1 = parcelRequire("daoB1");

var $2YP9W = parcelRequire("2YP9W");

var $3H5ry = parcelRequire("3H5ry");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh
    ]);
};
const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $2YP9W.useResource)((0, $bHhiy.getConsolidationStateResource)());
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $3H5ry.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $3H5ry.checkIsConsolidated)(tenantInfoResource.data),
        isOpsAdmin: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') && (0, $3H5ry.checkIsOpsAdmin)(tenantInfoResource.data),
        isTransitioning: (0, $3H5ry.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $3H5ry.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});

parcelRegister("jNHMi", function(module, exports) {

$parcel$export(module.exports, "useManageUsersPermission", () => $723fd3490632416b$export$d156f64dc61f3ce9);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $723fd3490632416b$var$initialState = {
    loading: true,
    canManageUsers: undefined
};
const $723fd3490632416b$var$Store = (0, $iXqE5.createStore)({
    initialState: $723fd3490632416b$var$initialState,
    actions: {
        fetch: ({ orgId: orgId, accountId: accountId, isSiteAdmin: isSiteAdmin })=>async ({ setState: setState, getState: getState })=>{
                if (getState().canManageUsers !== undefined) // Shortcut - Don't fetch again if we already have the data
                return;
                if (accountId == null || orgId == null) {
                    // Shortcut - Anonymous users cannot manage users, and orgId is required
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    return;
                }
                if (isSiteAdmin) {
                    // Shortcut - Site admins can manage users
                    setState({
                        loading: false,
                        canManageUsers: true
                    });
                    return;
                }
                setState({
                    loading: true
                });
                try {
                    const { permitted: permitted } = await (0, $eusud.performPostRequest)('/gateway/api/permissions/permitted', {
                        body: JSON.stringify({
                            resourceId: `ari:cloud:platform::org/${orgId}`,
                            principalId: `ari:cloud:identity::user/${accountId}`,
                            permissionId: 'manage-users'
                        })
                    });
                    setState({
                        loading: false,
                        canManageUsers: permitted
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // Fail safe - if we can't fetch the data, assume the user can't manage users
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'fetchManageUsersPermission',
                            packageName: 'jiraAtlassianNavigation',
                            teamName: 'navigation'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
    },
    name: 'ManageUsersPermissionInternal'
});
const $723fd3490632416b$var$useManageUsersPermissionInternal = (0, $3sQ5x.createHook)($723fd3490632416b$var$Store);
const $723fd3490632416b$export$d156f64dc61f3ce9 = ()=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const accountId = (0, $90yGq.useAccountId)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [state, { fetch: fetch }] = $723fd3490632416b$var$useManageUsersPermissionInternal();
    (0, $5uXOq.useEffect)(()=>{
        fetch({
            accountId: accountId,
            orgId: orgId,
            isSiteAdmin: isSiteAdmin
        });
    }, [
        fetch,
        accountId,
        orgId,
        isSiteAdmin
    ]);
    return state;
};

});

parcelRegister("e57bL", function(module, exports) {

$parcel$export(module.exports, "Home", () => $f8508cd3b3bbf491$export$b94310965bed44e6);

var $5uXOq = parcelRequire("5uXOq");

var $5gSBR = parcelRequire("5gSBR");

var $6lwNs = parcelRequire("6lwNs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $4drrb = parcelRequire("4drrb");
const $f8508cd3b3bbf491$export$b94310965bed44e6 = ({ messages: messages = (0, $6lwNs.default), settingsDrawerItems: settingsDrawerItems, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
            key: group.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4drrb.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.type === 'Content' && item.content) {
                const content = item.content({
                    update: ()=>Promise.resolve(null),
                    isOpen: false,
                    setInitialFocusRef: ()=>null
                });
                if ((0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: item.id
                }, content);
                return content;
            }
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: item.description || ''
            }, item.text || ''));
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
            key: group.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4drrb.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: messages[item.id] ? formatMessage(messages[item.id]) : undefined
            }, item.text || ''));
        })))));
};

});
parcelRegister("4drrb", function(module, exports) {

$parcel$export(module.exports, "HomeHeading", () => $fd56d3368a0677f4$export$e2344e30272a44c1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8xXpg = parcelRequire("8xXpg");

var $lsVF8 = parcelRequire("lsVF8");

var $8fabB = parcelRequire("8fabB");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

const $fd56d3368a0677f4$export$e2344e30272a44c1 = ({ group: group, messages: messages, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const headingMessage = (0, $5uXOq.useMemo)(()=>formatMessage(messages[group.id]), [
        formatMessage,
        group.id,
        messages
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsVF8.default), {
        as: "h2",
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, 'heading'),
        size: "xxsmall"
    }, group.heading || ''));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        headingLevel: 3,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, 'heading')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd56d3368a0677f4$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, headingMessage), !!group.sideHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $f524727bc2d3810c$export$f707547fc95f31c2)
    }, group.sideHeading())));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd56d3368a0677f4$var$HeadingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
const $f524727bc2d3810c$export$f707547fc95f31c2 = 'atlassian-navigation.ui.settings.menu.home.heading.side-heading';



parcelRegister("asDBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e49dd60f5b63059$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e49dd60f5b63059$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "atlassian-navigation.settings.menu.settings",
        "defaultMessage": "Settings"
    }
});

});

parcelRegister("6svfi", function(module, exports) {

$parcel$export(module.exports, "Personal", () => $3dfa9666dd9cff1a$export$3965927bf7a81700);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ljDWX = parcelRequire("ljDWX");

var $3w2DH = parcelRequire("3w2DH");

var $efRSh = parcelRequire("efRSh");

var $iN7Ro = parcelRequire("iN7Ro");

var $c3q7f = parcelRequire("c3q7f");

var $8xXpg = parcelRequire("8xXpg");
var $5gSBR = parcelRequire("5gSBR");

var $lsVF8 = parcelRequire("lsVF8");

var $8fabB = parcelRequire("8fabB");

var $3JGmH = parcelRequire("3JGmH");

var $5U49F = parcelRequire("5U49F");

var $6lwNs = parcelRequire("6lwNs");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $1C2yb = parcelRequire("1C2yb");

var $cYlk7 = parcelRequire("cYlk7");

var $7ziML = parcelRequire("7ziML");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $6zdS6 = parcelRequire("6zdS6");
const $3dfa9666dd9cff1a$export$3965927bf7a81700 = ({ testIdPrefix: testIdPrefix })=>{
    const { data: data } = (0, $cYlk7.useCurrentUser)();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    const email = data.user?.emailAddress;
    const atlassianPersonalSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'personal-settings');
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3dfa9666dd9cff1a$var$HeadingComponent, {
        heading: formatMessage((0, $6lwNs.default).personalJiraSettings),
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default).personalJiraSettings)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $6zdS6.default).generalSettingsDescription),
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3w2DH))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $6zdS6.default).generalSettingsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default).personalJiraSettings)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $6zdS6.default).notificationSettingsDescription),
        href: "/jira/settings/personal/notifications",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ljDWX))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $6zdS6.default).notificationSettingsLabel)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        headingLevel: 3,
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $6zdS6.default).accountSettingsDescription),
        href: atlassianPersonalSettingsLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U49F.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($efRSh))), {
            size: "small",
            primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c3q7f))), {
            LEGACY_size: "small",
            label: ""
        }),
        target: "_blank",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $6zdS6.default).accountSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $6zdS6.default).personalJiraSettingsDescription),
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U49F.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iN7Ro))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $6zdS6.default).personalJiraSettings)))));
};
const $3dfa9666dd9cff1a$var$HeadingComponent = (props)=>{
    const { heading: heading, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsVF8.default), {
        as: "h2",
        testId: testId,
        size: "xxsmall"
    }, heading));
};

});
parcelRegister("6zdS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a9428fb9b2a405$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $73a9428fb9b2a405$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    accountSettings: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings",
        "defaultMessage": "Atlassian account settings"
    },
    accountSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings-description",
        "defaultMessage": "Manage your language, time zone, and other profile information."
    },
    personalJiraSettings: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings",
        "defaultMessage": "Personal Jira settings"
    },
    personalJiraSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings-description",
        "defaultMessage": "Manage your email notifications and other Jira settings."
    },
    // Nav4 Messages
    generalSettingsLabel: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-label",
        "defaultMessage": "General settings"
    },
    generalSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-description",
        "defaultMessage": "Manage language, time zone, and other personal preferences"
    },
    notificationSettingsLabel: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-label",
        "defaultMessage": "Notification settings"
    },
    notificationSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-description",
        "defaultMessage": "Manage email and in-product notifications from Jira"
    }
});

});


parcelRegister("b59xm", function(module, exports) {

$parcel$export(module.exports, "Warning", () => $d53d46adbad8e7db$export$c688898c4e3580ee);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fvINg = parcelRequire("fvINg");

var $5gSBR = parcelRequire("5gSBR");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $8Vm26 = parcelRequire("8Vm26");
const $d53d46adbad8e7db$export$c688898c4e3580ee = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'warning');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $8Vm26.default).noAdminPermissionMessage,
        values: {
            contact: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvINg.default), {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $8Vm26.default).noAdminPermissionMessageContact))
        }
    })));
};
const $d53d46adbad8e7db$export$e6dfd72ab29f8598 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$var$Outer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$var$Inner, null, children));
// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53d46adbad8e7db$var$Outer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3v47k _n3tdutpp _19bvv47k",
            __cmplp.className
        ])
    });
});
const $d53d46adbad8e7db$var$Inner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _p12f1kdj _bfhk1tzq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Vm26", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed016ce81d29e02d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ed016ce81d29e02d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noAdminPermissionMessage: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message",
        "defaultMessage": "You do not have access to Jira settings or Atlassian admin, {contact} to grant you access."
    },
    noAdminPermissionMessageContact: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message-contact",
        "defaultMessage": "contact your Jira admin"
    }
});

});



parcelRegister("3Ug2v", function(module, exports) {

$parcel$export(module.exports, "settingsMenuEntryPoint", () => $2f15e587ee559e13$export$61e5d93bdc8bc226);

var $cluFV = parcelRequire("cluFV");

var $29g2n = parcelRequire("29g2n");

const $2f15e587ee559e13$export$61e5d93bdc8bc226 = (0, $29g2n.createEntryPoint)({
    root: (0, $cluFV.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("hrU50"))).then(({ MenuWithEntryPoint: MenuWithEntryPoint })=>MenuWithEntryPoint), {
        moduleId: "c918b04e"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("2YzXO", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $ecced68b9b5eee26$export$b64708c6f1b3ed96);

var $5uXOq = parcelRequire("5uXOq");

var $7BEo0 = parcelRequire("7BEo0");

var $8e2i5 = parcelRequire("8e2i5");

var $aWse0 = parcelRequire("aWse0");

var $3HwlS = parcelRequire("3HwlS");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $avqpn = parcelRequire("avqpn");

var $jZF14 = parcelRequire("jZF14");
const $ecced68b9b5eee26$var$SignIn = ({ useDestinationParam: useDestinationParam = (0, $jZF14.useDestinationParam), useIntl: useIntl = (0, $aWse0.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous) })=>{
    const destinationParam = useDestinationParam();
    const isAnonymous = useIsAnonymous();
    const { formatMessage: formatMessage } = useIntl();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SIGN_IN
    });
    if (!isAnonymous) return null;
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7BEo0.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8e2i5))),
        label: formatMessage((0, $avqpn.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7BEo0.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8e2i5))),
        label: formatMessage((0, $avqpn.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    }));
};
const $ecced68b9b5eee26$export$b64708c6f1b3ed96 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).SIGN_IN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecced68b9b5eee26$var$SignIn, props));

});
parcelRegister("avqpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $04389e942ceaefeb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04389e942ceaefeb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    signIn: {
        "id": "atlassian-navigation.sign-in.sign-in",
        "defaultMessage": "Sign in"
    }
});

});

parcelRegister("jZF14", function(module, exports) {

$parcel$export(module.exports, "useDestinationParam", () => $80954d3accb3f049$export$c9c176e0725165cc);

var $j0xEB = parcelRequire("j0xEB");
const $80954d3accb3f049$export$c9c176e0725165cc = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return `os_destination=${encodedRedirectUrl}`;
    }
    return '';
};

});


parcelRegister("1mNGt", function(module, exports) {

$parcel$export(module.exports, "Plans", () => $73b77f33bee79d45$export$fa027c23da0a12ea);
$parcel$export(module.exports, "OpenOverflowMenuForPlansSpotlightObserver", () => $73b77f33bee79d45$export$c741bc6980da6a32);

var $5uXOq = parcelRequire("5uXOq");

var $gDHs4 = parcelRequire("gDHs4");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $88fdg = parcelRequire("88fdg");

var $h9iZl = parcelRequire("h9iZl");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $7Fvqy = parcelRequire("7Fvqy");

var $edhzr = parcelRequire("edhzr");

var $2eMU9 = parcelRequire("2eMU9");

var $2FrC0 = parcelRequire("2FrC0");
const $73b77f33bee79d45$var$PlansDropdown = ()=>{
    const [isPlansVisible] = (0, $h9iZl.useNavigationPlansVisibility)();
    const [{ hasFetchedOnce: hasFetchedOncePlans }, { loadFavoritePlans: loadFavorite }] = (0, $bcn6L.useFavoritePlans)();
    const [{ hasSuccessOnce: hasSuccessOnce }, { load: load }] = (0, $88fdg.usePlansItems)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    // Initialise items data
    (0, $5uXOq.useEffect)(()=>{
        !hasSuccessOnce && !isStandardOrFree && isPlansVisible && load();
    }, [
        hasSuccessOnce,
        load,
        isPlansVisible,
        isStandardOrFree
    ]);
    // Keep items data fresh
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (!isStandardOrFree) {
            load();
            if (!hasFetchedOncePlans) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }
    }, // We dont care about hasFetchedOncePlans, it will generate a new call back which then closes the popup
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        load,
        loadFavorite
    ]);
    if (!isPlansVisible) return null;
    /**
   * Cannot do <Popup ... MenuTrigger={MenuTrigger} /> because
   * Popup passes exact common MenuTrigger props which doesn't have DI components
   * that makes Flow complains about props passing to customized MenuTrigger
   * */ // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type 'Ref<MenuTriggerProps> | undefined'.
    // FIXME: Navigation should fix that by extracting the forwarded component
    // eslint-disable-next-line react/no-unstable-nested-components
    const FinalMenuTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $edhzr.MenuTrigger), {
            ...props,
            ref: ref
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).PLANS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PLANS,
        Menu: (0, $2eMU9.default),
        // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<MenuTriggerProps> | undefined'.
        MenuTrigger: FinalMenuTrigger,
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $2FrC0.default).plans)
    }, formatMessage((0, $2FrC0.default).plans)));
};
const $73b77f33bee79d45$export$fa027c23da0a12ea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PLANS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73b77f33bee79d45$var$PlansDropdown, null));
const $73b77f33bee79d45$export$c741bc6980da6a32 = ()=>{
    const [isPlansVisible] = (0, $h9iZl.useNavigationPlansVisibility)();
    const [shouldShow] = (0, $cE2Qr.useShouldShowNudge)({
        itemNames: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK)
        ]
    });
    const WRAPPER_UID = 'plans-spotlight-target-wrapper';
    const spotlightVisible = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !false && document.querySelector(`[data-uid="${WRAPPER_UID}"]`) != null;
    const { openOverflowMenu: openOverflowMenu } = (0, $gDHs4.useOverflowStatus)();
    (0, $5uXOq.useEffect)(()=>{
        isPlansVisible && shouldShow && !spotlightVisible && openOverflowMenu();
    }, [
        isPlansVisible,
        openOverflowMenu,
        shouldShow,
        spotlightVisible
    ]);
    return null;
};

});
parcelRegister("88fdg", function(module, exports) {

$parcel$export(module.exports, "usePlansItems", () => $fbc1adaeeb4c0d23$export$9386de9ff002702a);

var $jjts0 = parcelRequire("jjts0");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $fbc1adaeeb4c0d23$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchPlansItems: fetchPlansItems, baseUrl: baseUrl, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchPlansItems(baseUrl);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $fbc1adaeeb4c0d23$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($fbc1adaeeb4c0d23$var$handleFetch());
            await promise;
        }
};
const $fbc1adaeeb4c0d23$export$b0dd7d935d0978a4 = ({ storeName: storeName = 'plans-item-store', fetchPlansItems: fetchPlansItems })=>{
    const initialState = {
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        fetchPlansItems: fetchPlansItems,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: null,
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: storeName,
        actions: $fbc1adaeeb4c0d23$var$actions,
        initialState: initialState
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const usePlansItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        usePlansItems: usePlansItems
    };
};
const { usePlansItems: $fbc1adaeeb4c0d23$export$9386de9ff002702a } = $fbc1adaeeb4c0d23$export$b0dd7d935d0978a4({
    fetchPlansItems: (0, $jjts0.fetchPlansItems)
});

});
parcelRegister("jjts0", function(module, exports) {

$parcel$export(module.exports, "fetchPlansItems", () => $9279033d6121eb6e$export$ae5884604a8ac77b);

var $5HnTq = parcelRequire("5HnTq");

var $g5X3G = parcelRequire("g5X3G");

const $9279033d6121eb6e$var$handleError = (error)=>{
    throw error;
};
const $9279033d6121eb6e$var$transformResult = ({ isVisible: isVisible, staticLinks: staticLinks, recentPlans: recentPlans = [] })=>{
    const recentItems = recentPlans.map(({ planId: planId, scenarioId: scenarioId, title: title, url: url })=>({
            id: `${planId}|${scenarioId}`,
            title: title || '',
            url: url,
            type: (0, $49a076eb01652100$export$eebccb886b064713)
        }));
    return {
        isVisible: isVisible,
        recent: recentItems,
        links: staticLinks
    };
};
const $9279033d6121eb6e$export$ae5884604a8ac77b = async (baseUrl = (0, $g5X3G.toBaseUrl)(''))=>{
    const url = `${baseUrl}/rest/jpo/1.0/navigation`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (response.ok) {
            const result = await response.json();
            return $9279033d6121eb6e$var$transformResult(result);
        }
        return $9279033d6121eb6e$var$handleError(new Error(response.statusText));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $9279033d6121eb6e$var$handleError(error);
    }
};

});


parcelRegister("4XiFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f53eb447f22f4276$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");
const $f53eb447f22f4276$var$PopupBoxWrapper = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        xcss: $f53eb447f22f4276$var$popupBoxWrapperStyles
    }, children);
    // Wraped children in <></> to avoid returning undefined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $f53eb447f22f4276$var$popupBoxWrapperStyles = (0, $aCJg8.xcss)({
    color: 'color.text',
    height: '100%'
});
var $f53eb447f22f4276$export$2e2bcd8739ae039 = $f53eb447f22f4276$var$PopupBoxWrapper;

});

parcelRegister("ebYJ0", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $85fdbd4ad4faa6ef$export$129a32eedafa97c5);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gDHs4 = parcelRequire("gDHs4");

var $gFVv0 = parcelRequire("gFVv0");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $gAtvZ = parcelRequire("gAtvZ");

var $fVbkk = parcelRequire("fVbkk");

var $8JFi2 = parcelRequire("8JFi2");
const $85fdbd4ad4faa6ef$var$OFFSET = [
    12,
    -11
];
const $85fdbd4ad4faa6ef$export$129a32eedafa97c5 = ({ Menu: Menu, MenuTrigger: MenuTrigger = (0, $fVbkk.MenuTrigger), children: children, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, label: label })=>{
    const [isMenuOpen, { off: closeMenu }] = (0, $2Ui4E.useTopMenus)(menuId);
    const [isEventFromSpotlightTour] = (0, $gAtvZ.useFromSpotlightTour)('spotlight');
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const Trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuTrigger, {
            ...props,
            onBeforeMenuOpen: onBeforeMenuOpen,
            menuId: menuId,
            navigationItemId: navigationItemId,
            "aria-haspopup": false
        }, children), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        menuId,
        navigationItemId,
        onBeforeMenuOpen
    ]);
    const testId = (0, $6cNb0.testIdGenerate)('primary-actions', menuId, 'menu-popup');
    const Content = (0, $5uXOq.useCallback)((props)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            onClick: (0, $8JFi2.stopPropagation),
            "data-testid": testId,
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            ...props,
            testIdPrefix: testId
        }, children)), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        testId
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFVv0.default), {
        shouldRenderToParent: true,
        isOpen: isMenuOpen,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : closeMenu,
        content: Content,
        offset: isVisible ? undefined : $85fdbd4ad4faa6ef$var$OFFSET,
        placement: isVisible ? 'bottom-start' : 'right-start',
        trigger: Trigger,
        label: label
    });
};

});
parcelRegister("gAtvZ", function(module, exports) {

$parcel$export(module.exports, "useFromSpotlightTour", () => $27f5c6431be57d88$export$dc0191efbad6291c);

var $2qauD = parcelRequire("2qauD");
const { useSwitch: $27f5c6431be57d88$var$useSwitch } = (0, $2qauD.createSwitchController)('spotlight');
const $27f5c6431be57d88$export$dc0191efbad6291c = $27f5c6431be57d88$var$useSwitch;

});

parcelRegister("fVbkk", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $bb37eb68c16a7749$export$27d2ad3c5815583e);
$parcel$export(module.exports, "ChevronRightIcon", () => $bb37eb68c16a7749$export$b837bd7eac09a33e);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gDHs4 = parcelRequire("gDHs4");

var $e4fCM = parcelRequire("e4fCM");

var $lrCjX = parcelRequire("lrCjX");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $hjSul = parcelRequire("hjSul");

var $kAJ4Y = parcelRequire("kAJ4Y");

var $iPj86 = parcelRequire("iPj86");

var $jmHsa = parcelRequire("jmHsa");

var $5MZG9 = parcelRequire("5MZG9");

var $jngLf = parcelRequire("jngLf");

var $9YfZr = parcelRequire("9YfZr");
const $bb37eb68c16a7749$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, params: params, query: query, replace: replace, to: to, type: type, analyticsAttributes: analyticsAttributes, ...rest }, ref)=>{
    const [isMenuOpen, { off: closeMenu, toggle: toggleMenu }] = (0, $2Ui4E.useTopMenus)(menuId);
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const isHighlighted = (0, $kAJ4Y.useMenuHighlighted)(menuId);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: navigationItemId
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isMenuOpen) onBeforeMenuOpen();
        toggleMenu();
        triggerAnalytics(analyticsAttributes);
    }, [
        analyticsAttributes,
        isMenuOpen,
        onBeforeMenuOpen,
        toggleMenu,
        triggerAnalytics
    ]);
    // close menu on unmount
    (0, $5uXOq.useEffect)(()=>closeMenu, [
        closeMenu
    ]);
    const testId = (0, $6cNb0.testIdGenerate)('primary-actions', menuId, 'menu-trigger');
    if (isVisible) return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmHsa.PrimaryButton), {
        ...rest,
        component: (0, $hjSul.Link),
        href: href,
        isHighlighted: isHighlighted,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // @ts-expect-error - Type '"a"' is not assignable to type '"submit" | "reset" | "button" | undefined'
        type: "a"
    }) : // @ts-expect-error - iconBefore types mismatch ReactNode vs ReactChild
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MZG9.PrimaryDropdownButton), {
        ...rest,
        isHighlighted: isHighlighted,
        isSelected: isMenuOpen,
        onClick: onClick,
        ref: ref,
        testId: testId
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YfZr.RouteLinkItem), {
        ...rest,
        onClick: onClick,
        params: params,
        query: query,
        replace: replace,
        testId: testId,
        to: to,
        type: type
    });
    return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jngLf.LinkItem), {
        ...rest,
        href: href,
        onClick: onClick,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrCjX.default), {
        ...rest,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb37eb68c16a7749$export$b837bd7eac09a33e, null),
        isSelected: isMenuOpen,
        onClick: onClick,
        testId: testId
    }));
});
// re-render regression detection
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'ForwardRefExoticComponent<Pick<any, string | number | symbol> & RefAttributes<MenuTriggerProps>>'.
$bb37eb68c16a7749$export$27d2ad3c5815583e.whyDidYouRender = {
    customName: 'MenuTrigger'
};
const $bb37eb68c16a7749$export$b837bd7eac09a33e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb37eb68c16a7749$var$ChevronWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e4fCM))), {
        spacing: "spacious",
        label: ""
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb37eb68c16a7749$var$ChevronWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_tzy4105o _2hwxmgjw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kAJ4Y", function(module, exports) {

$parcel$export(module.exports, "useMenuHighlighted", () => $afe91b4b16cc8923$export$d47286bd4be0870d);


var $2Ioew = parcelRequire("2Ioew");

var $6jY6G = parcelRequire("6jY6G");
const $afe91b4b16cc8923$export$d47286bd4be0870d = (menuId)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const topNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
    if (route.navigation) return route.navigation.menuId === menuId;
    if (topNavEntryPointReference) return topNavEntryPointReference.extraProps.menuId === menuId;
    return false;
};

});
const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';

parcelRegister("2Ioew", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $dcf886ac39f7cfda$export$fe1c839e8baf4110);

var $h22md = parcelRequire("h22md");

var $6jY6G = parcelRequire("6jY6G");
const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const entryPointReference = (0, $h22md.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("h22md", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $4e1bc9edc261b42d$export$c96377f800cdddb4);

var $3I4nj = parcelRequire("3I4nj");
const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $3I4nj.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});



parcelRegister("jmHsa", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $d112cde340963e02$export$ac16a6a04d9b7c84);

var $5uXOq = parcelRequire("5uXOq");

var $lc2CB = parcelRequire("lc2CB");

var $eQCK3 = parcelRequire("eQCK3");
const $d112cde340963e02$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eQCK3.SkeletonPrimaryButton), {
        text: props.children === undefined ? '' : props.children,
        isHighlighted: props.isHighlighted
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lc2CB.PrimaryButton), buttonProps);
});

});

parcelRegister("5MZG9", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $e5d31dff0e605df2$export$bb3af89fb196520d);

var $5uXOq = parcelRequire("5uXOq");

var $8TICv = parcelRequire("8TICv");

var $eQCK3 = parcelRequire("eQCK3");
const $e5d31dff0e605df2$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eQCK3.SkeletonPrimaryButton), {
        isDropdownButton: true,
        isHighlighted: props.isHighlighted,
        text: props.children === undefined ? '' : props.children
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TICv.PrimaryDropdownButton), buttonProps);
});

});


parcelRegister("8JFi2", function(module, exports) {

$parcel$export(module.exports, "stopPropagation", () => $df06b43d1eb10455$export$51134cce184326b9);
const $df06b43d1eb10455$export$51134cce184326b9 = (e)=>e.stopPropagation();

});


parcelRegister("7Fvqy", function(module, exports) {

$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $ac0a44b8f9a76c7a$export$5edaea31b41b30b);
$parcel$export(module.exports, "useIsPremiumJSW", () => $ac0a44b8f9a76c7a$export$d245a3118a8b4004);
$parcel$export(module.exports, "useIsUnlicensedJSW", () => $ac0a44b8f9a76c7a$export$47ec61465121ff53);

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $ac0a44b8f9a76c7a$export$a2bbf41e67157372 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION);
};
const $ac0a44b8f9a76c7a$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION) || jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$d245a3118a8b4004 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.PREMIUM_EDITION);
};
const $ac0a44b8f9a76c7a$export$47ec61465121ff53 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return !jswEdition || jswEdition === (0, $ldyPw.UNLICENSED);
};

});

parcelRegister("edhzr", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $4c1d4dc7eac32f82$export$27d2ad3c5815583e);

var $5uXOq = parcelRequire("5uXOq");

var $fVbkk = parcelRequire("fVbkk");

var $fcc8T = parcelRequire("fcc8T");
const $4c1d4dc7eac32f82$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcc8T.MenuTrigger), {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        ...props,
        ref: ref
    });
});

});
parcelRegister("fcc8T", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $4bbcc669498d0877$export$27d2ad3c5815583e);

var $5uXOq = parcelRequire("5uXOq");

var $KWXOy = parcelRequire("KWXOy");

var $gDHs4 = parcelRequire("gDHs4");

var $eyEct = parcelRequire("eyEct");
var $aQl8U = parcelRequire("aQl8U");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $88fdg = parcelRequire("88fdg");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $dsvCp = parcelRequire("dsvCp");

var $8QMHF = parcelRequire("8QMHF");

var $k9JTq = parcelRequire("k9JTq");

var $fVbkk = parcelRequire("fVbkk");

var $j94qH = parcelRequire("j94qH");
const $4bbcc669498d0877$var$WRAPPER_UID = 'plans-spotlight-target-wrapper';
const $4bbcc669498d0877$var$useDelayedSpotlight = ()=>{
    const [ready, setSpotlightReady] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>setSpotlightReady(true), 100);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return ready;
};
const $4bbcc669498d0877$var$useWrapper = ()=>{
    const ref = (0, $5uXOq.useRef)(null);
    return {
        ref: ref
    };
};
const $4bbcc669498d0877$var$state = {
    hasSpotlightShown: false,
    hasSpotlightDone: false
};
/**
 * The spotlight is forced closed on any click (outside of the menu), which is unexpected behavior
 * This hook will try to re-open the "More" dropdown when the "Plans" is unmounted until the user
 * clicks "Done" on the spotlight
 */ const $4bbcc669498d0877$var$useSpotlightForceOpen = ()=>{
    const { isVisible: isVisible, openOverflowMenu: openOverflowMenu } = (0, $gDHs4.useOverflowStatus)();
    const isDropdownItem = !isVisible;
    (0, $5uXOq.useLayoutEffect)(()=>()=>{
            const updateState = ()=>{
                /**
				 * The actual wrapper is supposed to be unmounted, so, if there is
				 * another wrapper element, it must be the cloned one on the spotlight
				 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const spotlightVisible = document.querySelector(`[data-uid="${$4bbcc669498d0877$var$WRAPPER_UID}"]`) != null;
                /**
				 * The dropdown menu is required to remaining openned after clicking Done on the
				 * spotlight. So openOverflowMenu() will be called until state.hasSpotlightDone is true.
				 */ $4bbcc669498d0877$var$state.hasSpotlightShown = $4bbcc669498d0877$var$state.hasSpotlightShown || spotlightVisible;
                if (isDropdownItem && spotlightVisible && $4bbcc669498d0877$var$state.hasSpotlightShown && !$4bbcc669498d0877$var$state.hasSpotlightDone) openOverflowMenu();
                if ($4bbcc669498d0877$var$state.hasSpotlightShown && !spotlightVisible) $4bbcc669498d0877$var$state.hasSpotlightDone = true;
            };
            queueMicrotask(updateState);
        }, [
        isDropdownItem,
        openOverflowMenu
    ]);
};
const $4bbcc669498d0877$export$56d544c4f479b7fb = ({ children: children, isVisible: isVisible })=>{
    const shouldShowNudge = (0, $dsvCp.useCanShowQuickstartNudge)();
    return shouldShowNudge && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8QMHF.NavigationPlansNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $4bbcc669498d0877$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, triggerRef)=>{
    const wrapper = $4bbcc669498d0877$var$useWrapper();
    const ready = $4bbcc669498d0877$var$useDelayedSpotlight();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    const [shouldShow] = (0, $cE2Qr.useShouldShowNudge)({
        itemNames: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK)
        ]
    });
    $4bbcc669498d0877$var$useSpotlightForceOpen();
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const analyticsAttributes = {
        isAbleToCreateSamplePlan: !!items?.links?.createSamplePlan?.isVisible,
        ...jswEdition ? {
            jswEdition: jswEdition
        } : {}
    };
    const [isMenuOpen, { toggle: toggleMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PLANS);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShow && !isMenuOpen) toggleMenu();
    }, [
        isMenuOpen,
        shouldShow,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        backgroundColor: "color.background.neutral.subtle",
        xcss: $4bbcc669498d0877$var$triggerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyEct.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
        name: "nav-advanced-roadmaps-plans-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        "data-uid": $4bbcc669498d0877$var$WRAPPER_UID,
        ref: wrapper.ref,
        backgroundColor: "color.background.neutral.subtle",
        xcss: $4bbcc669498d0877$var$triggerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bbcc669498d0877$export$56d544c4f479b7fb, {
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        ref: triggerRef,
        analyticsAttributes: analyticsAttributes,
        ...props
    })))), ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KWXOy.EngagementSpotlight), {
        engagementId: "nav-advanced-roadmaps-plans-spotlight"
    })));
});
const $4bbcc669498d0877$var$triggerWrapperStyles = (0, $aCJg8.xcss)({
    height: '100%',
    display: 'flex',
    flexGrow: 1
});

});
parcelRegister("8QMHF", function(module, exports) {

$parcel$export(module.exports, "NavigationPlansNavItemWrapperNudgeAsync", () => $721bcfa7775fc750$export$e2e248a8ac2b2891);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $721bcfa7775fc750$var$NavigationPlansNavItemLazy = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("8wUfI")).then((exportedModule)=>exportedModule.NavigationPlansNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-plans/index.tsx"
});
const $721bcfa7775fc750$export$e2e248a8ac2b2891 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-navigation-plans-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($721bcfa7775fc750$var$NavigationPlansNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("8wUfI", function(module, exports) {

let $635cf276f9957de7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $635cf276f9957de7$var$load("kgTCG").then(()=>parcelRequire('gf2wp'));

});


parcelRegister("j94qH", function(module, exports) {

$parcel$export(module.exports, "FullHeightTextColorWrapper", () => $1e4986b0c19053de$export$19a17a164d8e4de3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1e4986b0c19053de$export$7ac7d6a768c2e9b2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});
const $1e4986b0c19053de$export$19a17a164d8e4de3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _syaz1fxt _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});

});



parcelRegister("2eMU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5668dcd9601b742$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5gSBR = parcelRequire("5gSBR");

var $g0Gtc = parcelRequire("g0Gtc");

var $7CMCs = parcelRequire("7CMCs");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $cmvab = parcelRequire("cmvab");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $7Fvqy = parcelRequire("7Fvqy");

var $hZbyv = parcelRequire("hZbyv");

var $42REw = parcelRequire("42REw");

var $53HSR = parcelRequire("53HSR");

var $6MUS3 = parcelRequire("6MUS3");

var $5n6PC = parcelRequire("5n6PC");

var $aProA = parcelRequire("aProA");
const $c5668dcd9601b742$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).PLANS
};
const $c5668dcd9601b742$var$Menu = ({ ActionFooter: ActionFooter = (0, $hZbyv.ActionFooter), AdminFooter: AdminFooter = (0, $42REw.AdminFooter), Content: Content = (0, $53HSR.default), FavoriteContent: // @ts-expect-error - TS2339 - Property 'FavoriteContent' does not exist on type 'MenuProps'.
FavoriteContent = (0, $6MUS3.FavoriteContent), Error: Error = (0, $8vzcp.MenuError), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $5n6PC.LoadStatus), Section: Section = (0, $5gSBR.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), ViewExperienceSuccessTracker: ViewExperienceSuccessTracker = (0, $g0Gtc.ExperienceSuccessTracker), testIdPrefix: testIdPrefix, useFavorite: // @ts-expect-error - TS2339 - Property 'useFavorite' does not exist on type 'MenuProps'.
useFavorite = (0, $bcn6L.useFavoritePlans) })=>{
    const [, { loadFavoritePlans: loadFavorite }] = useFavorite();
    const contentTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const actionFooterTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'action-footer');
    const adminFooterTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'admin-footer');
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: contentTestId
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentTestId
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            !isStandardOrFree && loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite,
        isStandardOrFree
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).PLANS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $c5668dcd9601b742$var$EVENT_DATA
    }, isStandardOrFree ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aProA.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plans-menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmvab.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null),
        placement: "navigation.v3.plans"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewExperienceSuccessTracker, {
        location: "atlassian-navigation--primary-actions--plans--menu-popup--content",
        failureEventAttributes: null,
        parentProviders: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: contentTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, {
        testIdPrefix: contentTestId
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plans-menu-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ActionFooter, {
        testIdPrefix: actionFooterTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdminFooter, {
        testIdPrefix: adminFooterTestId
    }))))));
};
var $c5668dcd9601b742$export$2e2bcd8739ae039 = $c5668dcd9601b742$var$Menu;

});
parcelRegister("cmvab", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessRenderer", () => $3d319632a25c0850$export$64aa988820df8e0f);

var $b6HdT = parcelRequire("b6HdT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6zTpr = parcelRequire("6zTpr");

var $cLXfT = parcelRequire("cLXfT");

var $k9JTq = parcelRequire("k9JTq");

var $5oBMG = parcelRequire("5oBMG");

var $ldyPw = parcelRequire("ldyPw");


var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $7CMCs = parcelRequire("7CMCs");
const $3d319632a25c0850$var$AA_TEST_PLACEMENTS = [
    'navigation.plans',
    'navigation.v3.plans'
];
const $3d319632a25c0850$export$dc50189dfb775e17 = (props)=>{
    const { component: component, placement: placement } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const hamsProductKey = (0, $cLXfT.getHamsProductKey)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $b6HdT.default), {
        cloudId: cloudId,
        hamsProductKey: hamsProductKey
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const hasPaymentDetails = entitlement?.transactionAccount?.isBillToPresent === true;
    const isInAATestGroup = $3d319632a25c0850$var$AA_TEST_PLACEMENTS.includes(placement);
    if (hasPaymentDetails !== false) return null;
    const isEnrolled = isInAATestGroup ? (0, $6s1PB.expValEquals)('persistent_paid_feature_awareness_aa', 'cohort', 'variation', 'not-enrolled') : (0, $6s1PB.expValEquals)('persistent_paid_feature_awareness_ab', 'cohort', 'variation', 'not-enrolled');
    return isEnrolled && component;
};
const $3d319632a25c0850$export$43f5a9f3669b7084 = (props)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions.software;
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const jswEntitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const trialEndTime = jswEntitlementDetails?.trialEndTime;
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const isOnJSWTrial = Boolean(trialEndTime && currentDate < trialEndTime);
    /** Eligibility criteria (in order of evaluation)
   * - FG must be on
   * - Must be on JSW Premium Trial
   * - Must not have payment details entered (obtained via query)
   * - Must be in variation for experiment (fire exposure at this point)
   */ const isOnJswPremiumTrial = jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isOnJSWTrial;
    return isOnJswPremiumTrial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$dc50189dfb775e17, props) : null;
};
const $3d319632a25c0850$export$64aa988820df8e0f = (props)=>{
    return (0, $4R6GH.fg)('persistent_paid_feature_awareness') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "paidFeatureAwarenessBoundary",
        packageName: "@atlassian/jira-paid-feature-awareness-renderer",
        fallback: "unmount",
        teamName: "growth-tako",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6zTpr.default), {
        name: "paid-feature-awareness-renderer-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$43f5a9f3669b7084, props))) : null;
};

});
parcelRegister("b6HdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fb09f2fb680d6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85ec4d59c8e86d4308faa110713ea5f7>>
 * @relayHash 2459adfd1757dd053e03532f3ba7126d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 559ebf3d0a29f050ca3f81210a14c9d49648e0c94910577b09e5527b3f9daec3
const $96fb09f2fb680d6a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "559ebf3d0a29f050ca3f81210a14c9d49648e0c94910577b09e5527b3f9daec3",
            "metadata": {},
            "name": "uiGetPaymentDetailsEnteredQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96fb09f2fb680d6a$var$node.hash = "cd9ff36ba318610ca3a732f7742e9802";
var $96fb09f2fb680d6a$export$2e2bcd8739ae039 = $96fb09f2fb680d6a$var$node;

});

parcelRegister("cLXfT", function(module, exports) {

$parcel$export(module.exports, "getHamsProductKey", () => $be23717f2b4b385d$export$413aba2429285627);
$parcel$export(module.exports, "getHamsProductKeyForProject", () => $be23717f2b4b385d$export$74f585c1245fa1a4);


var $1laI5 = parcelRequire("1laI5");
const $be23717f2b4b385d$export$413aba2429285627 = (applicationKey)=>{
    // JPD key does not have '.ondemand'
    if (applicationKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return applicationKey;
    return `${applicationKey}.ondemand`;
};
const $be23717f2b4b385d$export$74f585c1245fa1a4 = (project)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    return $be23717f2b4b385d$export$413aba2429285627(application);
};

});


parcelRegister("8vzcp", function(module, exports) {

$parcel$export(module.exports, "MenuError", () => $51a1ea955baf80ff$export$b4cb8426191db8b3);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $jyltl = parcelRequire("jyltl");

var $bXAP4 = parcelRequire("bXAP4");

var $itL3d = parcelRequire("itL3d");
const $51a1ea955baf80ff$export$b4cb8426191db8b3 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const errorText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a1ea955baf80ff$var$TextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a1ea955baf80ff$var$Heading, null, formatMessage((0, $itL3d.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $itL3d.default).errorBody)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgAltText: formatMessage((0, $itL3d.default).errorImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($bXAP4))),
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'error'),
        text: errorText,
        useSmallImage: true
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a1ea955baf80ff$var$TextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $51a1ea955baf80ff$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "strong", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jyltl", function(module, exports) {

$parcel$export(module.exports, "MenuInfo", () => $c2ec3089b9809088$export$14caacd677140cdb);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $c2ec3089b9809088$export$14caacd677140cdb = ({ imgAltText: imgAltText, imgHeight: imgHeight, imgSrc: imgSrc, text: text, useSmallImage: useSmallImage = false, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$895814aa5a1cf38c, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$e54065c861f556f9, {
        alt: imgAltText || '',
        imgHeight: imgHeight,
        src: imgSrc,
        useSmallImage: useSmallImage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$7c3018f441722857, null, text));
const $c2ec3089b9809088$export$895814aa5a1cf38c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsbnklw _1e0c1txw _y3gn1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $c2ec3089b9809088$export$e54065c861f556f9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useSmallImage: useSmallImage, imgHeight: imgHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ve50id": (0, $lD23V.default)(__cmplp.imgHeight, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _ca0qv47k _u5f3idpf _n3tdpxbi _19bvidpf _p12f1osq",
            __cmplp.useSmallImage ? "_1bsb16xz" : "_1bsb1lit",
            __cmplp.imgHeight != null ? "_4t3i1m1g" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $c2ec3089b9809088$export$7c3018f441722857 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _ca0qidpf _u5f3v47k _n3tdv47k _19bvv47k",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bXAP4", function(module, exports) {
module.exports = new URL("generic-error.bc45c66a.svg", import.meta.url).toString();

});

parcelRegister("itL3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $9730b8dbc9b9bc1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9730b8dbc9b9bc1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "atlassian-navigation.common.menu.error.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "atlassian-navigation.common.menu.error.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    errorImg: {
        "id": "atlassian-navigation.common.menu.error.error-img",
        "defaultMessage": "An image showing that an error has occurred"
    }
});

});


parcelRegister("hZbyv", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $adef3029a926b6d1$export$2d2b754ac238f9aa);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $gD5Z0 = parcelRequire("gD5Z0");

var $4LAva = parcelRequire("4LAva");

var $L0P37 = parcelRequire("L0P37");

var $9EGDV = parcelRequire("9EGDV");

var $eemc9 = parcelRequire("eemc9");
const $adef3029a926b6d1$export$2d2b754ac238f9aa = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const isPlanListEmpty = (0, $eemc9.useIsPlanListEmpty)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'action-footer');
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    if (!items || !items.links) return null;
    const { links: links } = items;
    const { managePlans: managePlans, createPlan: createPlan, createSamplePlan: createSamplePlan } = links;
    const isAnyItemVisible = managePlans.isVisible || createPlan.isVisible;
    if (!isAnyItemVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        ...links.managePlans,
        title: formatMessage((0, $9EGDV.default).managePlans),
        testIdPrefix: testIdPrefix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        id: links.createPlan.id,
        isVisible: links.createPlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $9EGDV.default).createPlan),
        testIdPrefix: testIdPrefix,
        onClick: onClick
    }), createSamplePlan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        id: createSamplePlan.id,
        isVisible: createSamplePlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $9EGDV.default).createDemoPlan),
        testIdPrefix: testIdPrefix,
        onClick: openCreateSamplePlanModal
    }));
};

});
parcelRegister("gD5Z0", function(module, exports) {

$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a);
$parcel$export(module.exports, "useImportedMessagesForLocale", () => $13f82bb8cfc1f7f2$export$52303468eeac3ad0);

var $5uXOq = parcelRequire("5uXOq");

var $3e6Ej = parcelRequire("3e6Ej");

var $koVbs = parcelRequire("koVbs");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $13f82bb8cfc1f7f2$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $13f82bb8cfc1f7f2$var$initialState = {
    isOpen: false,
    plan: undefined,
    isPlanCreationComplete: false
};
const $13f82bb8cfc1f7f2$var$Store = (0, $iXqE5.createStore)({
    name: $13f82bb8cfc1f7f2$var$CONTROLLER_NAME,
    initialState: $13f82bb8cfc1f7f2$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            (0, $3e6Ej.default)('arj-create-plan-wizard-drawer');
            return (0, $4R6GH.fg)('ensure_plan_create_ufo_event_fires_successfully') ? ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan,
                    isPlanCreationComplete: false
                }) : ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                }),
        setIsPlanCreationComplete: (isPlanCreationComplete = true)=>({ setState: setState })=>(0, $4R6GH.fg)('ensure_plan_create_ufo_event_fires_successfully') ? setState({
                    isPlanCreationComplete: isPlanCreationComplete
                }) : undefined
    }
});
const $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a = (0, $3sQ5x.createHook)($13f82bb8cfc1f7f2$var$Store);
const $13f82bb8cfc1f7f2$export$9ec7b5762fb72de2 = (0, $gg7kZ.createContainer)($13f82bb8cfc1f7f2$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
const $13f82bb8cfc1f7f2$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
    };
    const packageName = (0, $4R6GH.fg)('finish_jira-portfolio-3-plan-wizard_migration') ? 'jira-portfolio-3-plan-wizard' : 'jira-portfolio-plan-wizard';
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await import(`@atlassian/${packageName}/dist/esm/i18n/*.js`);
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/${packageName}/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $13f82bb8cfc1f7f2$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [state, setState] = (0, $5uXOq.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $5uXOq.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: true
                }));
            const { default: intlMessages } = await $13f82bb8cfc1f7f2$export$19442c17ab279a67(locale);
            if (!mounted) return;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});

parcelRegister("4LAva", function(module, exports) {

$parcel$export(module.exports, "useCreateSamplePlan", () => $8f6b3552bc4c872c$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $8f6b3552bc4c872c$export$88b99aa46c223622);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $e0K2C = parcelRequire("e0K2C");

var $hK1fQ = parcelRequire("hK1fQ");
const $8f6b3552bc4c872c$var$CONTROLLER_NAME = 'create-sample-plan';
const $8f6b3552bc4c872c$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $8f6b3552bc4c872c$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($8f6b3552bc4c872c$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $hK1fQ.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $hK1fQ.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($8f6b3552bc4c872c$var$actions.close());
                } else {
                    const flagId = (0, $e0K2C.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(err.message)) (0, $jcw0u.default)({
                    error: err,
                    meta: {
                        id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorFlag, props)
                });
                dispatch($8f6b3552bc4c872c$var$actions.close());
            }
        }
};
const $8f6b3552bc4c872c$var$Store = (0, $iXqE5.createStore)({
    name: $8f6b3552bc4c872c$var$CONTROLLER_NAME,
    initialState: $8f6b3552bc4c872c$var$initialState,
    actions: $8f6b3552bc4c872c$var$actions
});
const $8f6b3552bc4c872c$export$53d6fde96f096b86 = (0, $3sQ5x.createHook)($8f6b3552bc4c872c$var$Store);
const $8f6b3552bc4c872c$export$88b99aa46c223622 = (0, $gg7kZ.createContainer)($8f6b3552bc4c872c$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("e0K2C", function(module, exports) {

$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $3613c4dc2e67ca96$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $3613c4dc2e67ca96$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $3613c4dc2e67ca96$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $3613c4dc2e67ca96$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $3613c4dc2e67ca96$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $3613c4dc2e67ca96$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $3613c4dc2e67ca96$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $3613c4dc2e67ca96$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $3613c4dc2e67ca96$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", () => $3613c4dc2e67ca96$export$525cba92c9b435f4);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $3613c4dc2e67ca96$export$2c5a783ab3215ce1);

var $2L5wO = parcelRequire("2L5wO");
const $3613c4dc2e67ca96$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $3613c4dc2e67ca96$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact';
const $3613c4dc2e67ca96$var$LEARN_MORE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $3613c4dc2e67ca96$export$62da4a2465b3b309 = 255;
const $3613c4dc2e67ca96$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $3613c4dc2e67ca96$export$abd17266df221a92 = 'samplePlanError';
const $3613c4dc2e67ca96$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS = 'EMPTY_ISSUE_LINKS';
const $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION = 'NO_BROWSE_PROJECTS_PERMISSION';
const $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION = 'NO_CREATE_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION = 'NO_TRANSITION_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION = 'NO_EDIT_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$WATCHING_DISABLED = 'WATCHING_DISABLED';
const $3613c4dc2e67ca96$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $3613c4dc2e67ca96$export$4a3e779cd3c10125 = [
    $3613c4dc2e67ca96$export$e6515d2009b1dba7,
    $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS,
    $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION,
    $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$WATCHING_DISABLED
];
const $3613c4dc2e67ca96$export$91ec80863c2c2030 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).tryAgainErrorTitle
};
const $3613c4dc2e67ca96$export$c43e20911e13ca0 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueError,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksError,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionError,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledError,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$525cba92c9b435f4 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$2c5a783ab3215ce1 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: {
        text: (0, $2L5wO.default).contactSupport,
        href: $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL
    }
};

});
parcelRegister("2L5wO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4969e0d482b1a0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4969e0d482b1a0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    },
    requiredFieldsConfiguredOnIssueErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
        "defaultMessage": "Your work items have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
        "defaultMessage": "Your site doesn't have work item links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noCreateIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create work items</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition work items</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit work items</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you have work item watching disabled. {readMoreLink}"
    }
});

});


parcelRegister("hK1fQ", function(module, exports) {

$parcel$export(module.exports, "createSamplePlanAsync", () => $4a753946a320d2b7$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $4a753946a320d2b7$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $jcw0u = parcelRequire("jcw0u");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $e0K2C = parcelRequire("e0K2C");
const $4a753946a320d2b7$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $jJZqs.default)(response.status, (0, $e0K2C.UNKNOWN_EXCEPTION), response.headers.get((0, $fnyT4.TRACE_ID_HEADER)) ?? undefined, response);
};
const $4a753946a320d2b7$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $4a753946a320d2b7$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $4a753946a320d2b7$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $eusud.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $4a753946a320d2b7$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $4a753946a320d2b7$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $4a753946a320d2b7$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $4a753946a320d2b7$var$delay();
        return $4a753946a320d2b7$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(error.message)) (0, $jcw0u.default)({
            meta: {
                id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("L0P37", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $3555250889c231c3$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $6cNb0 = parcelRequire("6cNb0");

var $d4B4Y = parcelRequire("d4B4Y");
const $3555250889c231c3$export$2ce376c2cc3355c8 = ({ id: id, url: url, title: title, isVisible: isVisible, onClick: onClick, testIdPrefix: testIdPrefix })=>isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: url,
        key: id,
        onClick: onClick,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-${id}`)
    }, title) : null;

});

parcelRegister("9EGDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b84dd9eb74c4947$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b84dd9eb74c4947$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    managePlans: {
        "id": "atlassian-navigation.plans.menu.action-footer.manage-plans",
        "defaultMessage": "View all plans"
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});

parcelRegister("eemc9", function(module, exports) {

$parcel$export(module.exports, "useIsPlanListEmpty", () => $6d7bc7f34f360a53$export$5b132e35e5bd9b74);

var $dMJS0 = parcelRequire("dMJS0");
const $6d7bc7f34f360a53$export$5b132e35e5bd9b74 = ()=>{
    const { recentItems: recentItems, favoriteItems: favoriteItems } = (0, $dMJS0.usePlanNavItems)();
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    return !(hasRecentItems || hasFavoriteItems);
};

});
parcelRegister("dMJS0", function(module, exports) {

$parcel$export(module.exports, "useBoardNavItems", () => $104764fbcbb91fe4$export$cad67ea3bdbadd5e);
$parcel$export(module.exports, "useDashboardNavItems", () => $104764fbcbb91fe4$export$eb662c364f65f2a5);
$parcel$export(module.exports, "useFilterNavItems", () => $104764fbcbb91fe4$export$b00ea32725560f5d);
$parcel$export(module.exports, "usePlanNavItems", () => $104764fbcbb91fe4$export$8448c28cc43804d4);
$parcel$export(module.exports, "useProjectNavItems", () => $104764fbcbb91fe4$export$4a9469e6b2e4297c);
$parcel$export(module.exports, "useRecentNavItems", () => $104764fbcbb91fe4$export$5cfe5f7fc9ab5417);
$parcel$export(module.exports, "useQueueNavItems", () => $104764fbcbb91fe4$export$7723949d2540d672);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bcn6L = parcelRequire("bcn6L");

var $4041n = parcelRequire("4041n");

var $88fdg = parcelRequire("88fdg");

var $apeap = parcelRequire("apeap");
const $104764fbcbb91fe4$var$getFavouriteAndRecentItems = (recentItems, favoriteItems, changedItems)=>{
    const mapChangedItems = (item)=>{
        const changedItem = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(changedItems, item.id);
        return changedItem ? {
            ...item,
            favourite: changedItem.value
        } : item;
    };
    const updatedFavorites = favoriteItems ? favoriteItems.map(mapChangedItems) : [];
    const updatedRecents = recentItems ? recentItems.map(mapChangedItems) : [];
    // this logic relies on the fact that we defer update favorites store on dropdown close
    // so we can assume that favorites list always affects recent list
    const favoritesIds = updatedFavorites.map((item)=>item.id);
    const filteredRecents = updatedRecents.filter((item)=>!favoritesIds.includes(Number(item.id)));
    return {
        favoriteItems: updatedFavorites,
        recentItems: filteredRecents
    };
};
const $104764fbcbb91fe4$var$getFilteredViewedItems = (viewedItems, // @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
workedOnItems)=>viewedItems?.filter((viewedItem)=>!workedOnItems?.some(// @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
        (workedOnItem)=>parseInt(workedOnItem.localResourceId, 10) === viewedItem.id && workedOnItem.type === viewedItem.type)) || [];
const $104764fbcbb91fe4$export$cad67ea3bdbadd5e = ()=>{
    const { changeFavorite: changeFavorite, items: { boards: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentBoards)();
    const [favoriteData] = (0, $bcn6L.useFavoriteBoards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$eb662c364f65f2a5 = ()=>{
    const { changeFavorite: changeFavorite, items: { dashboards: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentDashboards)();
    const [favoriteData] = (0, $bcn6L.useFavoriteDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$b00ea32725560f5d = ()=>{
    const { changeFavorite: changeFavorite, items: { filters: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentFilters)();
    const [favoriteData] = (0, $bcn6L.useFavoriteFilters)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$8448c28cc43804d4 = ()=>{
    const { changeFavorite: changeFavorite, items: { plans: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const [favoriteData] = (0, $bcn6L.useFavoritePlans)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>{
        const recentPlans = items?.recent ? items.recent.map(// the id is a concatenation of planId and scenarioId...
        // we need to strip the scenario so we just have the plan id
        (plan)=>({
                ...plan,
                id: plan.id.toString().split('|')[0]
            })) : [];
        return $104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentPlans, favoriteData.items, changedItems);
    }, [
        items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$4a9469e6b2e4297c = ()=>{
    const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentProjects)();
    const [favoriteData] = (0, $bcn6L.useFavoriteProjects)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$5cfe5f7fc9ab5417 = ()=>{
    const [viewedData] = (0, $apeap.useRecentAllSingleList)();
    const [workedOnData] = (0, $apeap.useWorkedOnAllSingleList)();
    const viewedItems = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFilteredViewedItems(viewedData.items, workedOnData.items), [
        viewedData.items,
        workedOnData.items
    ]);
    return {
        workedOnItems: workedOnData.items || [],
        viewedItems: viewedItems
    };
};
const $104764fbcbb91fe4$export$7723949d2540d672 = ()=>{
    const { changeFavorite: changeFavorite, items: { queues: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentQueues)();
    const [favoriteData] = (0, $bcn6L.useFavoriteQueues)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};

});
parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $fXz1L = parcelRequire("fXz1L");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $fXz1L.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $fXz1L.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $fXz1L.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $1Y49U = parcelRequire("1Y49U");

var $1WQct = parcelRequire("1WQct");

var $k0goX = parcelRequire("k0goX");

var $gbLWS = parcelRequire("gbLWS");

var $89DrR = parcelRequire("89DrR");

var $j5YhT = parcelRequire("j5YhT");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $j5YhT.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $gbLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $k0goX.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $89DrR.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $1WQct.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $1Y49U.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});

parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});






parcelRegister("42REw", function(module, exports) {

$parcel$export(module.exports, "AdminFooter", () => $7b2abd444f379ab5$export$d7aa9aad32d41ef6);

var $5uXOq = parcelRequire("5uXOq");

var $5gSBR = parcelRequire("5gSBR");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $d4B4Y = parcelRequire("d4B4Y");

var $7Josu = parcelRequire("7Josu");
const $7b2abd444f379ab5$export$d7aa9aad32d41ef6 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'admin-footer');
    if (!items || !items.links) return null;
    const { links: { settings: { id: id, isVisible: isVisible } } } = items;
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'planSettingsNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: "/jira/plans/settings/permissions",
        key: id,
        testId: (0, $6cNb0.testIdConcat)(testId, `item-${id}`)
    }, formatMessage((0, $7Josu.default).settings)));
};

});
parcelRegister("7Josu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ecad56cc035bca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7ecad56cc035bca$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "atlassian-navigation.plans.menu.admin-footer.settings",
        "defaultMessage": "Settings"
    }
});

});


parcelRegister("53HSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a598b0994a63b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $dMJS0 = parcelRequire("dMJS0");

var $9ZBW7 = parcelRequire("9ZBW7");

var $gJFyv = parcelRequire("gJFyv");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $c5a598b0994a63b7$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $c5a598b0994a63b7$var$Content = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.usePlanNavItems)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    if (!hasRecentItems && !hasFavoriteItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ZBW7.default), {
        testIdPrefix: (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty')
    });
    return hasRecentItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'heading')
    }, formatMessage((0, $gJFyv.default).recent)), recentItems.map((item, index)=>{
        const { id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const itemTitle = title || formatMessage((0, $gJFyv.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: index
            },
            href: item.url,
            key: item.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-${index}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5a598b0994a63b7$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PLANS_ITEM_TYPE)
            }),
            "aria-label": itemTitle
        }, itemTitle);
    })) : null;
};
var $c5a598b0994a63b7$export$2e2bcd8739ae039 = $c5a598b0994a63b7$var$Content;

});
parcelRegister("fhtpB", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $fd1b3cb9e133f54f$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $gDHs4 = parcelRequire("gDHs4");

var $hcObS = parcelRequire("hcObS");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");
const $fd1b3cb9e133f54f$export$8d5dab2ad1e19ea0 = ({ beforeEntityId: // @ts-expect-error - TS2339 - Property 'beforeEntityId' does not exist on type 'FavoriteButtonProps'.
beforeEntityId, beforeEntityType: // @ts-expect-error - TS2339 - Property 'beforeEntityType' does not exist on type 'FavoriteButtonProps'.
beforeEntityType, id: id, isFavorite: isFavorite, favoriteItemName: favoriteItemName, isPending: isPending, menuItemType: menuItemType, onChangeFavorite: onChangeFavorite, type: type })=>{
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const contextualAnalyticsDataAttributes = (0, $5uXOq.useMemo)(()=>({
            isInMore: !isVisible,
            menuType: type,
            menuItemType: menuItemType
        }), [
        isVisible,
        menuItemType,
        type
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const beforeEntity = beforeEntityId != null && beforeEntityType != null ? {
            beforeEntity: {
                id: beforeEntityId,
                type: beforeEntityType
            }
        } : undefined;
        onChangeFavorite({
            id: id,
            value: !isFavorite,
            type: type,
            ...beforeEntity
        });
        const actionSubject = type.slice(0, type.length - 1); // remove "s" from type ("projects" -> "project", etc)
        const action = isFavorite ? 'unstarred' : 'starred';
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, id);
    }, [
        beforeEntityId,
        beforeEntityType,
        createAnalyticsEvent,
        id,
        isFavorite,
        onChangeFavorite,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: contextualAnalyticsDataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        isSmall: true,
        isShownInList: true,
        isFavorite: isFavorite,
        favoriteItemName: favoriteItemName,
        pending: isPending,
        onClick: onClick
    }));
};

});
parcelRegister("hcObS", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $0a68425ce3fc2fa8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $7l0wY = parcelRequire("7l0wY");

var $3z1mQ = parcelRequire("3z1mQ");

var $9J0fZ = parcelRequire("9J0fZ");

var $g2ztk = parcelRequire("g2ztk");

var $3wk5D = parcelRequire("3wk5D");

var $j56NU = parcelRequire("j56NU");

var $ilLDC = parcelRequire("ilLDC");

var $7SsRN = parcelRequire("7SsRN");

var $c63mb = parcelRequire("c63mb");

var $iQv12 = parcelRequire("iQv12");

var $7XYc4 = parcelRequire("7XYc4");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6fQ6A = parcelRequire("6fQ6A");
const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $0a68425ce3fc2fa8$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7SsRN.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
            "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3z1mQ))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3wk5D))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9J0fZ))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($g2ztk))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($j56NU))) : (0, (/*@__PURE__*/$parcel$interopDefault($ilLDC)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($3z1mQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($9J0fZ)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6fQ6A.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6fQ6A.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c63mb.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7l0wY.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $az4zD.injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
const $0a68425ce3fc2fa8$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$db65185b5889c83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("6fQ6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc2ec5d9a72db1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});



parcelRegister("9ZBW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e027cbf3ff743a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7l0wY = parcelRequire("7l0wY");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");

var $ousew = parcelRequire("ousew");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $gD5Z0 = parcelRequire("gD5Z0");

var $4LAva = parcelRequire("4LAva");

var $8zOmE = parcelRequire("8zOmE");

var $jyltl = parcelRequire("jyltl");

var $fufBl = parcelRequire("fufBl");

var $iy6PK = parcelRequire("iy6PK");
const $72e027cbf3ff743a$var$EmptyWithCTAs = ({ testIdPrefix: testIdPrefix })=>{
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const handleRequestCreateSamplePlan = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationCreateSamplePlan');
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal
    ]);
    const handleRequestCreatePlan = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationCreatePlan');
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    const createPlan = items?.links?.createPlan;
    const createSamplePlan = items?.links?.createSamplePlan;
    const hasButtons = Boolean(createPlan?.isVisible || createSamplePlan?.isVisible);
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).plansText)), hasButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        xcss: $72e027cbf3ff743a$var$buttonGroupStyles
    }, createSamplePlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7l0wY.default), {
        onClick: handleRequestCreateSamplePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).createDemoPlan)), createPlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7l0wY.default), {
        appearance: "primary",
        onClick: handleRequestCreatePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).createPlan))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgAltText: "",
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($fufBl))),
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty'),
        text: text
    });
};
var $72e027cbf3ff743a$export$2e2bcd8739ae039 = $72e027cbf3ff743a$var$EmptyWithCTAs;
const $72e027cbf3ff743a$var$buttonGroupStyles = (0, $aCJg8.xcss)({
    marginTop: 'space.200',
    display: 'flex',
    gap: 'space.100',
    justifyContent: 'center'
});

});
parcelRegister("fufBl", function(module, exports) {
module.exports = new URL("plans-empty.7a647633.svg", import.meta.url).toString();

});

parcelRegister("iy6PK", function(module, exports) {

$parcel$export(module.exports, "default", () => $20432d5456b05a6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $20432d5456b05a6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plansText: {
        "id": "atlassian-navigation.plans.menu.content.empty.plans-text",
        "defaultMessage": "Create up-to-date plans from multiple teams and projects."
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-demo-plan",
        "defaultMessage": "Create demo plan"
    },
    learnMore: {
        "id": "atlassian-navigation.plans.menu.content.empty.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("gJFyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1da9814d244cf8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f1da9814d244cf8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.plans.menu.content.recent",
        "defaultMessage": "Recent"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("6MUS3", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $4f470a059723f912$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $8jQu6 = parcelRequire("8jQu6");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $fbx6q = parcelRequire("fbx6q");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $4f470a059723f912$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $4f470a059723f912$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.usePlanNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $fbx6q.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const itemTitle = title || formatMessage((0, $fbx6q.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f470a059723f912$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PLANS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            "aria-label": itemTitle
        }, itemTitle);
    }), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: "/jira/plans",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $8jQu6.plansDirectoryRoute)
    })) : null;
};

});
parcelRegister("8jQu6", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $f8b07af15c3bb184$export$143b4a1ef2ffc051);
const $f8b07af15c3bb184$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("56fXm", function(module, exports) {

$parcel$export(module.exports, "MenuItemViewAll", () => $fec3d6e24cccbb91$export$2d5ce40137c4f96d);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9TxfE = parcelRequire("9TxfE");

var $koVbs = parcelRequire("koVbs");

var $d4B4Y = parcelRequire("d4B4Y");

var $awxdD = parcelRequire("awxdD");
const $fec3d6e24cccbb91$var$styles = {
    viewAll: "_1toh18uv _5jyqglyw _mrqmnqa1 _vwjz18uv _1p6b18uv _1f98glyw _1p6mglyw _6xf7nqa1 _1ejunqa1 _zelm14q2 _1fh114q2 _ow0718uv _17rjglyw _1iqunqa1 _1l5a16c2 _1w9014q2 _ufb318uv _xrk1glyw _wgbdnqa1 _1tjq14q2"
};
const $fec3d6e24cccbb91$export$2d5ce40137c4f96d = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $d4B4Y.MenuItem), {
        ...props,
        target: "_blank",
        iconAfter: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9TxfE))), {
            spacing: "spacious",
            label: formatMessage((0, $awxdD.default).viewAllStarred)
        }),
        className: (0, $bwpsq.default)([
            $fec3d6e24cccbb91$var$styles.viewAll
        ])
    }, formatMessage((0, $awxdD.default).viewAllStarred));
};

});
parcelRegister("awxdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6318f13bf447304$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6318f13bf447304$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllStarred: {
        "id": "atlassian-navigation.common.menu.view-all.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("fbx6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5162b46fd824b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c5162b46fd824b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.plans.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.favorite-content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("5n6PC", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $28d55793d37ab45d$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $88fdg = parcelRequire("88fdg");

var $dHtVS = parcelRequire("dHtVS");
const $28d55793d37ab45d$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), usePlansItems: usePlansItems = (0, $88fdg.usePlansItems), shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: usePlansItems
    });

});
parcelRegister("dHtVS", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $97c251fd319eb785$export$c7df4a3f1b89de01);
const $97c251fd319eb785$export$c7df4a3f1b89de01 = ({ useProvider: useProvider, shouldThrowError: shouldThrowError = false })=>{
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const [{ fetchError: fetchError, isFetching: isFetching = false, promise: promise, hasSuccessOnce: hasSuccessOnce = false } = {}] = useProvider();
    if (fetchError != null && shouldThrowError && !hasSuccessOnce) throw fetchError;
    if (isFetching && !hasSuccessOnce) throw promise;
    return null;
};

});


parcelRegister("aProA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ef1621dccedbfe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $htQUQ = parcelRequire("htQUQ");

var $lsVF8 = parcelRequire("lsVF8");

var $4AEJj = parcelRequire("4AEJj");

var $8fabB = parcelRequire("8fabB");
var $aCJg8 = parcelRequire("aCJg8");

var $iH68k = parcelRequire("iH68k");

var $iwnVa = parcelRequire("iwnVa");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $liGrj = parcelRequire("liGrj");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $Mp6qH = parcelRequire("Mp6qH");

var $iIz7a = parcelRequire("iIz7a");

var $gblI8 = parcelRequire("gblI8");
const $59ef1621dccedbfe$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
// Statsig experiment `plans_menu_try_it_free_one_stop_shop_modal`
// the control cohort will be shown the modal, whereas the test cohort will be redirected to the billing page instead.
// if the check errors for whatever reason, we still want to show the modal, hence why it defaults to true
const $59ef1621dccedbfe$var$PremiumFeatureGate = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $iH68k.default)();
    const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
        data: {
            premiumTrialUpgradeLink: undefined
        }
    } : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iwnVa.useJswPremiumTrialUpgradeLink)({
        caller: (0, $Mp6qH.PACKAGE_NAME)
    });
    const onStartTrialClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationUpgradeToPremiumFromPlansMenu');
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationLearnMoreAboutPremiumFromPlansMenu');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIz7a.FeatureGateLogo), {
        alt: "",
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsVF8.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $gblI8.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        xcss: $59ef1621dccedbfe$var$contentDescriptionStyles
    }, formatMessage((0, $gblI8.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$LearnMoreButton, {
        appearance: "link",
        href: $59ef1621dccedbfe$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $gblI8.default).learnMoreLink)), (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AEJj))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButtonDirectLink, {
        href: premiumTrialUpgradeLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AEJj))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton))));
};
var $59ef1621dccedbfe$export$2e2bcd8739ae039 = $59ef1621dccedbfe$var$PremiumFeatureGate;
const $59ef1621dccedbfe$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liGrj.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$TryPremiumButtonDirectLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htQUQ.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htQUQ.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _11q717kt _189et94y _1dqonqa1 _1h6d3acm _vchhusvi _qjkjusvi _1y1m18uv _p12f4lgm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7gup1 _2rko1xsr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3il1r9 _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $59ef1621dccedbfe$var$contentDescriptionStyles = (0, $aCJg8.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _2rko4dok _ca0qidpf _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iwnVa", function(module, exports) {

$parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", () => $fc84e0a2b7204935$export$645eda3f5f2163ec);

var $2vSU6 = parcelRequire("2vSU6");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $7qMMP = parcelRequire("7qMMP");
const $fc84e0a2b7204935$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
    const { productEntitlementDetails: productEntitlementDetails } = (0, $9OXo1.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
    const { data: data, ...rest } = (0, $7qMMP.useGetBillingPageUrl)({
        isUsingCcp: isJswUsingCcp,
        editionToUpgradeTo: deepLink ? (0, $ldyPw.PREMIUM_EDITION) : undefined,
        caller: caller,
        skip: skip,
        subProduct: (0, $2vSU6.SOFTWARE_PROJECT)
    });
    return {
        data: {
            premiumTrialUpgradeLink: data.billingPageUrl
        },
        ...rest
    };
};

});
parcelRegister("7qMMP", function(module, exports) {

$parcel$export(module.exports, "useGetBillingPageUrl", () => $8899a5adc0f59798$export$7b1495b7581dcd01);

var $5uXOq = parcelRequire("5uXOq");

var $cVzoY = parcelRequire("cVzoY");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $14XJw = parcelRequire("14XJw");


var $ldyPw = parcelRequire("ldyPw");

var $16v4H = parcelRequire("16v4H");

var $9OXo1 = parcelRequire("9OXo1");

var $7j7Ij = parcelRequire("7j7Ij");

var $5aye8 = parcelRequire("5aye8");

var $5Q4f1 = parcelRequire("5Q4f1");

var $iHAwr = parcelRequire("iHAwr");
const $8899a5adc0f59798$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $5uXOq.useState)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const contextSubProduct = (0, $16v4H.useSubProduct)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const subProductToUse = subProduct || contextSubProduct;
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        const loadBillingInfo = async ()=>{
            try {
                const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
                const productKey = (0, $iHAwr.getProductKey)(subProductToUse, explicitlyLicensedProducts);
                const referrerKey = (0, $5aye8.getProductReferrerKey)(productKey);
                // The product key as used by Commerce.
                // JPD product key as used by Commerce does not include .ondemand
                const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                if (isUsingCcp) {
                    if (!entitlementId) {
                        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                            caller: caller,
                            productKey: productKey,
                            productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                            subProduct: subProductToUse
                        });
                        throw new Error('Empty entitlement ID');
                    }
                    const ccpTransactionAccountId = await (0, $5aye8.getCcpTransactionAccountId)(entitlementId);
                    // List of valid referrer values
                    // https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan#How-to-use-this-deeplink%3F
                    const ccpBaseUrl = `${(0, $5Q4f1.getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                    switch(editionToUpgradeTo){
                        case 0, $ldyPw.STANDARD_EDITION:
                        case 0, $ldyPw.PREMIUM_EDITION:
                            setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(ccpBaseUrl);
                    }
                } else // HAMS Billing System
                switch(editionToUpgradeTo){
                    case 0, $ldyPw.STANDARD_EDITION:
                    case 0, $ldyPw.PREMIUM_EDITION:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                        break;
                    default:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                }
            } catch (e) {
                setError(e);
                if (onError && e instanceof Error) onError(e);
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        caller,
        createAnalyticsEvent,
        editionToUpgradeTo,
        isUsingCcp,
        onError,
        orgId,
        skip,
        subProduct,
        subProductToUse,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
parcelRegister("7j7Ij", function(module, exports) {

$parcel$export(module.exports, "EDITION_KEY", () => $2797dd9db1687273$export$d73720c31c622c1f);

var $ldyPw = parcelRequire("ldyPw");
const $2797dd9db1687273$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $ldyPw.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $ldyPw.PREMIUM_EDITION_KEY)
};

});

parcelRegister("5aye8", function(module, exports) {

$parcel$export(module.exports, "getProductReferrerKey", () => $c065e9df012feb0c$export$b4fb3304d5d8fc5f);
$parcel$export(module.exports, "getCcpTransactionAccountId", () => $c065e9df012feb0c$export$5186b9d213f626fd);

var $7f4tk = parcelRequire("7f4tk");

const $c065e9df012feb0c$export$b4fb3304d5d8fc5f = (productKey)=>{
    if (productKey === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return 'jsw';
    if (productKey === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return 'jsm';
    if (productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return 'jpd';
    if (productKey === (0, $c06e1abca7c13910$export$db515c8cec1e6f79)) return 'jwm';
    return null;
};
const $c065e9df012feb0c$export$5186b9d213f626fd = async (entitlementId)=>{
    const entitlementDetails = await (0, $7f4tk.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) // TODO: Handle errors properly
    throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};

});

parcelRegister("5Q4f1", function(module, exports) {

$parcel$export(module.exports, "getAdminBaseUrl", () => $2c9346932f4dad13$export$76bb37a926058cca);

var $9HJOg = parcelRequire("9HJOg");
const $2c9346932f4dad13$export$76bb37a926058cca = ()=>`https://${(0, $9HJOg.getATLContextDomain)('admin')}`;

});

parcelRegister("iHAwr", function(module, exports) {

$parcel$export(module.exports, "getProductKey", () => $a2785a755bdb8c08$export$d0b7f02493f85477);

const $a2785a755bdb8c08$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $c06e1abca7c13910$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});



parcelRegister("liGrj", function(module, exports) {

$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $c0d01fc7cb7615a5$export$9901be7804227da7);

var $5uXOq = parcelRequire("5uXOq");

var $htQUQ = parcelRequire("htQUQ");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $b3Gth = parcelRequire("b3Gth");
const $c0d01fc7cb7615a5$var$entryPointParams = {};
const $c0d01fc7cb7615a5$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), $c0d01fc7cb7615a5$var$entryPointParams);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htQUQ.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};

});
parcelRegister("ivDCs", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);

var $5uXOq = parcelRequire("5uXOq");

var $h9io3 = parcelRequire("h9io3");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9io3.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("b3Gth", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $a50fd4829307668f$export$7116d5b1a93db8d6);

var $cluFV = parcelRequire("cluFV");

var $29g2n = parcelRequire("29g2n");

const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, $29g2n.createEntryPoint)({
    root: (0, $cluFV.JSResourceForInteraction)(()=>(parcelRequire("iMeCE")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iMeCE", function(module, exports) {

let $dab80d5e508a3df8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dab80d5e508a3df8$var$load("68Kzv"),
    $dab80d5e508a3df8$var$load("3NvtU"),
    $dab80d5e508a3df8$var$load("7FkEF"),
    $dab80d5e508a3df8$var$load("2HTVk")
]).then(()=>parcelRequire('5s8iH'));

});



parcelRegister("iIz7a", function(module, exports) {

$parcel$export(module.exports, "FeatureGateLogo", () => $bde809f68e5981c8$export$83d4ce06fb8c3c0);

var $5uXOq = parcelRequire("5uXOq");

var $2afLt = parcelRequire("2afLt");

var $h7X3G = parcelRequire("h7X3G");

var $h0uMa = parcelRequire("h0uMa");
const $bde809f68e5981c8$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2afLt.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($h7X3G))) : (0, (/*@__PURE__*/$parcel$interopDefault($h0uMa))),
        alt: alt
    });

});
parcelRegister("h7X3G", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("h0uMa", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("gblI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba9ec5dc8deac7d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ba9ec5dc8deac7d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
        "defaultMessage": "Unlock advanced planning tools"
    },
    imageAlt: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    description: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
        "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
    },
    learnMoreLink: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
        "defaultMessage": "Read the guide"
    },
    startTrialButton: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
        "defaultMessage": "Try it free"
    }
});

});



parcelRegister("2FrC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a254be368ab7ac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10a254be368ab7ac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plans: {
        "id": "atlassian-navigation.plans.plans",
        "defaultMessage": "Plans"
    }
});

});


parcelRegister("lbp13", function(module, exports) {

$parcel$export(module.exports, "YourWorkDropdown", () => $4aa4f1efd8bce12b$export$3f0b217fc9bdcb2b);

var $5uXOq = parcelRequire("5uXOq");

var $3zm3p = parcelRequire("3zm3p");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $koeKL = parcelRequire("koeKL");

var $hQj0H = parcelRequire("hQj0H");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $e8iSm = parcelRequire("e8iSm");

var $bJsBT = parcelRequire("bJsBT");

var $fFuPf = parcelRequire("fFuPf");
const $4aa4f1efd8bce12b$var$YourWorkDropdown = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const activityClient = (0, $hQj0H.useActivityClient)('v3', 'jira');
    const cloudId = (0, $koeKL.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3zm3p.AlertsStoreContainer), {
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8iSm.RecentActivityContainer), {
        activityClient: activityClient,
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).HOME,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).HOME,
        Menu: (0, $bJsBT.AsyncMenu),
        label: formatMessage((0, $fFuPf.default).title)
    }, formatMessage((0, $fFuPf.default).title)))));
};
const $4aa4f1efd8bce12b$export$3f0b217fc9bdcb2b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4aa4f1efd8bce12b$var$YourWorkDropdown, null));

});
parcelRegister("3zm3p", function(module, exports) {

$parcel$export(module.exports, "useAlertsStore", () => $d7740626dfebecb7$export$52a528b1f45cfa42);
$parcel$export(module.exports, "AlertsStoreContainer", () => $d7740626dfebecb7$export$dac8df4ae2328540);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $DWjzc = parcelRequire("DWjzc");

var $aT1mD = parcelRequire("aT1mD");
const $d7740626dfebecb7$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $d7740626dfebecb7$export$d4c72bab9d6cc13a = {};
const $d7740626dfebecb7$var$loadAlerts = ({ searchParams: searchParams, key: key, shouldOverwrite: shouldOverwrite = true })=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        if (!cloudId) throw new Error('`cloudId` is required please wrap your component with `AlertsStoreContainer`, and provide the prop.');
        if (!key) throw new Error('`key` is required please provie a unique key for each query.');
        try {
            const promise = (0, $aT1mD.fetchAlerts)({
                cloudId: cloudId,
                searchParams: searchParams
            });
            setState({
                ...getState(),
                [key]: {
                    ...$d7740626dfebecb7$export$a2290b0841306a43,
                    ...getState()[key],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            });
            const response = await promise;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const alerts = response?.values ?? null;
            const newItems = shouldOverwrite ? alerts : [
                ...getState()[key]?.items ?? [],
                ...alerts
            ];
            setState({
                ...getState(),
                [key]: {
                    ...getState()[key],
                    items: newItems,
                    totalCount: newItems.length,
                    hasSuccessOnce: true,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                [key]: {
                    ...$d7740626dfebecb7$export$a2290b0841306a43,
                    ...getState()[key],
                    fetchError: error,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
            throw error;
        }
    };
const $d7740626dfebecb7$var$removeAlert = ({ alertId: alertId, key: key })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [key]: {
                ...$d7740626dfebecb7$export$a2290b0841306a43,
                ...getState()[key],
                items: getState()[key]?.items?.filter((alert)=>alert.id !== alertId) ?? []
            }
        });
    };
const $d7740626dfebecb7$export$e324594224ef24da = {
    loadAlerts: $d7740626dfebecb7$var$loadAlerts,
    removeAlert: $d7740626dfebecb7$var$removeAlert
};
const $d7740626dfebecb7$var$alertsStore = (0, $iXqE5.createStore)({
    name: (0, $DWjzc.ALERTS_STORE_NAME),
    actions: $d7740626dfebecb7$export$e324594224ef24da,
    initialState: $d7740626dfebecb7$export$d4c72bab9d6cc13a
});
const $d7740626dfebecb7$export$52a528b1f45cfa42 = (0, $3sQ5x.createHook)($d7740626dfebecb7$var$alertsStore, {
    selector: (state)=>state
});
const $d7740626dfebecb7$export$dac8df4ae2328540 = (0, $gg7kZ.createContainer)($d7740626dfebecb7$var$alertsStore);

});
parcelRegister("DWjzc", function(module, exports) {

$parcel$export(module.exports, "ALERTS_STORE_NAME", () => $44a8ac0f9ca87731$export$6793992c0b67d9c9);
$parcel$export(module.exports, "PredefinedQueries", () => $44a8ac0f9ca87731$export$ed6721f2880ce367);
const $44a8ac0f9ca87731$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $44a8ac0f9ca87731$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`
};

});

parcelRegister("aT1mD", function(module, exports) {

$parcel$export(module.exports, "fetchAlerts", () => $523404c6486132da$export$f7b1e2075b3da718);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $g9E9n = parcelRequire("g9E9n");
const $523404c6486132da$export$f7b1e2075b3da718 = async ({ cloudId: cloudId, searchParams: searchParams })=>{
    try {
        const params = new URLSearchParams(searchParams ?? {});
        const result = await (0, $7f4tk.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/alerts/?${params.toString()}`);
        if (!result) throw Error('Could not retrieve alerts');
        // https://data-portal.internal.atlassian.com/analytics/registry/50237
        (0, $g9E9n.getAnalyticsWebClient)().getInstance().sendOperationalEvent({
            action: 'succeeded',
            actionSubject: 'jiraPlatformServicesAlertsStore.fetchAlerts',
            source: 'alertsStore'
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/50236
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchAlerts',
                packageName: 'jiraAlertsStore',
                teamName: 'alexstrasza'
            },
            attributes: {
                error: error,
                searchParams: searchParams
            },
            error: error
        });
        throw error;
    }
};

});


parcelRegister("e8iSm", function(module, exports) {

$parcel$export(module.exports, "RecentActivityContainer", () => $468ae279ad84e880$export$7143acbf492040ba);
$parcel$export(module.exports, "useRecentActivities", () => $468ae279ad84e880$export$623d449f25492804);
$parcel$export(module.exports, "useRecentActivitiesActions", () => $468ae279ad84e880$export$394af696e502ba5d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8PtXb = parcelRequire("8PtXb");
const $468ae279ad84e880$var$initialState = {
    items: null,
    fetchError: null,
    hasSuccessOnce: false,
    isFetching: false,
    promise: null
};
const $468ae279ad84e880$var$store = (0, $iXqE5.createStore)({
    actions: $8PtXb.actions,
    initialState: $468ae279ad84e880$var$initialState,
    name: 'navigation-your-work-recent-activites'
});
const $468ae279ad84e880$export$7143acbf492040ba = (0, $gg7kZ.createContainer)($468ae279ad84e880$var$store);
const $468ae279ad84e880$export$623d449f25492804 = (0, $3sQ5x.createHook)($468ae279ad84e880$var$store);
const $468ae279ad84e880$export$394af696e502ba5d = (0, $3sQ5x.createHook)($468ae279ad84e880$var$store, {
    selector: null
});

});
parcelRegister("8PtXb", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b1f4ac60f5b38eb1$export$e324594224ef24da);

var $4R6GH = parcelRequire("4R6GH");
const $b1f4ac60f5b38eb1$var$PRODUCTS = [
    'jira'
];
const $b1f4ac60f5b38eb1$var$loadRecentActivities = ()=>async ({ setState: setState }, meta)=>{
        setState({
            isFetching: true,
            fetchError: null
        });
        try {
            const filter = (0, $4R6GH.fg)('blu-3344-worked-on-menu-fix') ? {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                products: $b1f4ac60f5b38eb1$var$PRODUCTS
            } : {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                objectTypes: [
                    'issue'
                ],
                products: $b1f4ac60f5b38eb1$var$PRODUCTS
            };
            const promise = meta.activityClient.fetchActivities([
                50,
                125,
                250
            ], filter, [
                'workedOn'
            ]);
            setState({
                promise: promise
            });
            const activityItems = await promise;
            setState({
                hasSuccessOnce: true,
                items: activityItems,
                isFetching: false
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetching: false,
                fetchError: error
            });
        }
    };
const $b1f4ac60f5b38eb1$export$e324594224ef24da = {
    loadRecentActivities: $b1f4ac60f5b38eb1$var$loadRecentActivities
};

});


parcelRegister("bJsBT", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $6ff062438cc4c15e$export$81adf29ff528dc9c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

var $Mp6qH = parcelRequire("Mp6qH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ff062438cc4c15e$var$LazyMenu = (0, $58ST7.lazy)(()=>(parcelRequire("7vNtS")).then(({ Menu: Menu })=>Menu), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/your-work-dropdown/menu/index.tsx"
});
const $6ff062438cc4c15e$export$81adf29ff528dc9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "your-work-dropdown-menu",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: "navigation",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "your-work-dropdown-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ff062438cc4c15e$var$LazyMenu, null)));

});
parcelRegister("7vNtS", function(module, exports) {

let $5781cf84cd9edbd8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5781cf84cd9edbd8$var$load("7FkEF"),
    $5781cf84cd9edbd8$var$load("6dn79")
]).then(()=>parcelRequire('j5yhG'));

});


parcelRegister("fFuPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c95956b90fd313$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $29c95956b90fd313$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "atlassian-navigation.your-work-dropdown.title",
        "defaultMessage": "Your work"
    }
});

});


parcelRegister("a5zoF", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $a73319cb81e190a5$export$ca6fbb51b35e375c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");

var $13iNl = parcelRequire("13iNl");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $d40Fj = parcelRequire("d40Fj");

var $lmyls = parcelRequire("lmyls");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $apeap = parcelRequire("apeap");

var $hchBL = parcelRequire("hchBL");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $cZpsT = parcelRequire("cZpsT");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $4jROM = parcelRequire("4jROM");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $ebYJ0 = parcelRequire("ebYJ0");

var $f7TWB = parcelRequire("f7TWB");

var $b21tm = parcelRequire("b21tm");
const $a73319cb81e190a5$var$ProjectsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const baseUrl = '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: `${baseUrl}/jira/projects`,
        menuId: (0, $lmyls.MENU_ID).PROJECTS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS
    }, formatMessage((0, $b21tm.default).projects));
};
const $a73319cb81e190a5$var$ProjectsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    const accountId = (0, $90yGq.useAccountId)();
    const isInFedRamp = (0, $4jROM.isFedRamp)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteProjects: loadFavorite }] = (0, $bcn6L.useFavoriteProjects)();
    const [, { loadRecentProjects: loadRecent }] = (0, $apeap.useRecentProjects)();
    const [, { loadRecommendations: loadRecommendations }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [{ hasSuccessOnce: hasFetchedCreateProjectPermissions, canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        (0, $kklBj.projectsMenuDropdownRecommendationSelector).start();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        if (accountId) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown viewed', 'projectsMenuDropdown');
            if (hasFetchedCreateProjectPermissions) loadRecommendations((0, $13iNl.recommendations), {
                locale: locale,
                cloudId: cloudId,
                accountId: accountId,
                licensedProducts: licensedProducts,
                edition: edition,
                firstActivationDateMs: firstActivationDateMs,
                areProductSuggestionsEnabled: areProductSuggestionsEnabled,
                environment: environment,
                canCreateProject: canCreateProject,
                isInFedRamp: isInFedRamp
            }, createAnalyticsEvent({}));
        }
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        onStart,
        loadRecent,
        accountId,
        hasFetchedOnceFavorites,
        loadFavorite,
        createAnalyticsEvent,
        hasFetchedCreateProjectPermissions,
        loadRecommendations,
        locale,
        cloudId,
        licensedProducts,
        edition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        canCreateProject,
        isInFedRamp
    ]);
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        // We want the last of these nodes, but can spotlight as a fallback any intermediaries
        // It may cause the spotlight border to be bigger than intended (around the entire block element)
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const refToFirstChild = ref && ref.firstChild;
        const refToFirstGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstChild && refToFirstChild.firstChild;
        const refToFirstGreatGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstGrandchild && refToFirstGrandchild.firstChild;
        register(`NAVIGATION_${(0, $lmyls.MENU_ID).PROJECTS}`, refToFirstGreatGrandchild || refToFirstGrandchild || refToFirstChild || ref);
    }, [
        register
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$export$e6dfd72ab29f8598, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).PROJECTS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS,
        Menu: (0, $f7TWB.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $b21tm.default).projects)
    }, formatMessage((0, $b21tm.default).projects)));
};
const $a73319cb81e190a5$var$ProjectWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectsLoggedIn, null);
};
const $a73319cb81e190a5$export$ca6fbb51b35e375c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectWithAuth, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a73319cb81e190a5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _4t3i1osq _ae4v1h6o _11l41osq",
            false && "_1kibidpf _1laeidpf _1f5yidpf _kq8jidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hchBL", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $b03364e48d8512c5$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $b03364e48d8512c5$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $b03364e48d8512c5$export$6b4b878b04fd3017);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b03364e48d8512c5$var$store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, $gg7kZ.createContainer)($b03364e48d8512c5$var$store);
const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, $3sQ5x.createStateHook)($b03364e48d8512c5$var$store, {
    selector: (state, key)=>state[key]
});
const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
    ];
const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, $3sQ5x.createHook)($b03364e48d8512c5$var$store, {
    selector: null
});
const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("f7TWB", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $14a03ca5c167a73f$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $5gSBR = parcelRequire("5gSBR");

var $aQl8U = parcelRequire("aQl8U");

var $13iNl = parcelRequire("13iNl");

var $bEK4U = parcelRequire("bEK4U");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $d40Fj = parcelRequire("d40Fj");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $2KGAL = parcelRequire("2KGAL");

var $1xLtH = parcelRequire("1xLtH");

var $4nCpW = parcelRequire("4nCpW");

var $4ci63 = parcelRequire("4ci63");

var $i4bJa = parcelRequire("i4bJa");
const $14a03ca5c167a73f$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).PROJECTS
};
const $14a03ca5c167a73f$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $kLaXN.AuthenticationErrorBoundary), Empty: Empty = (0, $2KGAL.Empty), Error: Error = (0, $8vzcp.MenuError), FavoriteContent: FavoriteContent = (0, $1xLtH.FavoriteContent), Footer: Footer = (0, $4nCpW.Footer), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $4ci63.LoadStatus), RecentContent: RecentContent = (0, $i4bJa.RecentContent), RecommendationSelector: RecommendationSelector = (0, $bEK4U.RecommendationSelector), recommendations: recommendations = (0, $13iNl.recommendations), Section: Section = (0, $5gSBR.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), SpotlightTarget: SpotlightTarget = (0, $aQl8U.default), testIdPrefix: testIdPrefix, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $d40Fj.useCreateProjectPermission), useExperienceFail: useExperienceFail = (0, $93jKl.useExperienceFail), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects) })=>{
    const [, { loadFavoriteProjects: loadFavorite }] = useFavorite();
    const [{ hasFetchedOnce: hasFetchedOncePermissions, isFetching: isFetching }, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = useCreateProjectPermission();
    const onFail = useExperienceFail({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFetchedOncePermissions && !isFetching) fetchCreateProjectPermission();
    }, [
        hasFetchedOncePermissions,
        isFetching,
        fetchCreateProjectPermission
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
        name: (0, $Mp6qH.PROJECTS_SPOTLIGHT_KEY)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).PROJECTS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $14a03ca5c167a73f$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecommendationSelector, {
        recommendations: recommendations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        testIdPrefix: testIdFooter
    })))));
};

});
parcelRegister("bEK4U", function(module, exports) {

$parcel$export(module.exports, "RecommendationSelector", () => $3c478d901993099b$export$f97cd4c3e697ffee);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $3lXip = parcelRequire("3lXip");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");
const $3c478d901993099b$export$f97cd4c3e697ffee = ({ recommendations: recommendations })=>{
    const [state] = (0, $cmzJ2.useProjectMenuRecommendations)();
    if (state.status !== 'success') return null;
    const selectedRecommendation = recommendations.find((recommendation)=>recommendation.key === state.recommendationKey);
    return selectedRecommendation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `projects-menu-recommendation.${selectedRecommendation.key}`,
        packageName: "jiraAtlassianNavigationRecommendations",
        onError: ()=>(0, $kklBj.projectsMenuDropdownRecommendationSelector).failure(),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            recommendationKey: selectedRecommendation.key
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lXip.ExperienceSuccess), {
        experience: (0, $kklBj.projectsMenuDropdownRecommendationSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(selectedRecommendation.Component, null))) : null;
};

});

parcelRegister("kLaXN", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorBoundary", () => $2792454dc55144b9$export$124b2dc1d1aab5e6);

var $5uXOq = parcelRequire("5uXOq");

var $fPruT = parcelRequire("fPruT");
class $2792454dc55144b9$export$124b2dc1d1aab5e6 extends (0, $5uXOq.Component) {
    componentDidCatch(error, info) {
        if (error instanceof (0, $fPruT.AuthenticationError)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback();
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}

});

parcelRegister("2KGAL", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $bae626c9288cadc7$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $fvINg = parcelRequire("fvINg");

var $6YerV = parcelRequire("6YerV");

var $4R6GH = parcelRequire("4R6GH");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $kLm6M = parcelRequire("kLm6M");

var $RQqjE = parcelRequire("RQqjE");
const $bae626c9288cadc7$var$learnMoreHref = 'https://confluence.atlassian.com/adminjiracloud/creating-editing-deleting-and-hiding-projects-844500729.html';
const $bae626c9288cadc7$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $jyltl.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $3bQtK.useExperienceSuccess), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useItems: useItems = (0, $dMJS0.useProjectNavItems), useRecent: useRecent = (0, $apeap.useRecentProjects) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6YerV.default), {
        as: "p"
    }, formatMessage((0, $RQqjE.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, (0, $4R6GH.fg)('replace-anchor-with-link__navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvINg.default), {
        href: $bae626c9288cadc7$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $RQqjE.default).learnMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $bae626c9288cadc7$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $RQqjE.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    // it appears that when fetch error get thrown in loadstatus, the promise is still pending here
    // let's take the most simple approach for now
    const shouldShowEmptyForAnonymous = isAnonymous;
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuInfo, {
        imgAltText: formatMessage((0, $RQqjE.default).emptyImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($kLm6M))),
        imgHeight: 138,
        testId: testId,
        text: text
    });
};

});
parcelRegister("kLm6M", function(module, exports) {
module.exports = new URL("project-empty.0864e274.svg", import.meta.url).toString();

});

parcelRegister("RQqjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $15aec9727c6dd925$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $15aec9727c6dd925$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.projects.menu.empty.empty-text",
        "defaultMessage": "Make the most of your Atlassian products by extending them with projects."
    },
    learnMore: {
        "id": "atlassian-navigation.projects.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.projects.menu.empty.empty-img",
        "defaultMessage": "An image showing that the projects dropdown menu is empty"
    }
});

});


parcelRegister("1xLtH", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $e1a4963a7cc4d825$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $jzjnR = parcelRequire("jzjnR");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $Yyrw8 = parcelRequire("Yyrw8");
const $e1a4963a7cc4d825$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useProjectNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const projectsUrl = '/jira/projects?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $Yyrw8.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { params: params, query: query, route: to } = (0, $2EqxS.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $Yyrw8.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzjnR.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: to,
            "aria-label": `${title} ${metadata || ''}`
        }, title));
    })), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: projectsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: projectsUrl
    })) : null;
};

});
parcelRegister("Yyrw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $826ed05c79892831$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $826ed05c79892831$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.projects.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("4nCpW", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $feb4a5abece4d737$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $d40Fj = parcelRequire("d40Fj");

var $6cNb0 = parcelRequire("6cNb0");

var $foR3E = parcelRequire("foR3E");

var $e9QkH = parcelRequire("e9QkH");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $kdlJi = parcelRequire("kdlJi");
const $feb4a5abece4d737$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [, { on: openProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    const [{ canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/projects",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $foR3E.projectsDirectoryRoute)
    }, formatMessage((0, $kdlJi.default).viewAll)), !isAnonymous && canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: openProjectCreateDrawer,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $kdlJi.default).createProject)));
};

});
parcelRegister("foR3E", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $00577c595d2649c4$export$74114064f06cd71b);
const $00577c595d2649c4$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("e9QkH", function(module, exports) {

$parcel$export(module.exports, "useSwitchModals", () => $bbe85969245206f0$export$5ed4b99cbad4ebd6);

var $2qauD = parcelRequire("2qauD");
const { useSwitch: $bbe85969245206f0$var$useSwitch } = (0, $2qauD.createSwitchController)('jira-switch-modals');
const $bbe85969245206f0$export$5ed4b99cbad4ebd6 = $bbe85969245206f0$var$useSwitch;

});

parcelRegister("kdlJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e62ef08eaa20a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $54e62ef08eaa20a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createProject: {
        "id": "atlassian-navigation.projects.menu.footer.create-project",
        "defaultMessage": "Create project"
    },
    viewAll: {
        "id": "atlassian-navigation.projects.menu.footer.view-all",
        "defaultMessage": "View all projects"
    },
    importProject: {
        "id": "atlassian-navigation.projects.menu.footer.import-project",
        "defaultMessage": "Import project"
    }
});

});


parcelRegister("4ci63", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $0e36b7ec65a0b373$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $d40Fj = parcelRequire("d40Fj");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $0e36b7ec65a0b373$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), shouldThrowError: shouldThrowError = false, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $d40Fj.useCreateProjectPermission), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects), useRecent: useRecent = (0, $apeap.useRecentProjects) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useCreateProjectPermission
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }));

});

parcelRegister("i4bJa", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $dd89c0b17853b373$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $jzjnR = parcelRequire("jzjnR");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dMJS0 = parcelRequire("dMJS0");

var $9uulb = parcelRequire("9uulb");
const $dd89c0b17853b373$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useProjectNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $9uulb.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const { params: params, query: query, route: to } = (0, $2EqxS.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $9uulb.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzjnR.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: to,
            "aria-label": `${title} ${metadata || ''}`
        }, title));
    }))) : null;
};

});
parcelRegister("9uulb", function(module, exports) {

$parcel$export(module.exports, "default", () => $58ba7fa57975d970$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $58ba7fa57975d970$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.projects.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("b21tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7261af77ace424$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7261af77ace424$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "atlassian-navigation.projects.projects",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("jSplz", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $05595fb4c275b9c8$export$92a576f896a9bf72);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $kawVZ = parcelRequire("kawVZ");

var $7ikvo = parcelRequire("7ikvo");
const $05595fb4c275b9c8$var$FiltersAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS
    }, formatMessage((0, $7ikvo.default).filters));
};
const $05595fb4c275b9c8$var$FiltersLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteFilters: loadFavorite }] = (0, $bcn6L.useFavoriteFilters)();
    const [, { loadRecentFilters: loadRecent }] = (0, $apeap.useRecentFilters)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS,
        Menu: (0, $kawVZ.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $7ikvo.default).filters)
    }, formatMessage((0, $7ikvo.default).filters)));
};
const $05595fb4c275b9c8$var$FiltersWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersLoggedIn, null);
};
const $05595fb4c275b9c8$export$92a576f896a9bf72 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).FILTERS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersWithAuth, null));

});
parcelRegister("kawVZ", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $37b6403ac89429a0$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $5gSBR = parcelRequire("5gSBR");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $aC6ao = parcelRequire("aC6ao");

var $bBBg3 = parcelRequire("bBBg3");

var $7xt41 = parcelRequire("7xt41");

var $1Q2KE = parcelRequire("1Q2KE");

var $lQ0sa = parcelRequire("lQ0sa");
const $37b6403ac89429a0$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).FILTERS
};
const $37b6403ac89429a0$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $kLaXN.AuthenticationErrorBoundary), Empty: Empty = (0, $aC6ao.Empty), Error: Error = (0, $8vzcp.MenuError), FavoriteContent: FavoriteContent = (0, $bBBg3.FavoriteContent), Footer: Footer = (0, $7xt41.Footer), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $1Q2KE.LoadStatus), RecentContent: RecentContent = (0, $lQ0sa.RecentContent), Section: Section = (0, $5gSBR.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), testIdPrefix: testIdPrefix, useExperienceFail: useExperienceFail = (0, $93jKl.useExperienceFail), useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters) })=>{
    const [, { loadFavoriteFilters: loadFavorite }] = useFavorite();
    const onFail = useExperienceFail({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).FILTERS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $37b6403ac89429a0$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "atlassian-navigation-filters-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "atlassian-navigation-filters-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("aC6ao", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $c74c3409b5a3434a$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $fvINg = parcelRequire("fvINg");

var $6YerV = parcelRequire("6YerV");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $7aBlG = parcelRequire("7aBlG");

var $dODGv = parcelRequire("dODGv");
const $c74c3409b5a3434a$var$learnMoreHref = 'https://confluence.atlassian.com/jirasoftwarecloud/searching-for-issues-764478280.html#Searchingforissues-SearchallofJira';
const $c74c3409b5a3434a$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $jyltl.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $3bQtK.useExperienceSuccess), useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useItems: useItems = (0, $dMJS0.useFilterNavItems), useRecent: useRecent = (0, $apeap.useRecentFilters) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6YerV.default), {
        as: "p"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dODGv.default).emptyTextIssueTermRefresh : (0, $dODGv.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, (0, $4R6GH.fg)('replace-anchor-with-link__navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvINg.default), {
        href: $c74c3409b5a3434a$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $dODGv.default).learnMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $c74c3409b5a3434a$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $dODGv.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuInfo, {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($7aBlG))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("7aBlG", function(module, exports) {
module.exports = new URL("filter-empty.4c92f05b.svg", import.meta.url).toString();

});

parcelRegister("dODGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a795574a4eb398$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $56a795574a4eb398$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.filters.menu.empty.empty-text",
        "defaultMessage": "Search for issues across all projects and save them as filters."
    },
    learnMore: {
        "id": "atlassian-navigation.filters.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.filters.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    },
    emptyTextIssueTermRefresh: {
        "id": "atlassian-navigation.filters.menu.empty.empty-text-issue-term-refresh",
        "defaultMessage": "Search for work items across all projects and save them as filters."
    }
});

});


parcelRegister("bBBg3", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $e72dd94e33471bbd$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $8fcLo = parcelRequire("8fcLo");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $4zlUA = parcelRequire("4zlUA");

var $6cNb0 = parcelRequire("6cNb0");

var $f4La7 = parcelRequire("f4La7");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $31jbO = parcelRequire("31jbO");
const $e72dd94e33471bbd$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useFilterNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const filtersUrl = '/jira/filters?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $31jbO.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $31jbO.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8fcLo))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $f4La7.globalIssueNavigatorRoute),
            onClick: (0, $4zlUA.handleGinSPAClick),
            "aria-label": title
        }, title));
    })), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: filtersUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: filtersUrl
    })) : null;
};

});
parcelRegister("4zlUA", function(module, exports) {

$parcel$export(module.exports, "handleGinSPAClick", () => $7b30a009e09f47e3$export$f74673b086629362);
const $7b30a009e09f47e3$export$f74673b086629362 = (e)=>{
    const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
    typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
    const openInNewTab = // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
    e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
    if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA?.Issues?.Application) {
        e.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
            forceRefresh: true,
            checkPermission: true,
            replace: false,
            reset: true,
            routerEvent: true
        });
    }
};

});

parcelRegister("31jbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1350230aaed398a9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1350230aaed398a9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.filters.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("7xt41", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $8201760f444f9d16$export$a06f1c675e846f6f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $b6S3k = parcelRequire("b6S3k");

var $d4B4Y = parcelRequire("d4B4Y");

var $aXYEG = parcelRequire("aXYEG");
// Removes the bullet (•) and padding from <li>
const $8201760f444f9d16$var$filterUnorderedList = null;
const $8201760f444f9d16$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    return (0, $4R6GH.fg)('camptasks-1105-filter-menu-list-markup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $b6S3k.filtersDirectoryRoute)
    }, formatMessage((0, $aXYEG.default).viewAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aXYEG.default).viewAllIssuesIssueTermRefresh : (0, $aXYEG.default).viewAllIssues)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $b6S3k.filtersDirectoryRoute)
    }, formatMessage((0, $aXYEG.default).viewAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aXYEG.default).viewAllIssuesIssueTermRefresh : (0, $aXYEG.default).viewAllIssues)));
};

});
parcelRegister("b6S3k", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $45a85df0dbaf23d9$export$6350f52c8b40042d);
const $45a85df0dbaf23d9$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("aXYEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b207ae58b19dda$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04b207ae58b19dda$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllIssues: {
        "id": "atlassian-navigation.filters.menu.footer.view-all-issues",
        "defaultMessage": "View all issues"
    },
    viewAll: {
        "id": "atlassian-navigation.filters.menu.footer.view-all",
        "defaultMessage": "View all filters"
    },
    viewAllIssuesIssueTermRefresh: {
        "id": "atlassian-navigation.filters.menu.footer.view-all-issues-issue-term-refresh",
        "defaultMessage": "View all work items"
    }
});

});


parcelRegister("1Q2KE", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $5044ac4fa9b31340$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $5044ac4fa9b31340$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), shouldThrowError: shouldThrowError = false, useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters), useRecent: useRecent = (0, $apeap.useRecentFilters) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }));

});

parcelRegister("lQ0sa", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $2e9bf8b639eae23f$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $8fcLo = parcelRequire("8fcLo");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $4zlUA = parcelRequire("4zlUA");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $f4La7 = parcelRequire("f4La7");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dMJS0 = parcelRequire("dMJS0");

var $k3GIG = parcelRequire("k3GIG");
const $2e9bf8b639eae23f$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useFilterNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $k3GIG.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $k3GIG.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8fcLo))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $f4La7.globalIssueNavigatorRoute),
            onClick: (0, $4zlUA.handleGinSPAClick),
            "aria-label": title
        }, title));
    }))) : null;
};

});
parcelRegister("k3GIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e96da9bc3d6ed1b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e96da9bc3d6ed1b2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.filters.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("7ikvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $49764f41cba0da7b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $49764f41cba0da7b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filters: {
        "id": "atlassian-navigation.filters.filters",
        "defaultMessage": "Filters"
    }
});

});


parcelRegister("3bzLW", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $f1da5b4afde35356$export$dd47e695f88fad71);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $7HJPM = parcelRequire("7HJPM");

var $lQgHF = parcelRequire("lQgHF");
const $f1da5b4afde35356$var$DashboardsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: "/jira/dashboards",
        menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS
    }, formatMessage((0, $lQgHF.default).dashboards));
};
const $f1da5b4afde35356$var$DashboardsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteDashboards: loadFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const [, { loadRecentDashboards: loadRecent }] = (0, $apeap.useRecentDashboards)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS,
        Menu: (0, $7HJPM.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $lQgHF.default).dashboards)
    }, formatMessage((0, $lQgHF.default).dashboards)));
};
const $f1da5b4afde35356$var$DashboardsComponent = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsLoggedIn, null);
};
const $f1da5b4afde35356$export$dd47e695f88fad71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).DASHBOARDS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsComponent, null));

});
parcelRegister("7HJPM", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $9f76f48ca86ed8d3$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $5gSBR = parcelRequire("5gSBR");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $e8DNP = parcelRequire("e8DNP");

var $6gxIx = parcelRequire("6gxIx");

var $7qz2O = parcelRequire("7qz2O");

var $8nbY6 = parcelRequire("8nbY6");

var $dKlaW = parcelRequire("dKlaW");
const $9f76f48ca86ed8d3$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).DASHBOARDS
};
const $9f76f48ca86ed8d3$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix })=>{
    const [, { loadFavoriteDashboards: loadFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vzcp.MenuError), {
            testIdPrefix: testIdContent
        }), [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).DASHBOARDS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $9f76f48ca86ed8d3$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLaXN.AuthenticationErrorBoundary), {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8DNP.Empty), {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-dashboards-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nbY6.LoadStatus), {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6gxIx.FavoriteContent), {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dKlaW.RecentContent), {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gSBR.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-dashboards-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6WLja.MenuSkeletonFooter), {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nbY6.LoadStatus), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qz2O.Footer), {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("e8DNP", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $281eb0020f130a6b$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $fvINg = parcelRequire("fvINg");

var $6YerV = parcelRequire("6YerV");

var $4R6GH = parcelRequire("4R6GH");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $fDqSe = parcelRequire("fDqSe");

var $4MIFv = parcelRequire("4MIFv");
const $281eb0020f130a6b$var$learnMoreHref = 'https://confluence.atlassian.com/jiracorecloud/configuring-dashboards-765593585.html';
const $281eb0020f130a6b$export$1f74963c34e8bfec = ({ children: children, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6YerV.default), {
        as: "p"
    }, formatMessage((0, $4MIFv.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, (0, $4R6GH.fg)('replace-anchor-with-link__navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvINg.default), {
        href: $281eb0020f130a6b$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $4MIFv.default).learnMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $281eb0020f130a6b$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $4MIFv.default).learnMore))));
    const [{ hasSuccessOnce: hasSuccessOnceFavorite, isFetching: isFetchingFavorite, fetchError: fetchErrorFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const [{ hasSuccessOnce: hasSuccessOnceRecent, isFetching: isFetchingRecent, fetchError: fetchErrorRecent }] = (0, $apeap.useRecentDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $dMJS0.useDashboardNavItems)();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($fDqSe))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("fDqSe", function(module, exports) {
module.exports = new URL("dashboards-empty.ed2e5362.svg", import.meta.url).toString();

});

parcelRegister("4MIFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $69bb4571f94cb527$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69bb4571f94cb527$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-text",
        "defaultMessage": "Create a dashboard to track the status of your projects."
    },
    learnMore: {
        "id": "atlassian-navigation.dashboards.menu.empty.learn-more",
        "defaultMessage": "More about dashboards"
    },
    emptyImg: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    }
});

});


parcelRegister("6gxIx", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $96d17f8a5c6dc94c$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $l6CNK = parcelRequire("l6CNK");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $5gOBf = parcelRequire("5gOBf");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $fBffT = parcelRequire("fBffT");
const $96d17f8a5c6dc94c$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useDashboardNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const dashboardsUrl = '/jira/dashboards?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $fBffT.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l6CNK))), {
                spacing: "spacious",
                label: "dashboard"
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $5gOBf.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            },
            "aria-label": `${title} ${metadata || ''}`
        }, title);
    }), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: dashboardsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: dashboardsUrl
    })) : null;
};

});
parcelRegister("5gOBf", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRoute", () => $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6);
const $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("fBffT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9605aa9ba39b44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4e9605aa9ba39b44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.dashboards.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("7qz2O", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $9ea4139d651cf8bc$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dDmlh = parcelRequire("dDmlh");

var $cZpsT = parcelRequire("cZpsT");

var $d4B4Y = parcelRequire("d4B4Y");

var $a3jaK = parcelRequire("a3jaK");

var $cuZpl = parcelRequire("cuZpl");
const $9ea4139d651cf8bc$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    const dashboardsUrl = '/jira/dashboards';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: dashboardsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $dDmlh.dashboardsDirectoryRoute)
    }, formatMessage((0, $cuZpl.default).viewAll)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3jaK.CreateButton), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }));
};

});
parcelRegister("dDmlh", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $fd66dc0239264856$export$41bba408475cab16);
const $fd66dc0239264856$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});

parcelRegister("a3jaK", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $2b806b55754512d0$export$6d3c345ce7c38fd9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $e9QkH = parcelRequire("e9QkH");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $eqacc = parcelRequire("eqacc");
const $2b806b55754512d0$export$6d3c345ce7c38fd9 = ({ testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { on: modalOpen }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).DASHBOARD_CREATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: modalOpen,
        testId: testId
    }, formatMessage((0, $eqacc.default).createButton));
};

});
parcelRegister("eqacc", function(module, exports) {

$parcel$export(module.exports, "default", () => $956db87aa6fc3521$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $956db87aa6fc3521$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButton: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.create-button",
        "defaultMessage": "Create dashboard"
    },
    notAllowed: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.not-allowed",
        "defaultMessage": "You must be logged in to create dashboards"
    }
});

});


parcelRegister("cuZpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $55607ccb6f8aac9f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55607ccb6f8aac9f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.footer.view-all",
        "defaultMessage": "View all dashboards"
    }
});

});


parcelRegister("8nbY6", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $e364b42a3e2b8e03$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $e364b42a3e2b8e03$export$c7df4a3f1b89de01 = ({ shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHtVS.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $bcn6L.useFavoriteDashboards)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHtVS.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $apeap.useRecentDashboards)
    }));

});

parcelRegister("dKlaW", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $e3bdcf72a295ac60$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $l6CNK = parcelRequire("l6CNK");

var $8xXpg = parcelRequire("8xXpg");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $5gOBf = parcelRequire("5gOBf");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $dMJS0 = parcelRequire("dMJS0");

var $pwPQz = parcelRequire("pwPQz");
const $e3bdcf72a295ac60$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useDashboardNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xXpg.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $pwPQz.default).recent)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l6CNK))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $5gOBf.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            },
            "aria-label": `${title} ${metadata || ''}`
        }, title);
    })) : null;
};

});
parcelRegister("pwPQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $037213aaba1faf3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $037213aaba1faf3d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.recent",
        "defaultMessage": "Recent"
    },
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.view-all",
        "defaultMessage": "View all recent"
    }
});

});



parcelRegister("lQgHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4360ba769f596109$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4360ba769f596109$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dashboards: {
        "id": "atlassian-navigation.dashboards.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("cvQRb", function(module, exports) {

$parcel$export(module.exports, "People", () => $c53dc2abd00215a4$export$8d3edc4d62e152ad);

var $5uXOq = parcelRequire("5uXOq");

var $h7aWr = parcelRequire("h7aWr");

var $koVbs = parcelRequire("koVbs");

var $l5VaH = parcelRequire("l5VaH");

var $57aZp = parcelRequire("57aZp");

const $c53dc2abd00215a4$export$8d3edc4d62e152ad = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    return(// this won't have any effect on those using the old people-menu except it will still cache
    // the remotely configured result for when they are rolled out to the new version
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5VaH.PeopleAndTeamsConfigurationProvider), {
        product: "jira",
        locale: (0, $h7aWr.default)(locale)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57aZp.People), null)));
};

});
parcelRegister("57aZp", function(module, exports) {

$parcel$export(module.exports, "People", () => $73ab25b84abebed5$export$8d3edc4d62e152ad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $d5QnX = parcelRequire("d5QnX");

var $gDHs4 = parcelRequire("gDHs4");

var $joX8T = parcelRequire("joX8T");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $eIokK = parcelRequire("eIokK");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $1J3t1 = parcelRequire("1J3t1");


var $8GOso = parcelRequire("8GOso");

var $6jY6G = parcelRequire("6jY6G");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $at1Nr = parcelRequire("at1Nr");

var $69X1g = parcelRequire("69X1g");

var $heI7y = parcelRequire("heI7y");

var $cZpsT = parcelRequire("cZpsT");

var $9OXo1 = parcelRequire("9OXo1");

var $eT1fB = parcelRequire("eT1fB");

var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $j94qH = parcelRequire("j94qH");

var $gAtvZ = parcelRequire("gAtvZ");

var $kAJ4Y = parcelRequire("kAJ4Y");

var $iPj86 = parcelRequire("iPj86");

var $annPD = parcelRequire("annPD");

var $ikNzk = parcelRequire("ikNzk");
const $73ab25b84abebed5$var$isNthUserOnBoardingProjectRecommendationEnrolled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_nth_user_onboarding_proj_recommendation');
    // default value can't be a string to avoid type checking error
    return config.get('isEnabled', undefined) !== undefined;
};
const $73ab25b84abebed5$var$PeopleMenuDropdown = ()=>{
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PEOPLE);
    const baseUrl = '';
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const isHighlighted = (0, $kAJ4Y.useMenuHighlighted)((0, $lmyls.MENU_ID).PEOPLE);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PEOPLE
    });
    const [isEventFromSpotlightTour] = (0, $gAtvZ.useFromSpotlightTour)('spotlight');
    const checkUsersGroupPermission = (0, $annPD.useBrowseUsersGroupsPermissions)();
    const checkUsersGroupPermissionNext = (0, $annPD.useBrowseUsersGroupsPermissionsNext)(isMenuOpen);
    const isEnabledForTailoredOnboardingM2 = (0, $8GOso.useIsTailoredOnboardingM2ForQuickstartEnabled)();
    const addFlag = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.success-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ywcn.default), props);
        });
        if (appearance === 'warning') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.warning-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), props);
        });
        if (appearance === 'error') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.error-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), props);
        });
    }, [
        showFlag
    ]);
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    const pushRoute = (0, $5uXOq.useCallback)((url)=>push(`${baseUrl}${url}`), [
        baseUrl,
        push
    ]);
    const peopleMenuWrapperRef = (0, $d5QnX.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$77bc79debbf5c069), true).ref;
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const teamCreateDialogProps = (0, $5uXOq.useMemo)(()=>{
        const dialogProps = {
            currentUser: {
                id: user.accountId || '',
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user?.avatarUrls ? user.avatarUrls['16x16'] : '',
                nickname: user?.userFullname
            },
            enableMembershipSettingsChoice: true
        };
        dialogProps.onClose = ()=>{
            if (peopleMenuWrapperRef?.current) requestAnimationFrame(()=>{
                peopleMenuWrapperRef?.current?.querySelector('button')?.focus();
            });
        };
        return dialogProps;
    // the peopleMenuWrapperRef doesn't change as the condition if FG is static
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // close menu when transitioning to other pages.
        if (!(0, $4R6GH.fg)('dont-auto-close-people-menu')) closeMenu();
        // close menu on unmount
        return ()=>{
            if (!(0, $4R6GH.fg)('dont-auto-close-people-menu')) closeMenu();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route
    ]);
    const { data: projectSidebarNavigationData } = (0, $1J3t1.useProjectSidebarNavigation)();
    const subProduct = (0, $eIokK.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, appEditions: { software: software } } = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const invitePeopleExperimentalFeatures = (0, $5uXOq.useMemo)(()=>({
            inviteThirdPartyTeams: (0, $joX8T.VARIATION),
            coreInvitesDriveMultiProductInvites: true
        }), []);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let continueUrl = window.location.href;
    if ($73ab25b84abebed5$var$isNthUserOnBoardingProjectRecommendationEnrolled() && user?.accountId) {
        const url = new URL(continueUrl);
        url.searchParams.append('inviterId', user.accountId);
        continueUrl = url.toString();
    }
    const { openModal: openModal } = (0, $ikNzk.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        displayInfiSpotlight: true,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        }
    });
    const invitePeopleHandlers = (0, $5uXOq.useMemo)(()=>({
            handleClick: openModal
        }), [
        openModal
    ]);
    if (!atlassianAccountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PEOPLE,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$export$5d16118c15d58d20, {
        ref: peopleMenuWrapperRef,
        "data-testid": `menu-${(0, $Mp6qH.NAVIGATION_ITEM_ID).PEOPLE}-wrapper`
    }, (isEnabledForTailoredOnboardingM2 || (0, $4R6GH.fg)('jira-always-render-invite-nudge')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $at1Nr.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eT1fB.default), {
        shouldRenderToParent: true,
        product: "jira",
        cloudId: cloudId,
        userId: atlassianAccountId,
        isBrowseUsersEnabled: (0, $4R6GH.fg)('dont-auto-close-people-menu') ? checkUsersGroupPermissionNext : checkUsersGroupPermission,
        // allow PeopleMenu to do transitions to in-product People Directory
        pushRoute: pushRoute,
        isHighlighted: isHighlighted,
        // @ts-expect-error - TS2322 - Type '({ appearance, ...flagProps }: { [x: string]: any; appearance: any; }) => void' is not assignable to type '(flag: Flag) => void'.
        addFlag: addFlag,
        onClick: triggerAnalytics,
        // manage open state
        isOpen: isMenuOpen,
        onOpen: openMenu,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : closeMenu,
        customChevronIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.ChevronRightIcon), null),
        enablePreFetchingByHovering: false,
        subProduct: subProduct,
        isSSR: false,
        orgId: orgId ?? undefined,
        teamCreateDialogProps: teamCreateDialogProps,
        invitePeopleHandlers: invitePeopleHandlers,
        isSectionList: true
    })));
};
const $73ab25b84abebed5$var$PeopleWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    if (isAnonymous) return null;
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "navigation.people-menu.with-nudgetooltip",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69X1g.NavigationPeopleNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikNzk.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikNzk.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null);
};
const $73ab25b84abebed5$export$8d3edc4d62e152ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PEOPLE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleWithAuth, null));
const $73ab25b84abebed5$export$5d16118c15d58d20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1osq _16jlkb7n _shj5kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("joX8T", function(module, exports) {

$parcel$export(module.exports, "NOT_ENROLLED", () => $a85d1363752adaec$export$5b7423264d48ab04);
$parcel$export(module.exports, "VARIATION", () => $a85d1363752adaec$export$fa04ad826acc90da);

var $co1wz = parcelRequire("co1wz");
const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $a85d1363752adaec$export$5b7423264d48ab04,
    $a85d1363752adaec$export$43f367b3e957f219,
    $a85d1363752adaec$export$9ba2bc3b1bdc1519,
    $a85d1363752adaec$export$fa04ad826acc90da,
    $a85d1363752adaec$export$6486974e39493fa6,
    $a85d1363752adaec$export$7d994996134ad562,
    $a85d1363752adaec$export$795e7d69b248dcd0,
    $a85d1363752adaec$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $co1wz.getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("1wpPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebed3b5115fbfc5$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, $3KRpp.ErrorFlag);

});

parcelRegister("4ywcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a612b92e24f3853$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$1a612b92e24f3853$export$2e2bcd8739ae039 = (0, $3KRpp.SuccessFlag);

});

parcelRegister("8igKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b804070d792a00$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$87b804070d792a00$export$2e2bcd8739ae039 = (0, $3KRpp.WarningFlag);

});

parcelRegister("eIokK", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $2ca77bef45d99b5b$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $2ca77bef45d99b5b$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $2ca77bef45d99b5b$export$3500077858760067);
$parcel$export(module.exports, "jiraProjectTypeToSubProduct", () => $2ca77bef45d99b5b$export$9ce9c3ad0c2c5c71);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $g9eN3 = parcelRequire("g9eN3");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");
const $2ca77bef45d99b5b$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $2ca77bef45d99b5b$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($2ca77bef45d99b5b$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $2ca77bef45d99b5b$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const addFlag = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $g9eN3.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $4ywcn.default);
                break;
            case 'warning':
                FlagComponent = (0, $8igKv.default);
                break;
            case 'error':
                FlagComponent = (0, $1wpPp.default);
                break;
        }
        showFlag((serviceProps)=>{
            const props = {
                ...flagProps,
                ...serviceProps,
                messageId: `invite-people-drawer.ui.content.flag-component.${appearance}.${flagProps.id}`,
                messageType: 'transactional'
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props);
        });
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $2ca77bef45d99b5b$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};
const $2ca77bef45d99b5b$export$9ce9c3ad0c2c5c71 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 'software';
        case 'service_desk':
            return 'servicedesk';
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("g9eN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $100aabc6f0d895d9$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$100aabc6f0d895d9$export$2e2bcd8739ae039 = (0, $3KRpp.InfoFlag);

});


parcelRegister("8GOso", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $adde9919a40069db$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $adde9919a40069db$export$c89644b13b6e777f);
$parcel$export(module.exports, "useCommonEligibilityConditionsForTOM2P5", () => $adde9919a40069db$export$b633031bd0a88786);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $adde9919a40069db$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $adde9919a40069db$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $adde9919a40069db$export$6bc15f8ade1cf36);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dAfqg = parcelRequire("dAfqg");

var $AK64q = parcelRequire("AK64q");

var $8UmI9 = parcelRequire("8UmI9");

var $4mXzi = parcelRequire("4mXzi");

var $iAFnF = parcelRequire("iAFnF");
const $adde9919a40069db$var$store = (0, $iXqE5.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $4mXzi.actions
});
const $adde9919a40069db$export$5b1d43353c334c00 = (0, $3sQ5x.createActionsHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$31a443426d101362 = (0, $3sQ5x.createHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = projectContextData?.projectType === undefined || // letting undefined pass for non-project context usage, eg: onboarding
    projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT); // limiting only to CORE for Tailired Onboarding M2 usage
    return (0, $4R6GH.fg)('gups_personalisation_api_integration_improvements') ? isBusinessProject && isSiteAdmin : isSiteAdmin;
};
const $adde9919a40069db$export$b633031bd0a88786 = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isBusinessProject: isBusinessProject } = (0, $8UmI9.useIsBusinessProject)();
    return isBusinessProject && isSiteAdmin && (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate');
};
const $adde9919a40069db$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $adde9919a40069db$export$31a443426d101362();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $adde9919a40069db$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $adde9919a40069db$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $5uXOq.useRef)(false);
    const { data: data, isReady: isReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $iAFnF.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'useTailoredOnboardingPersonalisationM2',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            hasSentErrorOnce.current = true;
        }
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $adde9919a40069db$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const projectType = (0, $4R6GH.fg)('tailored_onboarding_m3_gate') ? projectContextData?.projectType : (0, $2vSU6.CORE_PROJECT);
    const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: projectType
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0);
};

});
parcelRegister("8UmI9", function(module, exports) {

$parcel$export(module.exports, "useIsBusinessProject", () => $d1bed05bd9fbc7d5$export$f1bf366948a19b0f);

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");
const $d1bed05bd9fbc7d5$export$f1bf366948a19b0f = ()=>{
    const { data: data, loading: loading } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = data?.projectType === (0, $2vSU6.CORE_PROJECT);
    return {
        isBusinessProject: isBusinessProject,
        loading: loading
    };
};

});

parcelRegister("4mXzi", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f50a5e3bb7b9f239$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7bRcT = parcelRequire("7bRcT");

var $FroD7 = parcelRequire("FroD7");
const $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation = (0, $7bRcT.cachedEndpointCall)((args)=>(0, $FroD7.fetchOnboardingPersonalisationWithRethrow)(args));
const $f50a5e3bb7b9f239$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $FroD7.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $f50a5e3bb7b9f239$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $f50a5e3bb7b9f239$var$trackPersonalisationAction
};

});
parcelRegister("FroD7", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $501ec097caecd266$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $501ec097caecd266$export$9835c32b78102887);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $fv5ut = parcelRequire("fv5ut");
const $501ec097caecd266$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $501ec097caecd266$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $501ec097caecd266$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $fv5ut.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $501ec097caecd266$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $fv5ut.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $501ec097caecd266$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("fv5ut", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$dda9cd59669fc243);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $673c953eac85fdf0$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jira-onboarding-personalisation');
const $673c953eac85fdf0$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $673c953eac85fdf0$var$localStorage.get($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $673c953eac85fdf0$export$dda9cd59669fc243 = (response)=>{
    try {
        $673c953eac85fdf0$var$localStorage.set($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("iAFnF", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $afa1ef0e1c3d15e2$export$1d38dc41bb005254);

var $5PxqD = parcelRequire("5PxqD");
const $afa1ef0e1c3d15e2$export$1d38dc41bb005254 = [
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("5PxqD", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $5d0851fa8905d151$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $5d0851fa8905d151$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $5d0851fa8905d151$export$517f94ab07724226);

var $jcw0u = parcelRequire("jcw0u");
// Roles defined in user segmentation
const $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $5d0851fa8905d151$export$572242e58bd07594 = 'customer-service';
const $5d0851fa8905d151$export$d7de553940261eba = 'it-support';
const $5d0851fa8905d151$export$4c29d0d04c15e55d = 'human-resources';
const $5d0851fa8905d151$export$3950f7f841bf94b6 = 'finance';
const $5d0851fa8905d151$export$881249b988b6030f = 'legal';
const $5d0851fa8905d151$export$e4824f74b9879164 = 'marketing';
const $5d0851fa8905d151$export$4f3cb0844009af52 = 'operations';
const $5d0851fa8905d151$export$1a65d50c4a641bb4 = 'sales';
const $5d0851fa8905d151$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $5d0851fa8905d151$export$2f3f9640393bd078 = 'unknown';
const $5d0851fa8905d151$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$5d0851fa8905d151$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$5d0851fa8905d151$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES = [
    $5d0851fa8905d151$export$4c29d0d04c15e55d,
    $5d0851fa8905d151$export$3950f7f841bf94b6,
    $5d0851fa8905d151$export$881249b988b6030f,
    $5d0851fa8905d151$export$e4824f74b9879164,
    $5d0851fa8905d151$export$4f3cb0844009af52,
    $5d0851fa8905d151$export$1a65d50c4a641bb4,
    $5d0851fa8905d151$export$b8b1ac856ba1434b
];
const $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $5d0851fa8905d151$var$getNormalizedEntry = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $5d0851fa8905d151$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $5d0851fa8905d151$export$4c9a72dac5ce80ae;
    const normalizedEntry = $5d0851fa8905d151$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $5d0851fa8905d151$export$2f3f9640393bd078;
};
class $5d0851fa8905d151$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $5d0851fa8905d151$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $5d0851fa8905d151$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
};
const $5d0851fa8905d151$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $5d0851fa8905d151$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});



parcelRegister("at1Nr", function(module, exports) {

$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $8b5bfc2ae277a997$export$a4b4061b22dbc897);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $cE2Qr = parcelRequire("cE2Qr");


var $ahfXN = parcelRequire("ahfXN");
const $8b5bfc2ae277a997$var$runtimeProps = {};
const $8b5bfc2ae277a997$var$entryPointParams = {};
const $8b5bfc2ae277a997$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $ahfXN.inviteTeamNudgeEntryPoint), $8b5bfc2ae277a997$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $8b5bfc2ae277a997$var$runtimeProps
    });
};

});
parcelRegister("ahfXN", function(module, exports) {

$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $140395164e9a1c0c$export$ff76bc343b4103b1);

var $cluFV = parcelRequire("cluFV");

var $29g2n = parcelRequire("29g2n");

const $140395164e9a1c0c$export$ff76bc343b4103b1 = (0, $29g2n.createEntryPoint)({
    root: (0, $cluFV.JSResourceForInteraction)(()=>(parcelRequire("8vota")), {
        moduleId: "4ca4d8af"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8vota", function(module, exports) {

let $6314331dc75b30b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6314331dc75b30b9$var$load("eiq0I").then(()=>parcelRequire('guBtq'));

});



parcelRegister("69X1g", function(module, exports) {

$parcel$export(module.exports, "NavigationPeopleNavItemWrapperNudgeAsync", () => $affd57fc52973db7$export$57ea67608b7cb448);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $affd57fc52973db7$var$NavigationPeopleNavItemLazy = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("dKP9D")).then((exportedModule)=>exportedModule.NavigationPeopleNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-people/index.tsx"
});
const $affd57fc52973db7$export$57ea67608b7cb448 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-people-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($affd57fc52973db7$var$NavigationPeopleNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("dKP9D", function(module, exports) {

let $a03740730c0931fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a03740730c0931fe$var$load("ljS4a").then(()=>parcelRequire('5NaVN'));

});


parcelRegister("annPD", function(module, exports) {

$parcel$export(module.exports, "useBrowseUsersGroupsPermissionsNext", () => $72cc6e3d980d69b6$export$f16858a6f1359756);
$parcel$export(module.exports, "useBrowseUsersGroupsPermissions", () => $72cc6e3d980d69b6$export$c12f7f185a3a245f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $72cc6e3d980d69b6$var$deferredPromise = ()=>{
    const deferred = {
        resolve: undefined,
        reject: undefined
    };
    const promise = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        // @ts-expect-error - TS2322 - Type '(result: boolean) => void' is not assignable to type 'undefined'.
        deferred.resolve = (result)=>{
            resolve(result);
        };
        // @ts-expect-error - TS2322 - Type '(error?: any) => void' is not assignable to type 'undefined'.
        deferred.reject = reject;
    });
    return {
        promise: promise,
        ...deferred
    };
};
class $72cc6e3d980d69b6$var$BrowseUsersGroupsCacheClient {
    fetch() {
        const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
        if (this.promise !== null) return this.promise;
        this.promise = (0, $eusud.performGetRequest)(requestUrl);
        return this.promise;
    }
    constructor(){
        this.promise = null;
    }
}
const $72cc6e3d980d69b6$var$client = new $72cc6e3d980d69b6$var$BrowseUsersGroupsCacheClient();
const $72cc6e3d980d69b6$export$f16858a6f1359756 = (force)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $5uXOq.useState)($72cc6e3d980d69b6$var$deferredPromise());
    (0, $5uXOq.useEffect)(()=>{
        if ((isReady || force) && (0, $4R6GH.fg)('dont-auto-close-people-menu')) $72cc6e3d980d69b6$var$client.fetch().then(resolve).catch(reject);
    }, [
        isReady,
        reject,
        resolve,
        force
    ]);
    return (0, $5uXOq.useCallback)(()=>promise, [
        promise
    ]);
};
const $72cc6e3d980d69b6$export$c12f7f185a3a245f = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $5uXOq.useState)($72cc6e3d980d69b6$var$deferredPromise());
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && !(0, $4R6GH.fg)('dont-auto-close-people-menu')) {
            const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
            (0, $eusud.performGetRequest)(requestUrl).then(resolve).catch(reject);
        }
    }, [
        isReady,
        reject,
        resolve
    ]);
    return (0, $5uXOq.useCallback)(()=>promise, [
        promise
    ]);
};

});

parcelRegister("ikNzk", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $d166ed08e92451be$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $d166ed08e92451be$export$496e4f58036bb94d);

var $5uXOq = parcelRequire("5uXOq");

var $4HY3N = parcelRequire("4HY3N");
var $iJuhn = parcelRequire("iJuhn");

var $6s1PB = parcelRequire("6s1PB");

var $dNEo8 = parcelRequire("dNEo8");

var $e5wyW = parcelRequire("e5wyW");
/*
 * When we cleaning up experiment 'jira-invite-people-to-project-modal', this file should be removed.
 * Depending on the success / failure of the expirement we can replace the import of the modal context and hook
 * with the one from the invite-people package or keep using the one from jira-invite-people-modal-context.
 */ const $d166ed08e92451be$var$isJiraInvitePeopleModalEnabled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    return config.get('isEnabled', false);
};
const $d166ed08e92451be$export$c9ab9acc5993c948 = (0, $e5wyW.functionWithCondition)(()=>$d166ed08e92451be$var$isJiraInvitePeopleModalEnabled(), ({ resourceAri: resourceAri, onSubmit: onSubmit, ...props })=>(0, $dNEo8.useJiraInvitePeopleModalBound)(props), (0, $iJuhn.useInvitePeopleModal));
const $d166ed08e92451be$export$b9ec44715ae5ad99 = (props)=>{
    const [, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    const { openModal: openModal } = $d166ed08e92451be$export$c9ab9acc5993c948(props);
    const openModalWithExposure = (0, $5uXOq.useCallback)(()=>{
        fireExposure();
        openModal();
    }, [
        openModal,
        fireExposure
    ]);
    return {
        openModal: openModalWithExposure
    };
};
const $d166ed08e92451be$export$496e4f58036bb94d = ({ children: children })=>{
    if ($d166ed08e92451be$var$isJiraInvitePeopleModalEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNEo8.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HY3N.InvitePeopleModalContextProvider), null, children);
};

});
parcelRegister("dNEo8", function(module, exports) {

$parcel$export(module.exports, "JiraInvitePeopleModalContextProvider", () => $dc5bcdd71ba92e9c$export$cdc03757c913ed0);
$parcel$export(module.exports, "useJiraInvitePeopleModalBound", () => $dc5bcdd71ba92e9c$export$569fef33efef0114);

var $5uXOq = parcelRequire("5uXOq");

var $gxYlr = parcelRequire("gxYlr");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $koeKL = parcelRequire("koeKL");
const $dc5bcdd71ba92e9c$var$noop = ()=>null;
const $dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: false,
    onOpen: $dc5bcdd71ba92e9c$var$noop,
    onClose: $dc5bcdd71ba92e9c$var$noop
});
const $dc5bcdd71ba92e9c$export$cdc03757c913ed0 = ({ children: children, ...props })=>{
    // new invite people modal requirements
    const cloudId = (0, $koeKL.useCloudId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [providerState, setProviderState] = (0, $5uXOq.useState)({
        props: {},
        isOpen: false
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setProviderState({
            props: {},
            isOpen: false
        });
    }, []);
    const onOpen = (0, $5uXOq.useCallback)((state)=>{
        setProviderState({
            props: state ?? {},
            isOpen: true
        });
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            isOpen: providerState.isOpen,
            onOpen: onOpen,
            onClose: onClose
        }), [
        providerState.isOpen,
        onOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext.Provider, {
        value: value
    }, providerState.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxYlr.default), {
        appEdition: appEditions.software,
        cloudId: cloudId,
        isOpen: providerState.isOpen,
        onClose: onClose,
        isSiteAdmin: isSiteAdmin,
        ...props,
        ...providerState.props
    }) : null, children);
};
const $dc5bcdd71ba92e9c$export$39f09976987c1e17 = ()=>(0, $5uXOq.useContext)($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext);
const $dc5bcdd71ba92e9c$export$569fef33efef0114 = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $5uXOq.useContext)($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext);
    const openModal = (0, $5uXOq.useCallback)(()=>onOpen(props), [
        onOpen,
        props
    ]);
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: onClose
    };
};

});
parcelRegister("gxYlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c808453409ea513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0c808453409ea513$var$LazyComponent = (0, $58ST7.lazyForPaint)(()=>(parcelRequire("j9bj7")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/jira-invite-people-modal/src/ui/index.tsx"
});
const $0c808453409ea513$export$65d7b8c193fa4f41 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-invite-people-modal",
        packageName: "jira-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c808453409ea513$var$LazyComponent, props)));
var $0c808453409ea513$export$2e2bcd8739ae039 = $0c808453409ea513$export$65d7b8c193fa4f41;

});
parcelRegister("j9bj7", function(module, exports) {

let $df07a0fe41a39e47$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $df07a0fe41a39e47$var$load("68Kzv"),
    $df07a0fe41a39e47$var$load("3NvtU"),
    $df07a0fe41a39e47$var$load("7FkEF"),
    $df07a0fe41a39e47$var$load("1XIAv")
]).then(()=>parcelRequire('xET05'));

});






parcelRegister("9i62K", function(module, exports) {

$parcel$export(module.exports, "useShowAssets", () => $ecfb0cbe48af33be$export$6d1797fe1bb33b7a);
$parcel$export(module.exports, "Insight", () => $ecfb0cbe48af33be$export$f9e7e087e1968b4a);

var $5uXOq = parcelRequire("5uXOq");

var $bliJ7 = parcelRequire("bliJ7");

var $7CMCs = parcelRequire("7CMCs");

var $lmyls = parcelRequire("lmyls");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $ktP1V = parcelRequire("ktP1V");

var $ahEft = parcelRequire("ahEft");

var $90yGq = parcelRequire("90yGq");

var $9OXo1 = parcelRequire("9OXo1");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $hFLLE = parcelRequire("hFLLE");
const $ecfb0cbe48af33be$export$6d1797fe1bb33b7a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) {
        if (isJSMUser) return true;
    }
    return false;
};
const $ecfb0cbe48af33be$var$Insight = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const isPremiumUser = (0, $ahEft.isLicensedPremiumUser)(tenantContext);
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const [hasDismissed] = (0, $bliJ7.useUserHasDismissed)();
    const showUpsell = hasDismissed === false && isJSMUser;
    (0, $5uXOq.useEffect)(()=>{
        if (!isPremiumUser && showUpsell) // fire analytics event only for non-premium users that haven't dimissed the Assets upsell page button.
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
    }, [
        createAnalyticsEvent,
        isPremiumUser,
        showUpsell,
        tenantContext.appEditions?.serviceDesk,
        tenantContext.isSiteAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightNavMenu",
        packageName: "jiraAtlassianNavigation",
        fallback: "unmount"
    }, !isPremiumUser && showUpsell || isPremiumUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFLLE.InsightMenuItem), null) : null);
};
const $ecfb0cbe48af33be$export$f9e7e087e1968b4a = ()=>{
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).INSIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bliJ7.CmdbUpsellPageContainer), {
        isGlobal: true,
        atlassianAccountId: atlassianAccountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecfb0cbe48af33be$var$Insight, null))));
};

});
parcelRegister("bliJ7", function(module, exports) {

$parcel$export(module.exports, "CmdbUpsellPageContainer", () => $215e0f2cc3aecb56$export$185a1503ee62245e);
$parcel$export(module.exports, "useUserHasDismissed", () => $215e0f2cc3aecb56$export$168f6ca47f2dd0d7);
$parcel$export(module.exports, "useCmdbUpsellPageStoreActions", () => $215e0f2cc3aecb56$export$7bdf1f3cf5d7163b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8aeF9 = parcelRequire("8aeF9");
var $9jmKp = parcelRequire("9jmKp");
const $215e0f2cc3aecb56$export$185a1503ee62245e = (0, $gg7kZ.createContainer)();
const $215e0f2cc3aecb56$var$initialState = {
    userHasDismissed: undefined
};
const $215e0f2cc3aecb56$var$store = (0, $iXqE5.createStore)({
    initialState: $215e0f2cc3aecb56$var$initialState,
    actions: $8aeF9,
    containedBy: $215e0f2cc3aecb56$export$185a1503ee62245e,
    handlers: {
        onInit: $9jmKp.fetchInitialState
    }
});
const $215e0f2cc3aecb56$export$168f6ca47f2dd0d7 = (0, $3sQ5x.createHook)($215e0f2cc3aecb56$var$store, {
    selector: (state)=>state.userHasDismissed
});
const $215e0f2cc3aecb56$export$81f35d374558f538 = (0, $3sQ5x.createHook)($215e0f2cc3aecb56$var$store);
const $215e0f2cc3aecb56$export$7bdf1f3cf5d7163b = (0, $3sQ5x.createActionsHook)($215e0f2cc3aecb56$var$store);
const $215e0f2cc3aecb56$export$d766ac3cb3a067c0 = (0, $51nlc.createSubscriber)($215e0f2cc3aecb56$var$store);

});
parcelRegister("8aeF9", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => (parcelRequire("9jmKp")).fetchInitialState);
$parcel$export(module.exports, "toggleShowPage", () => (parcelRequire("hVpHy")).toggleShowPage);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $9jmKp = parcelRequire("9jmKp");

var $hVpHy = parcelRequire("hVpHy");

});
parcelRegister("9jmKp", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => $bf172d9d821cf507$export$84ded0ac7058ab7a);

var $eeyUP = parcelRequire("eeyUP");
const $bf172d9d821cf507$export$84ded0ac7058ab7a = ()=>async ({ setState: setState, getState: getState }, { atlassianAccountId: atlassianAccountId })=>{
        if (getState().userHasDismissed === undefined) {
            const userHasDismissed = await (0, $eeyUP.fetchHasDismissedProperty)(atlassianAccountId);
            setState({
                userHasDismissed: userHasDismissed
            });
        }
    };

});
parcelRegister("eeyUP", function(module, exports) {

$parcel$export(module.exports, "fetchHasDismissedProperty", () => $2f0ac8757ae7c53f$export$872c472220985d8b);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $2f0ac8757ae7c53f$export$872c472220985d8b = async (atlassianAccountId)=>{
    const meta = {
        id: 'fetchUpsellDismissedProperty',
        packageName: 'jiraCmdbUpsellPage'
    };
    if (atlassianAccountId === null) {
        const error = new Error('atlassianAccountId is null');
        (0, $jcw0u.default)({
            error: error,
            meta: meta
        });
        return false;
    }
    try {
        await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533));
        return true;
    } catch (error) {
        if (error instanceof Error && (0, $jcw0u.isNetworkError)(error)) // don't capture analytics for this error as this is expected when a user has dimissed
        return false;
        (0, $jcw0u.default)({
            error: error instanceof Error ? error : undefined,
            meta: meta
        });
        return false;
    }
};

});
const $8f514cf95b75cc66$export$38c3dc12cf3da533 = 'jsm-cmdb-upsell-page-dismissed';



parcelRegister("hVpHy", function(module, exports) {

$parcel$export(module.exports, "toggleShowPage", () => $983267917c332983$export$76132886e83e1a9a);

var $b7zXG = parcelRequire("b7zXG");

var $eWMDa = parcelRequire("eWMDa");
const $983267917c332983$export$76132886e83e1a9a = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        const { userHasDismissed: userHasDismissed } = getState();
        if (userHasDismissed) dispatch((0, $eWMDa.enablePage)());
        else if (userHasDismissed === false) dispatch((0, $b7zXG.dismissPage)());
    };

});
parcelRegister("b7zXG", function(module, exports) {

$parcel$export(module.exports, "dismissPage", () => $54ab437faf58b2ea$export$b6e8cf6e649eeb96);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $54ab437faf58b2ea$export$b6e8cf6e649eeb96 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically hide Assets from the navigation bar immediately
        setState({
            userHasDismissed: true
        });
        try {
            // The specific value being set doesn't matter as long as the property *has* been set
            atlassianAccountId && await (0, $89SaW.setUserProperties)(atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533), '1');
        } catch (error) {
            // When setting the user property fails, we still want to hide Assets from the navigation bar
            (0, $jcw0u.default)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellDismissedProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});

parcelRegister("eWMDa", function(module, exports) {

$parcel$export(module.exports, "enablePage", () => $72e0594a39999a08$export$d904731aa3799771);

var $jcw0u = parcelRequire("jcw0u");


var $5aUqV = parcelRequire("5aUqV");
const $72e0594a39999a08$export$d904731aa3799771 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically show Assets in the navigation bar immediately
        setState({
            userHasDismissed: false
        });
        try {
            atlassianAccountId && await (0, $5aUqV.deleteUserProperties)('', atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533));
        } catch (error) {
            (0, $jcw0u.default)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellEnabledProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});
parcelRegister("5aUqV", function(module, exports) {

$parcel$export(module.exports, "deleteUserProperties", () => $9af5c0a0f8e96e9b$export$3de6197fc2f24c03);

var $89SaW = parcelRequire("89SaW");

var $6no39 = parcelRequire("6no39");
const $9af5c0a0f8e96e9b$export$3de6197fc2f24c03 = async (baseUrl, accountId, propertyKey)=>{
    const url = (0, $89SaW.getUserPropertiesUrl)(accountId, propertyKey);
    return fetch(url, {
        ...(0, $6no39.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});





parcelRegister("hFLLE", function(module, exports) {

$parcel$export(module.exports, "InsightMenuItem", () => $944d4f2112c8b786$export$eb258e2cec2937f9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $blEB6 = parcelRequire("blEB6");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fVbkk = parcelRequire("fVbkk");

var $7rU7r = parcelRequire("7rU7r");
const $944d4f2112c8b786$export$eb258e2cec2937f9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: (0, $blEB6.getLandingPageUrl)(),
        target: (0, $4R6GH.fg)('assets_as_an_app_v2') ? '_blank' : undefined,
        menuId: (0, $lmyls.MENU_ID).INSIGHT,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).INSIGHT,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin,
            serviceDeskEdition: appEditions?.serviceDesk
        }
    }, formatMessage((0, $7rU7r.default).titleCmdbAssets));
};

});
parcelRegister("blEB6", function(module, exports) {

$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $587a2dd53fdae2e8$export$42e57fb76a904fc3);
$parcel$export(module.exports, "isInsightRoute", () => $587a2dd53fdae2e8$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $587a2dd53fdae2e8$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $587a2dd53fdae2e8$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $587a2dd53fdae2e8$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $587a2dd53fdae2e8$export$20fd4a0aec335970);
$parcel$export(module.exports, "getDataManagerUrl", () => $587a2dd53fdae2e8$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $587a2dd53fdae2e8$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $587a2dd53fdae2e8$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsReportUrl", () => $587a2dd53fdae2e8$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsSearchResultsUrl", () => $587a2dd53fdae2e8$export$97bfda8f5f38a121);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $587a2dd53fdae2e8$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $587a2dd53fdae2e8$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $587a2dd53fdae2e8$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $587a2dd53fdae2e8$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $587a2dd53fdae2e8$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $587a2dd53fdae2e8$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $587a2dd53fdae2e8$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $587a2dd53fdae2e8$export$415502b49e27270d);

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

var $9PhlU = parcelRequire("9PhlU");
const $587a2dd53fdae2e8$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $587a2dd53fdae2e8$export$42e57fb76a904fc3 = '/jira/assets';
const $587a2dd53fdae2e8$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $587a2dd53fdae2e8$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $587a2dd53fdae2e8$export$296d80f3ce129968 = (pathname)=>pathname.includes($587a2dd53fdae2e8$export$6d7574dbda22cf7);
const $587a2dd53fdae2e8$export$1f9b8b558a361aaf = ()=>$587a2dd53fdae2e8$export$ee637ecb2dfa4f6a;
const $587a2dd53fdae2e8$export$5413f45d031c7806 = ()=>(0, $4R6GH.fg)('assets_as_an_app_v2') ? $587a2dd53fdae2e8$export$42e57fb76a904fc3 : $587a2dd53fdae2e8$export$80e512187a5e0d10;
const $587a2dd53fdae2e8$export$9366da5a373815e5 = ()=>$587a2dd53fdae2e8$export$5413f45d031c7806();
const $587a2dd53fdae2e8$export$20fd4a0aec335970 = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/global`;
const $587a2dd53fdae2e8$export$c9b27b0d2e19d52f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/`;
const $587a2dd53fdae2e8$export$cd6b35373ba077a = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/adapters/`;
const $587a2dd53fdae2e8$export$c1909404b7ea317f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/reports`;
const $587a2dd53fdae2e8$export$272d35cbff1c220e = (reportId)=>`${$587a2dd53fdae2e8$export$c1909404b7ea317f()}/${reportId}`;
const $587a2dd53fdae2e8$export$97bfda8f5f38a121 = (query)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $587a2dd53fdae2e8$export$c48ea1282c74411e = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schemas`;
const $587a2dd53fdae2e8$export$3a0332e980fe56cf = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$587a2dd53fdae2e8$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9PhlU.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $587a2dd53fdae2e8$export$f02479149ce3cac7 = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$51e4229f2c7d3866 = (objectId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object/${objectId}`;
const $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $587a2dd53fdae2e8$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$587a2dd53fdae2e8$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $587a2dd53fdae2e8$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $587a2dd53fdae2e8$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $587a2dd53fdae2e8$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9PhlU", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $dee65df3d835c7b2$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $dee65df3d835c7b2$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $dee65df3d835c7b2$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $dee65df3d835c7b2$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $dee65df3d835c7b2$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $dee65df3d835c7b2$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $dee65df3d835c7b2$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $dee65df3d835c7b2$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $dee65df3d835c7b2$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $dee65df3d835c7b2$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $dee65df3d835c7b2$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $dee65df3d835c7b2$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $dee65df3d835c7b2$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $dee65df3d835c7b2$export$1927b50f7d074492);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $5Ny9E = parcelRequire("5Ny9E");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");
const $dee65df3d835c7b2$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $dee65df3d835c7b2$export$f7855185bab37329 = 'reference-types';
const $dee65df3d835c7b2$export$3739ebbc7c6e87e8 = 'statuses';
const $dee65df3d835c7b2$export$2c22dc6c729ae0bd = 'icons';
const $dee65df3d835c7b2$export$f37b3a97acf56eaf = 'data-manager';
const $dee65df3d835c7b2$export$12ebb1d5017e1d6d = 'general';
const $dee65df3d835c7b2$export$a77734d9ea30fe44 = 'roles';
const $dee65df3d835c7b2$export$be37b820df30c947 = 'import';
const $dee65df3d835c7b2$export$670faa8ae93e0903 = 'inheritance';
const $dee65df3d835c7b2$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const updateQueryParams = (0, $5uXOq.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $5uXOq.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $dee65df3d835c7b2$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $5uXOq.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $dee65df3d835c7b2$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $5Ny9E.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $dee65df3d835c7b2$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $dee65df3d835c7b2$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("7rU7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $421905193c27f8ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $421905193c27f8ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleCmdbAssets: {
        "id": "atlassian-navigation.insight.title-cmdb-assets",
        "defaultMessage": "Assets"
    }
});

});



parcelRegister("el0Fl", function(module, exports) {

$parcel$export(module.exports, "Roadmaps", () => $767dc22cd21e9a9b$export$a68bc1ba98e0d580);

var $5uXOq = parcelRequire("5uXOq");

var $aQl8U = parcelRequire("aQl8U");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $aOD49 = parcelRequire("aOD49");

var $dWQF5 = parcelRequire("dWQF5");

var $9OXo1 = parcelRequire("9OXo1");

var $d9ulS = parcelRequire("d9ulS");

var $fClqt = parcelRequire("fClqt");

var $4R6GH = parcelRequire("4R6GH");

var $90yGq = parcelRequire("90yGq");

var $cAcWf = parcelRequire("cAcWf");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $6yVM4 = parcelRequire("6yVM4");
const $767dc22cd21e9a9b$export$9564042b1b0a7d8f = ()=>{
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    const isRoadmapsEnabled = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    return appPermissions.hasProductDiscoveryAccess && isRoadmapsEnabled;
};
const $767dc22cd21e9a9b$export$90296ede40c0af4a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const accountId = (0, $90yGq.useAccountId)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isJpdProjectView = window?.location.pathname.includes('/jira/polaris/projects');
    const menuTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: (0, $aOD49.getCollectionsPageUrl)(),
        menuId: (0, $lmyls.MENU_ID).ROADMAPS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ROADMAPS,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, formatMessage((0, $6yVM4.default).titleJpdRoadmaps));
    if (!isJpdProjectView || !(0, $4R6GH.fg)('polaris_roadmaps_introduction_spotlight')) return menuTrigger;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cAcWf.OnboardingFlowsContainer), {
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
        name: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT)
    }, menuTrigger, isJpdProjectView && (0, $4R6GH.fg)('polaris_roadmaps_introduction_spotlight') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fClqt.RoadmapIntroductionSpotlight), {
        collectionsUrl: (0, $aOD49.getCollectionsPageUrl)(),
        placement: "bottom center"
    })));
};
const $767dc22cd21e9a9b$export$a68bc1ba98e0d580 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).ROADMAPS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($767dc22cd21e9a9b$export$90296ede40c0af4a, null));

});
parcelRegister("aOD49", function(module, exports) {

$parcel$export(module.exports, "getCollectionDetailsPageUrl", () => $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12);
$parcel$export(module.exports, "getCollectionViewPageUrl", () => $a92ae6c7b428c3ad$export$32ac8841347e1f79);
$parcel$export(module.exports, "getCollectionsPageUrl", () => $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7);
const $a92ae6c7b428c3ad$var$withQueryParams = (path, queryParams)=>{
    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key)=>{
            if (queryParams[key]) searchParams.set(key, queryParams[key]);
        });
        if (searchParams.size > 0) return `${path}?${searchParams.toString()}`;
    }
    return path;
};
const $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
const $a92ae6c7b428c3ad$export$32ac8841347e1f79 = (collectionUUID, viewUUID, queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`, queryParams);
const $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7 = (queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams('/jira/polaris/roadmaps', queryParams);

});

parcelRegister("d9ulS", function(module, exports) {

$parcel$export(module.exports, "GO_TO_PROJECT_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$d4b65c1c7753dab5);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_DISMISSED", () => $033135e4463a547c$export$5ca3ca33630ba93c);
$parcel$export(module.exports, "EXPLORE_SECTION_MESSAGE_DISMISSED", () => $033135e4463a547c$export$a81698c00c65eb4a);
$parcel$export(module.exports, "SEEN_PULSATING_FIELDS_BUTTON", () => $033135e4463a547c$export$3085446206860099);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_DISMISSED", () => $033135e4463a547c$export$d32c1bbde6ae670d);
$parcel$export(module.exports, "PROJECT_FIELDS_PAGE_VIEWED", () => $033135e4463a547c$export$ca2e8a74c8b43637);
$parcel$export(module.exports, "TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED", () => $033135e4463a547c$export$c6877be73b5f3d5a);
$parcel$export(module.exports, "COLLECTIONS_TOUR_DISMISSED", () => $033135e4463a547c$export$9a1ee3e31621d60);
$parcel$export(module.exports, "PREMIUM_MODAL_DISMISSED", () => $033135e4463a547c$export$522f4dc72dc494f2);
$parcel$export(module.exports, "PREMIUM_LAST_VISIT", () => $033135e4463a547c$export$34f7000ddecc0e7f);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_DISMISSED", () => $033135e4463a547c$export$1be797d9a57b42ac);
$parcel$export(module.exports, "VIEW_PERMISSIONS_LOCK_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$94164335b70940ae);
$parcel$export(module.exports, "CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$c176277d0ae24685);
$parcel$export(module.exports, "CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$dc14a417cdf40a4e);
$parcel$export(module.exports, "CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$76d94539e8fefb4a);
$parcel$export(module.exports, "CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$c98b8b1065f15440);
$parcel$export(module.exports, "INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$a7071dd1945a163a);
$parcel$export(module.exports, "USER_PROPERTY_BY_STATE_KEY", () => $033135e4463a547c$export$61a0683bfb4060d7);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$34cb8e95f71c5026);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$7f842ac8d21dd77c);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$bd207a2522aeeba4);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$204b6702ab1fae0e);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$14b1ce7029803351);
$parcel$export(module.exports, "GLOBAL_FIELDS_GO_TO_PROJECT_SPOTLIGHT", () => $033135e4463a547c$export$4aa3d2e1dc759f3c);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$c1ff7f4df78bdbc4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$465e1e9058d0a33e);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$22cb3b19b9a67a4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$639255389f81ee25);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_5", () => $033135e4463a547c$export$5420b6f468b681cb);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$b51c0dd69192efcd);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT", () => $033135e4463a547c$export$1e3c409324b9e1c8);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$960902aa280e7c02);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$a2cbd84444b19ad9);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$1ecd157040cc790b);
$parcel$export(module.exports, "JPD_NAV_VIEWS_SPOTLIGHT", () => $033135e4463a547c$export$f0a483c398048551);
$parcel$export(module.exports, "NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$6e3db205cdfcc126);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$6231ca46e95bc736);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$cd247efd7ec3525c);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_DISMISSED", () => $033135e4463a547c$export$2c379250399a65);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT", () => $033135e4463a547c$export$3134ae340fb4ae39);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$6ec637a8d4b52e12);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT", () => $033135e4463a547c$export$10bda8c91e48ff2c);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$4c25160b46095f67);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT", () => $033135e4463a547c$export$ec0f5ceae1abcc93);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$4aa206dd068119fd);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS", () => $033135e4463a547c$export$84d5c6b713e2a436);
$parcel$export(module.exports, "PRODUCT_START_TIMESTAMP", () => $033135e4463a547c$export$810ba1749ac4ea65);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS", () => $033135e4463a547c$export$bc58a8e989fbe3bc);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$414ec9dafc5e9628);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$a546fb30dcbeb6b5);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$dc3c81a11cac598);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$620c0e8c369ed103);
// User property names
const $033135e4463a547c$export$d4b65c1c7753dab5 = 'polaris.global-fields.go-to-project-spotlight-dismissed';
const $033135e4463a547c$export$5ca3ca33630ba93c = 'polaris.global-fields.tour-dismissed';
const $033135e4463a547c$export$a81698c00c65eb4a = 'polaris.project-fields.explore-section-message-dismissed';
const $033135e4463a547c$export$3085446206860099 = 'polaris.project-fields.seen-pulsating-fields-button';
const $033135e4463a547c$export$d32c1bbde6ae670d = 'polaris.project-fields.tour-dismissed';
const $033135e4463a547c$export$ca2e8a74c8b43637 = 'polaris.project-fields.page-viewed';
const $033135e4463a547c$export$c6877be73b5f3d5a = 'polaris.timeline.dates-config-section-message-dismissed';
const $033135e4463a547c$export$9a1ee3e31621d60 = 'polaris.collections.tour-dismissed';
const $033135e4463a547c$export$522f4dc72dc494f2 = 'polaris.premium.modal-dismissed';
const $033135e4463a547c$export$34f7000ddecc0e7f = 'polaris.premium.last-visit';
const $033135e4463a547c$export$1be797d9a57b42ac = 'polaris.cross-project-view.tour-dismissed';
const $033135e4463a547c$export$94164335b70940ae = 'polaris.view-permissions-lock.spotlight-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED = 'polaris.cross-project-view.list-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED = 'polaris.cross-project-view.timeline-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED = 'polaris.cross-project-view.board-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED = 'polaris.cross-project-view.matrix-fields-dismissed';
const $033135e4463a547c$export$c176277d0ae24685 = 'listViewfieldsDismissed';
const $033135e4463a547c$export$dc14a417cdf40a4e = 'timelineViewfieldsDismissed';
const $033135e4463a547c$export$76d94539e8fefb4a = 'boardViewfieldsDismissed';
const $033135e4463a547c$export$c98b8b1065f15440 = 'matrixViewfieldsDismissed';
const $033135e4463a547c$export$a7071dd1945a163a = 'polaris.share-dialog.invite.spotlight-dismissed';
const $033135e4463a547c$export$61a0683bfb4060d7 = {
    [$033135e4463a547c$export$c176277d0ae24685]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED,
    [$033135e4463a547c$export$dc14a417cdf40a4e]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED,
    [$033135e4463a547c$export$76d94539e8fefb4a]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED,
    [$033135e4463a547c$export$c98b8b1065f15440]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED
};
const $033135e4463a547c$export$34cb8e95f71c5026 = 'global-fields.tour.spotlights.step-1';
const $033135e4463a547c$export$7f842ac8d21dd77c = 'global-fields.tour.spotlights.step-2';
const $033135e4463a547c$export$bd207a2522aeeba4 = 'global-fields.tour.spotlights.step-3';
const $033135e4463a547c$export$204b6702ab1fae0e = 'global-fields.tour.spotlights.step-4';
const $033135e4463a547c$export$14b1ce7029803351 = 'global-fields.tour.spotlights.step-last';
const $033135e4463a547c$export$4aa3d2e1dc759f3c = 'global-fields.go-to-project.spotlight';
const $033135e4463a547c$export$c1ff7f4df78bdbc4 = 'project-fields.tour.spotlights.step-1';
const $033135e4463a547c$export$465e1e9058d0a33e = 'project-fields.tour.spotlights.step-2';
const $033135e4463a547c$export$22cb3b19b9a67a4 = 'project-fields.tour.spotlights.step-3';
const $033135e4463a547c$export$639255389f81ee25 = 'project-fields.tour.spotlights.step-4';
const $033135e4463a547c$export$5420b6f468b681cb = 'project-fields.tour.spotlights.step-5';
const $033135e4463a547c$export$b51c0dd69192efcd = 'project-fields.tour.spotlights.step-last';
const $033135e4463a547c$export$1e3c409324b9e1c8 = 'collections.create-roadmap.spotlight';
const $033135e4463a547c$export$960902aa280e7c02 = 'collections.create-roadmap.spotlight-dismissed';
const $033135e4463a547c$export$a2cbd84444b19ad9 = 'cross-project-view.tour.spotlights.step-1';
const $033135e4463a547c$export$1ecd157040cc790b = 'cross-project-view.tour.spotlights.step-last';
const $033135e4463a547c$export$f0a483c398048551 = 'jpd-nav-views.spotlight';
const $033135e4463a547c$export$6e3db205cdfcc126 = 'polaris.nav-jpd-views.spotlight-dismissed';
const $033135e4463a547c$export$6231ca46e95bc736 = 'prioritization-view.tour.spotlights.step-1';
const $033135e4463a547c$export$cd247efd7ec3525c = 'prioritization-view.tour.spotlights.step-last';
const $033135e4463a547c$export$2c379250399a65 = 'polaris.prioritization-view.tour-dismissed';
const $033135e4463a547c$export$3134ae340fb4ae39 = 'roadmap-view.spotlight';
const $033135e4463a547c$export$6ec637a8d4b52e12 = 'polaris.roadmap-view.spotlight-dismissed';
const $033135e4463a547c$export$10bda8c91e48ff2c = 'roadmap-view.column-config.spotlight';
const $033135e4463a547c$export$4c25160b46095f67 = 'polaris.roadmap-view.column-config-spotlight-dismissed';
const $033135e4463a547c$export$ec0f5ceae1abcc93 = 'roadmap.introduction.spotlight';
const $033135e4463a547c$export$4aa206dd068119fd = 'roadmap.introduction.spotlight.dismissed';
const $033135e4463a547c$export$ef2e4b0f650c3249 = 'roadmap-view.initial-prompt.spotlight';
const $033135e4463a547c$export$84d5c6b713e2a436 = [
    $033135e4463a547c$export$522f4dc72dc494f2,
    $033135e4463a547c$export$6e3db205cdfcc126
];
const $033135e4463a547c$export$810ba1749ac4ea65 = 'polaris.product-start-timestamp';
const $033135e4463a547c$export$bc58a8e989fbe3bc = 'polaris.view-creator.spotlight';
const $033135e4463a547c$export$414ec9dafc5e9628 = 'view-creator.tour.spotlights.step-1';
const $033135e4463a547c$export$a546fb30dcbeb6b5 = 'view-creator.tour.spotlights.step-2';
const $033135e4463a547c$export$dc3c81a11cac598 = 'view-creator.tour.spotlights.step-3';
const $033135e4463a547c$export$620c0e8c369ed103 = 'view-creator.tour.spotlights.step-4';

});

parcelRegister("fClqt", function(module, exports) {

$parcel$export(module.exports, "RoadmapIntroductionSpotlight", () => $4083f42e34bf2006$export$71e9b7b9d410b300);

var $5uXOq = parcelRequire("5uXOq");

var $8LALs = parcelRequire("8LALs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $ehdJY = parcelRequire("ehdJY");

var $daoB1 = parcelRequire("daoB1");

var $lVJAU = parcelRequire("lVJAU");

var $eS9wG = parcelRequire("eS9wG");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $cAcWf = parcelRequire("cAcWf");

var $7qsHB = parcelRequire("7qsHB");

var $jhE94 = parcelRequire("jhE94");

var $9V003 = parcelRequire("9V003");

var $3aLoA = parcelRequire("3aLoA");
const $4083f42e34bf2006$export$8130629f6db139c2 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $daoB1.useApplicationPermissions)() ?? {};
    return Boolean(hasProductDiscoveryAccess);
};
const $4083f42e34bf2006$export$71e9b7b9d410b300 = ({ collectionsUrl: collectionsUrl, placement: placement })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isLicensedUser = $4083f42e34bf2006$export$8130629f6db139c2();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const expandSideNav = (0, $eS9wG.useExpandSideNav)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const { loadRoadmapIntroductionDismissed: loadRoadmapIntroductionDismissed, loadRoadmapIntroductionPrerequisiteDismissalsMet: loadRoadmapIntroductionPrerequisiteDismissalsMet, loadProductUsageStartTimestamp: loadProductUsageStartTimestamp, setRoadmapIntroductionDismissed: setRoadmapIntroductionDismissed } = (0, $cAcWf.useOnboardingFlowsActions)();
    (0, $5uXOq.useEffect)(()=>{
        // we can prevent unnecessary calls in these cases
        if (isAlreadyInRoadmaps || !isLicensedUser) return;
        loadRoadmapIntroductionDismissed();
        loadRoadmapIntroductionPrerequisiteDismissalsMet();
        loadProductUsageStartTimestamp();
    }, [
        isAlreadyInRoadmaps,
        isLicensedUser,
        loadProductUsageStartTimestamp,
        loadRoadmapIntroductionDismissed,
        loadRoadmapIntroductionPrerequisiteDismissalsMet
    ]);
    const isIntroductionDismissed = (0, $7qsHB.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $7qsHB.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $jhE94.useProductUsageStartTimestamp)();
    if (isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !(0, $3aLoA.checkIfOlderThanNDays)(productUsageStartTimestamp)) return null;
    const dismiss = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dismiss');
        setRoadmapIntroductionDismissed();
    };
    const openRoadmaps = (analyticsEvent)=>{
        if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openRoadmaps');
        else (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openRoadmaps');
        setRoadmapIntroductionDismissed();
        push(collectionsUrl);
    };
    if ((0, $4R6GH.fg)('polaris_expand_sidenav_for_roadmaps_spotlight')) expandSideNav();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LALs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>dismiss(analyticsEvent),
                text: formatMessage((0, $9V003.messages).dismiss),
                testId: 'roadmap-introduction-spotlight-dismiss-button'
            },
            {
                onClick: (_, analyticsEvent)=>openRoadmaps(analyticsEvent),
                text: formatMessage((0, $9V003.messages).giveItATry)
            }
        ],
        dialogPlacement: placement,
        dialogWidth: 275,
        target: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT),
        key: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT),
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetOnClick: (_event)=>openRoadmaps(),
        messageId: "polaris-lib-onboarding-flows.ui.collections.tour.roadmap-introduction-spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $9V003.messages).message)));
};

});
parcelRegister("ehdJY", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $61a8dc1ff1116911$export$e209c6be9ab8c4f4);

var $5uXOq = parcelRequire("5uXOq");

var $aNBdv = parcelRequire("aNBdv");

var $10xFf = parcelRequire("10xFf");

var $5NHqU = parcelRequire("5NHqU");
const $61a8dc1ff1116911$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NHqU.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNBdv.default), rest);
};

});
parcelRegister("5NHqU", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $b7d2a49fe3b12822$export$e01943d134357d00);
// eslint-disable-next-line jira/import/no-restricted-import

var $aNBdv = parcelRequire("aNBdv");

var $cSWNW = parcelRequire("cSWNW");
const $b7d2a49fe3b12822$export$e01943d134357d00 = (0, $cSWNW.withChoreographedRender)((0, $aNBdv.default));

});


parcelRegister("cAcWf", function(module, exports) {

$parcel$export(module.exports, "useOnboardingFlowsActions", () => $7dbb55da8793fd57$export$e3d86ac85365138c);
$parcel$export(module.exports, "createHook", () => $7dbb55da8793fd57$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "OnboardingFlowsContainer", () => $7dbb55da8793fd57$export$214c4fcbf19b9a1d);

var $5uXOq = parcelRequire("5uXOq");

var $eyEct = parcelRequire("eyEct");

var $6ToME = parcelRequire("6ToME");

var $iXqE5 = parcelRequire("iXqE5");

var $flDq6 = parcelRequire("flDq6");

var $7D44j = parcelRequire("7D44j");
const $7dbb55da8793fd57$export$46c52354b8798e89 = (0, $iXqE5.createStore)({
    name: 'PolarisLibOnboardingFlowsStore',
    initialState: {
        containerProps: {
            accountId: undefined
        },
        productUsageStartTimestamp: undefined,
        globalFields: {
            goToProjectSpotlightDismissed: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        projectFields: {
            exploreSectionMessageDismissed: undefined,
            seenPulsatingFieldsButton: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null,
            pageViewed: undefined
        },
        collections: {
            tourDismissed: undefined,
            tourSpotlightStep: null,
            introductionDismissed: undefined,
            introductionPrerequisiteDismissalsMet: undefined
        },
        crossProjectView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        timeline: {
            sectionMessageDismissed: undefined
        },
        viewPermissions: {
            spotlightDismissed: undefined
        },
        shareDialog: {
            inviteSpotlightDismissed: undefined
        },
        allViews: {
            spotlightDismissed: undefined
        },
        prioritizationView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        roadmapView: {
            spotlightDismissed: undefined,
            columnConfigSpotlightDismissed: undefined
        },
        viewCreator: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        premium: {
            modalDismissed: undefined,
            lastVisit: {
                isPremium: undefined,
                updated: undefined
            },
            promise: (0, $flDq6.createDeferredPromise)()
        }
    },
    actions: $7D44j.default
});
const { Container: $7dbb55da8793fd57$export$2e28a971a45925e3, useActions: $7dbb55da8793fd57$export$e3d86ac85365138c, createHook: $7dbb55da8793fd57$export$e7f733c8fc2b8a24, createHigherLevelHook: $7dbb55da8793fd57$export$757252247e722815 } = (0, $6ToME.createJpdContainer)($7dbb55da8793fd57$export$46c52354b8798e89);
const $7dbb55da8793fd57$export$214c4fcbf19b9a1d = ({ accountId: accountId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyEct.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dbb55da8793fd57$export$2e28a971a45925e3, {
        isGlobal: true,
        accountId: accountId
    }, children));

});
parcelRegister("6ToME", function(module, exports) {

$parcel$export(module.exports, "createJpdContainer", () => $23346b108d18c150$export$7ed5db99dcc39128);

var $gJBT6 = parcelRequire("gJBT6");

var $jYn8S = parcelRequire("jYn8S");

var $3sQ5x = parcelRequire("3sQ5x");

var $5vOOL = parcelRequire("5vOOL");
const $23346b108d18c150$var$createSelectorHook = (store, selector)=>{
    const innerHook = (0, $3sQ5x.createHook)(store, {
        selector: (state)=>selector(state, state.containerProps)
    });
    return ()=>{
        const [val] = innerHook();
        return val;
    };
};
const $23346b108d18c150$export$757252247e722815 = (store, selectorCreator)=>{
    // TODO POL-2195 memoize one is not suitable for this task, as it will only memoize the last invocation. while this
    //               improves subsequent calls with the same argument set, it does not improve calls with different args
    //               this case should be solved with a generic memoization lib, e.g. reselect (4.1+) or moize
    //               discussion: https://hello.atlassian.net/wiki/spaces/TGR/pages/1416371989/Dependency+review+moize
    const memoizedSelectorCreator = (0, $jYn8S.cacheSelectorCreator)(selectorCreator);
    // TODO POL-2195 in the meantime, we can use lodash/memoize to at least solve the 1-ary case,
    //               which should be 99% of our selector creators anyway
    const monadicSelectorCreatorMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(selectorCreator);
    const rssHook = (0, $3sQ5x.createHook)(store, {
        selector: (state, args)=>{
            if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
            return memoizedSelectorCreator(...args)(state, state.containerProps);
        }
    });
    return (...args)=>{
        // @ts-expect-error - TS2345 - Argument of type 'SelectorCreatorArgs' is not assignable to parameter
        const [val] = rssHook(args);
        return val;
    };
};
const $23346b108d18c150$export$7ed5db99dcc39128 = (store, options)=>{
    const Container = (0, $5vOOL.createContainerWithContext)(store, options);
    const useEmptyState = (0, $3sQ5x.createHook)(store, {
        selector: null
    });
    const useActions = ()=>{
        const [, actions] = useEmptyState();
        return actions;
    };
    return {
        createHook: (selector)=>$23346b108d18c150$var$createSelectorHook(store, selector),
        createHigherLevelHook: (selectorCreator)=>$23346b108d18c150$export$757252247e722815(store, selectorCreator),
        useActions: useActions,
        Container: Container
    };
};

});
parcelRegister("jYn8S", function(module, exports) {

$parcel$export(module.exports, "cacheSelectorCreator", () => $904e561f620684de$export$413433974f0869c3);
$parcel$export(module.exports, "getCacheValue", () => $904e561f620684de$export$e15acfbd8ab989dd);
let $904e561f620684de$var$cache = new WeakMap();
let $904e561f620684de$var$jsonEqualityMap = new WeakMap();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $904e561f620684de$var$getValueFromJsonEqualityCache = (f, value, options)=>{
    if (options?.useJsonEquality !== true) return value;
    if (!$904e561f620684de$var$jsonEqualityMap.has(f)) $904e561f620684de$var$jsonEqualityMap.set(f, new Map());
    const storage = $904e561f620684de$var$jsonEqualityMap.get(f);
    try {
        const key = JSON.stringify(value);
        if (storage.has(key)) return storage.get(key);
        storage.set(key, value);
    } catch  {
    // do nothing
    }
    return value;
};
function $904e561f620684de$export$413433974f0869c3(f, options) {
    if (f.__isCachedSelectorCreator === true) return f;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cacheFunction = (...args)=>{
        if ($904e561f620684de$var$cache.has(f)) {
            let lastNode = $904e561f620684de$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) {
                    lastNode = null;
                    break;
                }
                lastNode = lastNode.args.get(value);
            }
            if (lastNode?.selector) return lastNode.selector;
        }
        const maybeSelector = f(...args);
        if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
            if (!$904e561f620684de$var$cache.has(f)) $904e561f620684de$var$cache.set(f, {
                args: new Map(),
                selector: null
            });
            let lastNode = $904e561f620684de$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) lastNode.args.set(value, {
                    args: new Map(),
                    selector: null
                });
                lastNode = lastNode.args.get(value);
            }
            lastNode.selector = maybeSelector;
        }
        return maybeSelector;
    };
    cacheFunction.__isCachedSelectorCreator = true;
    cacheFunction.__origin = f;
    cacheFunction.displayName = f.name || f.displayName;
    return cacheFunction;
}
const $904e561f620684de$export$e2575ed62a2f107b = ()=>$904e561f620684de$var$cache;
const $904e561f620684de$export$e15acfbd8ab989dd = (key)=>$904e561f620684de$var$cache.get(key);
const $904e561f620684de$export$6e5dca841bdf93e3 = ()=>{
    $904e561f620684de$var$cache = new WeakMap();
    $904e561f620684de$var$jsonEqualityMap = new WeakMap();
};

});

parcelRegister("5vOOL", function(module, exports) {

$parcel$export(module.exports, "createContainerWithContext", () => $3e805df79a9b7626$export$ce6d80db779db7dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");

var $battw = parcelRequire("battw");
const $3e805df79a9b7626$export$ce6d80db779db7dc = (store, options)=>(0, $gg7kZ.createContainer)(store, {
        ...options,
        onInit: ()=>(api, containerProps)=>{
                (0, $battw.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    options?.onInit && dispatch(options.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $battw.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    options?.onUpdate && dispatch(options.onUpdate());
                })(api, containerProps);
            }
    });

});
parcelRegister("battw", function(module, exports) {

$parcel$export(module.exports, "batchStateUpdates", () => $cbff8929059d4af1$export$4f8b20404a906ca3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cbff8929059d4af1$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
        let finalized = false;
        let localState = api.getState();
        const setState = (newState)=>{
            if (finalized) {
                api.setState(newState);
                return;
            }
            localState = {
                ...localState,
                ...newState
            };
        };
        const getState = ()=>finalized ? api.getState() : localState;
        const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                dispatch: dispatch,
                setState: setState,
                getState: getState
            }, containerProps);
        const patchedApi = {
            setState: setState,
            getState: getState,
            dispatch: dispatch
        };
        cb(patchedApi, containerProps);
        finalized = true;
        api.setState({
            ...localState
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        localState = null;
    };

});



parcelRegister("flDq6", function(module, exports) {

$parcel$export(module.exports, "checkIfActivatedMoreThanFourDays", () => $4c6cd1f60d2b26de$export$562701f849a0aba7);
$parcel$export(module.exports, "normalizeError", () => $4c6cd1f60d2b26de$export$e7bd538fb0c5db1a);
$parcel$export(module.exports, "createDeferredPromise", () => $4c6cd1f60d2b26de$export$87a845ded7190bfc);
$parcel$export(module.exports, "checkPrerequisiteDismissals", () => $4c6cd1f60d2b26de$export$b20d00c7cb810f65);

var $5egm2 = parcelRequire("5egm2");

var $89SaW = parcelRequire("89SaW");
const $4c6cd1f60d2b26de$export$562701f849a0aba7 = (productUsageStartTimestamp)=>{
    const diffInDays = (0, $5egm2.default)(new Date(), new Date(productUsageStartTimestamp));
    return diffInDays >= 4;
};
const $4c6cd1f60d2b26de$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unknown error');
};
function $4c6cd1f60d2b26de$export$87a845ded7190bfc() {
    // These will be properly initialized in the Promise constructor
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $4c6cd1f60d2b26de$export$b20d00c7cb810f65 = async (prerequisiteDismissals, accountId)=>{
    if (!accountId) return;
    const prerequisiteDismissalsPromises = prerequisiteDismissals.map((prerequisite)=>{
        return (0, $89SaW.getUserProperty)(accountId, prerequisite);
    });
    return Promise.all(prerequisiteDismissalsPromises);
};

});

parcelRegister("7D44j", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ced0fde2678944$export$2e2bcd8739ae039);

var $hTGLO = parcelRequire("hTGLO");

var $3nX69 = parcelRequire("3nX69");

var $j7wFs = parcelRequire("j7wFs");

var $fw4kd = parcelRequire("fw4kd");

var $aLCt5 = parcelRequire("aLCt5");

var $ekdyp = parcelRequire("ekdyp");

var $9SWPx = parcelRequire("9SWPx");

var $7lHeU = parcelRequire("7lHeU");

var $7kErt = parcelRequire("7kErt");

var $8DEAI = parcelRequire("8DEAI");

var $jJ3r3 = parcelRequire("jJ3r3");

var $43cMo = parcelRequire("43cMo");

var $ehOuS = parcelRequire("ehOuS");

var $1bQtC = parcelRequire("1bQtC");

var $5lIPS = parcelRequire("5lIPS");

var $1iEjh = parcelRequire("1iEjh");

var $gSOEi = parcelRequire("gSOEi");

var $irhvp = parcelRequire("irhvp");

var $i1anS = parcelRequire("i1anS");

var $cXfUC = parcelRequire("cXfUC");

var $9nrm9 = parcelRequire("9nrm9");

var $a6Bob = parcelRequire("a6Bob");

var $dke7D = parcelRequire("dke7D");
const $73ced0fde2678944$var$actions = {
    loadProductUsageStartTimestamp: $dke7D.loadProductUsageStartTimestamp,
    loadGoToProjectSpotlightDismissed: $9SWPx.loadGoToProjectSpotlightDismissed,
    setGoToProjectSpotlightDismissed: $9SWPx.setGoToProjectSpotlightDismissed,
    setGlobalFieldsTourSpotlightStep: $7lHeU.setGlobalFieldsTourSpotlightStep,
    loadGlobalFieldsTourDismissed: $7kErt.loadGlobalFieldsTourDismissed,
    setGlobalFieldsTourDismissed: $7kErt.setGlobalFieldsTourDismissed,
    loadExploreSectionMessageDismissed: $8DEAI.loadExploreSectionMessageDismissed,
    setExploreSectionMessageDismissed: $8DEAI.setExploreSectionMessageDismissed,
    loadProjectFieldsPageViewed: $jJ3r3.loadProjectFieldsPageViewed,
    setProjectFieldsPageViewed: $jJ3r3.setProjectFieldsPageViewed,
    loadSeenPulsatingFieldsButton: $43cMo.loadSeenPulsatingFieldsButton,
    setSeenPulsatingFieldsButton: $43cMo.setSeenPulsatingFieldsButton,
    loadProjectFieldsTourDismissed: $1bQtC.loadProjectFieldsTourDismissed,
    setProjectFieldsTourDismissed: $1bQtC.setProjectFieldsTourDismissed,
    setProjectFieldsTourSpotlightStep: $ehOuS.setProjectFieldsTourSpotlightStep,
    loadCollectionsTourDismissed: $3nX69.loadCollectionsTourDismissed,
    loadRoadmapIntroductionPrerequisiteDismissalsMet: $ekdyp.loadRoadmapIntroductionPrerequisiteDismissalsMet,
    setCollectionsTourDismissed: $3nX69.setCollectionsTourDismissed,
    setCollectionsTourSpotlightStep: $hTGLO.setCollectionsTourSpotlightStep,
    loadRoadmapIntroductionDismissed: $ekdyp.loadRoadmapIntroductionDismissed,
    setRoadmapIntroductionDismissed: $ekdyp.setRoadmapIntroductionDismissed,
    loadCrossProjectViewTourDismissed: $aLCt5.loadCrossProjectViewTourDismissed,
    setCrossProjectViewTourDismissed: $aLCt5.setCrossProjectViewTourDismissed,
    setCrossProjectViewTourSpotlightStep: $fw4kd.setCrossProjectViewTourSpotlightStep,
    loadTimelineSectionMessageDismissed: $5lIPS.loadTimelineSectionMessageDismissed,
    setTimelineSectionMessageDismissed: $5lIPS.setTimelineSectionMessageDismissed,
    loadViewPermissionsSpotlightDismissed: $1iEjh.loadViewPermissionsSpotlightDismissed,
    setViewPermissionsSpotlightDismissed: $1iEjh.setViewPermissionsSpotlightDismissed,
    loadCrossProjectViewFieldsDismissed: $j7wFs.loadCrossProjectViewFieldsDismissed,
    setCrossProjectViewFieldsDismissed: $j7wFs.setCrossProjectViewFieldsDismissed,
    loadInviteFromShareDialogSpotlightDismissed: $gSOEi.loadInviteFromShareDialogSpotlightDismissed,
    setInviteFromShareDialogSpotlightDismissed: $gSOEi.setInviteFromShareDialogSpotlightDismissed,
    loadAllViewsSpotlightDismissed: $irhvp.loadAllViewsSpotlightDismissed,
    setAllViewsSpotlightDismissed: $irhvp.setAllViewsSpotlightDismissed,
    loadRoadmapViewSpotlightDismissed: $cXfUC.loadRoadmapViewSpotlightDismissed,
    setRoadmapViewSpotlightDismissed: $cXfUC.setRoadmapViewSpotlightDismissed,
    loadRoadmapColumnConfigSpotlightDismissed: $cXfUC.loadRoadmapColumnConfigSpotlightDismissed,
    setRoadmapColumnConfigSpotlightDismissed: $cXfUC.setRoadmapColumnConfigSpotlightDismissed,
    loadPrioritizationViewTourDismissed: $i1anS.loadPrioritizationViewTourDismissed,
    setPrioritizationViewTourDismissed: $i1anS.setPrioritizationViewTourDismissed,
    setPrioritizationViewTourSpotlightStep: $i1anS.setPrioritizationViewTourSpotlightStep,
    setViewCreatorSpotlightDismissed: $9nrm9.setViewCreatorSpotlightDismissed,
    setViewCreatorSpotlightTourStep: $9nrm9.setViewCreatorSpotlightTourStep,
    loadViewCreatorSpotlightState: $9nrm9.loadViewCreatorSpotlightState,
    loadPremiumLastVisit: $a6Bob.loadPremiumLastVisit,
    loadPremiumModalDismissed: $a6Bob.loadPremiumModalDismissed,
    setPremiumLastVisit: $a6Bob.setPremiumLastVisit,
    setPremiumModalDismissed: $a6Bob.setPremiumModalDismissed,
    unlockOnboardingFlow: $a6Bob.unlockOnboardingFlow
};
var $73ced0fde2678944$export$2e2bcd8739ae039 = $73ced0fde2678944$var$actions;

});
parcelRegister("hTGLO", function(module, exports) {

$parcel$export(module.exports, "setCollectionsTourSpotlightStep", () => $6d68522005faa178$export$501a98d23141dc4d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $6d68522005faa178$export$501a98d23141dc4d = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("3nX69", function(module, exports) {

$parcel$export(module.exports, "loadCollectionsTourDismissed", () => $f4b58b9aa01e4518$export$c7e2395278267e1d);
$parcel$export(module.exports, "setCollectionsTourDismissed", () => $f4b58b9aa01e4518$export$2a7240b702e8d617);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $f4b58b9aa01e4518$export$c7e2395278267e1d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.COLLECTIONS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.tourDismissed;
    };
const $f4b58b9aa01e4518$export$2a7240b702e8d617 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.COLLECTIONS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});
parcelRegister("8U9Op", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $5cb445ae48fef3c4$export$ebd6466ba18b2f3a);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");




const $5cb445ae48fef3c4$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    const modifiedEvent = event;
    if (modifiedEvent instanceof (0, $jJZqs.default) && modifiedEvent.originalResponse) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $2YZCu.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
};

});

parcelRegister("6FNg9", function(module, exports) {

$parcel$export(module.exports, "maybeWaitForPremiumModal", () => $a42f0641756b90a5$export$b797d1ff3b371e8a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a42f0641756b90a5$export$b797d1ff3b371e8a = async (getState)=>{
    // Await the resolution of the deferred promise associated with the premium modal.
    // This ensures that the premium modal has either never been displayed or has already been closed.
    // This mechanism allows for seamless orchestration of all spotlights within a single package,
    // ensuring they are postponed until the premium modal can be displayed and is dismissed.
    // Treat this similar to the `!accountId`, as every loading action
    // in the `onboarding-flow` package should incorporate this check.
    await getState().premium.promise.promise;
};

});


parcelRegister("j7wFs", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewFieldsDismissed", () => $bf11a724423fc392$export$e6e8b16aaeac983b);
$parcel$export(module.exports, "setCrossProjectViewFieldsDismissed", () => $bf11a724423fc392$export$2468c71857d0e133);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $bf11a724423fc392$export$e6e8b16aaeac983b = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView[viewKindStateKey] === 'boolean') return;
        const userProperty = (0, $d9ulS.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            const viewfieldsDismissed = await (0, $89SaW.getUserProperty)(accountId, userProperty);
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    [viewKindStateKey]: viewfieldsDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        [viewKindStateKey]: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to get user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView[viewKindStateKey];
    };
const $bf11a724423fc392$export$2468c71857d0e133 = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                [viewKindStateKey]: true
            }
        });
        const userProperty = (0, $d9ulS.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            await (0, $89SaW.setUserProperties)(accountId, userProperty, 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to set user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("fw4kd", function(module, exports) {

$parcel$export(module.exports, "setCrossProjectViewTourSpotlightStep", () => $85bd86cefde8c272$export$7e29b1ed314f9b12);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $85bd86cefde8c272$export$7e29b1ed314f9b12 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("aLCt5", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewTourDismissed", () => $27e7ac097dc825d8$export$24c1a2fce44090f2);
$parcel$export(module.exports, "setCrossProjectViewTourDismissed", () => $27e7ac097dc825d8$export$d25b2932701a97e6);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $27e7ac097dc825d8$export$24c1a2fce44090f2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView.tourDismissed;
    };
const $27e7ac097dc825d8$export$d25b2932701a97e6 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("ekdyp", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapIntroductionDismissed", () => $bb8292cba90e90b4$export$1a7b263d41622a5b);
$parcel$export(module.exports, "loadRoadmapIntroductionPrerequisiteDismissalsMet", () => $bb8292cba90e90b4$export$de983a99630cdc7d);
$parcel$export(module.exports, "setRoadmapIntroductionDismissed", () => $bb8292cba90e90b4$export$19c464c17f9739ab);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");

var $flDq6 = parcelRequire("flDq6");
const $bb8292cba90e90b4$export$1a7b263d41622a5b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.introductionDismissed === 'boolean') return;
        try {
            const introductionDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    introductionDismissed: introductionDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        introductionDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.introductionDismissed;
    };
const $bb8292cba90e90b4$export$de983a99630cdc7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        let dismissals = [];
        try {
            dismissals = await (0, $flDq6.checkPrerequisiteDismissals)((0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS), accountId);
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.prerequisites', 'Failed to get user properties for roadmap introduction spotlight prerequisites', error instanceof Error ? error : undefined);
        }
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionPrerequisiteDismissalsMet: dismissals?.every((dismissal)=>dismissal) ?? false
            }
        });
        return getState().collections.introductionPrerequisiteDismissalsMet;
    };
const $bb8292cba90e90b4$export$19c464c17f9739ab = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("9SWPx", function(module, exports) {

$parcel$export(module.exports, "loadGoToProjectSpotlightDismissed", () => $068bea930b483a71$export$4c8d16771ecf8930);
$parcel$export(module.exports, "setGoToProjectSpotlightDismissed", () => $068bea930b483a71$export$3ea7a545c4faccd4);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $068bea930b483a71$export$4c8d16771ecf8930 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.goToProjectSpotlightDismissed === 'boolean') return;
        try {
            const goToProjectSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    goToProjectSpotlightDismissed: goToProjectSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        goToProjectSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to get user property with key: ${(0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $068bea930b483a71$export$3ea7a545c4faccd4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                goToProjectSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to set user property with key: ${(0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("7lHeU", function(module, exports) {

$parcel$export(module.exports, "setGlobalFieldsTourSpotlightStep", () => $1b436c0378152500$export$71a13f0fff467880);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1b436c0378152500$export$71a13f0fff467880 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("7kErt", function(module, exports) {

$parcel$export(module.exports, "loadGlobalFieldsTourDismissed", () => $1bb555275befe735$export$6dbef36cf5394497);
$parcel$export(module.exports, "setGlobalFieldsTourDismissed", () => $1bb555275befe735$export$7ddbf8611b7a51e2);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $1bb555275befe735$export$6dbef36cf5394497 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $1bb555275befe735$export$7ddbf8611b7a51e2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("8DEAI", function(module, exports) {

$parcel$export(module.exports, "loadExploreSectionMessageDismissed", () => $c1db7be05492658f$export$178c75cc028231a2);
$parcel$export(module.exports, "setExploreSectionMessageDismissed", () => $c1db7be05492658f$export$994e754bbe4537c1);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $c1db7be05492658f$export$178c75cc028231a2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.exploreSectionMessageDismissed === 'boolean') return;
        try {
            const exploreSectionMessageDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    exploreSectionMessageDismissed: exploreSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        exploreSectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to get user property with key: ${(0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c1db7be05492658f$export$994e754bbe4537c1 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                exploreSectionMessageDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to set user property with key: ${(0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("jJ3r3", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsPageViewed", () => $15b014e1ee504e23$export$2932bbb803f6ab52);
$parcel$export(module.exports, "setProjectFieldsPageViewed", () => $15b014e1ee504e23$export$5425efd17972eca4);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $15b014e1ee504e23$export$2932bbb803f6ab52 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.pageViewed === 'boolean') return;
        try {
            const pageViewed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    pageViewed: pageViewed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        pageViewed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to get user property with key: ${(0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };
const $15b014e1ee504e23$export$5425efd17972eca4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                pageViewed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to set user property with key: ${(0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("43cMo", function(module, exports) {

$parcel$export(module.exports, "loadSeenPulsatingFieldsButton", () => $be3d4f9e88ab6d4d$export$4248149cb54f9a58);
$parcel$export(module.exports, "setSeenPulsatingFieldsButton", () => $be3d4f9e88ab6d4d$export$ef1450ffea0c5a63);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $be3d4f9e88ab6d4d$export$4248149cb54f9a58 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.seenPulsatingFieldsButton === 'boolean') return;
        try {
            const seenPulsatingFieldsButton = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    seenPulsatingFieldsButton: seenPulsatingFieldsButton
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        seenPulsatingFieldsButton: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to get user property with key: ${(0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };
const $be3d4f9e88ab6d4d$export$ef1450ffea0c5a63 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                seenPulsatingFieldsButton: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to set user property with key: ${(0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("ehOuS", function(module, exports) {

$parcel$export(module.exports, "setProjectFieldsTourSpotlightStep", () => $69d9a94b5f8df0a0$export$a6b8eee670a4eb2f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $69d9a94b5f8df0a0$export$a6b8eee670a4eb2f = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("1bQtC", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsTourDismissed", () => $5e852a2e701cb81c$export$9be5e6fba10e92ef);
$parcel$export(module.exports, "setProjectFieldsTourDismissed", () => $5e852a2e701cb81c$export$2ad2aec3cf81b681);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $5e852a2e701cb81c$export$9be5e6fba10e92ef = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $5e852a2e701cb81c$export$2ad2aec3cf81b681 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("5lIPS", function(module, exports) {

$parcel$export(module.exports, "loadTimelineSectionMessageDismissed", () => $4c4013cb55e34c16$export$85213c72021b1243);
$parcel$export(module.exports, "setTimelineSectionMessageDismissed", () => $4c4013cb55e34c16$export$f5452ae8fa9e3836);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $4c4013cb55e34c16$export$85213c72021b1243 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().timeline.sectionMessageDismissed === 'boolean') return;
        try {
            const timelineSectionMessageDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                timeline: {
                    sectionMessageDismissed: timelineSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    timeline: {
                        sectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to get user property with key: ${(0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $4c4013cb55e34c16$export$f5452ae8fa9e3836 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            timeline: {
                sectionMessageDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to set user property with key: ${(0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("1iEjh", function(module, exports) {

$parcel$export(module.exports, "loadViewPermissionsSpotlightDismissed", () => $7a608510c9ee8b06$export$54cafbe0d6b064a7);
$parcel$export(module.exports, "setViewPermissionsSpotlightDismissed", () => $7a608510c9ee8b06$export$1f66e0ea425845f8);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $1As78 = parcelRequire("1As78");

var $aiePb = parcelRequire("aiePb");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");

var $6FNg9 = parcelRequire("6FNg9");
const $7a608510c9ee8b06$export$54cafbe0d6b064a7 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().viewPermissions.spotlightDismissed === 'boolean') return;
        try {
            const viewPermissionsSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.VIEW_PERMISSIONS_LOCK_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                viewPermissions: {
                    spotlightDismissed: viewPermissionsSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && (0, $aiePb.isNotFoundError)(error)) {
                const state = getState();
                setState({
                    ...state,
                    viewPermissions: {
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.view-permissions-lock.spotlight-dismissed', (0, $flDq6.normalizeError)(error)));
        }
    };
const $7a608510c9ee8b06$export$1f66e0ea425845f8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            viewPermissions: {
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_PERMISSIONS_LOCK_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.view-permissions-lock.spotlight-dismissed', (0, $flDq6.normalizeError)(error)));
        }
    };

});
parcelRegister("1As78", function(module, exports) {

$parcel$export(module.exports, "createErrorAnalytics", () => $7cf658edd2cdbf14$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $7cf658edd2cdbf14$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $7cf658edd2cdbf14$export$4e01d30cacaf82b8);

var $5uXOq = parcelRequire("5uXOq");

var $2NSHC = parcelRequire("2NSHC");

var $2xRxR = parcelRequire("2xRxR");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $eW55R = parcelRequire("eW55R");

var $lH8Ty = parcelRequire("lH8Ty");

var $l6caf = parcelRequire("l6caf");

var $aiePb = parcelRequire("aiePb");
const $7cf658edd2cdbf14$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $7cf658edd2cdbf14$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $aiePb.getMetadata)(errorObject));
};
const $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverLoadFailedDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $lH8Ty.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $lH8Ty.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage((0, $l6caf.default).entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xRxR.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NSHC))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $aiePb.isPermissionError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).permissionErrorDescription)
        });
        if ((0, $aiePb.isConfigError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).configErrorTitle),
            description: formatMessage((0, $l6caf.default).configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorPossibleAccessLoss)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $7cf658edd2cdbf14$var$usePossibleAccessLossError();
    const generalActionFailedError = $7cf658edd2cdbf14$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling();
    return (0, $5uXOq.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $7cf658edd2cdbf14$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("eW55R", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $3e7591c0992d0e62$export$53d5ca6c3f53e109);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $deZYt = parcelRequire("deZYt");

var $2NSHC = parcelRequire("2NSHC");

var $7R4eB = parcelRequire("7R4eB");
var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");
const $3e7591c0992d0e62$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $7Jxgt.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $3e7591c0992d0e62$var$customFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $d4xRU.default));
const $3e7591c0992d0e62$var$customAutoDismissFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $7R4eB.default));
const $3e7591c0992d0e62$var$success = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($deZYt))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$errorWithRefresh = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NSHC))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$error = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NSHC))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("7R4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $435170f9f2349b2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;

});

parcelRegister("d4xRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61381db0e069bc03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;

});


parcelRegister("lH8Ty", function(module, exports) {

$parcel$export(module.exports, "EntityLimitError", () => $bbaa521f44d79b10$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $bbaa521f44d79b10$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $bbaa521f44d79b10$export$cf58cbb2768ea4f);

var $e3a3O = parcelRequire("e3a3O");

var $ht021 = parcelRequire("ht021");

var $j7a90 = parcelRequire("j7a90");

var $lTDxG = parcelRequire("lTDxG");
class $bbaa521f44d79b10$export$c4e01b2c2ba95919 extends (0, $ht021.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
const $bbaa521f44d79b10$export$13f6f9a6b905ebbd = (error)=>{
    // If already an EntityLimitError, return it
    if (error instanceof $bbaa521f44d79b10$export$c4e01b2c2ba95919) return error;
    // If not an ApolloError, return null as we can't handle it
    if (!(error instanceof (0, $e3a3O.ApolloError))) return null;
    // Get first entity limit error
    const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
    // If no entity limit error or no extensions, return null
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entityLimitErrorType = (0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $bbaa521f44d79b10$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $bbaa521f44d79b10$export$cf58cbb2768ea4f = (error)=>(0, $j7a90.default)[error.type] || null;

});
parcelRegister("j7a90", function(module, exports) {

$parcel$export(module.exports, "default", () => $6233b95581c40425$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");

var $lTDxG = parcelRequire("lTDxG");
var $6233b95581c40425$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
        "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
        "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
        "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    }
});

});
parcelRegister("lTDxG", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $557259e823a7e117$export$a197d88688faa32c);
const $557259e823a7e117$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});



parcelRegister("l6caf", function(module, exports) {

$parcel$export(module.exports, "default", () => $891c8f37fb7de7f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $891c8f37fb7de7f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "polaris-lib-errors.controllers.error-title",
        "defaultMessage": "Something went wrong."
    },
    permissionErrorDescription: {
        "id": "polaris-lib-errors.controllers.permission-error-description",
        "defaultMessage": "You may not have the permissions required to perform this operation."
    },
    configErrorTitle: {
        "id": "polaris-lib-errors.controllers.config-error-title",
        "defaultMessage": "We couldn't save that."
    },
    configErrorDescription: {
        "id": "polaris-lib-errors.controllers.config-error-description",
        "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
    },
    serverLoadFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-load-failed-description",
        "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
    },
    serverUpdateFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-update-failed-description",
        "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
    },
    errorDescription: {
        "id": "polaris-lib-errors.controllers.error-description",
        "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
    },
    workflowLoadingFailedDescription: {
        "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
        "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
    },
    errorPossibleAccessLoss: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss",
        "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
    },
    cyclicFormulaFieldDescription: {
        "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
        "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
    },
    entityLimitErrorTitle: {
        "id": "polaris-lib-errors.controllers.entity-limit-error-title",
        "defaultMessage": "You\u2019ve hit a limit"
    }
});

});

parcelRegister("aiePb", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $b7e19fcceac7c31b$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $b7e19fcceac7c31b$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $b7e19fcceac7c31b$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $b7e19fcceac7c31b$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isClientClosedError", () => $b7e19fcceac7c31b$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $b7e19fcceac7c31b$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConfigError", () => $b7e19fcceac7c31b$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $b7e19fcceac7c31b$export$8548546c0aa631e6);

var $561FV = parcelRequire("561FV");

var $8LQ84 = parcelRequire("8LQ84");

var $icGZu = parcelRequire("icGZu");
const $b7e19fcceac7c31b$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || // that's probably obsolete
        safeMessage.includes('status code 403') // that's probably obsolete
        ;
    });
    return false;
};
const $b7e19fcceac7c31b$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $b7e19fcceac7c31b$export$a8908c3867f6f20b = (errorObject)=>{
    return $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$b7e19fcceac7c31b$var$checkRateLimitErrorMatch(error)) || false;
};
const $b7e19fcceac7c31b$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $b7e19fcceac7c31b$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $b7e19fcceac7c31b$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $b7e19fcceac7c31b$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $b7e19fcceac7c31b$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $b7e19fcceac7c31b$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});



parcelRegister("gSOEi", function(module, exports) {

$parcel$export(module.exports, "loadInviteFromShareDialogSpotlightDismissed", () => $13bae66d7887fecd$export$8303e588f14a5f5);
$parcel$export(module.exports, "setInviteFromShareDialogSpotlightDismissed", () => $13bae66d7887fecd$export$57382f7f22e8cda0);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $1As78 = parcelRequire("1As78");

var $aiePb = parcelRequire("aiePb");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");

var $6FNg9 = parcelRequire("6FNg9");
const $13bae66d7887fecd$export$8303e588f14a5f5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().shareDialog.inviteSpotlightDismissed === 'boolean') return;
        try {
            const inviteFromShareDialogSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                shareDialog: {
                    ...state.shareDialog,
                    inviteSpotlightDismissed: inviteFromShareDialogSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && (0, $aiePb.isNotFoundError)(error)) {
                const state = getState();
                setState({
                    ...state,
                    shareDialog: {
                        ...state.shareDialog,
                        inviteSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)((0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), (0, $flDq6.normalizeError)(error)));
        }
    };
const $13bae66d7887fecd$export$57382f7f22e8cda0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            shareDialog: {
                ...state.shareDialog,
                inviteSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)((0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), (0, $flDq6.normalizeError)(error)));
        }
    };

});

parcelRegister("irhvp", function(module, exports) {

$parcel$export(module.exports, "loadAllViewsSpotlightDismissed", () => $386a76adebfd5ad6$export$73f482a9822cc952);
$parcel$export(module.exports, "setAllViewsSpotlightDismissed", () => $386a76adebfd5ad6$export$84df3d965709961e);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $386a76adebfd5ad6$export$73f482a9822cc952 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().allViews.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                allViews: {
                    ...state.allViews,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    allViews: {
                        ...state.allViews,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $386a76adebfd5ad6$export$84df3d965709961e = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            allViews: {
                ...state.allViews,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to set user property with key: ${(0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("i1anS", function(module, exports) {

$parcel$export(module.exports, "loadPrioritizationViewTourDismissed", () => $21cf3ff4ec7ad773$export$f610fdf8823d3e34);
$parcel$export(module.exports, "setPrioritizationViewTourDismissed", () => $21cf3ff4ec7ad773$export$a72bdc987d4b2c7d);
$parcel$export(module.exports, "setPrioritizationViewTourSpotlightStep", () => $21cf3ff4ec7ad773$export$a76ccd1e602a886c);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $21cf3ff4ec7ad773$export$f610fdf8823d3e34 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().prioritizationView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                prioritizationView: {
                    ...state.prioritizationView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    prioritizationView: {
                        ...state.prioritizationView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to get user property with key: ${(0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $21cf3ff4ec7ad773$export$a72bdc987d4b2c7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to set user property with key: ${(0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $21cf3ff4ec7ad773$export$a76ccd1e602a886c = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("cXfUC", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapViewSpotlightDismissed", () => $2206505688e5db6e$export$7efa8325e0de15f);
$parcel$export(module.exports, "setRoadmapViewSpotlightDismissed", () => $2206505688e5db6e$export$b55083c189662aa5);
$parcel$export(module.exports, "loadRoadmapColumnConfigSpotlightDismissed", () => $2206505688e5db6e$export$9e6f136ba325b100);
$parcel$export(module.exports, "setRoadmapColumnConfigSpotlightDismissed", () => $2206505688e5db6e$export$866ee7083694a75f);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $2206505688e5db6e$export$7efa8325e0de15f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().roadmapView.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$b55083c189662aa5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$9e6f136ba325b100 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().roadmapView.columnConfigSpotlightDismissed === 'boolean') return;
        try {
            const columnConfigSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    columnConfigSpotlightDismissed: columnConfigSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        columnConfigSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$866ee7083694a75f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                columnConfigSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-column-config-spotlight', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("9nrm9", function(module, exports) {

$parcel$export(module.exports, "loadViewCreatorSpotlightState", () => $99d368e0edf5cbc9$export$9a1628c8a6cce5a8);
$parcel$export(module.exports, "setViewCreatorSpotlightTourStep", () => $99d368e0edf5cbc9$export$55b6ef0c08b2c8bc);
$parcel$export(module.exports, "setViewCreatorSpotlightDismissed", () => $99d368e0edf5cbc9$export$b883437f952d9bab);

var $hJCUd = parcelRequire("hJCUd");

var $4R6GH = parcelRequire("4R6GH");

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $6FNg9 = parcelRequire("6FNg9");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");
const $99d368e0edf5cbc9$export$9a1628c8a6cce5a8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().viewCreator.tourDismissed === 'boolean') return;
        try {
            const remoteState = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS));
            const state = getState();
            setState({
                ...state,
                viewCreator: {
                    ...state.viewCreator,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(remoteState, {
                        tourSpotlightStep: null,
                        tourDismissed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    viewCreator: {
                        ...state.viewCreator,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.view-creator-spotlight', `Failed to get user property with key: ${(0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $99d368e0edf5cbc9$export$55b6ef0c08b2c8bc = (step)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourSpotlightStep: step
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };
const $99d368e0edf5cbc9$export$b883437f952d9bab = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourDismissed: true
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };

});

parcelRegister("a6Bob", function(module, exports) {

$parcel$export(module.exports, "loadPremiumModalDismissed", () => $f7233d1c4eea5348$export$f4ca311cb4b4350f);
$parcel$export(module.exports, "setPremiumModalDismissed", () => $f7233d1c4eea5348$export$99d8813bb6724f28);
$parcel$export(module.exports, "loadPremiumLastVisit", () => $f7233d1c4eea5348$export$6825e78fd5bc05f5);
$parcel$export(module.exports, "setPremiumLastVisit", () => $f7233d1c4eea5348$export$c2d4fef533f3196c);
$parcel$export(module.exports, "unlockOnboardingFlow", () => $f7233d1c4eea5348$export$f92cc7ff16154919);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $d9ulS = parcelRequire("d9ulS");
const $f7233d1c4eea5348$export$f4ca311cb4b4350f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.modalDismissed === 'boolean') return;
        try {
            const modalDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PREMIUM_MODAL_DISMISSED));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    modalDismissed: modalDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        modalDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to get user property with key: ${(0, $d9ulS.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $f7233d1c4eea5348$export$99d8813bb6724f28 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        // we need to pass isPremium to the lastVisit object to ensure that the modal is dismissed
        // when the user is on the premium edition and the last visit was on the free edition
        setState({
            premium: {
                ...state.premium,
                modalDismissed: true,
                lastVisit: {
                    ...state.premium.lastVisit,
                    isPremium: true
                }
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PREMIUM_MODAL_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to set user property with key: ${(0, $d9ulS.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $f7233d1c4eea5348$export$6825e78fd5bc05f5 = (isPremiumEdition)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.lastVisit.isPremium === 'boolean') return;
        try {
            const lastVisitOnPremium = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PREMIUM_LAST_VISIT));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        isPremium: lastVisitOnPremium
                    }
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        lastVisit: {
                            ...state.premium.lastVisit,
                            isPremium: isPremiumEdition
                        }
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to get user property with key: ${(0, $d9ulS.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $f7233d1c4eea5348$export$c2d4fef533f3196c = (isPremium)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if (getState().premium.lastVisit.updated) // If lastVisit has been updated already
        // then don't do it again
        return;
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PREMIUM_LAST_VISIT), String(isPremium));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        updated: true
                    }
                }
            });
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to set user property with key: ${(0, $d9ulS.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
    };
const $f7233d1c4eea5348$export$f92cc7ff16154919 = ()=>async ({ getState: getState })=>{
        getState().premium.promise.resolve();
    };

});

parcelRegister("dke7D", function(module, exports) {

$parcel$export(module.exports, "loadProductUsageStartTimestamp", () => $f2bc503204fd19f2$export$7cb2c6cd0d7c32c0);

var $89SaW = parcelRequire("89SaW");

var $8U9Op = parcelRequire("8U9Op");

var $d9ulS = parcelRequire("d9ulS");
const $f2bc503204fd19f2$export$7cb2c6cd0d7c32c0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // usage timestamp already loaded
        if (getState().productUsageStartTimestamp) return;
        try {
            const { isoDateString: productUsageStartTimestamp } = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PRODUCT_START_TIMESTAMP));
            const state = getState();
            setState({
                ...state,
                productUsageStartTimestamp: productUsageStartTimestamp
            });
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $d9ulS.PRODUCT_START_TIMESTAMP)}`, error instanceof Error ? error : undefined);
        }
        return getState().productUsageStartTimestamp;
    };

});



parcelRegister("7qsHB", function(module, exports) {

$parcel$export(module.exports, "useCollectionsTourDismissed", () => $de678aee09ba157d$export$17de768881ff6446);
$parcel$export(module.exports, "useTourSpotlightStep", () => $de678aee09ba157d$export$152b14ddbe17966d);
$parcel$export(module.exports, "useCollectionsIntroductionDismissed", () => $de678aee09ba157d$export$2c88e8fbdc79e33c);
$parcel$export(module.exports, "useCollectionsIntroductionPrerequisiteDismissalsMet", () => $de678aee09ba157d$export$45df47b92137b673);

var $cAcWf = parcelRequire("cAcWf");

var $3u3TI = parcelRequire("3u3TI");
const $de678aee09ba157d$export$17de768881ff6446 = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsTourDismissed));
const $de678aee09ba157d$export$152b14ddbe17966d = (0, $cAcWf.createHook)((0, $3u3TI.getTourSpotlightStep));
const $de678aee09ba157d$export$2c88e8fbdc79e33c = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsIntroductionDismissed));
const $de678aee09ba157d$export$45df47b92137b673 = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsIntroductionPrerequisiteDismissalsMet));

});
parcelRegister("3u3TI", function(module, exports) {

$parcel$export(module.exports, "getCollectionsTourDismissed", () => $dd2f618ed5b718df$export$2f4e8052c0c8cc36);
$parcel$export(module.exports, "getTourSpotlightStep", () => $dd2f618ed5b718df$export$c0777ba57d86bcd1);
$parcel$export(module.exports, "getCollectionsIntroductionDismissed", () => $dd2f618ed5b718df$export$df23a375f28a4c0f);
$parcel$export(module.exports, "getCollectionsIntroductionPrerequisiteDismissalsMet", () => $dd2f618ed5b718df$export$e6b937f1096fabf9);

var $dGvGJ = parcelRequire("dGvGJ");
const $dd2f618ed5b718df$export$9bc19dcd1978ec48 = (state)=>state.collections;
const $dd2f618ed5b718df$export$2f4e8052c0c8cc36 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.tourDismissed);
const $dd2f618ed5b718df$export$c0777ba57d86bcd1 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.tourSpotlightStep);
const $dd2f618ed5b718df$export$df23a375f28a4c0f = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.introductionDismissed);
const $dd2f618ed5b718df$export$e6b937f1096fabf9 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.introductionPrerequisiteDismissalsMet);

});


parcelRegister("jhE94", function(module, exports) {

$parcel$export(module.exports, "useProductUsageStartTimestamp", () => $2346875d10b87fd5$export$935abb673611c138);

var $cAcWf = parcelRequire("cAcWf");

var $eyW9h = parcelRequire("eyW9h");
const $2346875d10b87fd5$export$935abb673611c138 = (0, $cAcWf.createHook)((0, $eyW9h.getProductUsageStartTimestamp));

});
parcelRegister("eyW9h", function(module, exports) {

$parcel$export(module.exports, "getProductUsageStartTimestamp", () => $4d3ab3242e339cb7$export$e96fba6f475323c2);
const $4d3ab3242e339cb7$export$e96fba6f475323c2 = (state)=>state.productUsageStartTimestamp;

});


parcelRegister("9V003", function(module, exports) {

$parcel$export(module.exports, "messages", () => $896b0ce39c051edc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $896b0ce39c051edc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dismiss: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.dismiss",
        "defaultMessage": "Dismiss"
    },
    giveItATry: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.give-it-a-try",
        "defaultMessage": "Give it a try!"
    },
    message: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.message",
        "defaultMessage": "Create a roadmap tailored to the information your stakeholders care about the most by selecting which projects and ideas to include."
    }
});

});

parcelRegister("3aLoA", function(module, exports) {

$parcel$export(module.exports, "checkIfOlderThanNDays", () => $769a162525414dfb$export$cbcf9869d63af9cf);
const $769a162525414dfb$export$cbcf9869d63af9cf = (productStartTimestamp, days = 7)=>{
    if (!productStartTimestamp) return false;
    const daysInMs = days * 86400000;
    const currentDate = new Date();
    const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
    return productAge > daysInMs;
};

});


parcelRegister("6yVM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe7682072c5451b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2fe7682072c5451b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleJpdRoadmaps: {
        "id": "atlassian-navigation.roadmaps.title-jpd-roadmaps",
        "defaultMessage": "Roadmaps"
    }
});

});


parcelRegister("6U0zt", function(module, exports) {

$parcel$export(module.exports, "Addons", () => $10f4e1510a5de408$export$a97e6a0578b4c83);

var $5uXOq = parcelRequire("5uXOq");

var $gDHs4 = parcelRequire("gDHs4");

var $kJH82 = parcelRequire("kJH82");

var $azzrO = parcelRequire("azzrO");

var $kaHBi = parcelRequire("kaHBi");

var $6s1PB = parcelRequire("6s1PB");

var $eKYL7 = parcelRequire("eKYL7");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $iXVV6 = parcelRequire("iXVV6");

var $dAfqg = parcelRequire("dAfqg");

var $a4k7n = parcelRequire("a4k7n");

var $heI7y = parcelRequire("heI7y");

var $9OXo1 = parcelRequire("9OXo1");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $j94qH = parcelRequire("j94qH");

var $ebYJ0 = parcelRequire("ebYJ0");

var $h5OKf = parcelRequire("h5OKf");

var $1bhgl = parcelRequire("1bhgl");

var $dEiSH = parcelRequire("dEiSH");
const $10f4e1510a5de408$var$AddonsView = ()=>{
    const { key: projectIdOrKey } = (0, $dAfqg.useProjectContext)();
    const [, { load: loadItem, setContext: setContext }] = (0, $kJH82.useAddon)();
    const [, { load: loadForgeItem }] = (0, $eKYL7.useForgeGlobalItems)();
    (0, $5uXOq.useEffect)(()=>{
        setContext({
            projectIdOrKey: projectIdOrKey
        });
    }, [
        projectIdOrKey,
        setContext
    ]);
    const [{ hasSuccessOnce: hasSuccessOnceUserSegmentation }, { loadPersonalisedAppsUserSegmentation: loadPersonalisedAppsUserSegmentation }] = (0, $h5OKf.usePersonalisedAppsTeamType)();
    const { cloudId: cloudId, isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ADDONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        loadItem();
        loadForgeItem({
            cloudId: cloudId,
            isAnonymous: isAnonymous
        });
        !hasSuccessOnceUserSegmentation && loadPersonalisedAppsUserSegmentation();
        (0, $azzrO.NAVIGATION_TOP_DROPDOWN_MARKS).ADDONS.start();
    }, [
        onStart,
        loadItem,
        hasSuccessOnceUserSegmentation,
        loadPersonalisedAppsUserSegmentation,
        loadForgeItem,
        cloudId,
        isAnonymous
    ]);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            isEmbeddedMarketplaceEnabledForEndUsers: (0, $6s1PB.expVal)('enduser-emcee-discover', 'value', true),
            isEmbeddedMarketplaceSpaEnabled: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).ADDONS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ADDONS,
        Menu: (0, $1bhgl.AsyncMenu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $dEiSH.default).apps)
    }, formatMessage((0, $dEiSH.default).apps)));
};
const $10f4e1510a5de408$export$a97e6a0578b4c83 = ()=>{
    const { isVisible: isVisible } = (0, $gDHs4.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).ADDONS
    }, !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4k7n.NavigationAppsNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10f4e1510a5de408$var$AddonsView, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10f4e1510a5de408$var$AddonsView, null));
};

});
parcelRegister("kJH82", function(module, exports) {

$parcel$export(module.exports, "useAddon", () => $0672771da90f2be9$export$550c6d89b9b85724);

var $6Rmr1 = parcelRequire("6Rmr1");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $0672771da90f2be9$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchAddons: fetchAddons, fetchAddonContext: fetchAddonContext, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchAddons(undefined, fetchAddonContext);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $0672771da90f2be9$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($0672771da90f2be9$var$handleFetch());
            await promise;
        },
    setFavourite: (item, isAddon)=>async ({ setState: setState, getState: getState })=>{
            const { items: items, addToFavorite: addToFavorite, removeFromFavorite: removeFromFavorite } = getState();
            const newItemData = {
                ...item,
                favourite: true
            };
            if (isAddon) {
                setState({
                    items: [
                        newItemData,
                        ...items
                    ]
                });
                await addToFavorite(newItemData);
            } else {
                setState({
                    items: items.filter((theItem)=>theItem.id !== item.id)
                });
                await removeFromFavorite(item);
            }
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                fetchAddonContext: context
            });
        }
};
const $0672771da90f2be9$export$f350d6bef9972cd3 = (defaults)=>{
    const initialState = {
        fetchAddons: defaults.fetchAddons,
        fetchAddonContext: {},
        addToFavorite: defaults.addToFavorite,
        removeFromFavorite: defaults.removeFromFavorite,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'addon-store',
        actions: $0672771da90f2be9$var$actions,
        initialState: initialState
    });
    const AddonContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState({
                    fetchAddons: props.fetchAddons,
                    addToFavorite: props.addToFavorite,
                    removeFromFavorite: props.removeFromFavorite
                });
            }
    });
    const AddonTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const AddonSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'AddonSubscriber',
        selector: selector
    }); // Bug with createSubscriber type means that React children end up "never"
    // Deprecated: to be removed
    const useAddonActions = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    const useAddon = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        AddonSubscriber: AddonSubscriber,
        useAddonActions: useAddonActions,
        useAddon: useAddon,
        AddonTestContainer: AddonTestContainer,
        AddonContainer: AddonContainer
    };
};
const $0672771da90f2be9$var$defaultAddToFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const $0672771da90f2be9$var$defaultRemoveFromFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const { useAddon: $0672771da90f2be9$export$550c6d89b9b85724 } = $0672771da90f2be9$export$f350d6bef9972cd3({
    fetchAddons: (0, $6Rmr1.fetchAddonItems),
    addToFavorite: $0672771da90f2be9$var$defaultAddToFavorite,
    removeFromFavorite: $0672771da90f2be9$var$defaultRemoveFromFavorite
});

});
parcelRegister("6Rmr1", function(module, exports) {

$parcel$export(module.exports, "fetchAddonItems", () => $c9dd134b6cc78152$export$fe5ef9b24322d3c1);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $g5X3G = parcelRequire("g5X3G");

var $fPruT = parcelRequire("fPruT");

const $c9dd134b6cc78152$var$handleError = (error)=>{
    // Temp
    throw error;
};
const $c9dd134b6cc78152$export$fe5ef9b24322d3c1 = async (baseUrl = (0, $g5X3G.toBaseUrl)(''), context)=>{
    const params = $c9dd134b6cc78152$var$getContextParams(context);
    const url = `${baseUrl}/rest/navigation/3/global/addons${params ? `?${params}` : ''}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $c9dd134b6cc78152$var$handleError(new (0, $fPruT.AuthenticationError)(`${errorCode}`));
            return $c9dd134b6cc78152$var$handleError(new (0, $jJZqs.default)(errorCode, response.statusText));
        }
        const addonsItems = await response.json();
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        return addonsItems.map((item)=>({
                id: item.id,
                title: item.name,
                avatarUrl: item.iconUrl,
                type: (0, $49a076eb01652100$export$5e2cc09b58170ca2),
                url: item.url,
                className: item.styleClass
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // network issue
        return $c9dd134b6cc78152$var$handleError(error);
    }
};
function $c9dd134b6cc78152$var$getContextParams(context) {
    const filteredParams = Object.fromEntries(Object.entries(context || {}).filter(([, value])=>!!value));
    return new URLSearchParams(filteredParams).toString();
}

});


parcelRegister("eKYL7", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalItems", () => $b1e0d26740806b04$export$fa6081acdcc112a0);

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $b1e0d26740806b04$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $b1e0d26740806b04$var$transformTitle = (title, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${title} - ${environmentKey}`;
    return title;
};
const $b1e0d26740806b04$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch global items since they are implemented elsewhere.
            if ((0, $3HwlS.getWillShowNav4)()) return;
            const promise = (0, $iVaKa.fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: true,
                types: [
                    (0, $k2DRb.GLOBAL_PAGE_MODULE)
                ],
                source: (0, $k2DRb.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const globalPageData = data ? data[0, $k2DRb.GLOBAL_PAGE_MODULE] : [];
            const items = globalPageData.filter((0, $5cmSg.isExtensionVisible)).map((extension)=>({
                    id: extension.id,
                    title: $b1e0d26740806b04$var$transformTitle(extension.properties.title, extension.environmentType, extension.environmentKey),
                    avatarUrl: extension.properties.icon,
                    url: $b1e0d26740806b04$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    module: (0, $k2DRb.GLOBAL_PAGE_MODULE)
                }));
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $b1e0d26740806b04$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($b1e0d26740806b04$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
            await promise;
        }
};
const $b1e0d26740806b04$export$a87c2a3d589b7efd = ()=>{
    const initialState = {
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'forge-global-items-store',
        actions: // @ts-expect-error - TS2322 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' is not assignable to type 'Record<string, ActionThunk<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<FullPage[] | null>; hasFetchedOnce: boolean; ... 4 more ...; isFetching: boolean; }, { ...; }>>'.
        $b1e0d26740806b04$var$actions,
        initialState: initialState
    });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: // @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
    items, hasFetchedOnce: // @ts-expect-error - TS7031 - Binding element 'hasFetchedOnce' implicitly has an 'any' type.
    hasFetchedOnce, fetchError: // @ts-expect-error - TS7031 - Binding element 'fetchError' implicitly has an 'any' type.
    fetchError, promise: // @ts-expect-error - TS7031 - Binding element 'promise' implicitly has an 'any' type.
    promise, hasSuccessOnce: // @ts-expect-error - TS7031 - Binding element 'hasSuccessOnce' implicitly has an 'any' type.
    hasSuccessOnce, isFetching: // @ts-expect-error - TS7031 - Binding element 'isFetching' implicitly has an 'any' type.
    isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            fetchError: fetchError,
            promise: promise,
            hasSuccessOnce: hasSuccessOnce,
            isFetching: isFetching
        });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'ForgeGlobalItemsSubscriber',
        selector: selector
    });
    const useForgeGlobalItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    // @ts-expect-error - TS2322 - Type 'HookFunction<{ items: any; hasFetchedOnce: any; fetchError: any; promise: any; hasSuccessOnce: any; isFetching: any; }, BoundActions<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<...>; ... 5 more ...; isFetching: boolean; }, Record<...>>, void>' is not assignable to type '() => HookReturnValue<GenericPublicState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>'.
    return {
        ForgeGlobalItemsSubscriber: ForgeGlobalItemsSubscriber,
        useForgeGlobalItems: useForgeGlobalItems,
        ForgeGlobalItemsTestContainer: ForgeGlobalItemsTestContainer
    };
};
const { useForgeGlobalItems: $b1e0d26740806b04$export$fa6081acdcc112a0 } = $b1e0d26740806b04$export$a87c2a3d589b7efd();

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});


parcelRegister("a4k7n", function(module, exports) {

$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $86c9ba44b2aedf6e$export$c143067f544307f);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy = (0, $58ST7.lazyAfterPaint)(()=>(parcelRequire("3UNsE")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
});
const $86c9ba44b2aedf6e$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("3UNsE", function(module, exports) {

let $2d9cf80049ad7f52$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d9cf80049ad7f52$var$load("5NmQj").then(()=>parcelRequire('3Hy6N'));

});


parcelRegister("h5OKf", function(module, exports) {

$parcel$export(module.exports, "usePersonalisedAppsTeamType", () => $1c093da579689f30$export$952bf3a355bf4d23);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $cE27s = parcelRequire("cE27s");
const $1c093da579689f30$var$initialState = {
    isLoading: false,
    isSuccess: false,
    error: null,
    promise: null,
    teamType: undefined,
    hasSuccessOnce: false
};
const $1c093da579689f30$var$store = (0, $iXqE5.createStore)({
    actions: $cE27s.actions,
    initialState: $1c093da579689f30$var$initialState,
    name: 'atlassian-navigation-addons-personalised-apps-team-type'
});
const $1c093da579689f30$export$952bf3a355bf4d23 = (0, $3sQ5x.createHook)($1c093da579689f30$var$store);
const $1c093da579689f30$export$202fd798d158e553 = (0, $3sQ5x.createHook)($1c093da579689f30$var$store, {
    selector: null
});

});
parcelRegister("cE27s", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cbb59c8ecf2badc7$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $i5yN4 = parcelRequire("i5yN4");

var $26xre = parcelRequire("26xre");
const $cbb59c8ecf2badc7$var$loadPersonalisedAppsUserSegmentation = ()=>async ({ setState: setState })=>{
        const promise = (0, $i5yN4.getUserSegmentationData)();
        setState({
            error: null,
            isLoading: true,
            isSuccess: false,
            promise: promise
        });
        try {
            const { team: team } = await promise;
            const teamType = (0, $26xre.mapUserTeamTypeToTeamType)(team);
            setState({
                teamType: teamType,
                isSuccess: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error
            });
        } finally{
            setState({
                isLoading: false
            });
        }
    };
const $cbb59c8ecf2badc7$export$e324594224ef24da = {
    loadPersonalisedAppsUserSegmentation: $cbb59c8ecf2badc7$var$loadPersonalisedAppsUserSegmentation
};

});
parcelRegister("i5yN4", function(module, exports) {

$parcel$export(module.exports, "getUserSegmentationData", () => $d567b9983c1fa90f$export$f0a14a7cbbb7397e);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $d567b9983c1fa90f$var$GET_ME_URL = '/gateway/api/me';
const $d567b9983c1fa90f$export$318c25600a19e2ee = ()=>(0, $eusud.performGetRequest)($d567b9983c1fa90f$var$GET_ME_URL);
const $d567b9983c1fa90f$export$f0a14a7cbbb7397e = async ()=>{
    let response = {
        jobTitle: undefined,
        team: undefined
    };
    try {
        const { extended_profile: extendedProfile } = await $d567b9983c1fa90f$export$318c25600a19e2ee();
        const { job_title: jobTitle, team_type: team } = extendedProfile;
        response = {
            jobTitle: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            jobTitle,
            team: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            team
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // failed to fetch user segmentation data, analytics will be added later
        (0, $jcw0u.default)({
            meta: {
                id: 'getUserSegmentationData',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            },
            error: error
        });
    }
    return response;
};

});

parcelRegister("26xre", function(module, exports) {

$parcel$export(module.exports, "mapUserTeamTypeToTeamType", () => $3464a59742bad1ac$export$38b9d6b529723f8c);

var $2nA8w = parcelRequire("2nA8w");
const $3464a59742bad1ac$export$38b9d6b529723f8c = (team)=>{
    switch(team){
        case (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment;
        case (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).itSupport:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).itSupport;
        default:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).marketing;
    }
};

});
parcelRegister("2nA8w", function(module, exports) {

$parcel$export(module.exports, "PERSONALISED_APPS_TEAM_TYPES", () => $e0c89db7eea0cd0a$export$2bdcfab7823ff30);
const $e0c89db7eea0cd0a$export$2bdcfab7823ff30 = {
    marketing: 'Business Management and Operations',
    itSupport: 'IT Support',
    softwareDevelopment: 'Software Development'
};

});




parcelRegister("1bhgl", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $ed4263c510e6df56$export$81adf29ff528dc9c);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5gSBR = parcelRequire("5gSBR");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");
var $3TPR8 = parcelRequire("3TPR8");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");
const $ed4263c510e6df56$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$var$AppsSectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), null)));

const $ed4263c510e6df56$export$c49a6d699b74b197 = (0, $58ST7.lazy)(()=>(parcelRequire("14qM9")).then((module)=>module.Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/addons/menu/index.tsx"
});
const $ed4263c510e6df56$export$81adf29ff528dc9c = ({ shouldLoad: shouldLoad = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TPR8.LazyWait), {
        until: shouldLoad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$var$Skeleton, null),
        name: "lazy-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$export$c49a6d699b74b197, null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ed4263c510e6df56$var$AppsSectionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5gSBR.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke12am",
            __cmplp.className
        ])
    });
});

});
parcelRegister("14qM9", function(module, exports) {

let $0c7aef3f2877f831$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c7aef3f2877f831$var$load("cFH97").then(()=>parcelRequire('4opAu'));

});


parcelRegister("dEiSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ce60ec2367163b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f4ce60ec2367163b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    apps: {
        "id": "atlassian-navigation.addons.apps",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("fwJYI", function(module, exports) {

$parcel$export(module.exports, "Search", () => $e3b17dd8db2850a9$export$4b85d3515bd863a5);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $58ST7 = parcelRequire("58ST7");

var $Mp6qH = parcelRequire("Mp6qH");

var $gIk9n = parcelRequire("gIk9n");

var $crtj2 = parcelRequire("crtj2");

var $gIJdF = parcelRequire("gIJdF");
const $e3b17dd8db2850a9$var$LoadingSkeleton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIJdF.Skeleton), {
        placeholder: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonPlaceholder),
        ariaLabel: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonAriaLabel)
    });
};
const $e3b17dd8db2850a9$var$SearchDialogMetricStart = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $crtj2.searchDialogMetric).startFromPageLoad();
        (0, $crtj2.searchDialogMetric).mark((0, $crtj2.SEARCH_DIALOG_DOWNLOAD_START_MARK));
    }, []);
    return null;
};
const $e3b17dd8db2850a9$var$SearchDialogMetricEnd = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $crtj2.searchDialogMetric).mark((0, $crtj2.SEARCH_DIALOG_DOWNLOAD_END_MARK));
    }, []);
    return null;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e3b17dd8db2850a9$var$LazySearch = (0, $58ST7.lazyForPaint)(()=>(parcelRequire("4KQgd")).then((m)=>m.Search), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.tsx"
});
const $e3b17dd8db2850a9$export$4b85d3515bd863a5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "search",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$SearchDialogMetricStart, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-search",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$LoadingSkeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$LazySearch, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$SearchDialogMetricEnd, null)));

});
parcelRegister("gIk9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88bffd5106f4b78$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b88bffd5106f4b78$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updated: {
        "id": "atlassian-navigation.search.updated",
        "defaultMessage": "Updated"
    },
    interactiveSearchSkeletonPlaceholder: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-placeholder",
        "defaultMessage": "Search"
    },
    interactiveSearchSkeletonAriaLabel: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-aria-label",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("crtj2", function(module, exports) {

$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_START_MARK", () => $f04658be14f95c1c$export$8cd6a987249a6f33);
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_END_MARK", () => $f04658be14f95c1c$export$80ab6637ae730993);
$parcel$export(module.exports, "searchDialogMetric", () => $f04658be14f95c1c$export$46d64d80a1040e9b);

var $ktw2A = parcelRequire("ktw2A");
const $f04658be14f95c1c$var$SEARCH_DIALOG_METRIC_KEY = 'search-dialog';
const $f04658be14f95c1c$export$8cd6a987249a6f33 = 'download-start';
const $f04658be14f95c1c$export$80ab6637ae730993 = 'download-end';
const $f04658be14f95c1c$export$46d64d80a1040e9b = (0, $ktw2A.metrics).pageSegmentLoad({
    key: $f04658be14f95c1c$var$SEARCH_DIALOG_METRIC_KEY,
    timings: [
        {
            key: 'download',
            startMark: $f04658be14f95c1c$export$8cd6a987249a6f33,
            endMark: $f04658be14f95c1c$export$80ab6637ae730993
        }
    ]
});

});

parcelRegister("gIJdF", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $315a2135ffa56c8b$export$8f31e4c4a37b8e9c);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $1O4x4 = parcelRequire("1O4x4");

var $70nOQ = parcelRequire("70nOQ");

var $4R6GH = parcelRequire("4R6GH");

var $eoNiZ = parcelRequire("eoNiZ");
const $315a2135ffa56c8b$export$8f31e4c4a37b8e9c = ({ ProductSearchInputSkeleton: ProductSearchInputSkeleton = (0, $70nOQ.ProductSearchInputSkeleton), useTheme: useTheme = (0, $eoNiZ.useTheme), placeholder: placeholder, ariaLabel: ariaLabel })=>{
    /**
	 * The nav3 custom theme object
	 */ const theme = useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $1O4x4.useLegacySearchTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProductSearchInputSkeleton, {
        shouldFillContainer: (0, $3HwlS.getWillShowNav4)(),
        theme: (0, $3HwlS.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder,
        ariaLabel: ariaLabel,
        dataSsrPlaceholder: (0, $4R6GH.fg)('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined
    });
};

});

parcelRegister("4KQgd", function(module, exports) {

let $3763ff257481bedd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3763ff257481bedd$var$load("68Kzv"),
    $3763ff257481bedd$var$load("3NvtU"),
    $3763ff257481bedd$var$load("7FkEF"),
    $3763ff257481bedd$var$load("dvReR"),
    $3763ff257481bedd$var$load("5J0Y3")
]).then(()=>parcelRequire('1jMgA'));

});


parcelRegister("jUhOq", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistant", () => $a6baf802cdb95631$export$9777b121d71c4de1);

var $5uXOq = parcelRequire("5uXOq");

var $8fabB = parcelRequire("8fabB");

var $aBTsJ = parcelRequire("aBTsJ");

var $lEr0j = parcelRequire("lEr0j");

var $31pzm = parcelRequire("31pzm");

var $3y1Yo = parcelRequire("3y1Yo");


var $7XYc4 = parcelRequire("7XYc4");

var $hsmeR = parcelRequire("hsmeR");

var $2Ui4E = parcelRequire("2Ui4E");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $kkNtb = parcelRequire("kkNtb");

var $koeKL = parcelRequire("koeKL");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");
const $a6baf802cdb95631$var$AssistantButton = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), (0, $3y1Yo.ConversationAssistantButtonNav4), (0, $3y1Yo.ConversationAssistantButton));
const $a6baf802cdb95631$var$ConversationAssistantButton = ()=>{
    const [_topMenusValue, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $hsmeR.useActiveRightSidebarState)() || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isActive = panelId === (0, $a32ac52330287123$export$dffb4ed44e20ea9a) && !isCollapsed;
    const onButtonClickOld = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: isCollapsed,
            isActive: isActive
        });
        if (isActive) closeCurrentRightSidebar();
        else openRightSidebar((0, $a32ac52330287123$export$dffb4ed44e20ea9a), (0, $a32ac52330287123$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        createAnalyticsEvent,
        isActive,
        isCollapsed,
        openRightSidebar
    ]);
    const onButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: !isActive,
            isActive: isActive
        });
        isActive ? closeCurrentRightSidebar() : openRightSidebar((0, $a32ac52330287123$export$dffb4ed44e20ea9a), (0, $a32ac52330287123$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        isActive,
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        createAnalyticsEvent
    ]);
    const buttonRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fabB.default), {
        as: "span",
        paddingInlineStart: (0, $3HwlS.getWillShowNav4)() ? undefined : 'space.050',
        testId: "atlassian-navigation.ui.conversation-assistant.app-navigation-ai-mate",
        role: // This element is a direct descendant of the top nav actions list, so needs the listitem role.
        // While the button is internally wrapped in a listitem, screen readers do not pick this up due to multiple wrapper elements.
        (0, $3HwlS.getWillShowNav4)() ? 'listitem' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6baf802cdb95631$var$AssistantButton, {
        onClick: (0, $3HwlS.getWillShowNav4)() ? onButtonClick : onButtonClickOld,
        isActive: isActive,
        siteId: cloudId,
        productKey: "jira"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31pzm.ChatContextSubscriber), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBTsJ.ChatOpenerSubscriber), {
        onTriggerOpeningChat: ()=>{
            if (!isActive) openRightSidebar((0, $a32ac52330287123$export$dffb4ed44e20ea9a), (0, $a32ac52330287123$export$64aee74ba59709e5), false, true);
        }
    }));
};
const $a6baf802cdb95631$export$9777b121d71c4de1 = ()=>{
    const { data: data } = (0, $kkNtb.useRovoEntitlementResource)();
    const shouldShowConversationAssistantButton = data?.isRovoLLMEnabled ?? false;
    const buttonRender = shouldShowConversationAssistantButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6baf802cdb95631$var$ConversationAssistantButton, null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).CONVERSATION_ASSISTANT
    }, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lEr0j.RovoEntitlementSetter), {
        isRovoEnabled: shouldShowConversationAssistantButton
    }));
};

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $a32ac52330287123$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $a32ac52330287123$export$64aee74ba59709e5 = 439; // px
const $a32ac52330287123$export$1c07393c5bb1bc27 = 439; // px
const $a32ac52330287123$export$aa3478deee7adbeb = 350; // px
const $a32ac52330287123$export$21e515a86cd1733b = 'Chat';


parcelRegister("inFGE", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $611a60e3341e79e1$export$36ba2f559d49a8f6);
$parcel$export(module.exports, "NotificationsContentWrapper", () => $611a60e3341e79e1$export$34c02505a1643f00);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gFVv0 = parcelRequire("gFVv0");

var $dwE2v = parcelRequire("dwE2v");

var $7CMCs = parcelRequire("7CMCs");

var $kaHBi = parcelRequire("kaHBi");

var $aWse0 = parcelRequire("aWse0");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $c0dQj = parcelRequire("c0dQj");

var $lfTZh = parcelRequire("lfTZh");

var $cZpsT = parcelRequire("cZpsT");

var $58ST7 = parcelRequire("58ST7");

var $7XYc4 = parcelRequire("7XYc4");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $keCgG = parcelRequire("keCgG");

var $iPj86 = parcelRequire("iPj86");

var $5vuhU = parcelRequire("5vuhU");


var $b7Ryd = parcelRequire("b7Ryd");

const $611a60e3341e79e1$var$BadgeDI = (0, $58ST7.lazy)(()=>(parcelRequire("cekWc")).then(({ Badge: Badge })=>Badge), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/badge/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $611a60e3341e79e1$var$MenuDI = (0, $58ST7.lazy)(()=>(parcelRequire("lg2Os")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $611a60e3341e79e1$var$Notifications = ({ Badge: Badge = $611a60e3341e79e1$var$BadgeDI, ErrorBoundary: ErrorBoundary = (0, $7CMCs.JSErrorBoundary), Icon: Icon = (0, $keCgG.Notification), Menu: Menu = $611a60e3341e79e1$var$MenuDI, NotificationContentFrame: NotificationContentFrame = $611a60e3341e79e1$var$NotificationContentFrameDI, Popup: Popup = (0, $gFVv0.default), useExperienceStart: useExperienceStart = (0, $kaHBi.useExperienceStart), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) })=>{
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'notifications');
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const [isNotificationCleared, setIsNotificationCleared] = (0, $5uXOq.useState)(false);
    const [notificationCount, setNotificationCount] = (0, $5uXOq.useState)(0);
    const handleCountUpdate = (0, $5uXOq.useCallback)((newCount)=>{
        setNotificationCount(newCount);
    }, []);
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = useTopMenus((0, $lmyls.MENU_ID).NOTIFICATIONS);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = useExperienceStart({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isMenuOpen) performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        setIsNotificationCleared(true);
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const handleNotificationIconHover = ()=>{
        $611a60e3341e79e1$var$MenuDI.preload();
    };
    (0, $5vuhU.useRegisterNotificationsInCommandPalette)(onClick);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NotificationContentFrame, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdPrefix
    ]);
    const badge = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
            id: "notifications.badge.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "badge",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Badge, {
            isNotificationCleared: isNotificationCleared,
            setIsNotificationCleared: setIsNotificationCleared,
            isNotificationDrawerOpen: isMenuOpen,
            onNotificationCountChange: handleCountUpdate
        }))), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isNotificationCleared,
        isMenuOpen
    ]);
    const badgeEmpty = (0, $5uXOq.useCallback)(()=>null, []);
    const notificationsLabel = notificationCount < (0, $3c41b45407aae96c$export$14c62ba6f49b806f) ? formatMessage((0, $b7Ryd.default).label, {
        count: notificationCount
    }) : formatMessage((0, $b7Ryd.default).overNineNotifications);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            onMouseEnter: handleNotificationIconHover,
            tooltip: formatMessage((0, $b7Ryd.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        badge,
        isMenuOpen,
        onClick,
        formatMessage,
        testIdPrefix,
        notificationCount
    ]);
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        badge: badgeEmpty,
        tooltip: formatMessage((0, $b7Ryd.default).tooltip)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};
const $611a60e3341e79e1$export$36ba2f559d49a8f6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dwE2v.UsingNotificationsToImproveAdminApprovalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($611a60e3341e79e1$var$Notifications, props)));
const $611a60e3341e79e1$var$NotificationContentFrameDIOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1w2c _4t3i54ef _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $611a60e3341e79e1$var$notificationContentFrameStyles = null;
const $611a60e3341e79e1$var$NotificationContentFrameDIWithResponsiveWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1xd4 _4t3i54ef _1e0c1txw _g7111w2c"
        ])
    }, children); // TODO: When the cleanup is done, remove the exported wrapper component below please (see NotificationsContentWrapper)
//       Add fix the import in the Nav4Notifications componponent (which is colocated)
const $611a60e3341e79e1$var$NotificationContentFrameDI = (0, $7XYc4.componentWithCondition)(()=>(0, $c0dQj.isMobileAndInViewPanelIterationExperiment)(), $611a60e3341e79e1$var$NotificationContentFrameDIWithResponsiveWidth, $611a60e3341e79e1$var$NotificationContentFrameDIOld); // This has been created to circumvent a ratcheting rule and avoid an ESLint suppression
const $611a60e3341e79e1$export$34c02505a1643f00 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($611a60e3341e79e1$var$NotificationContentFrameDI, null, children);
};

});
parcelRegister("dwE2v", function(module, exports) {

$parcel$export(module.exports, "CoordinationStopProvider", () => $108b0001dbc2c488$export$83d026e3dd5706d);
$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalProvider", () => $108b0001dbc2c488$export$a5554f3421878be1);
$parcel$export(module.exports, "useUsingNotificationsToImproveAdminApprovalContext", () => $108b0001dbc2c488$export$3e450d633150d6ca);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $9OXo1 = parcelRequire("9OXo1");

const $108b0001dbc2c488$var$TouchpointContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    hasSpotlightBeenShown: true,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    markSpotlightAsShown: ()=>{}
});
const $108b0001dbc2c488$var$localStorage = (0, $bSSG7.createLocalStorageProvider)((0, $95839ee75937f648$export$67a034c701fa7ff6));
const $108b0001dbc2c488$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $108b0001dbc2c488$export$a5554f3421878be1 = ({ children: children })=>{
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $5uXOq.useState)(true);
    const spotlightLocalStorageKey = `${(0, $95839ee75937f648$export$7a86d77850136bf4)}_${cloudId}_${atlassianAccountId}`;
    (0, $5uXOq.useEffect)(()=>{
        setHasSpotlightBeenShown($108b0001dbc2c488$var$localStorage.get(spotlightLocalStorageKey) || false);
    }, [
        spotlightLocalStorageKey
    ]);
    const markSpotlightAsShown = (0, $5uXOq.useCallback)(()=>{
        $108b0001dbc2c488$var$localStorage.set(spotlightLocalStorageKey, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown,
        spotlightLocalStorageKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($108b0001dbc2c488$var$TouchpointContext.Provider, {
        value: {
            hasSpotlightBeenShown: hasSpotlightBeenShown,
            markSpotlightAsShown: markSpotlightAsShown
        }
    }, children);
};
const $108b0001dbc2c488$export$3e450d633150d6ca = ()=>(0, $5uXOq.useContext)($108b0001dbc2c488$var$TouchpointContext);

});
const $95839ee75937f648$export$67a034c701fa7ff6 = 'uniapa';
const $95839ee75937f648$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $95839ee75937f648$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';


parcelRegister("keCgG", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $5d149cd838a80129$export$14834abbfce3b8cd);

var $5uXOq = parcelRequire("5uXOq");

var $lMtuZ = parcelRequire("lMtuZ");

var $jsjfv = parcelRequire("jsjfv");

var $eyEct = parcelRequire("eyEct");
var $aQl8U = parcelRequire("aQl8U");
var $8LALs = parcelRequire("8LALs");


var $dwE2v = parcelRequire("dwE2v");

var $lglOU = parcelRequire("lglOU");

var $eGLgs = parcelRequire("eGLgs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $d8lsH = parcelRequire("d8lsH");

var $9OXo1 = parcelRequire("9OXo1");

var $52Kde = parcelRequire("52Kde");

var $6s1PB = parcelRequire("6s1PB");
// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
const $5d149cd838a80129$var$renderNotifications = (props, ref)=>{
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $52Kde.Notifications), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
            ref: ref
        });
    }
    const buttonProps = {
        ...notificationProps,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lMtuZ.Notifications), buttonProps);
};
const $5d149cd838a80129$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { markSpotlightAsShown: markSpotlightAsShown, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $dwE2v.useUsingNotificationsToImproveAdminApprovalContext)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d8lsH.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    // As an experiment we will bypass the SSR route for notifications so that instead of rendering
    // a skeleton component that will be replaced by the real component, we will render the real component.
    // This means that TTVC should increase because there will be less work to do on the client side.
    if ((0, $3HwlS.getWillShowNav4)()) {
        if (!(0, $6s1PB.expVal)('blu-6229-nav4-top-nav-notifications-perf', 'cohort', false) && false) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsjfv.Nav4SkeletonNotificationButton), {
            label: props.tooltip
        });
    } else if (false) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsjfv.SkeletonNotificationButton), {
        label: props.tooltip
    });
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    /**
	 * Send analytics event when user clicks "Close" or "View requests" button on the request spotlight
	 * Event registry - https://data-portal.internal.atlassian.com/analytics/registry/52348
	 * @param {"close"|"viewRequests"} buttonType
	 */ const handleSendAnalyticsEventForClickRequestSpotlightButton = (buttonType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'requestSpotlightButton', {
            buttonType: buttonType,
            isSiteAdmin: isSiteAdmin
        });
    };
    const shouldShowRequestsSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    if (!shouldShowRequestsSpotlight) return $5d149cd838a80129$var$renderNotifications(notificationProps, ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyEct.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQl8U.default), {
        name: "admin-request-spotlight"
    }, $5d149cd838a80129$var$renderNotifications(notificationProps, ref)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LALs.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $95839ee75937f648$export$d2ea4f931a71a509),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dwE2v.CoordinationStopProvider), null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lglOU.UsingNotificationsToImproveAdminApprovalSpotlight), {
            onViewRequests: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                onViewRequests && onViewRequests();
                handleSendAnalyticsEventForClickRequestSpotlightButton('viewRequests');
                stop && stop();
            },
            onClose: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                handleSendAnalyticsEventForClickRequestSpotlightButton('close');
                stop && stop();
            }
        })))));
});

});
parcelRegister("lglOU", function(module, exports) {

$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalSpotlight", () => $76067028c6c9ade1$export$aa9f9fc1c08b114f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $ehdJY = parcelRequire("ehdJY");

var $9OXo1 = parcelRequire("9OXo1");

var $a2BKa = parcelRequire("a2BKa");
const $76067028c6c9ade1$export$aa9f9fc1c08b114f = ({ onViewRequests: onViewRequests, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: "requestSpotlight",
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: onViewRequests,
                text: formatMessage((0, $a2BKa.default).uniapaSpotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: formatMessage((0, $a2BKa.default).uniapaSpotlightCloseButtonText),
                appearance: 'subtle'
            }
        ],
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        messageId: "cross-flow-using-notifications-to-improve-admin-approval.ui.jira-spotlight.admin-request-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $a2BKa.default).uniapaSpotlightNotificationText))));
};

});
parcelRegister("a2BKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $801cdcf6d45d9579$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $801cdcf6d45d9579$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    uniapaSpotlightNotificationText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
        "defaultMessage": "When someone in your team requests a new product you'll get a notification here now."
    },
    uniapaSpotlightCloseButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
        "defaultMessage": "Close"
    },
    uniapaSpotlightViewRequestsButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
        "defaultMessage": "View requests"
    }
});

});


parcelRegister("eGLgs", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $754c27d37ccd1133$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $754c27d37ccd1133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2sI0Y = parcelRequire("2sI0Y");

var $jbKoc = parcelRequire("jbKoc");
var $62S9T = parcelRequire("62S9T");

var $hJZUM = parcelRequire("hJZUM");

var $ioD1B = parcelRequire("ioD1B");

var $10xFf = parcelRequire("10xFf");

var $4Pf62 = parcelRequire("4Pf62");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $14XJw = parcelRequire("14XJw");

var $7qPn9 = parcelRequire("7qPn9");
const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
class $754c27d37ccd1133$export$580a2294c917898c extends (0, $62S9T.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $2sI0Y.envType).PROD;
            if (env === 'staging') return (0, $2sI0Y.envType).STAGING;
            return (0, $2sI0Y.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $10xFf.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $hJZUM.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $4R6GH.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $hJZUM.MessageDeliveryStatus).STARTED : (0, $hJZUM.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $hJZUM.MessageDeliveryStatus).STOPPED : (0, $hJZUM.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $hJZUM.MessageDeliveryStatus).STARTED : (0, $hJZUM.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $hJZUM.MessageDeliveryStatus).STOPPED : (0, $hJZUM.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbKoc.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});


parcelRegister("5vuhU", function(module, exports) {

$parcel$export(module.exports, "useRegisterNotificationsInCommandPalette", () => $179b48f3297e7dbc$export$1859b18f10ade54c);

var $5uXOq = parcelRequire("5uXOq");

var $7VEwn = parcelRequire("7VEwn");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $1Kt4o = parcelRequire("1Kt4o");

var $5zCdk = parcelRequire("5zCdk");

var $jh7L9 = parcelRequire("jh7L9");

var $koVbs = parcelRequire("koVbs");


var $2ju1i = parcelRequire("2ju1i");
const $179b48f3297e7dbc$export$1859b18f10ade54c = (onClick)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const commands = [
        {
            id: (0, $309f32bbf2afff80$export$e0226a83abddbd07),
            name: formatMessage((0, $2ju1i.messages).checkNotifications),
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: onClick
            },
            keywords: getKeywords('checkNotificationsSynonyms'),
            section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
            priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7VEwn))), {
                        spacing: "spacious",
                        label: formatMessage((0, $2ju1i.messages).checkNotifications)
                    })
            },
            analytics: {
                action: 'checkNotifications'
            }
        }
    ];
    (0, $5zCdk.useRegisterCommands)((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).CHECK_NOTIFICATIONS, commands);
};

});
parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $7691773a5eed3db6$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $7691773a5eed3db6$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $7691773a5eed3db6$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("5rVQI", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $c7aab549acec9d6e$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $c7aab549acec9d6e$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 5] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("eG9rp", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $61ebfb9239c4f8e5$export$4d8fe3ef6385358);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dYWZb = parcelRequire("dYWZb");
const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, $dYWZb.messages)[keywordGroup] ? formatMessage((0, $dYWZb.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("dYWZb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df7d7dd7b88156b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    },
    goToIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Advanced work item search Project Filter JQL search list View all"
    },
    viewAllIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Site work items JQL View all"
    }
});

});


parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("5zCdk", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $c2fc115f119fcec7$export$3f626f8a5dbc29e4);

var $6QoIp = parcelRequire("6QoIp");
const $c2fc115f119fcec7$export$3f626f8a5dbc29e4 = (0, $6QoIp.useRegisterCommandsWithRegistry);

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});



const $309f32bbf2afff80$export$e0226a83abddbd07 = 'check-notifications';

parcelRegister("2ju1i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0cb403ddbf46e2b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0cb403ddbf46e2b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    checkNotifications: {
        "id": "atlassian-navigation.notifications.command-palette.check-notifications",
        "defaultMessage": "Check notifications"
    }
});

});


const $3c41b45407aae96c$export$14c62ba6f49b806f = 9;

parcelRegister("b7Ryd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3829bacc3127c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a4d3829bacc3127c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.notifications.tooltip",
        "defaultMessage": "Notifications"
    },
    oldLabel: {
        "id": "atlassian-navigation.notifications.old-label",
        "defaultMessage": "Notifications"
    },
    label: {
        "id": "atlassian-navigation.notifications.label",
        "defaultMessage": "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        "id": "atlassian-navigation.notifications.over-nine-notifications",
        "defaultMessage": "Over 9 Notifications"
    }
});

});

parcelRegister("cekWc", function(module, exports) {

let $8e7708a65e03f2d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e7708a65e03f2d1$var$load("c8f5t").then(()=>parcelRequire('6z8GT'));

});

parcelRegister("lg2Os", function(module, exports) {

let $f79d4625aa3b0ede$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f79d4625aa3b0ede$var$load("68Kzv"),
    $f79d4625aa3b0ede$var$load("3NvtU"),
    $f79d4625aa3b0ede$var$load("bnGQJ")
]).then(()=>parcelRequire('hJbTL'));

});





parcelRegister("MBTxm", function(module, exports) {

$parcel$export(module.exports, "InitialDataLoader", () => $0c63bc4f7fc4fb59$export$867ec025b81eadf3);

var $5uXOq = parcelRequire("5uXOq");

var $kJH82 = parcelRequire("kJH82");


var $bcn6L = parcelRequire("bcn6L");

var $eKYL7 = parcelRequire("eKYL7");

var $7uSIc = parcelRequire("7uSIc");

var $d40Fj = parcelRequire("d40Fj");

var $apeap = parcelRequire("apeap");

var $lsa9q = parcelRequire("lsa9q");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");
const $0c63bc4f7fc4fb59$export$867ec025b81eadf3 = ()=>{
    const [, { loadRecentAll: loadRecentAll }] = (0, $apeap.useRecentActions)();
    const [, { loadFavoriteAll: loadFavoriteAll }] = (0, $bcn6L.useFavoriteActions)();
    const [, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = (0, $d40Fj.useCreateProjectPermissionActions)();
    const [, { load: loadForgeGlobalItem }] = (0, $eKYL7.useForgeGlobalItems)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const [, { load: loadAddons }] = (0, $kJH82.useAddon)();
    const hasFetchedAll = (0, $5uXOq.useRef)(false);
    const [{ hasLoaded: hasLoaded }] = (0, $lsa9q.default)();
    const [hasTimedOut, setHasTimedOut] = (0, $5uXOq.useState)(false);
    const accountId = (0, $90yGq.useAccountId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
            loadRecentAll();
            loadFavoriteAll((0, $7a1562bd0ca086b0$export$ea341e6cc435ed40));
            loadForgeGlobalItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            loadForgePersonalSettingsItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            fetchCreateProjectPermission();
            loadAddons();
            hasFetchedAll.current = true;
        }
    }, [
        hasLoaded,
        hasTimedOut,
        hasFetchedAll,
        loadRecentAll,
        loadFavoriteAll,
        fetchCreateProjectPermission,
        loadForgeGlobalItem,
        loadForgePersonalSettingsItem,
        loadAddons,
        accountId,
        cloudId,
        isAnonymous
    ]);
    // given not all pages use SpaStateReady yet, we fallback to timeout
    // so we preload nav items anyway after some time
    (0, $5uXOq.useEffect)(()=>{
        let t;
        if (!hasLoaded) t = setTimeout(()=>setHasTimedOut(true), 10000);
        return ()=>clearTimeout(t);
    }, [
        hasLoaded,
        setHasTimedOut
    ]);
    return null;
};

});

parcelRegister("0396H", function(module, exports) {

$parcel$export(module.exports, "NavigationRouterListener", () => $fe5862efafb61dce$export$85575e1c48f0a517);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $hUGiV = parcelRequire("hUGiV");
const $fe5862efafb61dce$export$85575e1c48f0a517 = ()=>{
    const [{ route: route, location: location, match: match }] = (0, $doZTA.useRouter)();
    const onEnd = (0, $hUGiV.useAtlassianNavigationEnd)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onEnd();
    }, [
        route,
        match,
        location,
        onEnd
    ]);
    return null;
};

});
parcelRegister("hUGiV", function(module, exports) {

$parcel$export(module.exports, "useAtlassianNavigationEnd", () => $c2d6674a75325f63$export$4b9602c0fdb8b1bb);

var $5uXOq = parcelRequire("5uXOq");


var $4oDnX = parcelRequire("4oDnX");
const $c2d6674a75325f63$export$4b9602c0fdb8b1bb = ()=>{
    const [, { setAppReadyWithAppId: setAppReadyWithAppId }] = (0, $4oDnX.useSpaStateActions)();
    return (0, $5uXOq.useCallback)(()=>{
        setAppReadyWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82));
    }, [
        setAppReadyWithAppId
    ]);
};

});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';



parcelRegister("2E6jA", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsData", () => $61e3aa9159c11335$export$4be76e93f368ccd9);

var $4P1ax = parcelRequire("4P1ax");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $Mp6qH = parcelRequire("Mp6qH");

var $dFNPB = parcelRequire("dFNPB");
const $61e3aa9159c11335$export$4be76e93f368ccd9 = (props)=>{
    const { queryReference: queryReference } = props;
    const fragmentData = (0, $8Uumt.useFragment)((0, $4P1ax.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-notifications-error-boundary",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: (0, $Mp6qH.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dFNPB.Nav4Notifications), {
        fragmentData: fragmentData
    }));
};

});
parcelRegister("4P1ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c394e155eea9691$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab5a4efb2e4c302f6507731481aad167>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c394e155eea9691$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4NotificationsData",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Notifications"
        }
    ],
    "type": "Query"
};
$2c394e155eea9691$var$node.hash = "359a3dc4bc79536755e5a1c2e1775462";
var $2c394e155eea9691$export$2e2bcd8739ae039 = $2c394e155eea9691$var$node;

});

parcelRegister("dFNPB", function(module, exports) {

$parcel$export(module.exports, "Nav4Notifications", () => $aa3a9f45bb52149a$export$c50c32b171c62438);

var $aH68m = parcelRequire("aH68m");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gFVv0 = parcelRequire("gFVv0");

var $6cNb0 = parcelRequire("6cNb0");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $2Ui4E = parcelRequire("2Ui4E");

var $lmyls = parcelRequire("lmyls");

var $kaHBi = parcelRequire("kaHBi");

var $koVbs = parcelRequire("koVbs");

var $58ST7 = parcelRequire("58ST7");

var $c0dQj = parcelRequire("c0dQj");

var $jbk4C = parcelRequire("jbk4C");

var $2YZCu = parcelRequire("2YZCu");

var $Mp6qH = parcelRequire("Mp6qH");

var $iPj86 = parcelRequire("iPj86");

var $keCgG = parcelRequire("keCgG");

var $6v03K = parcelRequire("6v03K");

var $inFGE = parcelRequire("inFGE");

var $8s8Nt = parcelRequire("8s8Nt");


var $b7Ryd = parcelRequire("b7Ryd");

var $5vuhU = parcelRequire("5vuhU");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aa3a9f45bb52149a$var$LazyMenu = (0, $58ST7.lazy)(()=>(parcelRequire("lg2Os")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $aa3a9f45bb52149a$export$c50c32b171c62438 = (props)=>{
    const { fragmentData: fragmentData } = props;
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [_queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $jbk4C.default));
    const [data] = (0, $8Uumt.useRefetchableFragment)((0, $aH68m.default), fragmentData);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Check for new notifications every 5 minutes. This is currently done through polling because
    // Relay subscriptions are not yet supported server side. This polling will need to be replaced with
    // a subscription in the future (when notifications are migrated to Post Office).
    (0, $6v03K.usePolling)(()=>{
        (0, $8Uumt.fetchQuery)(environment, (0, $jbk4C.default), {}).subscribe({
            complete: ()=>{
                loadQuery({}, {
                    fetchPolicy: 'store-and-network'
                });
            },
            error: (error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $Mp6qH.PACKAGE_NAME)}.Nav4Notifications`, 'Error fetching notification', error);
            }
        });
    }, 300000);
    const fetchedNotificationsCount = data.notifications?.unseenNotificationCount ?? 0;
    // Initialise the state to false on page load, but use an effect to update it if the unseen notification
    // count changes (i.e. as a result of polling) to ensure the badge is shown when there are new notifications.
    const [isNotificationCleared, setIsNotificationCleared] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchedNotificationsCount > 0) setIsNotificationCleared(false);
    }, [
        fetchedNotificationsCount
    ]);
    // If notifications have been cleared, force the badge to be 0. This crudely addresses a race condition where
    // opening the menu (which resets the unseen notification count) does not complete before a refetch completes.
    const notificationsCount = isNotificationCleared ? 0 : fetchedNotificationsCount;
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'notifications');
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).NOTIFICATIONS);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inFGE.NotificationsContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa3a9f45bb52149a$var$LazyMenu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), [
        testIdPrefix
    ]);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isMenuOpen) performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        // Always set isNotificationCleared to true when the menu trigger is clicked
        // that there are no unseen notifications).
        setIsNotificationCleared(true);
    // PLEASE NOTE: Refetching the notifications does not occur here because for some reason
    // it blocks the popup from being closed.
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    (0, $5vuhU.useRegisterNotificationsInCommandPalette)(onClick);
    const badge = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8s8Nt.Nav4NotificationsBadge), {
            count: notificationsCount
        }), [
        notificationsCount
    ]);
    const notificationsLabel = notificationsCount < (0, $3c41b45407aae96c$export$14c62ba6f49b806f) ? formatMessage((0, $b7Ryd.default).label, {
        count: notificationsCount
    }) : formatMessage((0, $b7Ryd.default).overNineNotifications);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $keCgG.Notification), {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $b7Ryd.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), [
        badge,
        formatMessage,
        isMenuOpen,
        notificationsLabel,
        onClick,
        openMenu,
        testIdPrefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFVv0.default), {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};

});
parcelRegister("aH68m", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a2c8d85b91b234$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39ea3d6e0f88481971cec9a363b97835>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $jbk4C = parcelRequire("jbk4C");
const $66a2c8d85b91b234$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $jbk4C.default)
        }
    },
    "name": "Nav4Notifications",
    "selections": [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ],
    "type": "Query"
};
$66a2c8d85b91b234$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $66a2c8d85b91b234$export$2e2bcd8739ae039 = $66a2c8d85b91b234$var$node;

});
parcelRegister("jbk4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc9d5ac7020c75c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e946028ffc3086f1d9efb784e3dbaa5>>
 * @relayHash b27ca3910e82a09b8cdc053e9a61ed19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e
const $fbc9d5ac7020c75c$var$node = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Notifications"
            }
        ],
        "type": "Query"
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "concreteType": "InfluentsNotificationQuery",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "unseenNotificationCount"
                    }
                ]
            }
        ]
    },
    "params": {
        "id": "f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e",
        "metadata": {},
        "name": "Nav4NotificationsRefetchableQuery",
        "operationKind": "query",
        "text": null
    }
};
$fbc9d5ac7020c75c$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $fbc9d5ac7020c75c$export$2e2bcd8739ae039 = $fbc9d5ac7020c75c$var$node;

});


parcelRegister("6v03K", function(module, exports) {

$parcel$export(module.exports, "usePolling", () => $05a8008a7f962bd5$export$a11f73e3adecd502);

var $5uXOq = parcelRequire("5uXOq");
const $05a8008a7f962bd5$export$a11f73e3adecd502 = (callback, delay)=>{
    const callbackRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const tick = ()=>{
            if (callbackRef.current) callbackRef.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("8s8Nt", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsBadge", () => $f526d936b34d800d$export$c4129d57a4559409);

var $5uXOq = parcelRequire("5uXOq");

var $jd94h = parcelRequire("jd94h");
const $f526d936b34d800d$export$c4129d57a4559409 = (props)=>{
    const { count: count } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jd94h.Nav4NotificationsIndicator), {
        count: count
    });
};

});
parcelRegister("jd94h", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsIndicator", () => $e95bd3f66906bc5b$export$6891e3964002ac9);

var $5uXOq = parcelRequire("5uXOq");

var $a7UT2 = parcelRequire("a7UT2");
const $e95bd3f66906bc5b$var$MAX_NOTIFICATIONS_COUNT = 9;
const $e95bd3f66906bc5b$export$6891e3964002ac9 = (props)=>{
    const { appearance: appearance = 'important', count: count, max: max = $e95bd3f66906bc5b$var$MAX_NOTIFICATIONS_COUNT } = props;
    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-selector": "NotificationIndicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a7UT2.default), {
        testId: "atlassian-navigation.ui.notifications.notification-indicator-badge",
        max: max,
        appearance: appearance
    }, count)) : null;
};

});





// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


//# sourceMappingURL=async-atlassian-navigation.b3ccd3bd.js.map
